import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import * as React from "react";
import React__default, { forwardRef, useState, useEffect, useRef, useLayoutEffect, createContext, useImperativeHandle, useMemo, memo, Fragment as Fragment$1, useContext, PureComponent, useCallback } from "react";
import { TextLink, Heading, DynamicMediaPicture, fullWidthImageConfigs, LegalDisclaimer, withSetting, IndicatorBar, RichText, breakpoints as breakpoints$1, Text, mobileFullDesktopHalfImageConfig, SwipeIndicator, Icon, DynamicMediaVideo, Dialog, useScrollIndicatorProgress as useScrollIndicatorProgress$1, Tabs, CursorIcon, IconLink, TextButton, NotificationBadge, Button } from "@smart/web-components";
import { L as LinkDestination, a as LegalDisclaimers, I as ImageWithTransparencySupportContent, c as createId, b as createImage, d as createLinkContent, e as createLegalDisclaimerContents, _ as __assign, f as __rest, g as __spreadArray, h as __spreadArrays } from "./tslib.es6-16e4959a.mjs";
import { Tag, Icon as Icon$1 } from "@smart/react-components";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      var classes2 = "";
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes2 = appendClass(classes2, parseValue(arg));
        }
      }
      return classes2;
    }
    function parseValue(arg) {
      if (typeof arg === "string" || typeof arg === "number") {
        return arg;
      }
      if (typeof arg !== "object") {
        return "";
      }
      if (Array.isArray(arg)) {
        return classNames2.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
        return arg.toString();
      }
      var classes2 = "";
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes2 = appendClass(classes2, key);
        }
      }
      return classes2;
    }
    function appendClass(value2, newClass) {
      if (!newClass) {
        return value2;
      }
      if (value2) {
        return value2 + " " + newClass;
      }
      return value2 + newClass;
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
const navigation$2 = "_navigation_1bu37_15";
const picture$7 = "_picture_1bu37_21";
const headline$g = "_headline_1bu37_27";
const priceTag$3 = "_priceTag_1bu37_30";
const cta$8 = "_cta_1bu37_44";
const content$5 = "_content_1bu37_47";
const hasNavigation$1 = "_hasNavigation_1bu37_67";
const styles$I = {
  "image-stage": "_image-stage_1bu37_1",
  navigation: navigation$2,
  picture: picture$7,
  headline: headline$g,
  priceTag: priceTag$3,
  cta: cta$8,
  content: content$5,
  hasNavigation: hasNavigation$1,
  "legal-disclaimer": "_legal-disclaimer_1bu37_81"
};
const navigation$1 = "_navigation_13xvo_1";
const ul = "_ul_13xvo_11";
const li = "_li_13xvo_29";
const link$5 = "_link_13xvo_36";
const isActive$1 = "_isActive_13xvo_42";
const styles$H = {
  navigation: navigation$1,
  ul,
  li,
  link: link$5,
  isActive: isActive$1
};
const InStageNavigation = ({ className, items }) => {
  const generateMenuItems = () => items.map((link2, idx) => /* @__PURE__ */ jsx("li", { className: styles$H.li, children: /* @__PURE__ */ jsx(
    TextLink,
    {
      className: classNames(styles$H.link, { [styles$H.isActive]: link2.isActive }),
      ...link2,
      variant: "hyperlink-100",
      linkText: link2.label
    }
  ) }, `in-stage-navigation-item-${idx}`));
  return /* @__PURE__ */ jsx("nav", { className: classNames(styles$H.navigation, className), children: /* @__PURE__ */ jsx("ul", { className: styles$H.ul, children: generateMenuItems() }) });
};
const ImageStageComponent = forwardRef(
  ({ headline: headline2, image: image2, link: link2, className, legalDisclaimers, priceTag: priceTag2, inStageNavigation }, forwardedRef) => {
    const hasDarkeningLayer = !!(headline2 || link2 || priceTag2 || inStageNavigation);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("section", { className: classNames(styles$I["image-stage"], className), ref: forwardedRef, children: [
        inStageNavigation && /* @__PURE__ */ jsx(InStageNavigation, { className: styles$I.navigation, items: inStageNavigation }),
        /* @__PURE__ */ jsxs("div", { className: classNames(styles$I.content, { [styles$I.hasNavigation]: inStageNavigation }), children: [
          headline2 && /* @__PURE__ */ jsx(Heading, { withShadow: true, variant: "display-emotional-200", tag: "h1", className: styles$I.headline, children: headline2 }),
          priceTag2 && !inStageNavigation && /* @__PURE__ */ jsx(Heading, { withShadow: true, className: styles$I.priceTag, variant: "headline-functional-300", tag: "span", children: priceTag2 }),
          link2 && /* @__PURE__ */ jsx(TextLink, { ...link2, className: styles$I.cta, variant: "button-secondary-on-media", linkText: link2.label })
        ] }),
        /* @__PURE__ */ jsx(
          DynamicMediaPicture,
          {
            hasDarkeningLayer,
            className: styles$I.picture,
            imageAltText: image2.imageAltText,
            imageUrl: image2.imageUrl,
            imageConfigs: fullWidthImageConfigs,
            initialIsInView: true,
            noLoadingLogo: true,
            isObjectFit: true,
            fetchPriority: "high"
          }
        )
      ] }),
      legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$I["legal-disclaimer"], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
    ] });
  }
);
ImageStageComponent.displayName = "ImageStageComponent";
const ImageStage = withSetting(ImageStageComponent, "inverted");
const styles$G = {
  "headline-with-text": "_headline-with-text_152yv_1",
  "headline-with-text__indicator-bar": "_headline-with-text__indicator-bar_152yv_22",
  "headline-with-text__indicator-bar-container": "_headline-with-text__indicator-bar-container_152yv_31",
  "headline-with-text__headline": "_headline-with-text__headline_152yv_37",
  "headline-with-text__cta": "_headline-with-text__cta_152yv_45",
  "headline-with-text__cta-wrapper": "_headline-with-text__cta-wrapper_152yv_49",
  "headline-with-text__paragraphs": "_headline-with-text__paragraphs_152yv_54",
  "headline-with-text--highlight": "_headline-with-text--highlight_152yv_67"
};
const useScrollIndicatorProgress = (elementRef) => {
  const [intersectionRatio, setIntersectionRatio] = useState(0);
  useEffect(() => {
    const viewPortHeight = window.innerHeight;
    const tenPercentViewportHeight = viewPortHeight / 10;
    const handleIntersections = (entries) => {
      const [entry] = entries;
      if (entry.boundingClientRect.bottom + tenPercentViewportHeight <= viewPortHeight) {
        setIntersectionRatio(1);
        return;
      }
      setIntersectionRatio(entry.intersectionRatio);
    };
    const observer = new IntersectionObserver(handleIntersections, {
      threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      rootMargin: `-${tenPercentViewportHeight}px 0px `
    });
    const el = elementRef.current;
    if (el) {
      observer.observe(el);
    }
    return () => {
      if (el) {
        observer.unobserve(el);
      }
    };
  }, [elementRef]);
  const progressPercentage = Math.round(intersectionRatio * 100);
  return progressPercentage >= 0 ? progressPercentage : 0;
};
const baseClass$r = "headline-with-text";
const HeadlineWithText = ({
  headline: headline2,
  copyText: copyText2,
  highlight,
  link: link2,
  indicatorBar: indicatorBar2,
  className
}) => {
  const headlineVariant = highlight ? "display-functional-200" : "display-functional-200-fixed";
  const classes2 = classNames(
    styles$G[baseClass$r],
    {
      [styles$G[`${baseClass$r}--highlight`]]: highlight
    },
    className
  );
  const indicatorBarContainerRef = useRef(null);
  const indicatorBarContainerProgress = useScrollIndicatorProgress(indicatorBarContainerRef);
  return /* @__PURE__ */ jsxs("section", { className: classes2, children: [
    indicatorBar2 && /* @__PURE__ */ jsx("div", { className: styles$G[`${baseClass$r}__indicator-bar-container`], ref: indicatorBarContainerRef, children: /* @__PURE__ */ jsx(IndicatorBar, { progress: indicatorBarContainerProgress, className: styles$G[`${baseClass$r}__indicator-bar`] }) }),
    headline2 && /* @__PURE__ */ jsx(Heading, { className: styles$G[`${baseClass$r}__headline`], variant: headlineVariant, tag: "h2", children: headline2 }),
    copyText2 && /* @__PURE__ */ jsx(RichText, { mdString: copyText2, className: styles$G[`${baseClass$r}__paragraphs`] }),
    /* @__PURE__ */ jsx("div", { className: styles$G[`${baseClass$r}__cta-wrapper`], children: link2 && /* @__PURE__ */ jsx(TextLink, { ...link2, variant: "button-primary", className: styles$G[`${baseClass$r}__cta`], linkText: link2.label }) })
  ] });
};
const fullWidthTeaser = "_fullWidthTeaser_1v6uu_1";
const hasLegalText = "_hasLegalText_1v6uu_7";
const inner$1 = "_inner_1v6uu_10";
const picture$6 = "_picture_1v6uu_29";
const content$4 = "_content_1v6uu_34";
const headline$f = "_headline_1v6uu_40";
const copyText = "_copyText_1v6uu_41";
const legalDisclaimer$2 = "_legalDisclaimer_1v6uu_51";
const styles$F = {
  fullWidthTeaser,
  hasLegalText,
  inner: inner$1,
  picture: picture$6,
  content: content$4,
  headline: headline$f,
  copyText,
  legalDisclaimer: legalDisclaimer$2
};
const imageConfig$6 = [
  {
    aspectRatio: "1-1",
    sizes: "100vw",
    media: `(max-width: ${breakpoints$1.m}px)`
  },
  {
    aspectRatio: "16-9",
    sizes: "100vw",
    media: `(min-width: ${breakpoints$1.m}px)`
  }
];
const FullWidthTeaser = ({
  image: image2,
  link: link2,
  headline: headline2,
  copyText: copyText2,
  legalDisclaimers,
  className
}) => {
  const hasLegalDisclaimers = legalDisclaimers && !!legalDisclaimers.length;
  const classes2 = classNames(styles$F.fullWidthTeaser, { [styles$F.hasLegalText]: hasLegalDisclaimers }, className);
  const innerClasses = classNames(styles$F.inner, "setting--inverted");
  const hasDarkeningLayer = !!(headline2 || copyText2 || link2);
  return /* @__PURE__ */ jsxs("section", { className: classes2, children: [
    /* @__PURE__ */ jsxs("div", { className: innerClasses, children: [
      /* @__PURE__ */ jsxs("div", { className: styles$F.content, children: [
        headline2 && /* @__PURE__ */ jsx(Heading, { withShadow: true, className: styles$F.headline, variant: "headline-functional-100", tag: "span", children: headline2 }),
        copyText2 && /* @__PURE__ */ jsx(Text, { withShadow: true, className: styles$F.copyText, variant: "paragraph-100", children: copyText2 }),
        /* @__PURE__ */ jsx(TextLink, { ...link2, variant: "button-secondary-on-media", linkText: link2.label })
      ] }),
      /* @__PURE__ */ jsx(
        DynamicMediaPicture,
        {
          hasDarkeningLayer,
          className: styles$F.picture,
          imageConfigs: imageConfig$6,
          imageAltText: image2.imageAltText,
          imageUrl: image2.imageUrl,
          noLoadingLogo: true,
          isObjectFit: true
        }
      )
    ] }),
    hasLegalDisclaimers && /* @__PURE__ */ jsx("div", { className: styles$F.legalDisclaimer, children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
  ] });
};
const priceTag$2 = "_priceTag_zrj5o_25";
const isHighlighted = "_isHighlighted_zrj5o_28";
const styles$E = {
  "flexible-text-image": "_flexible-text-image_zrj5o_1",
  "flexible-text-image__top-container": "_flexible-text-image__top-container_zrj5o_8",
  "flexible-text-image__bottom-container": "_flexible-text-image__bottom-container_zrj5o_14",
  priceTag: priceTag$2,
  isHighlighted,
  "flexible-text-image__content-wrapper": "_flexible-text-image__content-wrapper_zrj5o_32",
  "flexible-text-image__image": "_flexible-text-image__image_zrj5o_37",
  "flexible-text-image__image-container": "_flexible-text-image__image-container_zrj5o_40",
  "flexible-text-image__content": "_flexible-text-image__content_zrj5o_32",
  "flexible-text-image__image--leading": "_flexible-text-image__image--leading_zrj5o_93",
  "flexible-text-image--highlight": "_flexible-text-image--highlight_zrj5o_108",
  "legal-disclaimer": "_legal-disclaimer_zrj5o_118",
  "flexible-text-image__copy-text": "_flexible-text-image__copy-text_zrj5o_178",
  "flexible-text-image__headline": "_flexible-text-image__headline_zrj5o_184",
  "flexible-text-image__component-headline": "_flexible-text-image__component-headline_zrj5o_200",
  "flexible-text-image__indicator-bar-container": "_flexible-text-image__indicator-bar-container_zrj5o_207",
  "flexible-text-image__link": "_flexible-text-image__link_zrj5o_225",
  "flexible-text-image__primary-link": "_flexible-text-image__primary-link_zrj5o_225"
};
const baseClass$q = "flexible-text-image";
const FlexibleTextImage = ({
  copyText: copyText2,
  link: link2,
  primaryLink: primaryLink2,
  image: image2,
  headline: headline2,
  imageLeading = false,
  className,
  componentHeadline: componentHeadline2,
  highlight = false,
  legalDisclaimers,
  indicatorBar: indicatorBar2,
  priceTag: priceTag2
}) => {
  const headlineVariant = highlight ? "headline-emotional-200" : "headline-functional-300";
  const classes2 = classNames(
    styles$E[baseClass$q],
    { [styles$E[`${baseClass$q}__image--leading`]]: imageLeading },
    { [styles$E[`${baseClass$q}--highlight`]]: highlight },
    className
  );
  const indicatorBarRef = useRef(null);
  const indicatorBarProgress = useScrollIndicatorProgress(indicatorBarRef);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("section", { className: classes2, children: [
    /* @__PURE__ */ jsxs("div", { className: styles$E[`${baseClass$q}__top-container`], children: [
      componentHeadline2 && /* @__PURE__ */ jsx(Heading, { className: styles$E[`${baseClass$q}__component-headline`], variant: "display-functional-200", tag: "h2", children: componentHeadline2 }),
      indicatorBar2 && /* @__PURE__ */ jsx("div", { className: styles$E[`${baseClass$q}__indicator-bar-container`], children: /* @__PURE__ */ jsx(
        IndicatorBar,
        {
          progress: indicatorBarProgress,
          className: styles$E[`${baseClass$q}__indicator-bar`],
          ref: indicatorBarRef
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles$E[`${baseClass$q}__bottom-container`], children: [
      /* @__PURE__ */ jsx("div", { className: styles$E[`${baseClass$q}__content-wrapper`], children: /* @__PURE__ */ jsxs("div", { className: styles$E[`${baseClass$q}__content`], children: [
        headline2 || priceTag2 ? /* @__PURE__ */ jsxs("div", { className: styles$E[`${baseClass$q}__headline`], children: [
          headline2 && /* @__PURE__ */ jsx(Heading, { variant: headlineVariant, tag: "h2", children: headline2 }),
          priceTag2 && highlight ? /* @__PURE__ */ jsx(
            Heading,
            {
              className: classNames(styles$E.priceTag, styles$E.isHighlighted),
              variant: "headline-functional-400",
              tag: "span",
              children: priceTag2
            }
          ) : /* @__PURE__ */ jsx(Text, { className: styles$E.priceTag, variant: "label-100", children: priceTag2 })
        ] }) : /* @__PURE__ */ jsx(Fragment, {}),
        copyText2 && /* @__PURE__ */ jsx(RichText, { className: styles$E[`${baseClass$q}__copy-text`], mdString: copyText2 }),
        primaryLink2 && /* @__PURE__ */ jsx(
          TextLink,
          {
            ...primaryLink2,
            className: styles$E[`${baseClass$q}__primary-link`],
            variant: "button-primary",
            linkText: primaryLink2.label
          }
        ),
        link2 && /* @__PURE__ */ jsx(
          TextLink,
          {
            ...link2,
            className: styles$E[`${baseClass$q}__link`],
            variant: "button-secondary",
            linkText: link2.label
          }
        )
      ] }) }),
      /* @__PURE__ */ jsxs("div", { className: styles$E[`${baseClass$q}__image-container`], children: [
        /* @__PURE__ */ jsx(
          DynamicMediaPicture,
          {
            className: styles$E[`${baseClass$q}__image`],
            imageAltText: image2.imageAltText,
            imageConfigs: mobileFullDesktopHalfImageConfig,
            imageUrl: image2.imageUrl,
            hasImageTransparency: image2.hasImageTransparency
          }
        ),
        legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$E[`legal-disclaimer`], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
      ] })
    ] })
  ] }) });
};
var useIsomorphicLayoutEffect$1 = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function useDraggable(ref, _temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$decayRate = _ref.decayRate, decayRate = _ref$decayRate === void 0 ? 0.95 : _ref$decayRate, _ref$safeDisplacement = _ref.safeDisplacement, safeDisplacement = _ref$safeDisplacement === void 0 ? 10 : _ref$safeDisplacement, _ref$applyRubberBandE = _ref.applyRubberBandEffect, applyRubberBandEffect = _ref$applyRubberBandE === void 0 ? false : _ref$applyRubberBandE, _ref$activeMouseButto = _ref.activeMouseButton, activeMouseButton = _ref$activeMouseButto === void 0 ? "Left" : _ref$activeMouseButto, _ref$isMounted = _ref.isMounted, isMounted = _ref$isMounted === void 0 ? true : _ref$isMounted;
  var internalState = useRef({
    isMouseDown: false,
    isDraggingX: false,
    isDraggingY: false,
    initialMouseX: 0,
    initialMouseY: 0,
    lastMouseX: 0,
    lastMouseY: 0,
    scrollSpeedX: 0,
    scrollSpeedY: 0,
    lastScrollX: 0,
    lastScrollY: 0
  });
  var isScrollableAlongX = false;
  var isScrollableAlongY = false;
  var maxHorizontalScroll = 0;
  var maxVerticalScroll = 0;
  var cursorStyleOfWrapperElement;
  var cursorStyleOfChildElements;
  var transformStyleOfChildElements;
  var transitionStyleOfChildElements;
  var timing = 1 / 60 * 1e3;
  useIsomorphicLayoutEffect$1(function() {
    if (isMounted) {
      isScrollableAlongX = window.getComputedStyle(ref.current).overflowX === "scroll";
      isScrollableAlongY = window.getComputedStyle(ref.current).overflowY === "scroll";
      maxHorizontalScroll = ref.current.scrollWidth - ref.current.clientWidth;
      maxVerticalScroll = ref.current.scrollHeight - ref.current.clientHeight;
      cursorStyleOfWrapperElement = window.getComputedStyle(ref.current).cursor;
      cursorStyleOfChildElements = [];
      transformStyleOfChildElements = [];
      transitionStyleOfChildElements = [];
      ref.current.childNodes.forEach(function(child) {
        cursorStyleOfChildElements.push(window.getComputedStyle(child).cursor);
        transformStyleOfChildElements.push(window.getComputedStyle(child).transform === "none" ? "" : window.getComputedStyle(child).transform);
        transitionStyleOfChildElements.push(window.getComputedStyle(child).transition === "none" ? "" : window.getComputedStyle(child).transition);
      });
    }
  }, [isMounted]);
  var runScroll = function runScroll2() {
    var dx = internalState.current.scrollSpeedX * timing;
    var dy = internalState.current.scrollSpeedY * timing;
    var offsetX = ref.current.scrollLeft + dx;
    var offsetY = ref.current.scrollTop + dy;
    ref.current.scrollLeft = offsetX;
    ref.current.scrollTop = offsetY;
    internalState.current.lastScrollX = offsetX;
    internalState.current.lastScrollY = offsetY;
  };
  var rubberBandCallback = function rubberBandCallback2(e) {
    var dx = e.clientX - internalState.current.initialMouseX;
    var dy = e.clientY - internalState.current.initialMouseY;
    var _ref$current = ref.current, clientWidth = _ref$current.clientWidth, clientHeight = _ref$current.clientHeight;
    var displacementX = 0;
    var displacementY = 0;
    if (isScrollableAlongX && isScrollableAlongY) {
      displacementX = 0.3 * clientWidth * Math.sign(dx) * Math.log10(1 + 0.5 * Math.abs(dx) / clientWidth);
      displacementY = 0.3 * clientHeight * Math.sign(dy) * Math.log10(1 + 0.5 * Math.abs(dy) / clientHeight);
    } else if (isScrollableAlongX) {
      displacementX = 0.3 * clientWidth * Math.sign(dx) * Math.log10(1 + 0.5 * Math.abs(dx) / clientWidth);
    } else if (isScrollableAlongY) {
      displacementY = 0.3 * clientHeight * Math.sign(dy) * Math.log10(1 + 0.5 * Math.abs(dy) / clientHeight);
    }
    ref.current.childNodes.forEach(function(child) {
      child.style.transform = "translate3d(" + displacementX + "px, " + displacementY + "px, 0px)";
      child.style.transition = "transform 0ms";
    });
  };
  var recoverChildStyle = function recoverChildStyle2() {
    ref.current.childNodes.forEach(function(child, i) {
      child.style.transform = transformStyleOfChildElements[i];
      child.style.transition = transitionStyleOfChildElements[i];
    });
  };
  var rubberBandAnimationTimer;
  var keepMovingX;
  var keepMovingY;
  var callbackMomentum = function callbackMomentum2() {
    var minimumSpeedToTriggerMomentum = 0.05;
    keepMovingX = setInterval(function() {
      var lastScrollSpeedX = internalState.current.scrollSpeedX;
      var newScrollSpeedX = lastScrollSpeedX * decayRate;
      internalState.current.scrollSpeedX = newScrollSpeedX;
      var isAtLeft = ref.current.scrollLeft <= 0;
      var isAtRight = ref.current.scrollLeft >= maxHorizontalScroll;
      var hasReachedHorizontalEdges = isAtLeft || isAtRight;
      runScroll();
      if (Math.abs(newScrollSpeedX) < minimumSpeedToTriggerMomentum || internalState.current.isMouseDown || hasReachedHorizontalEdges) {
        internalState.current.scrollSpeedX = 0;
        clearInterval(keepMovingX);
      }
    }, timing);
    keepMovingY = setInterval(function() {
      var lastScrollSpeedY = internalState.current.scrollSpeedY;
      var newScrollSpeedY = lastScrollSpeedY * decayRate;
      internalState.current.scrollSpeedY = newScrollSpeedY;
      var isAtTop = ref.current.scrollTop <= 0;
      var isAtBottom = ref.current.scrollTop >= maxVerticalScroll;
      var hasReachedVerticalEdges = isAtTop || isAtBottom;
      runScroll();
      if (Math.abs(newScrollSpeedY) < minimumSpeedToTriggerMomentum || internalState.current.isMouseDown || hasReachedVerticalEdges) {
        internalState.current.scrollSpeedY = 0;
        clearInterval(keepMovingY);
      }
    }, timing);
    internalState.current.isDraggingX = false;
    internalState.current.isDraggingY = false;
    if (applyRubberBandEffect) {
      var transitionDurationInMilliseconds = 250;
      ref.current.childNodes.forEach(function(child) {
        child.style.transform = "translate3d(0px, 0px, 0px)";
        child.style.transition = "transform " + transitionDurationInMilliseconds + "ms";
      });
      rubberBandAnimationTimer = setTimeout(recoverChildStyle, transitionDurationInMilliseconds);
    }
  };
  var preventClick = function preventClick2(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var getIsMousePressActive = function getIsMousePressActive2(buttonsCode) {
    return activeMouseButton === "Left" && buttonsCode === 1 || activeMouseButton === "Middle" && buttonsCode === 4 || activeMouseButton === "Right" && buttonsCode === 2;
  };
  var onMouseDown = function onMouseDown2(e) {
    var isMouseActive = getIsMousePressActive(e.buttons);
    if (!isMouseActive) {
      return;
    }
    internalState.current.isMouseDown = true;
    internalState.current.lastMouseX = e.clientX;
    internalState.current.lastMouseY = e.clientY;
    internalState.current.initialMouseX = e.clientX;
    internalState.current.initialMouseY = e.clientY;
  };
  var onMouseUp = function onMouseUp2(e) {
    var isDragging = internalState.current.isDraggingX || internalState.current.isDraggingY;
    var dx = internalState.current.initialMouseX - e.clientX;
    var dy = internalState.current.initialMouseY - e.clientY;
    var isMotionIntentional = Math.abs(dx) > safeDisplacement || Math.abs(dy) > safeDisplacement;
    var isDraggingConfirmed = isDragging && isMotionIntentional;
    if (isDraggingConfirmed) {
      ref.current.childNodes.forEach(function(child) {
        child.addEventListener("click", preventClick);
      });
    } else {
      ref.current.childNodes.forEach(function(child) {
        child.removeEventListener("click", preventClick);
      });
    }
    internalState.current.isMouseDown = false;
    internalState.current.lastMouseX = 0;
    internalState.current.lastMouseY = 0;
    ref.current.style.cursor = cursorStyleOfWrapperElement;
    ref.current.childNodes.forEach(function(child, i) {
      child.style.cursor = cursorStyleOfChildElements[i];
    });
    if (isDraggingConfirmed) {
      callbackMomentum();
    }
  };
  var onMouseMove = function onMouseMove2(e) {
    if (!internalState.current.isMouseDown) {
      return;
    }
    e.preventDefault();
    var dx = internalState.current.lastMouseX - e.clientX;
    internalState.current.lastMouseX = e.clientX;
    internalState.current.scrollSpeedX = dx / timing;
    internalState.current.isDraggingX = true;
    var dy = internalState.current.lastMouseY - e.clientY;
    internalState.current.lastMouseY = e.clientY;
    internalState.current.scrollSpeedY = dy / timing;
    internalState.current.isDraggingY = true;
    ref.current.style.cursor = "grabbing";
    ref.current.childNodes.forEach(function(child) {
      child.style.cursor = "grabbing";
    });
    var isAtLeft = ref.current.scrollLeft <= 0 && isScrollableAlongX;
    var isAtRight = ref.current.scrollLeft >= maxHorizontalScroll && isScrollableAlongX;
    var isAtTop = ref.current.scrollTop <= 0 && isScrollableAlongY;
    var isAtBottom = ref.current.scrollTop >= maxVerticalScroll && isScrollableAlongY;
    var isAtAnEdge = isAtLeft || isAtRight || isAtTop || isAtBottom;
    if (isAtAnEdge && applyRubberBandEffect) {
      rubberBandCallback(e);
    }
    runScroll();
  };
  var handleResize = function handleResize2() {
    maxHorizontalScroll = ref.current.scrollWidth - ref.current.clientWidth;
    maxVerticalScroll = ref.current.scrollHeight - ref.current.clientHeight;
  };
  useEffect(function() {
    if (isMounted) {
      window.addEventListener("mouseup", onMouseUp);
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("resize", handleResize);
    }
    return function() {
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("resize", handleResize);
      clearInterval(keepMovingX);
      clearInterval(keepMovingY);
      clearTimeout(rubberBandAnimationTimer);
    };
  }, [isMounted]);
  return {
    events: {
      onMouseDown
    }
  };
}
const scrollableIndicatorBar = "_scrollableIndicatorBar_1e82q_97";
const indicator$1 = "_indicator_1e82q_110";
const nonScrollableIndicatorBar = "_nonScrollableIndicatorBar_1e82q_196";
const styles$D = {
  "flexible-gallery": "_flexible-gallery_1e82q_1",
  "flexible-gallery__item": "_flexible-gallery__item_1e82q_7",
  "flexible-gallery__caption-container": "_flexible-gallery__caption-container_1e82q_20",
  "flexible-gallery__picture": "_flexible-gallery__picture_1e82q_36",
  "flexible-gallery__item--square": "_flexible-gallery__item--square_1e82q_41",
  "flexible-gallery__scrollable": "_flexible-gallery__scrollable_1e82q_62",
  "flexible-gallery__item-container": "_flexible-gallery__item-container_1e82q_62",
  "flexible-gallery__link-container": "_flexible-gallery__link-container_1e82q_97",
  scrollableIndicatorBar,
  indicator: indicator$1,
  "flexible-gallery__header": "_flexible-gallery__header_1e82q_120",
  "flexible-gallery__component-headline": "_flexible-gallery__component-headline_1e82q_137",
  "flexible-gallery__text-container": "_flexible-gallery__text-container_1e82q_166",
  "flexible-gallery__text-container__item": "_flexible-gallery__text-container__item_1e82q_172",
  "flexible-gallery__caption-title": "_flexible-gallery__caption-title_1e82q_175",
  "flexible-gallery__caption-copy": "_flexible-gallery__caption-copy_1e82q_175",
  nonScrollableIndicatorBar,
  "flexible-gallery__link": "_flexible-gallery__link_1e82q_97",
  "flexible-gallery--has-legal-text": "_flexible-gallery--has-legal-text_1e82q_216",
  "legal-disclaimer": "_legal-disclaimer_1e82q_220"
};
const baseClass$p = "flexible-gallery";
const FlexibleGallery = ({
  className,
  galleryItems,
  componentHeadline: componentHeadline2,
  link: link2,
  highlight,
  legalDisclaimers
}) => {
  const scrollableGallery = galleryItems.length > 3;
  const classes2 = classNames(
    styles$D[baseClass$p],
    {
      [styles$D[`${baseClass$p}--has-legal-text`]]: legalDisclaimers
    },
    className,
    { [styles$D[`${baseClass$p}__scrollable`]]: scrollableGallery }
  );
  const headingVariant = highlight ? "display-functional-200" : "display-functional-300";
  const headerIndicatorBarRef = useRef(null);
  const linkContainerIndicatorBarRef = useRef(null);
  const itemIndicatorBarRef = useRef(null);
  const itemContainerRef = useRef();
  const headerProgress = useScrollIndicatorProgress(headerIndicatorBarRef);
  const linkContainerProgress = useScrollIndicatorProgress(linkContainerIndicatorBarRef);
  const itemIndicatorProgress = useScrollIndicatorProgress(itemIndicatorBarRef);
  const { events: events2 } = useDraggable(itemContainerRef, { isMounted: true });
  const [scrollPercentage, setScrollPercentage] = useState(0);
  useEffect(() => {
    const { current: current2 } = itemContainerRef;
    const event = () => {
      const scrollPosition = current2.scrollLeft;
      const scrollWidth = current2.scrollWidth - current2.clientWidth;
      setScrollPercentage(scrollPosition / scrollWidth * 100);
    };
    current2.addEventListener("scroll", event);
    return () => {
      current2.removeEventListener("scroll", event);
    };
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("section", { className: classes2, children: [
      componentHeadline2 && /* @__PURE__ */ jsxs("div", { className: styles$D[`${baseClass$p}__header`], children: [
        /* @__PURE__ */ jsx(Heading, { tag: "h2", variant: headingVariant, className: styles$D[`${baseClass$p}__component-headline`], children: componentHeadline2 }),
        /* @__PURE__ */ jsx(
          IndicatorBar,
          {
            progress: headerProgress,
            className: styles$D[`${baseClass$p}__indicator-bar`],
            ref: headerIndicatorBarRef
          }
        )
      ] }),
      /* @__PURE__ */ jsx("div", { className: styles$D[`${baseClass$p}__item-container`], ref: itemContainerRef, ...events2, children: galleryItems.map((item2, i) => {
        const { imageHeadline, imageCopyText, imageCaptionHeadline, imageCaptionCopyText, image: image2 } = item2;
        const isSquare = (i + 2) % 3 === 2;
        const aspectRatio = isSquare ? "1-1" : "3-4";
        const imageConfig2 = [
          {
            aspectRatio: "1-1",
            sizes: "100vw",
            media: `(max-width: ${breakpoints$1.m}px)`
          },
          {
            aspectRatio,
            sizes: "33.33vw",
            media: `(min-width: ${breakpoints$1.m}px)`
          }
        ];
        const itemClasses = classNames(styles$D[`${baseClass$p}__item`], {
          [styles$D[`${baseClass$p}__item--square`]]: isSquare
        });
        return /* @__PURE__ */ jsxs("div", { className: itemClasses, children: [
          (imageCopyText || imageHeadline) && /* @__PURE__ */ jsxs("div", { className: styles$D[`${baseClass$p}__text-container`], children: [
            imageHeadline && /* @__PURE__ */ jsx(Text, { variant: "label-100", className: styles$D[`${baseClass$p}__text-container__item`], children: imageHeadline }),
            imageCopyText && /* @__PURE__ */ jsx(Text, { variant: "paragraph-100", className: styles$D[`${baseClass$p}__text-container__item`], children: imageCopyText })
          ] }),
          (imageCaptionCopyText || imageCopyText) && /* @__PURE__ */ jsxs("figure", { children: [
            /* @__PURE__ */ jsx(
              DynamicMediaPicture,
              {
                className: styles$D[`${baseClass$p}__picture`],
                imageAltText: image2.imageAltText,
                imageUrl: image2.imageUrl,
                imageConfigs: imageConfig2,
                hasImageTransparency: image2.hasImageTransparency
              }
            ),
            (imageCaptionCopyText || imageCaptionHeadline) && /* @__PURE__ */ jsxs("figcaption", { className: styles$D[`${baseClass$p}__caption-container`], children: [
              imageCaptionHeadline && /* @__PURE__ */ jsx(Text, { variant: "label-100", className: styles$D[`${baseClass$p}__caption-title`], children: imageCaptionHeadline }),
              imageCaptionCopyText && /* @__PURE__ */ jsx(Text, { variant: "paragraph-200", className: styles$D[`${baseClass$p}__caption-copy`], children: imageCaptionCopyText })
            ] })
          ] }),
          !scrollableGallery && link2 && i === 1 && /* @__PURE__ */ jsxs("div", { className: classNames(styles$D[`${baseClass$p}__link-container`], styles$D.nonScrollableIndicatorBar), children: [
            /* @__PURE__ */ jsx(
              IndicatorBar,
              {
                progress: itemIndicatorProgress,
                className: styles$D[`${baseClass$p}__indicator-bar`],
                ref: itemIndicatorBarRef
              }
            ),
            /* @__PURE__ */ jsx(
              TextLink,
              {
                ...link2,
                variant: "button-primary",
                className: styles$D[`${baseClass$p}__link`],
                linkText: link2.label
              }
            )
          ] })
        ] }, i);
      }) }),
      scrollableGallery && /* @__PURE__ */ jsx(SwipeIndicator, { className: styles$D.indicator, value: scrollPercentage }),
      link2 && /* @__PURE__ */ jsxs("div", { className: classNames(styles$D[`${baseClass$p}__link-container`], styles$D.scrollableIndicatorBar), children: [
        /* @__PURE__ */ jsx(
          IndicatorBar,
          {
            progress: linkContainerProgress,
            className: styles$D[`${baseClass$p}__indicator-bar`],
            ref: linkContainerIndicatorBarRef
          }
        ),
        /* @__PURE__ */ jsx(
          TextLink,
          {
            ...link2,
            variant: "button-primary",
            className: styles$D[`${baseClass$p}__link`],
            linkText: link2.label
          }
        )
      ] })
    ] }),
    legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$D[`legal-disclaimer`], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
  ] });
};
function isObject$3(obj) {
  return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend$2(target = {}, src = {}) {
  Object.keys(src).forEach((key) => {
    if (typeof target[key] === "undefined")
      target[key] = src[key];
    else if (isObject$3(src[key]) && isObject$3(target[key]) && Object.keys(src[key]).length > 0) {
      extend$2(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc = typeof document !== "undefined" ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === "undefined") {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === "undefined") {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== "undefined" ? window : {};
  extend$2(win, ssrWindow);
  return win;
}
function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach((key) => {
    try {
      object[key] = null;
    } catch (e) {
    }
    try {
      delete object[key];
    } catch (e) {
    }
  });
}
function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window2 = getWindow();
  let style;
  if (window2.getComputedStyle) {
    style = window2.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis = "x") {
  const window2 = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);
  if (window2.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(",").length > 6) {
      curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ");
    }
    transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
    matrix = transformMatrix.toString().split(",");
  }
  if (axis === "x") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m41;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[12]);
    else
      curTransform = parseFloat(matrix[4]);
  }
  if (axis === "y") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m42;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[13]);
    else
      curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$2(o) {
  return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
  if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend$1(...args) {
  const to = Object(args[0]);
  const noExtend = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];
    if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
      for (let nextIndex2 = 0, len = keysArray.length; nextIndex2 < len; nextIndex2 += 1) {
        const nextKey = keysArray[nextIndex2];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== void 0 && desc.enumerable) {
          if (isObject$2(to[nextKey]) && isObject$2(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$2(to[nextKey]) && isObject$2(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll({
  swiper: swiper2,
  targetPosition,
  side
}) {
  const window2 = getWindow();
  const startPosition = -swiper2.translate;
  let startTime = null;
  let time;
  const duration = swiper2.params.speed;
  swiper2.wrapperEl.style.scrollSnapType = "none";
  window2.cancelAnimationFrame(swiper2.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev";
  const isOutOfBound = (current2, target) => {
    return dir === "next" && current2 >= target || dir === "prev" && current2 <= target;
  };
  const animate = () => {
    time = (/* @__PURE__ */ new Date()).getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress2 = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress2 * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper2.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper2.wrapperEl.style.overflow = "hidden";
      swiper2.wrapperEl.style.scrollSnapType = "";
      setTimeout(() => {
        swiper2.wrapperEl.style.overflow = "";
        swiper2.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window2.cancelAnimationFrame(swiper2.cssModeFrameID);
      return;
    }
    swiper2.cssModeFrameID = window2.requestAnimationFrame(animate);
  };
  animate();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowEl && slideEl.shadowEl.querySelector(".swiper-slide-transform") || slideEl;
}
function elementChildren(element, selector = "") {
  return [...element.children].filter((el) => el.matches(selector));
}
function createElement(tag, classes2 = []) {
  const el = document.createElement(tag);
  el.classList.add(...Array.isArray(classes2) ? classes2 : [classes2]);
  return el;
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling;
    if (selector) {
      if (prev.matches(selector))
        prevEls.push(prev);
    } else
      prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling;
    if (selector) {
      if (next.matches(selector))
        nextEls.push(next);
    } else
      nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window2 = getWindow();
  return window2.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1)
        i += 1;
    }
    return i;
  }
  return void 0;
}
function elementParents(el, selector) {
  const parents = [];
  let parent = el.parentElement;
  while (parent) {
    if (selector) {
      if (parent.matches(selector))
        parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el)
      return;
    callback.call(el, e);
    el.removeEventListener("transitionend", fireCallBack);
  }
  if (callback) {
    el.addEventListener("transitionend", fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  const window2 = getWindow();
  if (includeMargins) {
    return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
  }
  return el.offsetWidth;
}
let support;
function calcSupport() {
  const window2 = getWindow();
  const document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && document2.documentElement.style && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
let deviceCached;
function calcDevice({
  userAgent
} = {}) {
  const support2 = getSupport();
  const window2 = getWindow();
  const platform = window2.navigator.platform;
  const ua = userAgent || window2.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window2.screen.width;
  const screenHeight = window2.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad)
      ipad = [0, 1, "13_0_0"];
    macos = false;
  }
  if (android && !windows) {
    device.os = "android";
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = "ios";
    device.ios = true;
  }
  return device;
}
function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
let browser;
function calcBrowser() {
  const window2 = getWindow();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window2.navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
  }
  if (isSafari()) {
    const ua = String(window2.navigator.userAgent);
    if (ua.includes("Version/")) {
      const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  return {
    isSafari: needPerspectiveFix || isSafari(),
    needPerspectiveFix,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent)
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize({
  swiper: swiper2,
  on,
  emit
}) {
  const window2 = getWindow();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper2 || swiper2.destroyed || !swiper2.initialized)
      return;
    emit("beforeResize");
    emit("resize");
  };
  const createObserver = () => {
    if (!swiper2 || swiper2.destroyed || !swiper2.initialized)
      return;
    observer = new ResizeObserver((entries) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper2;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper2.el)
            return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper2.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window2.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper2.el) {
      observer.unobserve(swiper2.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper2 || swiper2.destroyed || !swiper2.initialized)
      return;
    emit("orientationchange");
  };
  on("init", () => {
    if (swiper2.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler);
    window2.addEventListener("orientationchange", orientationChangeHandler);
  });
  on("destroy", () => {
    removeObserver();
    window2.removeEventListener("resize", resizeHandler);
    window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer({
  swiper: swiper2,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window2 = getWindow();
  const attach = (target, options = {}) => {
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
    const observer = new ObserverFunc((mutations) => {
      if (swiper2.__preventObserver__)
        return;
      if (mutations.length === 1) {
        emit("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate2() {
        emit("observerUpdate", mutations[0]);
      };
      if (window2.requestAnimationFrame) {
        window2.requestAnimationFrame(observerUpdate);
      } else {
        window2.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === "undefined" ? true : options.attributes,
      childList: typeof options.childList === "undefined" ? true : options.childList,
      characterData: typeof options.characterData === "undefined" ? true : options.characterData
    });
    observers.push(observer);
  };
  const init = () => {
    if (!swiper2.params.observer)
      return;
    if (swiper2.params.observeParents) {
      const containerParents = elementParents(swiper2.el);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    attach(swiper2.el, {
      childList: swiper2.params.observeSlideChildren
    });
    attach(swiper2.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach((observer) => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on("init", init);
  on("destroy", destroy);
}
const eventsEmitter = {
  on(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (typeof handler !== "function")
      return self2;
    const method = priority ? "unshift" : "push";
    events2.split(" ").forEach((event) => {
      if (!self2.eventsListeners[event])
        self2.eventsListeners[event] = [];
      self2.eventsListeners[event][method](handler);
    });
    return self2;
  },
  once(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (typeof handler !== "function")
      return self2;
    function onceHandler(...args) {
      self2.off(events2, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      handler.apply(self2, args);
    }
    onceHandler.__emitterProxy = handler;
    return self2.on(events2, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (typeof handler !== "function")
      return self2;
    const method = priority ? "unshift" : "push";
    if (self2.eventsAnyListeners.indexOf(handler) < 0) {
      self2.eventsAnyListeners[method](handler);
    }
    return self2;
  },
  offAny(handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (!self2.eventsAnyListeners)
      return self2;
    const index = self2.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self2.eventsAnyListeners.splice(index, 1);
    }
    return self2;
  },
  off(events2, handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (!self2.eventsListeners)
      return self2;
    events2.split(" ").forEach((event) => {
      if (typeof handler === "undefined") {
        self2.eventsListeners[event] = [];
      } else if (self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self2.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self2;
  },
  emit(...args) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (!self2.eventsListeners)
      return self2;
    let events2;
    let data2;
    let context;
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
      events2 = args[0];
      data2 = args.slice(1, args.length);
      context = self2;
    } else {
      events2 = args[0].events;
      data2 = args[0].data;
      context = args[0].context || self2;
    }
    data2.unshift(context);
    const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
    eventsArray.forEach((event) => {
      if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
        self2.eventsAnyListeners.forEach((eventHandler) => {
          eventHandler.apply(context, [event, ...data2]);
        });
      }
      if (self2.eventsListeners && self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler) => {
          eventHandler.apply(context, data2);
        });
      }
    });
    return self2;
  }
};
function updateSize() {
  const swiper2 = this;
  let width;
  let height;
  const el = swiper2.el;
  if (typeof swiper2.params.width !== "undefined" && swiper2.params.width !== null) {
    width = swiper2.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper2.params.height !== "undefined" && swiper2.params.height !== null) {
    height = swiper2.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper2.isHorizontal() || height === 0 && swiper2.isVertical()) {
    return;
  }
  width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
  height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
  if (Number.isNaN(width))
    width = 0;
  if (Number.isNaN(height))
    height = 0;
  Object.assign(swiper2, {
    width,
    height,
    size: swiper2.isHorizontal() ? width : height
  });
}
function updateSlides() {
  const swiper2 = this;
  function getDirectionLabel(property) {
    if (swiper2.isHorizontal()) {
      return property;
    }
    return {
      "width": "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      "marginRight": "marginBottom"
    }[property];
  }
  function getDirectionPropertyValue(node, label2) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label2)) || 0);
  }
  const params = swiper2.params;
  const {
    wrapperEl,
    slidesEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper2;
  const isVirtual = swiper2.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper2.virtual.slides.length : swiper2.slides.length;
  const slides = elementChildren(slidesEl, `.${swiper2.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper2.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === "function") {
    offsetBefore = params.slidesOffsetBefore.call(swiper2);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === "function") {
    offsetAfter = params.slidesOffsetAfter.call(swiper2);
  }
  const previousSnapGridLength = swiper2.snapGrid.length;
  const previousSlidesGridLength = swiper2.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === "undefined") {
    return;
  }
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper2.virtualSize = -spaceBetween;
  slides.forEach((slideEl) => {
    if (rtl) {
      slideEl.style.marginLeft = "";
    } else {
      slideEl.style.marginRight = "";
    }
    slideEl.style.marginBottom = "";
    slideEl.style.marginTop = "";
  });
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper2.grid;
  if (gridEnabled) {
    swiper2.grid.initSlides(slidesLength);
  }
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
    return typeof params.breakpoints[key].slidesPerView !== "undefined";
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    let slide2;
    if (slides[i])
      slide2 = slides[i];
    if (gridEnabled) {
      swiper2.grid.updateSlide(i, slide2, slidesLength, getDirectionLabel);
    }
    if (slides[i] && elementStyle(slide2, "display") === "none")
      continue;
    if (params.slidesPerView === "auto") {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel("width")] = ``;
      }
      const slideStyles = getComputedStyle(slide2);
      const currentTransform = slide2.style.transform;
      const currentWebKitTransform = slide2.style.webkitTransform;
      if (currentTransform) {
        slide2.style.transform = "none";
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = "none";
      }
      if (params.roundLengths) {
        slideSize = swiper2.isHorizontal() ? elementOuterSize(slide2, "width", true) : elementOuterSize(slide2, "height", true);
      } else {
        const width = getDirectionPropertyValue(slideStyles, "width");
        const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
        const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
        const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
        const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
        const boxSizing = slideStyles.getPropertyValue("box-sizing");
        if (boxSizing && boxSizing === "border-box") {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide2;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide2.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1e3)
        slidePosition = 0;
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper2.params.slidesPerGroupSkip, index)) % swiper2.params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper2.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper2.virtualSize = Math.max(swiper2.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
    wrapperEl.style.width = `${swiper2.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[getDirectionLabel("width")] = `${swiper2.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper2.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  }
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths)
        slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper2.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper2.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper2.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper2.virtual.slidesBefore + swiper2.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper2.virtual.slidesBefore + swiper2.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper2.virtualSize += size;
    }
  }
  if (snapGrid.length === 0)
    snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper2.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop)
        return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach((slideEl) => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map((snap) => {
      if (snap <= 0)
        return -offsetBefore;
      if (snap > maxSnap)
        return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper2, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper2.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper2.snapGrid[0];
    const addToSlidesGrid = -swiper2.slidesGrid[0];
    swiper2.snapGrid = swiper2.snapGrid.map((v) => v + addToSnapGrid);
    swiper2.slidesGrid = swiper2.slidesGrid.map((v) => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper2.emit("slidesLengthChange");
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper2.params.watchOverflow)
      swiper2.checkOverflow();
    swiper2.emit("snapGridLengthChange");
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper2.emit("slidesGridLengthChange");
  }
  if (params.watchSlidesProgress) {
    swiper2.updateSlidesOffset();
  }
  if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper2.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded)
        swiper2.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper2.el.classList.remove(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  const swiper2 = this;
  const activeSlides = [];
  const isVirtual = swiper2.virtual && swiper2.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === "number") {
    swiper2.setTransition(speed);
  } else if (speed === true) {
    swiper2.setTransition(swiper2.params.speed);
  }
  const getSlideByIndex = (index) => {
    if (isVirtual) {
      return swiper2.slides[swiper2.getSlideIndexByData(index)];
    }
    return swiper2.slides[index];
  };
  if (swiper2.params.slidesPerView !== "auto" && swiper2.params.slidesPerView > 1) {
    if (swiper2.params.centeredSlides) {
      (swiper2.visibleSlides || []).forEach((slide2) => {
        activeSlides.push(slide2);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper2.params.slidesPerView); i += 1) {
        const index = swiper2.activeIndex + i;
        if (index > swiper2.slides.length && !isVirtual)
          break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper2.activeIndex));
  }
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== "undefined") {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }
  if (newHeight || newHeight === 0)
    swiper2.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
  const swiper2 = this;
  const slides = swiper2.slides;
  const minusOffset = swiper2.isElement ? swiper2.isHorizontal() ? swiper2.wrapperEl.offsetLeft : swiper2.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper2.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper2.cssOverflowAdjustment();
  }
}
function updateSlidesProgress(translate2 = this && this.translate || 0) {
  const swiper2 = this;
  const params = swiper2.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper2;
  if (slides.length === 0)
    return;
  if (typeof slides[0].swiperSlideOffset === "undefined")
    swiper2.updateSlidesOffset();
  let offsetCenter = -translate2;
  if (rtl)
    offsetCenter = translate2;
  slides.forEach((slideEl) => {
    slideEl.classList.remove(params.slideVisibleClass);
  });
  swiper2.visibleSlidesIndexes = [];
  swiper2.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper2.size;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide2 = slides[i];
    let slideOffset = slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper2.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper2.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper2.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper2.size - 1 || slideAfter > 1 && slideAfter <= swiper2.size || slideBefore <= 0 && slideAfter >= swiper2.size;
    if (isVisible) {
      swiper2.visibleSlides.push(slide2);
      swiper2.visibleSlidesIndexes.push(i);
      slides[i].classList.add(params.slideVisibleClass);
    }
    slide2.progress = rtl ? -slideProgress : slideProgress;
    slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}
function updateProgress(translate2) {
  const swiper2 = this;
  if (typeof translate2 === "undefined") {
    const multiplier = swiper2.rtlTranslate ? -1 : 1;
    translate2 = swiper2 && swiper2.translate && swiper2.translate * multiplier || 0;
  }
  const params = swiper2.params;
  const translatesDiff = swiper2.maxTranslate() - swiper2.minTranslate();
  let {
    progress: progress2,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper2;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress2 = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress2 = (translate2 - swiper2.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate2 - swiper2.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate2 - swiper2.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress2 <= 0;
    isEnd = isEndRounded || progress2 >= 1;
    if (isBeginningRounded)
      progress2 = 0;
    if (isEndRounded)
      progress2 = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper2.getSlideIndexByData(0);
    const lastSlideIndex = swiper2.getSlideIndexByData(swiper2.slides.length - 1);
    const firstSlideTranslate = swiper2.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper2.slidesGrid[lastSlideIndex];
    const translateMax = swiper2.slidesGrid[swiper2.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate2);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1)
      progressLoop -= 1;
  }
  Object.assign(swiper2, {
    progress: progress2,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight)
    swiper2.updateSlidesProgress(translate2);
  if (isBeginning && !wasBeginning) {
    swiper2.emit("reachBeginning toEdge");
  }
  if (isEnd && !wasEnd) {
    swiper2.emit("reachEnd toEdge");
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper2.emit("fromEdge");
  }
  swiper2.emit("progress", progress2);
}
function updateSlidesClasses() {
  const swiper2 = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper2;
  const isVirtual = swiper2.virtual && params.virtual.enabled;
  const getFilteredSlide = (selector) => {
    return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  slides.forEach((slideEl) => {
    slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
  });
  let activeSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper2.virtual.slidesBefore;
      if (slideIndex < 0)
        slideIndex = swiper2.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper2.virtual.slides.length)
        slideIndex -= swiper2.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    activeSlide = slides[activeIndex];
  }
  if (activeSlide) {
    activeSlide.classList.add(params.slideActiveClass);
    let nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
    if (params.loop && !nextSlide) {
      nextSlide = slides[0];
    }
    if (nextSlide) {
      nextSlide.classList.add(params.slideNextClass);
    }
    let prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
    if (params.loop && !prevSlide === 0) {
      prevSlide = slides[slides.length - 1];
    }
    if (prevSlide) {
      prevSlide.classList.add(params.slidePrevClass);
    }
  }
  swiper2.emitSlidesClasses();
}
const processLazyPreloader = (swiper2, imageEl) => {
  if (!swiper2 || swiper2.destroyed || !swiper2.params)
    return;
  const slideSelector = () => swiper2.isElement ? `swiper-slide` : `.${swiper2.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    const lazyEl = slideEl.querySelector(`.${swiper2.params.lazyPreloaderClass}`);
    if (lazyEl)
      lazyEl.remove();
  }
};
const unlazy = (swiper2, index) => {
  if (!swiper2.slides[index])
    return;
  const imageEl = swiper2.slides[index].querySelector('[loading="lazy"]');
  if (imageEl)
    imageEl.removeAttribute("loading");
};
const preload = (swiper2) => {
  if (!swiper2 || swiper2.destroyed || !swiper2.params)
    return;
  let amount = swiper2.params.lazyPreloadPrevNext;
  const len = swiper2.slides.length;
  if (!len || !amount || amount < 0)
    return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper2.params.slidesPerView === "auto" ? swiper2.slidesPerViewDynamic() : Math.ceil(swiper2.params.slidesPerView);
  const activeIndex = swiper2.activeIndex;
  if (swiper2.params.grid && swiper2.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper2.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column))
        unlazy(swiper2, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper2.params.rewind || swiper2.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView)
        unlazy(swiper2, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper2, i);
      }
    }
  }
};
function getActiveIndexByTranslate(swiper2) {
  const {
    slidesGrid,
    params
  } = swiper2;
  const translate2 = swiper2.rtlTranslate ? swiper2.translate : -swiper2.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== "undefined") {
      if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate2 >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === "undefined")
      activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper2 = this;
  const translate2 = swiper2.rtlTranslate ? swiper2.translate : -swiper2.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper2;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = (aIndex) => {
    let realIndex2 = aIndex - swiper2.virtual.slidesBefore;
    if (realIndex2 < 0) {
      realIndex2 = swiper2.virtual.slides.length + realIndex2;
    }
    if (realIndex2 >= swiper2.virtual.slides.length) {
      realIndex2 -= swiper2.virtual.slides.length;
    }
    return realIndex2;
  };
  if (typeof activeIndex === "undefined") {
    activeIndex = getActiveIndexByTranslate(swiper2);
  }
  if (snapGrid.indexOf(translate2) >= 0) {
    snapIndex = snapGrid.indexOf(translate2);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper2.snapIndex = snapIndex;
      swiper2.emit("snapIndexChange");
    }
    if (swiper2.params.loop && swiper2.virtual && swiper2.params.virtual.enabled) {
      swiper2.realIndex = getVirtualRealIndex(activeIndex);
    }
    return;
  }
  let realIndex;
  if (swiper2.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (swiper2.slides[activeIndex]) {
    realIndex = parseInt(swiper2.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper2, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper2.initialized) {
    preload(swiper2);
  }
  swiper2.emit("activeIndexChange");
  swiper2.emit("snapIndexChange");
  if (previousRealIndex !== realIndex) {
    swiper2.emit("realIndexChange");
  }
  if (swiper2.initialized || swiper2.params.runCallbacksOnInit) {
    swiper2.emit("slideChange");
  }
}
function updateClickedSlide(e) {
  const swiper2 = this;
  const params = swiper2.params;
  const slide2 = e.closest(`.${params.slideClass}, swiper-slide`);
  let slideFound = false;
  let slideIndex;
  if (slide2) {
    for (let i = 0; i < swiper2.slides.length; i += 1) {
      if (swiper2.slides[i] === slide2) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide2 && slideFound) {
    swiper2.clickedSlide = slide2;
    if (swiper2.virtual && swiper2.params.virtual.enabled) {
      swiper2.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
    } else {
      swiper2.clickedIndex = slideIndex;
    }
  } else {
    swiper2.clickedSlide = void 0;
    swiper2.clickedIndex = void 0;
    return;
  }
  if (params.slideToClickedSlide && swiper2.clickedIndex !== void 0 && swiper2.clickedIndex !== swiper2.activeIndex) {
    swiper2.slideToClickedSlide();
  }
}
const update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
  const swiper2 = this;
  const {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    wrapperEl
  } = swiper2;
  if (params.virtualTranslate) {
    return rtl ? -translate2 : translate2;
  }
  if (params.cssMode) {
    return translate2;
  }
  let currentTranslate = getTranslate(wrapperEl, axis);
  currentTranslate += swiper2.cssOverflowAdjustment();
  if (rtl)
    currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper2 = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress: progress2
  } = swiper2;
  let x = 0;
  let y = 0;
  const z2 = 0;
  if (swiper2.isHorizontal()) {
    x = rtl ? -translate2 : translate2;
  } else {
    y = translate2;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper2.previousTranslate = swiper2.translate;
  swiper2.translate = swiper2.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper2.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper2.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper2.isHorizontal()) {
      x -= swiper2.cssOverflowAdjustment();
    } else {
      y -= swiper2.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z2}px)`;
  }
  let newProgress;
  const translatesDiff = swiper2.maxTranslate() - swiper2.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate2 - swiper2.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress2) {
    swiper2.updateProgress(translate2);
  }
  swiper2.emit("setTranslate", swiper2.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2 = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper2 = this;
  const {
    params,
    wrapperEl
  } = swiper2;
  if (swiper2.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate2 = swiper2.minTranslate();
  const maxTranslate2 = swiper2.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2)
    newTranslate = minTranslate2;
  else if (translateBounds && translate2 < maxTranslate2)
    newTranslate = maxTranslate2;
  else
    newTranslate = translate2;
  swiper2.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper2.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    } else {
      if (!swiper2.support.smoothScroll) {
        animateCSSModeScroll({
          swiper: swiper2,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper2.setTransition(0);
    swiper2.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper2.emit("beforeTransitionStart", speed, internal);
      swiper2.emit("transitionEnd");
    }
  } else {
    swiper2.setTransition(speed);
    swiper2.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper2.emit("beforeTransitionStart", speed, internal);
      swiper2.emit("transitionStart");
    }
    if (!swiper2.animating) {
      swiper2.animating = true;
      if (!swiper2.onTranslateToWrapperTransitionEnd) {
        swiper2.onTranslateToWrapperTransitionEnd = function transitionEnd2(e) {
          if (!swiper2 || swiper2.destroyed)
            return;
          if (e.target !== this)
            return;
          swiper2.wrapperEl.removeEventListener("transitionend", swiper2.onTranslateToWrapperTransitionEnd);
          swiper2.onTranslateToWrapperTransitionEnd = null;
          delete swiper2.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper2.emit("transitionEnd");
          }
        };
      }
      swiper2.wrapperEl.addEventListener("transitionend", swiper2.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
const translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper2 = this;
  if (!swiper2.params.cssMode) {
    swiper2.wrapperEl.style.transitionDuration = `${duration}ms`;
  }
  swiper2.emit("setTransition", duration, byController);
}
function transitionEmit({
  swiper: swiper2,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper2;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex)
      dir = "next";
    else if (activeIndex < previousIndex)
      dir = "prev";
    else
      dir = "reset";
  }
  swiper2.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === "reset") {
      swiper2.emit(`slideResetTransition${step}`);
      return;
    }
    swiper2.emit(`slideChangeTransition${step}`);
    if (dir === "next") {
      swiper2.emit(`slideNextTransition${step}`);
    } else {
      swiper2.emit(`slidePrevTransition${step}`);
    }
  }
}
function transitionStart(runCallbacks = true, direction) {
  const swiper2 = this;
  const {
    params
  } = swiper2;
  if (params.cssMode)
    return;
  if (params.autoHeight) {
    swiper2.updateAutoHeight();
  }
  transitionEmit({
    swiper: swiper2,
    runCallbacks,
    direction,
    step: "Start"
  });
}
function transitionEnd(runCallbacks = true, direction) {
  const swiper2 = this;
  const {
    params
  } = swiper2;
  swiper2.animating = false;
  if (params.cssMode)
    return;
  swiper2.setTransition(0);
  transitionEmit({
    swiper: swiper2,
    runCallbacks,
    direction,
    step: "End"
  });
}
const transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index === "string") {
    index = parseInt(index, 10);
  }
  const swiper2 = this;
  let slideIndex = index;
  if (slideIndex < 0)
    slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper2;
  if (swiper2.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }
  const skip = Math.min(swiper2.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper2.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  const translate2 = -snapGrid[snapIndex];
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== "undefined") {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  if (swiper2.initialized && slideIndex !== activeIndex) {
    if (!swiper2.allowSlideNext && (rtl ? translate2 > swiper2.translate && translate2 > swiper2.minTranslate() : translate2 < swiper2.translate && translate2 < swiper2.minTranslate())) {
      return false;
    }
    if (!swiper2.allowSlidePrev && translate2 > swiper2.translate && translate2 > swiper2.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper2.emit("beforeSlideChangeStart");
  }
  swiper2.updateProgress(translate2);
  let direction;
  if (slideIndex > activeIndex)
    direction = "next";
  else if (slideIndex < activeIndex)
    direction = "prev";
  else
    direction = "reset";
  if (rtl && -translate2 === swiper2.translate || !rtl && translate2 === swiper2.translate) {
    swiper2.updateActiveIndex(slideIndex);
    if (params.autoHeight) {
      swiper2.updateAutoHeight();
    }
    swiper2.updateSlidesClasses();
    if (params.effect !== "slide") {
      swiper2.setTranslate(translate2);
    }
    if (direction !== "reset") {
      swiper2.transitionStart(runCallbacks, direction);
      swiper2.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper2.isHorizontal();
    const t = rtl ? translate2 : -translate2;
    if (speed === 0) {
      const isVirtual = swiper2.virtual && swiper2.params.virtual.enabled;
      if (isVirtual) {
        swiper2.wrapperEl.style.scrollSnapType = "none";
        swiper2._immediateVirtual = true;
      }
      if (isVirtual && !swiper2._cssModeVirtualInitialSet && swiper2.params.initialSlide > 0) {
        swiper2._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        });
      } else {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper2.wrapperEl.style.scrollSnapType = "";
          swiper2._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper2.support.smoothScroll) {
        animateCSSModeScroll({
          swiper: swiper2,
          targetPosition: t,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t,
        behavior: "smooth"
      });
    }
    return true;
  }
  swiper2.setTransition(speed);
  swiper2.setTranslate(translate2);
  swiper2.updateActiveIndex(slideIndex);
  swiper2.updateSlidesClasses();
  swiper2.emit("beforeTransitionStart", speed, internal);
  swiper2.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper2.transitionEnd(runCallbacks, direction);
  } else if (!swiper2.animating) {
    swiper2.animating = true;
    if (!swiper2.onSlideToWrapperTransitionEnd) {
      swiper2.onSlideToWrapperTransitionEnd = function transitionEnd2(e) {
        if (!swiper2 || swiper2.destroyed)
          return;
        if (e.target !== this)
          return;
        swiper2.wrapperEl.removeEventListener("transitionend", swiper2.onSlideToWrapperTransitionEnd);
        swiper2.onSlideToWrapperTransitionEnd = null;
        delete swiper2.onSlideToWrapperTransitionEnd;
        swiper2.transitionEnd(runCallbacks, direction);
      };
    }
    swiper2.wrapperEl.addEventListener("transitionend", swiper2.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index === "string") {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper2 = this;
  let newIndex = index;
  if (swiper2.params.loop) {
    if (swiper2.virtual && swiper2.params.virtual.enabled) {
      newIndex = newIndex + swiper2.virtual.slidesBefore;
    } else {
      newIndex = swiper2.getSlideIndexByData(newIndex);
    }
  }
  return swiper2.slideTo(newIndex, speed, runCallbacks, internal);
}
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper2 = this;
  const {
    enabled,
    params,
    animating
  } = swiper2;
  if (!enabled)
    return swiper2;
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper2.slidesPerViewDynamic("current", true), 1);
  }
  const increment = swiper2.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper2.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding)
      return false;
    swiper2.loopFix({
      direction: "next"
    });
    swiper2._clientLeft = swiper2.wrapperEl.clientLeft;
  }
  if (params.rewind && swiper2.isEnd) {
    return swiper2.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper2.slideTo(swiper2.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper2 = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper2;
  if (!enabled)
    return swiper2;
  const isVirtual = swiper2.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding)
      return false;
    swiper2.loopFix({
      direction: "prev"
    });
    swiper2._clientLeft = swiper2.wrapperEl.clientLeft;
  }
  const translate2 = rtlTranslate ? swiper2.translate : -swiper2.translate;
  function normalize(val) {
    if (val < 0)
      return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate2);
  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === "undefined" && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== "undefined") {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== "undefined") {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0)
      prevIndex = swiper2.activeIndex - 1;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper2.slidesPerViewDynamic("previous", true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper2.isBeginning) {
    const lastIndex = swiper2.params.virtual && swiper2.params.virtual.enabled && swiper2.virtual ? swiper2.virtual.slides.length - 1 : swiper2.slides.length - 1;
    return swiper2.slideTo(lastIndex, speed, runCallbacks, internal);
  }
  return swiper2.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper2 = this;
  return swiper2.slideTo(swiper2.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper2 = this;
  let index = swiper2.activeIndex;
  const skip = Math.min(swiper2.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper2.params.slidesPerGroup);
  const translate2 = swiper2.rtlTranslate ? swiper2.translate : -swiper2.translate;
  if (translate2 >= swiper2.snapGrid[snapIndex]) {
    const currentSnap = swiper2.snapGrid[snapIndex];
    const nextSnap = swiper2.snapGrid[snapIndex + 1];
    if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper2.params.slidesPerGroup;
    }
  } else {
    const prevSnap = swiper2.snapGrid[snapIndex - 1];
    const currentSnap = swiper2.snapGrid[snapIndex];
    if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper2.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper2.slidesGrid.length - 1);
  return swiper2.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper2 = this;
  const {
    params,
    slidesEl
  } = swiper2;
  const slidesPerView = params.slidesPerView === "auto" ? swiper2.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper2.clickedIndex;
  let realIndex;
  const slideSelector = swiper2.isElement ? `swiper-slide` : `.${params.slideClass}`;
  if (params.loop) {
    if (swiper2.animating)
      return;
    realIndex = parseInt(swiper2.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper2.loopedSlides - slidesPerView / 2 || slideToIndex > swiper2.slides.length - swiper2.loopedSlides + slidesPerView / 2) {
        swiper2.loopFix();
        slideToIndex = swiper2.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper2.slideTo(slideToIndex);
        });
      } else {
        swiper2.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper2.slides.length - slidesPerView) {
      swiper2.loopFix();
      slideToIndex = swiper2.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      nextTick(() => {
        swiper2.slideTo(slideToIndex);
      });
    } else {
      swiper2.slideTo(slideToIndex);
    }
  } else {
    swiper2.slideTo(slideToIndex);
  }
}
const slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(slideRealIndex) {
  const swiper2 = this;
  const {
    params,
    slidesEl
  } = swiper2;
  if (!params.loop || swiper2.virtual && swiper2.params.virtual.enabled)
    return;
  const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  slides.forEach((el, index) => {
    el.setAttribute("data-swiper-slide-index", index);
  });
  swiper2.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? void 0 : "next"
  });
}
function loopFix({
  slideRealIndex,
  slideTo: slideTo2 = true,
  direction,
  setTranslate: setTranslate2,
  activeSlideIndex,
  byController,
  byMousewheel
} = {}) {
  const swiper2 = this;
  if (!swiper2.params.loop)
    return;
  swiper2.emit("beforeLoopFix");
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper2;
  swiper2.allowSlidePrev = true;
  swiper2.allowSlideNext = true;
  if (swiper2.virtual && params.virtual.enabled) {
    if (slideTo2) {
      if (!params.centeredSlides && swiper2.snapIndex === 0) {
        swiper2.slideTo(swiper2.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper2.snapIndex < params.slidesPerView) {
        swiper2.slideTo(swiper2.virtual.slides.length + swiper2.snapIndex, 0, false, true);
      } else if (swiper2.snapIndex === swiper2.snapGrid.length - 1) {
        swiper2.slideTo(swiper2.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper2.allowSlidePrev = allowSlidePrev;
    swiper2.allowSlideNext = allowSlideNext;
    swiper2.emit("loopFix");
    return;
  }
  const slidesPerView = params.slidesPerView === "auto" ? swiper2.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
  let loopedSlides = params.loopedSlides || slidesPerView;
  if (loopedSlides % params.slidesPerGroup !== 0) {
    loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
  }
  swiper2.loopedSlides = loopedSlides;
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  let activeIndex = swiper2.activeIndex;
  if (typeof activeSlideIndex === "undefined") {
    activeSlideIndex = swiper2.getSlideIndex(swiper2.slides.filter((el) => el.classList.contains(params.slideActiveClass))[0]);
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === "next" || !direction;
  const isPrev = direction === "prev" || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  if (activeSlideIndex < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeSlideIndex; i += 1) {
      const index = i - Math.floor(i / slides.length) * slides.length;
      prependSlidesIndexes.push(slides.length - index - 1);
    }
  } else if (activeSlideIndex > swiper2.slides.length - loopedSlides * 2) {
    slidesAppended = Math.max(activeSlideIndex - (swiper2.slides.length - loopedSlides * 2), params.slidesPerGroup);
    for (let i = 0; i < slidesAppended; i += 1) {
      const index = i - Math.floor(i / slides.length) * slides.length;
      appendSlidesIndexes.push(index);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach((index) => {
      swiper2.slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(swiper2.slides[index]);
      swiper2.slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach((index) => {
      swiper2.slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(swiper2.slides[index]);
      swiper2.slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper2.recalcSlides();
  if (params.slidesPerView === "auto") {
    swiper2.updateSlides();
  }
  if (params.watchSlidesProgress) {
    swiper2.updateSlidesOffset();
  }
  if (slideTo2) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper2.slidesGrid[activeIndex];
        const newSlideTranslate = swiper2.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper2.setTranslate(swiper2.translate - diff);
        } else {
          swiper2.slideTo(activeIndex + slidesPrepended, 0, false, true);
          if (setTranslate2) {
            swiper2.touches[swiper2.isHorizontal() ? "startX" : "startY"] += diff;
          }
        }
      } else {
        if (setTranslate2) {
          swiper2.slideToLoop(slideRealIndex, 0, false, true);
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper2.slidesGrid[activeIndex];
        const newSlideTranslate = swiper2.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper2.setTranslate(swiper2.translate - diff);
        } else {
          swiper2.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate2) {
            swiper2.touches[swiper2.isHorizontal() ? "startX" : "startY"] += diff;
          }
        }
      } else {
        swiper2.slideToLoop(slideRealIndex, 0, false, true);
      }
    }
  }
  swiper2.allowSlidePrev = allowSlidePrev;
  swiper2.allowSlideNext = allowSlideNext;
  if (swiper2.controller && swiper2.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      slideTo: false,
      direction,
      setTranslate: setTranslate2,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper2.controller.control)) {
      swiper2.controller.control.forEach((c) => {
        if (!c.destroyed && c.params.loop)
          c.loopFix(loopParams);
      });
    } else if (swiper2.controller.control instanceof swiper2.constructor && swiper2.controller.control.params.loop) {
      swiper2.controller.control.loopFix(loopParams);
    }
  }
  swiper2.emit("loopFix");
}
function loopDestroy() {
  const swiper2 = this;
  const {
    params,
    slidesEl
  } = swiper2;
  if (!params.loop || swiper2.virtual && swiper2.params.virtual.enabled)
    return;
  swiper2.recalcSlides();
  const newSlidesOrder = [];
  swiper2.slides.forEach((slideEl) => {
    const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper2.slides.forEach((slideEl) => {
    slideEl.removeAttribute("data-swiper-slide-index");
  });
  newSlidesOrder.forEach((slideEl) => {
    slidesEl.append(slideEl);
  });
  swiper2.recalcSlides();
  swiper2.slideTo(swiper2.realIndex, 0);
}
const loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper2 = this;
  if (!swiper2.params.simulateTouch || swiper2.params.watchOverflow && swiper2.isLocked || swiper2.params.cssMode)
    return;
  const el = swiper2.params.touchEventsTarget === "container" ? swiper2.el : swiper2.wrapperEl;
  if (swiper2.isElement) {
    swiper2.__preventObserver__ = true;
  }
  el.style.cursor = "move";
  el.style.cursor = moving ? "grabbing" : "grab";
  if (swiper2.isElement) {
    requestAnimationFrame(() => {
      swiper2.__preventObserver__ = false;
    });
  }
}
function unsetGrabCursor() {
  const swiper2 = this;
  if (swiper2.params.watchOverflow && swiper2.isLocked || swiper2.params.cssMode) {
    return;
  }
  if (swiper2.isElement) {
    swiper2.__preventObserver__ = true;
  }
  swiper2[swiper2.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
  if (swiper2.isElement) {
    requestAnimationFrame(() => {
      swiper2.__preventObserver__ = false;
    });
  }
}
const grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow())
      return null;
    if (el.assignedSlot)
      el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function onTouchStart(event) {
  const swiper2 = this;
  const document2 = getDocument();
  const window2 = getWindow();
  const data2 = swiper2.touchEventsData;
  data2.evCache.push(event);
  const {
    params,
    touches,
    enabled
  } = swiper2;
  if (!enabled)
    return;
  if (!params.simulateTouch && event.pointerType === "mouse")
    return;
  if (swiper2.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper2.animating && params.cssMode && params.loop) {
    swiper2.loopFix();
  }
  let e = event;
  if (e.originalEvent)
    e = e.originalEvent;
  let targetEl = e.target;
  if (params.touchEventsTarget === "wrapper") {
    if (!swiper2.wrapperEl.contains(targetEl))
      return;
  }
  if ("which" in e && e.which === 3)
    return;
  if ("button" in e && e.button > 0)
    return;
  if (data2.isTouched && data2.isMoved)
    return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
  const eventPath = event.composedPath ? event.composedPath() : event.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper2.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler))
      return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;
  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === "prevent") {
      event.preventDefault();
    } else {
      return;
    }
  }
  Object.assign(data2, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: void 0,
    startMoving: void 0
  });
  touches.startX = startX;
  touches.startY = startY;
  data2.touchStartTime = now();
  swiper2.allowClick = true;
  swiper2.updateSize();
  swiper2.swipeDirection = void 0;
  if (params.threshold > 0)
    data2.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data2.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === "SELECT") {
      data2.isTouched = false;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data2.focusableElements) && document2.activeElement !== targetEl) {
    document2.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper2.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper2.freeMode && swiper2.animating && !params.cssMode) {
    swiper2.freeMode.onTouchStart();
  }
  swiper2.emit("touchStart", e);
}
function onTouchMove(event) {
  const document2 = getDocument();
  const swiper2 = this;
  const data2 = swiper2.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper2;
  if (!enabled)
    return;
  if (!params.simulateTouch && event.pointerType === "mouse")
    return;
  let e = event;
  if (e.originalEvent)
    e = e.originalEvent;
  if (!data2.isTouched) {
    if (data2.startMoving && data2.isScrolling) {
      swiper2.emit("touchMoveOpposite", e);
    }
    return;
  }
  const pointerIndex = data2.evCache.findIndex((cachedEv) => cachedEv.pointerId === e.pointerId);
  if (pointerIndex >= 0)
    data2.evCache[pointerIndex] = e;
  const targetTouch = data2.evCache.length > 1 ? data2.evCache[0] : e;
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper2.allowTouchMove) {
    if (!e.target.matches(data2.focusableElements)) {
      swiper2.allowClick = false;
    }
    if (data2.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        prevX: swiper2.touches.currentX,
        prevY: swiper2.touches.currentY,
        currentX: pageX,
        currentY: pageY
      });
      data2.touchStartTime = now();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper2.isVertical()) {
      if (pageY < touches.startY && swiper2.translate <= swiper2.maxTranslate() || pageY > touches.startY && swiper2.translate >= swiper2.minTranslate()) {
        data2.isTouched = false;
        data2.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper2.translate <= swiper2.maxTranslate() || pageX > touches.startX && swiper2.translate >= swiper2.minTranslate()) {
      return;
    }
  }
  if (document2.activeElement) {
    if (e.target === document2.activeElement && e.target.matches(data2.focusableElements)) {
      data2.isMoved = true;
      swiper2.allowClick = false;
      return;
    }
  }
  if (data2.allowTouchCallbacks) {
    swiper2.emit("touchMove", e);
  }
  if (e.targetTouches && e.targetTouches.length > 1)
    return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper2.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper2.params.threshold)
    return;
  if (typeof data2.isScrolling === "undefined") {
    let touchAngle;
    if (swiper2.isHorizontal() && touches.currentY === touches.startY || swiper2.isVertical() && touches.currentX === touches.startX) {
      data2.isScrolling = false;
    } else {
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data2.isScrolling = swiper2.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data2.isScrolling) {
    swiper2.emit("touchMoveOpposite", e);
  }
  if (typeof data2.startMoving === "undefined") {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data2.startMoving = true;
    }
  }
  if (data2.isScrolling || swiper2.zoom && swiper2.params.zoom && swiper2.params.zoom.enabled && data2.evCache.length > 1) {
    data2.isTouched = false;
    return;
  }
  if (!data2.startMoving) {
    return;
  }
  swiper2.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper2.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper2.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper2.touchesDirection;
  swiper2.swipeDirection = diff > 0 ? "prev" : "next";
  swiper2.touchesDirection = touchesDiff > 0 ? "prev" : "next";
  const isLoop = swiper2.params.loop && !params.cssMode;
  if (!data2.isMoved) {
    if (isLoop) {
      swiper2.loopFix({
        direction: swiper2.swipeDirection
      });
    }
    data2.startTranslate = swiper2.getTranslate();
    swiper2.setTransition(0);
    if (swiper2.animating) {
      const evt = new window.CustomEvent("transitionend", {
        bubbles: true,
        cancelable: true
      });
      swiper2.wrapperEl.dispatchEvent(evt);
    }
    data2.allowMomentumBounce = false;
    if (params.grabCursor && (swiper2.allowSlideNext === true || swiper2.allowSlidePrev === true)) {
      swiper2.setGrabCursor(true);
    }
    swiper2.emit("sliderFirstMove", e);
  }
  let loopFixed;
  if (data2.isMoved && prevTouchesDirection !== swiper2.touchesDirection && isLoop && Math.abs(diff) >= 1) {
    swiper2.loopFix({
      direction: swiper2.swipeDirection,
      setTranslate: true
    });
    loopFixed = true;
  }
  swiper2.emit("sliderMove", e);
  data2.isMoved = true;
  data2.currentTranslate = diff + data2.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && !loopFixed && data2.currentTranslate > (params.centeredSlides ? swiper2.minTranslate() - swiper2.size / 2 : swiper2.minTranslate())) {
      swiper2.loopFix({
        direction: "prev",
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data2.currentTranslate > swiper2.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data2.currentTranslate = swiper2.minTranslate() - 1 + (-swiper2.minTranslate() + data2.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && !loopFixed && data2.currentTranslate < (params.centeredSlides ? swiper2.maxTranslate() + swiper2.size / 2 : swiper2.maxTranslate())) {
      swiper2.loopFix({
        direction: "next",
        setTranslate: true,
        activeSlideIndex: swiper2.slides.length - (params.slidesPerView === "auto" ? swiper2.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data2.currentTranslate < swiper2.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data2.currentTranslate = swiper2.maxTranslate() + 1 - (swiper2.maxTranslate() - data2.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }
  if (!swiper2.allowSlideNext && swiper2.swipeDirection === "next" && data2.currentTranslate < data2.startTranslate) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (!swiper2.allowSlidePrev && swiper2.swipeDirection === "prev" && data2.currentTranslate > data2.startTranslate) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (!swiper2.allowSlidePrev && !swiper2.allowSlideNext) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data2.allowThresholdMove) {
      if (!data2.allowThresholdMove) {
        data2.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data2.currentTranslate = data2.startTranslate;
        touches.diff = swiper2.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data2.currentTranslate = data2.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode)
    return;
  if (params.freeMode && params.freeMode.enabled && swiper2.freeMode || params.watchSlidesProgress) {
    swiper2.updateActiveIndex();
    swiper2.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper2.freeMode) {
    swiper2.freeMode.onTouchMove();
  }
  swiper2.updateProgress(data2.currentTranslate);
  swiper2.setTranslate(data2.currentTranslate);
}
function onTouchEnd(event) {
  const swiper2 = this;
  const data2 = swiper2.touchEventsData;
  const pointerIndex = data2.evCache.findIndex((cachedEv) => cachedEv.pointerId === event.pointerId);
  if (pointerIndex >= 0) {
    data2.evCache.splice(pointerIndex, 1);
  }
  if (["pointercancel", "pointerout", "pointerleave"].includes(event.type)) {
    const proceed = event.type === "pointercancel" && (swiper2.browser.isSafari || swiper2.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper2;
  if (!enabled)
    return;
  if (!params.simulateTouch && event.pointerType === "mouse")
    return;
  let e = event;
  if (e.originalEvent)
    e = e.originalEvent;
  if (data2.allowTouchCallbacks) {
    swiper2.emit("touchEnd", e);
  }
  data2.allowTouchCallbacks = false;
  if (!data2.isTouched) {
    if (data2.isMoved && params.grabCursor) {
      swiper2.setGrabCursor(false);
    }
    data2.isMoved = false;
    data2.startMoving = false;
    return;
  }
  if (params.grabCursor && data2.isMoved && data2.isTouched && (swiper2.allowSlideNext === true || swiper2.allowSlidePrev === true)) {
    swiper2.setGrabCursor(false);
  }
  const touchEndTime = now();
  const timeDiff = touchEndTime - data2.touchStartTime;
  if (swiper2.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper2.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper2.emit("tap click", e);
    if (timeDiff < 300 && touchEndTime - data2.lastClickTime < 300) {
      swiper2.emit("doubleTap doubleClick", e);
    }
  }
  data2.lastClickTime = now();
  nextTick(() => {
    if (!swiper2.destroyed)
      swiper2.allowClick = true;
  });
  if (!data2.isTouched || !data2.isMoved || !swiper2.swipeDirection || touches.diff === 0 || data2.currentTranslate === data2.startTranslate) {
    data2.isTouched = false;
    data2.isMoved = false;
    data2.startMoving = false;
    return;
  }
  data2.isTouched = false;
  data2.isMoved = false;
  data2.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper2.translate : -swiper2.translate;
  } else {
    currentPos = -data2.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper2.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  let stopIndex = 0;
  let groupSize = swiper2.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment2] !== "undefined") {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment2]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment2] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper2.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper2.virtual ? swiper2.virtual.slides.length - 1 : swiper2.slides.length - 1;
    } else if (swiper2.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper2.slideTo(swiper2.activeIndex);
      return;
    }
    if (swiper2.swipeDirection === "next") {
      if (ratio >= params.longSwipesRatio)
        swiper2.slideTo(params.rewind && swiper2.isEnd ? rewindFirstIndex : stopIndex + increment);
      else
        swiper2.slideTo(stopIndex);
    }
    if (swiper2.swipeDirection === "prev") {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper2.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper2.slideTo(rewindLastIndex);
      } else {
        swiper2.slideTo(stopIndex);
      }
    }
  } else {
    if (!params.shortSwipes) {
      swiper2.slideTo(swiper2.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper2.navigation && (e.target === swiper2.navigation.nextEl || e.target === swiper2.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper2.swipeDirection === "next") {
        swiper2.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper2.swipeDirection === "prev") {
        swiper2.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper2.navigation.nextEl) {
      swiper2.slideTo(stopIndex + increment);
    } else {
      swiper2.slideTo(stopIndex);
    }
  }
}
function onResize() {
  const swiper2 = this;
  const {
    params,
    el
  } = swiper2;
  if (el && el.offsetWidth === 0)
    return;
  if (params.breakpoints) {
    swiper2.setBreakpoint();
  }
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper2;
  const isVirtual = swiper2.virtual && swiper2.params.virtual.enabled;
  swiper2.allowSlideNext = true;
  swiper2.allowSlidePrev = true;
  swiper2.updateSize();
  swiper2.updateSlides();
  swiper2.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper2.isEnd && !swiper2.isBeginning && !swiper2.params.centeredSlides && !isVirtualLoop) {
    swiper2.slideTo(swiper2.slides.length - 1, 0, false, true);
  } else {
    if (swiper2.params.loop && !isVirtual) {
      swiper2.slideToLoop(swiper2.realIndex, 0, false, true);
    } else {
      swiper2.slideTo(swiper2.activeIndex, 0, false, true);
    }
  }
  if (swiper2.autoplay && swiper2.autoplay.running && swiper2.autoplay.paused) {
    clearTimeout(swiper2.autoplay.resizeTimeout);
    swiper2.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper2.autoplay && swiper2.autoplay.running && swiper2.autoplay.paused) {
        swiper2.autoplay.resume();
      }
    }, 500);
  }
  swiper2.allowSlidePrev = allowSlidePrev;
  swiper2.allowSlideNext = allowSlideNext;
  if (swiper2.params.watchOverflow && snapGrid !== swiper2.snapGrid) {
    swiper2.checkOverflow();
  }
}
function onClick(e) {
  const swiper2 = this;
  if (!swiper2.enabled)
    return;
  if (!swiper2.allowClick) {
    if (swiper2.params.preventClicks)
      e.preventDefault();
    if (swiper2.params.preventClicksPropagation && swiper2.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  const swiper2 = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper2;
  if (!enabled)
    return;
  swiper2.previousTranslate = swiper2.translate;
  if (swiper2.isHorizontal()) {
    swiper2.translate = -wrapperEl.scrollLeft;
  } else {
    swiper2.translate = -wrapperEl.scrollTop;
  }
  if (swiper2.translate === 0)
    swiper2.translate = 0;
  swiper2.updateActiveIndex();
  swiper2.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper2.maxTranslate() - swiper2.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper2.translate - swiper2.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper2.progress) {
    swiper2.updateProgress(rtlTranslate ? -swiper2.translate : swiper2.translate);
  }
  swiper2.emit("setTranslate", swiper2.translate, false);
}
function onLoad(e) {
  const swiper2 = this;
  processLazyPreloader(swiper2, e.target);
  if (swiper2.params.cssMode || swiper2.params.slidesPerView !== "auto" && !swiper2.params.autoHeight) {
    return;
  }
  swiper2.update();
}
let dummyEventAttached = false;
function dummyEventListener() {
}
const events = (swiper2, method) => {
  const document2 = getDocument();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper2;
  const capture = !!params.nested;
  const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
  const swiperMethod = method;
  el[domMethod]("pointerdown", swiper2.onTouchStart, {
    passive: false
  });
  document2[domMethod]("pointermove", swiper2.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("pointerup", swiper2.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointercancel", swiper2.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerout", swiper2.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerleave", swiper2.onTouchEnd, {
    passive: true
  });
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]("click", swiper2.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]("scroll", swiper2.onScroll);
  }
  if (params.updateOnWindowResize) {
    swiper2[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
  } else {
    swiper2[swiperMethod]("observerUpdate", onResize, true);
  }
  el[domMethod]("load", swiper2.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper2 = this;
  const document2 = getDocument();
  const {
    params
  } = swiper2;
  swiper2.onTouchStart = onTouchStart.bind(swiper2);
  swiper2.onTouchMove = onTouchMove.bind(swiper2);
  swiper2.onTouchEnd = onTouchEnd.bind(swiper2);
  if (params.cssMode) {
    swiper2.onScroll = onScroll.bind(swiper2);
  }
  swiper2.onClick = onClick.bind(swiper2);
  swiper2.onLoad = onLoad.bind(swiper2);
  if (!dummyEventAttached) {
    document2.addEventListener("touchstart", dummyEventListener);
    dummyEventAttached = true;
  }
  events(swiper2, "on");
}
function detachEvents() {
  const swiper2 = this;
  events(swiper2, "off");
}
const events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (swiper2, params) => {
  return swiper2.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper2 = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper2;
  const breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0)
    return;
  const breakpoint = swiper2.getBreakpoint(breakpoints2, swiper2.params.breakpointsBase, swiper2.el);
  if (!breakpoint || swiper2.currentBreakpoint === breakpoint)
    return;
  const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
  const breakpointParams = breakpointOnlyParams || swiper2.originalParams;
  const wasMultiRow = isGridEnabled(swiper2, params);
  const isMultiRow = isGridEnabled(swiper2, breakpointParams);
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper2.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper2.emitContainerClasses();
  }
  ["navigation", "pagination", "scrollbar"].forEach((prop) => {
    if (typeof breakpointParams[prop] === "undefined")
      return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper2[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper2[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  if (directionChanged && initialized) {
    swiper2.changeDirection();
  }
  extend$1(swiper2.params, breakpointParams);
  const isEnabled = swiper2.params.enabled;
  Object.assign(swiper2, {
    allowTouchMove: swiper2.params.allowTouchMove,
    allowSlideNext: swiper2.params.allowSlideNext,
    allowSlidePrev: swiper2.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper2.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper2.enable();
  }
  swiper2.currentBreakpoint = breakpoint;
  swiper2.emit("_beforeBreakpoint", breakpointParams);
  if (needsReLoop && initialized) {
    swiper2.loopDestroy();
    swiper2.loopCreate(realIndex);
    swiper2.updateSlides();
  }
  swiper2.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base = "window", containerEl) {
  if (!breakpoints2 || base === "container" && !containerEl)
    return void 0;
  let breakpoint = false;
  const window2 = getWindow();
  const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints2).map((point) => {
    if (typeof point === "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value2 = currentHeight * minRatio;
      return {
        value: value2,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value: value2
    } = points[i];
    if (base === "window") {
      if (window2.matchMedia(`(min-width: ${value2}px)`).matches) {
        breakpoint = point;
      }
    } else if (value2 <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || "max";
}
const breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach((item2) => {
    if (typeof item2 === "object") {
      Object.keys(item2).forEach((classNames2) => {
        if (item2[classNames2]) {
          resultClasses.push(prefix + classNames2);
        }
      });
    } else if (typeof item2 === "string") {
      resultClasses.push(prefix + item2);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper2 = this;
  const {
    classNames: classNames2,
    params,
    rtl,
    el,
    device
  } = swiper2;
  const suffixes = prepareClasses(["initialized", params.direction, {
    "free-mode": swiper2.params.freeMode && params.freeMode.enabled
  }, {
    "autoheight": params.autoHeight
  }, {
    "rtl": rtl
  }, {
    "grid": params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    "android": device.android
  }, {
    "ios": device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    "centered": params.cssMode && params.centeredSlides
  }, {
    "watch-progress": params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames2.push(...suffixes);
  el.classList.add(...classNames2);
  swiper2.emitContainerClasses();
}
function removeClasses() {
  const swiper2 = this;
  const {
    el,
    classNames: classNames2
  } = swiper2;
  el.classList.remove(...classNames2);
  swiper2.emitContainerClasses();
}
const classes = {
  addClasses,
  removeClasses
};
function checkOverflow() {
  const swiper2 = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper2;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper2.slides.length - 1;
    const lastSlideRightEdge = swiper2.slidesGrid[lastSlideIndex] + swiper2.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper2.isLocked = swiper2.size > lastSlideRightEdge;
  } else {
    swiper2.isLocked = swiper2.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper2.allowSlideNext = !swiper2.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper2.allowSlidePrev = !swiper2.isLocked;
  }
  if (wasLocked && wasLocked !== swiper2.isLocked) {
    swiper2.isEnd = false;
  }
  if (wasLocked !== swiper2.isLocked) {
    swiper2.emit(swiper2.isLocked ? "lock" : "unlock");
  }
}
const checkOverflow$1 = {
  checkOverflow
};
const defaults = {
  init: true,
  direction: "horizontal",
  oneWayMovement: false,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopedSlides: null,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== "object" || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }
    if (!(moduleParamName in params && "enabled" in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName])
      params[moduleParamName] = {
        enabled: false
      };
    extend$1(allModulesParams, obj);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
let Swiper$1 = class Swiper {
  constructor(...args) {
    let el;
    let params;
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params)
      params = {};
    params = extend$1({}, params);
    if (el && !params.el)
      params.el = el;
    const document2 = getDocument();
    if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document2.querySelectorAll(params.el).forEach((containerEl) => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    }
    const swiper2 = this;
    swiper2.__swiper__ = true;
    swiper2.support = getSupport();
    swiper2.device = getDevice({
      userAgent: params.userAgent
    });
    swiper2.browser = getBrowser();
    swiper2.eventsListeners = {};
    swiper2.eventsAnyListeners = [];
    swiper2.modules = [...swiper2.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper2.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper2.modules.forEach((mod) => {
      mod({
        params,
        swiper: swiper2,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper2.on.bind(swiper2),
        once: swiper2.once.bind(swiper2),
        off: swiper2.off.bind(swiper2),
        emit: swiper2.emit.bind(swiper2)
      });
    });
    const swiperParams = extend$1({}, defaults, allModulesParams);
    swiper2.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper2.originalParams = extend$1({}, swiper2.params);
    swiper2.passedParams = extend$1({}, params);
    if (swiper2.params && swiper2.params.on) {
      Object.keys(swiper2.params.on).forEach((eventName) => {
        swiper2.on(eventName, swiper2.params.on[eventName]);
      });
    }
    if (swiper2.params && swiper2.params.onAny) {
      swiper2.onAny(swiper2.params.onAny);
    }
    Object.assign(swiper2, {
      enabled: swiper2.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper2.params.direction === "horizontal";
      },
      isVertical() {
        return swiper2.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper2.params.allowSlideNext,
      allowSlidePrev: swiper2.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: swiper2.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper2.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper2.emit("_swiper");
    if (swiper2.params.init) {
      swiper2.init();
    }
    return swiper2;
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = elementIndex(slides[0]);
    return elementIndex(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
  }
  recalcSlides() {
    const swiper2 = this;
    const {
      slidesEl,
      params
    } = swiper2;
    swiper2.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper2 = this;
    if (swiper2.enabled)
      return;
    swiper2.enabled = true;
    if (swiper2.params.grabCursor) {
      swiper2.setGrabCursor();
    }
    swiper2.emit("enable");
  }
  disable() {
    const swiper2 = this;
    if (!swiper2.enabled)
      return;
    swiper2.enabled = false;
    if (swiper2.params.grabCursor) {
      swiper2.unsetGrabCursor();
    }
    swiper2.emit("disable");
  }
  setProgress(progress2, speed) {
    const swiper2 = this;
    progress2 = Math.min(Math.max(progress2, 0), 1);
    const min = swiper2.minTranslate();
    const max = swiper2.maxTranslate();
    const current2 = (max - min) * progress2 + min;
    swiper2.translateTo(current2, typeof speed === "undefined" ? 0 : speed);
    swiper2.updateActiveIndex();
    swiper2.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper2 = this;
    if (!swiper2.params._emitClasses || !swiper2.el)
      return;
    const cls = swiper2.el.className.split(" ").filter((className) => {
      return className.indexOf("swiper") === 0 || className.indexOf(swiper2.params.containerModifierClass) === 0;
    });
    swiper2.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper2 = this;
    if (swiper2.destroyed)
      return "";
    return slideEl.className.split(" ").filter((className) => {
      return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper2.params.slideClass) === 0;
    }).join(" ");
  }
  emitSlidesClasses() {
    const swiper2 = this;
    if (!swiper2.params._emitClasses || !swiper2.el)
      return;
    const updates = [];
    swiper2.slides.forEach((slideEl) => {
      const classNames2 = swiper2.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames: classNames2
      });
      swiper2.emit("_slideClass", slideEl, classNames2);
    });
    swiper2.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view = "current", exact = false) {
    const swiper2 = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper2;
    let spv = 1;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
    } else {
      if (view === "current") {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper2 = this;
    if (!swiper2 || swiper2.destroyed)
      return;
    const {
      snapGrid,
      params
    } = swiper2;
    if (params.breakpoints) {
      swiper2.setBreakpoint();
    }
    [...swiper2.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper2, imageEl);
      }
    });
    swiper2.updateSize();
    swiper2.updateSlides();
    swiper2.updateProgress();
    swiper2.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper2.rtlTranslate ? swiper2.translate * -1 : swiper2.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper2.maxTranslate()), swiper2.minTranslate());
      swiper2.setTranslate(newTranslate);
      swiper2.updateActiveIndex();
      swiper2.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate2();
      if (params.autoHeight) {
        swiper2.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper2.isEnd && !params.centeredSlides) {
        const slides = swiper2.virtual && params.virtual.enabled ? swiper2.virtual.slides : swiper2.slides;
        translated = swiper2.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper2.slideTo(swiper2.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate2();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper2.snapGrid) {
      swiper2.checkOverflow();
    }
    swiper2.emit("update");
  }
  changeDirection(newDirection, needUpdate = true) {
    const swiper2 = this;
    const currentDirection = swiper2.params.direction;
    if (!newDirection) {
      newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
    }
    if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
      return swiper2;
    }
    swiper2.el.classList.remove(`${swiper2.params.containerModifierClass}${currentDirection}`);
    swiper2.el.classList.add(`${swiper2.params.containerModifierClass}${newDirection}`);
    swiper2.emitContainerClasses();
    swiper2.params.direction = newDirection;
    swiper2.slides.forEach((slideEl) => {
      if (newDirection === "vertical") {
        slideEl.style.width = "";
      } else {
        slideEl.style.height = "";
      }
    });
    swiper2.emit("changeDirection");
    if (needUpdate)
      swiper2.update();
    return swiper2;
  }
  changeLanguageDirection(direction) {
    const swiper2 = this;
    if (swiper2.rtl && direction === "rtl" || !swiper2.rtl && direction === "ltr")
      return;
    swiper2.rtl = direction === "rtl";
    swiper2.rtlTranslate = swiper2.params.direction === "horizontal" && swiper2.rtl;
    if (swiper2.rtl) {
      swiper2.el.classList.add(`${swiper2.params.containerModifierClass}rtl`);
      swiper2.el.dir = "rtl";
    } else {
      swiper2.el.classList.remove(`${swiper2.params.containerModifierClass}rtl`);
      swiper2.el.dir = "ltr";
    }
    swiper2.update();
  }
  mount(element) {
    const swiper2 = this;
    if (swiper2.mounted)
      return true;
    let el = element || swiper2.params.el;
    if (typeof el === "string") {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper2;
    if (el.shadowEl) {
      swiper2.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper2.params.wrapperClass || "").trim().split(" ").join(".")}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        return res;
      }
      return elementChildren(el, getWrapperSelector())[0];
    };
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper2.params.createElements) {
      wrapperEl = createElement("div", swiper2.params.wrapperClass);
      el.append(wrapperEl);
      elementChildren(el, `.${swiper2.params.slideClass}`).forEach((slideEl) => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper2, {
      el,
      wrapperEl,
      slidesEl: swiper2.isElement ? el : wrapperEl,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
      rtlTranslate: swiper2.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
      wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
    });
    return true;
  }
  init(el) {
    const swiper2 = this;
    if (swiper2.initialized)
      return swiper2;
    const mounted = swiper2.mount(el);
    if (mounted === false)
      return swiper2;
    swiper2.emit("beforeInit");
    if (swiper2.params.breakpoints) {
      swiper2.setBreakpoint();
    }
    swiper2.addClasses();
    swiper2.updateSize();
    swiper2.updateSlides();
    if (swiper2.params.watchOverflow) {
      swiper2.checkOverflow();
    }
    if (swiper2.params.grabCursor && swiper2.enabled) {
      swiper2.setGrabCursor();
    }
    if (swiper2.params.loop && swiper2.virtual && swiper2.params.virtual.enabled) {
      swiper2.slideTo(swiper2.params.initialSlide + swiper2.virtual.slidesBefore, 0, swiper2.params.runCallbacksOnInit, false, true);
    } else {
      swiper2.slideTo(swiper2.params.initialSlide, 0, swiper2.params.runCallbacksOnInit, false, true);
    }
    if (swiper2.params.loop) {
      swiper2.loopCreate();
    }
    swiper2.attachEvents();
    [...swiper2.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper2, imageEl);
      } else {
        imageEl.addEventListener("load", (e) => {
          processLazyPreloader(swiper2, e.target);
        });
      }
    });
    preload(swiper2);
    swiper2.initialized = true;
    preload(swiper2);
    swiper2.emit("init");
    swiper2.emit("afterInit");
    return swiper2;
  }
  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper2 = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper2;
    if (typeof swiper2.params === "undefined" || swiper2.destroyed) {
      return null;
    }
    swiper2.emit("beforeDestroy");
    swiper2.initialized = false;
    swiper2.detachEvents();
    if (params.loop) {
      swiper2.loopDestroy();
    }
    if (cleanStyles) {
      swiper2.removeClasses();
      el.removeAttribute("style");
      wrapperEl.removeAttribute("style");
      if (slides && slides.length) {
        slides.forEach((slideEl) => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute("style");
          slideEl.removeAttribute("data-swiper-slide-index");
        });
      }
    }
    swiper2.emit("destroy");
    Object.keys(swiper2.eventsListeners).forEach((eventName) => {
      swiper2.off(eventName);
    });
    if (deleteInstance !== false) {
      swiper2.el.swiper = null;
      deleteProps(swiper2);
    }
    swiper2.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__)
      Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === "function" && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach((m) => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
};
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);
function effectInit(params) {
  const {
    effect,
    swiper: swiper2,
    on,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on("beforeInit", () => {
    if (swiper2.params.effect !== effect)
      return;
    swiper2.classNames.push(`${swiper2.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper2.classNames.push(`${swiper2.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper2.params, overwriteParamsResult);
    Object.assign(swiper2.originalParams, overwriteParamsResult);
  });
  on("setTranslate", () => {
    if (swiper2.params.effect !== effect)
      return;
    setTranslate2();
  });
  on("setTransition", (_s, duration) => {
    if (swiper2.params.effect !== effect)
      return;
    setTransition2(duration);
  });
  on("transitionEnd", () => {
    if (swiper2.params.effect !== effect)
      return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows)
        return;
      swiper2.slides.forEach((slideEl) => {
        slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl) => shadowEl.remove());
      });
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on("virtualUpdate", () => {
    if (swiper2.params.effect !== effect)
      return;
    if (!swiper2.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper2.slides && swiper2.slides.length) {
        setTranslate2();
        requireUpdateOnVirtual = false;
      }
    });
  });
}
function effectTarget(effectParams, slideEl) {
  const transformEl = getSlideTransformEl(slideEl);
  if (transformEl !== slideEl) {
    transformEl.style.backfaceVisibility = "hidden";
    transformEl.style["-webkit-backface-visibility"] = "hidden";
  }
  return transformEl;
}
function effectVirtualTransitionEnd({
  swiper: swiper2,
  duration,
  transformElements,
  allSlides
}) {
  const {
    activeIndex
  } = swiper2;
  const getSlide = (el) => {
    if (!el.parentElement) {
      const slide2 = swiper2.slides.filter((slideEl) => slideEl.shadowEl && slideEl.shadowEl === el.parentNode)[0];
      return slide2;
    }
    return el.parentElement;
  };
  if (swiper2.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let transitionEndTarget;
    if (allSlides) {
      transitionEndTarget = transformElements;
    } else {
      transitionEndTarget = transformElements.filter((transformEl) => {
        const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
        return swiper2.getSlideIndex(el) === activeIndex;
      });
    }
    transitionEndTarget.forEach((el) => {
      elementTransitionEnd(el, () => {
        if (eventTriggered)
          return;
        if (!swiper2 || swiper2.destroyed)
          return;
        eventTriggered = true;
        swiper2.animating = false;
        const evt = new window.CustomEvent("transitionend", {
          bubbles: true,
          cancelable: true
        });
        swiper2.wrapperEl.dispatchEvent(evt);
      });
    });
  }
}
function createShadow(params, slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
  const shadowContainer = getSlideTransformEl(slideEl);
  let shadowEl = shadowContainer.querySelector(`.${shadowClass}`);
  if (!shadowEl) {
    shadowEl = createElement("div", `swiper-slide-shadow${side ? `-${side}` : ""}`);
    shadowContainer.append(shadowEl);
  }
  return shadowEl;
}
function EffectCreative({
  swiper: swiper2,
  extendParams,
  on
}) {
  extendParams({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const getTranslateValue = (value2) => {
    if (typeof value2 === "string")
      return value2;
    return `${value2}px`;
  };
  const setTranslate2 = () => {
    const {
      slides,
      wrapperEl,
      slidesSizesGrid
    } = swiper2;
    const params = swiper2.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper2.params.centeredSlides;
    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper2.params.slidesOffsetBefore || 0;
      wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress2 = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress2;
      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
      }
      const offset = slideEl.swiperSlideOffset;
      const t = [swiper2.params.cssMode ? -offset - swiper2.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom2 = false;
      if (!swiper2.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }
      let data2 = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };
      if (progress2 < 0) {
        data2 = params.next;
        custom2 = true;
      } else if (progress2 > 0) {
        data2 = params.prev;
        custom2 = true;
      }
      t.forEach((value2, index) => {
        t[index] = `calc(${value2}px + (${getTranslateValue(data2.translate[index])} * ${Math.abs(progress2 * multiplier)}))`;
      });
      r.forEach((value2, index) => {
        r[index] = data2.rotate[index] * Math.abs(progress2 * multiplier);
      });
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(", ");
      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data2.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data2.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data2.opacity) * originalProgress * multiplier : 1 - (1 - data2.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
      if (custom2 && data2.shadow || !custom2) {
        let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
        if (!shadowEl && data2.shadow) {
          shadowEl = createShadow(params, slideEl);
        }
        if (shadowEl) {
          const shadowOpacity = params.shadowPerProgress ? progress2 * (1 / params.limitProgress) : progress2;
          shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
      targetEl.style.opacity = opacityString;
      if (data2.origin) {
        targetEl.style.transformOrigin = data2.origin;
      }
    }
  };
  const setTransition2 = (duration) => {
    const transformElements = swiper2.slides.map((slideEl) => getSlideTransformEl(slideEl));
    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl) => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper: swiper2,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effectInit({
    effect: "creative",
    swiper: swiper2,
    on,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    perspective: () => swiper2.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper2.params.cssMode
    })
  });
}
function isObject$1(o) {
  return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function extend(target, src) {
  const noExtend = ["__proto__", "constructor", "prototype"];
  Object.keys(src).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
    if (typeof target[key] === "undefined")
      target[key] = src[key];
    else if (isObject$1(src[key]) && isObject$1(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__)
        target[key] = src[key];
      else
        extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}
function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === "undefined" && typeof params.navigation.prevEl === "undefined";
}
function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === "undefined";
}
function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === "undefined";
}
function uniqueClasses(classNames2 = "") {
  const classes2 = classNames2.split(" ").map((c) => c.trim()).filter((c) => !!c);
  const unique = [];
  classes2.forEach((c) => {
    if (unique.indexOf(c) < 0)
      unique.push(c);
  });
  return unique.join(" ");
}
function wrapperClass(className = "") {
  if (!className)
    return "swiper-wrapper";
  if (!className.includes("swiper-wrapper"))
    return `swiper-wrapper ${className}`;
  return className;
}
const paramsList = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopedSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events2 = {};
  const passedParams = {};
  extend(params, Swiper$1.defaults);
  extend(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map((key) => key.replace(/_/, ""));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach((key) => {
    if (typeof obj[key] === "undefined")
      return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject$1(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === "function") {
      if (splitEvents) {
        events2[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ["navigation", "pagination", "scrollbar"].forEach((key) => {
    if (params[key] === true)
      params[key] = {};
    if (params[key] === false)
      delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events: events2
  };
}
function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper: swiper2
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper2.params.navigation.nextEl = nextEl;
    swiper2.originalParams.navigation.nextEl = nextEl;
    swiper2.params.navigation.prevEl = prevEl;
    swiper2.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper2.params.pagination.el = paginationEl;
    swiper2.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper2.params.scrollbar.el = scrollbarEl;
    swiper2.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper2.init(el);
}
function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams)
    return keys;
  const addKey = (key) => {
    if (keys.indexOf(key) < 0)
      keys.push(key);
  };
  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join("") !== childrenKeys.join(""))
      addKey("children");
    if (oldChildren.length !== children.length)
      addKey("children");
  }
  const watchParams = paramsList.filter((key) => key[0] === "_").map((key) => key.replace(/_/, ""));
  watchParams.forEach((key) => {
    if (key in swiperParams && key in oldParams) {
      if (isObject$1(swiperParams[key]) && isObject$1(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach((newKey) => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach((oldKey) => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey])
              addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}
function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes("SwiperSlide");
}
function processChildren(c) {
  const slides = [];
  React__default.Children.toArray(c).forEach((child) => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach((slide2) => slides.push(slide2));
    }
  });
  return slides;
}
function getChildren(c) {
  const slides = [];
  const slots = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  React__default.Children.toArray(c).forEach((child) => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach((slide2) => slides.push(slide2));
      } else {
        slots["container-end"].push(child);
      }
    } else {
      slots["container-end"].push(child);
    }
  });
  return {
    slides,
    slots
  };
}
function updateSwiper({
  swiper: swiper2,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter((key) => key !== "children" && key !== "direction" && key !== "wrapperClass");
  const {
    params: currentParams,
    pagination: pagination2,
    navigation: navigation2,
    scrollbar,
    virtual,
    thumbs
  } = swiper2;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  let loopNeedDestroy;
  let loopNeedEnable;
  let loopNeedReloop;
  if (changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }
  if (changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination2 && !pagination2.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation2 && !navigation2.prevEl && !navigation2.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = (mod) => {
    if (!swiper2[mod])
      return;
    swiper2[mod].destroy();
    if (mod === "navigation") {
      if (swiper2.isElement) {
        swiper2[mod].prevEl.remove();
        swiper2[mod].nextEl.remove();
      }
      currentParams[mod].prevEl = void 0;
      currentParams[mod].nextEl = void 0;
      swiper2[mod].prevEl = void 0;
      swiper2[mod].nextEl = void 0;
    } else {
      if (swiper2.isElement) {
        swiper2[mod].el.remove();
      }
      currentParams[mod].el = void 0;
      swiper2[mod].el = void 0;
    }
  };
  if (changedParams.includes("loop") && swiper2.isElement) {
    if (currentParams.loop && !passedParams.loop) {
      loopNeedDestroy = true;
    } else if (!currentParams.loop && passedParams.loop) {
      loopNeedEnable = true;
    } else {
      loopNeedReloop = true;
    }
  }
  updateParams.forEach((key) => {
    if (isObject$1(currentParams[key]) && isObject$1(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
      if ((key === "navigation" || key === "pagination" || key === "scrollbar") && "enabled" in passedParams[key] && !passedParams[key].enabled) {
        destroyModule(key);
      }
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === "navigation" || key === "pagination" || key === "scrollbar")) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes("controller") && !needControllerInit && swiper2.controller && swiper2.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper2.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes("children") && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  }
  if (changedParams.includes("children") && slides && currentParams.loop) {
    loopNeedReloop = true;
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized)
      thumbs.update(true);
  }
  if (needControllerInit) {
    swiper2.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (swiper2.isElement && (!paginationEl || typeof paginationEl === "string")) {
      paginationEl = document.createElement("div");
      paginationEl.classList.add("swiper-pagination");
      swiper2.el.shadowEl.appendChild(paginationEl);
    }
    if (paginationEl)
      currentParams.pagination.el = paginationEl;
    pagination2.init();
    pagination2.render();
    pagination2.update();
  }
  if (needScrollbarInit) {
    if (swiper2.isElement && (!scrollbarEl || typeof scrollbarEl === "string")) {
      scrollbarEl = document.createElement("div");
      scrollbarEl.classList.add("swiper-scrollbar");
      swiper2.el.shadowEl.appendChild(scrollbarEl);
    }
    if (scrollbarEl)
      currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (swiper2.isElement) {
      if (!nextEl || typeof nextEl === "string") {
        nextEl = document.createElement("div");
        nextEl.classList.add("swiper-button-next");
        swiper2.el.shadowEl.appendChild(nextEl);
      }
      if (!prevEl || typeof prevEl === "string") {
        prevEl = document.createElement("div");
        prevEl.classList.add("swiper-button-prev");
        swiper2.el.shadowEl.appendChild(prevEl);
      }
    }
    if (nextEl)
      currentParams.navigation.nextEl = nextEl;
    if (prevEl)
      currentParams.navigation.prevEl = prevEl;
    navigation2.init();
    navigation2.update();
  }
  if (changedParams.includes("allowSlideNext")) {
    swiper2.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes("allowSlidePrev")) {
    swiper2.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes("direction")) {
    swiper2.changeDirection(passedParams.direction, false);
  }
  if (loopNeedDestroy || loopNeedReloop) {
    swiper2.loopDestroy();
  }
  if (loopNeedEnable || loopNeedReloop) {
    swiper2.loopCreate();
  }
  swiper2.update();
}
function renderVirtual(swiper2, slides, virtualData) {
  if (!virtualData)
    return null;
  const getSlideIndex = (index) => {
    let slideIndex = index;
    if (index < 0) {
      slideIndex = slides.length + index;
    } else if (slideIndex >= slides.length) {
      slideIndex = slideIndex - slides.length;
    }
    return slideIndex;
  };
  const style = swiper2.isHorizontal() ? {
    [swiper2.rtlTranslate ? "right" : "left"]: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  const {
    from,
    to
  } = virtualData;
  const loopFrom = swiper2.params.loop ? -slides.length : 0;
  const loopTo = swiper2.params.loop ? slides.length * 2 : slides.length;
  const slidesToRender = [];
  for (let i = loopFrom; i < loopTo; i += 1) {
    if (i >= from && i <= to) {
      slidesToRender.push(slides[getSlideIndex(i)]);
    }
  }
  return slidesToRender.map((child, index) => {
    return /* @__PURE__ */ React__default.cloneElement(child, {
      swiper: swiper2,
      style,
      key: `slide-${index}`
    });
  });
}
const updateOnVirtualData = (swiper2) => {
  if (!swiper2 || swiper2.destroyed || !swiper2.params.virtual || swiper2.params.virtual && !swiper2.params.virtual.enabled)
    return;
  swiper2.updateSlides();
  swiper2.updateProgress();
  swiper2.updateSlidesClasses();
  if (swiper2.parallax && swiper2.params.parallax && swiper2.params.parallax.enabled) {
    swiper2.parallax.setTranslate();
  }
};
function useIsomorphicLayoutEffect(callback, deps) {
  if (typeof window === "undefined")
    return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}
const SwiperSlideContext = /* @__PURE__ */ createContext(null);
const SwiperContext = /* @__PURE__ */ createContext(null);
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
const Swiper2 = /* @__PURE__ */ forwardRef(function(_temp, externalElRef) {
  let {
    className,
    tag: Tag2 = "div",
    wrapperTag: WrapperTag = "div",
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = useState("swiper");
  const [virtualData, setVirtualData] = useState(null);
  const [breakpointChanged, setBreakpointChanged] = useState(false);
  const initializedRef = useRef(false);
  const swiperElRef = useRef(null);
  const swiperRef = useRef(null);
  const oldPassedParamsRef = useRef(null);
  const oldSlides = useRef(null);
  const nextElRef = useRef(null);
  const prevElRef = useRef(null);
  const paginationElRef = useRef(null);
  const scrollbarElRef = useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events: events2
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper2, classes2) {
      setContainerClasses(classes2);
    }
  });
  const initSwiper = () => {
    Object.assign(swiperParams.on, events2);
    eventsAssigned = true;
    const passParams = {
      ...swiperParams
    };
    delete passParams.wrapperClass;
    swiperRef.current = new Swiper$1(passParams);
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }
  if (swiperRef.current) {
    swiperRef.current.on("_beforeBreakpoint", onBeforeBreakpoint);
  }
  const attachEvents2 = () => {
    if (eventsAssigned || !events2 || !swiperRef.current)
      return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.on(eventName, events2[eventName]);
    });
  };
  const detachEvents2 = () => {
    if (!events2 || !swiperRef.current)
      return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.off(eventName, events2[eventName]);
    });
  };
  useEffect(() => {
    return () => {
      if (swiperRef.current)
        swiperRef.current.off("_beforeBreakpoint", onBeforeBreakpoint);
    };
  });
  useEffect(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });
  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current)
      return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper)
      onSwiper(swiperRef.current);
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);
  useIsomorphicLayoutEffect(() => {
    attachEvents2();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, (c) => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents2();
    };
  });
  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    return slides.map((child, index) => {
      return /* @__PURE__ */ React__default.cloneElement(child, {
        swiper: swiperRef.current,
        swiperSlideIndex: index
      });
    });
  }
  return /* @__PURE__ */ React__default.createElement(Tag2, _extends$2({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ""}`)
  }, restProps), /* @__PURE__ */ React__default.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots["container-start"], /* @__PURE__ */ React__default.createElement(WrapperTag, {
    className: wrapperClass(swiperParams.wrapperClass)
  }, slots["wrapper-start"], renderSlides(), slots["wrapper-end"]), needsNavigation(swiperParams) && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ React__default.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /* @__PURE__ */ React__default.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /* @__PURE__ */ React__default.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots["container-end"]));
});
Swiper2.displayName = "Swiper";
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
const SwiperSlide = /* @__PURE__ */ forwardRef(function(_temp, externalRef) {
  let {
    tag: Tag2 = "div",
    children,
    className = "",
    swiper: swiper2,
    zoom,
    lazy,
    virtualIndex,
    swiperSlideIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = useRef(null);
  const [slideClasses, setSlideClasses] = useState("swiper-slide");
  const [lazyLoaded, setLazyLoaded] = useState(false);
  function updateClasses(_s, el, classNames2) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames2);
    }
  }
  useIsomorphicLayoutEffect(() => {
    if (typeof swiperSlideIndex !== "undefined") {
      slideElRef.current.swiperSlideIndex = swiperSlideIndex;
    }
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper2) {
      return;
    }
    if (swiper2.destroyed) {
      if (slideClasses !== "swiper-slide") {
        setSlideClasses("swiper-slide");
      }
      return;
    }
    swiper2.on("_slideClass", updateClasses);
    return () => {
      if (!swiper2)
        return;
      swiper2.off("_slideClass", updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper2 && slideElRef.current && !swiper2.destroyed) {
      setSlideClasses(swiper2.getSlideClasses(slideElRef.current));
    }
  }, [swiper2]);
  const slideData = {
    isActive: slideClasses.indexOf("swiper-slide-active") >= 0,
    isVisible: slideClasses.indexOf("swiper-slide-visible") >= 0,
    isPrev: slideClasses.indexOf("swiper-slide-prev") >= 0,
    isNext: slideClasses.indexOf("swiper-slide-next") >= 0
  };
  const renderChildren = () => {
    return typeof children === "function" ? children(slideData) : children;
  };
  const onLoad2 = () => {
    setLazyLoaded(true);
  };
  return /* @__PURE__ */ React__default.createElement(Tag2, _extends$1({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ""}`),
    "data-swiper-slide-index": virtualIndex,
    onLoad: onLoad2
  }, rest), zoom && /* @__PURE__ */ React__default.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === "number" ? zoom : void 0
  }, renderChildren(), lazy && !lazyLoaded && /* @__PURE__ */ React__default.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !zoom && /* @__PURE__ */ React__default.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, renderChildren(), lazy && !lazyLoaded && /* @__PURE__ */ React__default.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
SwiperSlide.displayName = "SwiperSlide";
const swiper_min = "";
const pageIndex = "_pageIndex_1lg9b_1";
const pageIndex__dot = "_pageIndex__dot_1lg9b_5";
const styles$C = {
  pageIndex,
  pageIndex__dot,
  "pageIndex__dot--current": "_pageIndex__dot--current_1lg9b_12",
  "pageIndex__dot--current--brabus": "_pageIndex__dot--current--brabus_1lg9b_18"
};
const baseClass$o = "pageIndex";
const PageIndex = ({ current: current2, total, mode }) => /* @__PURE__ */ jsx("div", { className: styles$C[baseClass$o], children: [...Array(total)].map((item2, index) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames(styles$C[`${baseClass$o}__dot`], {
      [styles$C[`${baseClass$o}__dot--current`]]: index === current2,
      [styles$C[`${baseClass$o}__dot--current--brabus`]]: mode === "brabus"
    })
  },
  `pageIndex${index}`
)) });
const useIsPortrait = () => {
  const [isPortrait, setIsPortrait] = useState(void 0);
  useEffect(() => {
    setIsPortrait(window.innerHeight > window.innerWidth);
  }, []);
  return isPortrait;
};
const control$1 = "_control_omsvu_14";
const progress$2 = "_progress_omsvu_42";
const pause$2 = "_pause_omsvu_57";
const play$2 = "_play_omsvu_61";
const styles$B = {
  "video-card": "_video-card_omsvu_1",
  control: control$1,
  "progress-bg": "_progress-bg_omsvu_42",
  progress: progress$2,
  "progress-brabus": "_progress-brabus_omsvu_52",
  pause: pause$2,
  play: play$2
};
const baseClass$n = "video-card";
const VideoCard = forwardRef(
  ({ landscapeUrl, portraitUrl, posterUrl, altText, className, observeVideo = false, onStart, children, mode }, forwardedRef) => {
    const videoRef = useRef(null);
    const progressRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const isManuallyPaused = useRef(false);
    const [isInView, setIsInView] = useState(false);
    const isPortrait = useIsPortrait();
    const url = isPortrait ? portraitUrl : landscapeUrl;
    const onVideoTimeUpdate = (e) => {
      const video2 = e.target;
      setIsPlaying(video2.currentTime > 0 && !video2.paused && !video2.ended);
      const percent = video2.duration ? video2.currentTime / video2.duration : 0;
      const circle2 = progressRef.current;
      if (circle2) {
        const perimeter = circle2.getTotalLength();
        circle2.setAttribute("stroke-dasharray", `${perimeter * percent} ${perimeter * (1 - percent)}`);
      }
    };
    const play2 = () => {
      const video2 = videoRef.current;
      if (video2 && !isPlaying && !isManuallyPaused.current) {
        setIsPlaying(true);
      }
    };
    const pause2 = () => {
      const video2 = videoRef.current;
      if (video2 && isPlaying) {
        setIsPlaying(false);
      }
    };
    const manuallyPauseAndPlay = (e) => {
      e.preventDefault();
      if (isPlaying) {
        isManuallyPaused.current = true;
        setIsPlaying(false);
      } else {
        isManuallyPaused.current = false;
        setIsPlaying(true);
        onStart && onStart();
      }
    };
    useEffect(() => {
      const video2 = videoRef.current;
      if (video2) {
        if (isPlaying) {
          video2.play();
        } else {
          video2.pause();
        }
      }
    }, [isPlaying]);
    useEffect(() => {
      const handleObserve = (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
          setIsInView(true);
        }
        if (observeVideo) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            setIsPlaying(true);
          } else {
            setIsPlaying(false);
          }
        }
      };
      const observer = new IntersectionObserver(handleObserve, {
        threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      });
      const video2 = videoRef.current;
      if (video2) {
        observer.observe(video2);
      }
      return () => {
        if (video2) {
          observer == null ? void 0 : observer.unobserve(video2);
        }
      };
    }, [observeVideo]);
    useImperativeHandle(forwardedRef, () => ({
      isPlaying: () => isPlaying,
      play: play2,
      pause: pause2
    }));
    return /* @__PURE__ */ jsxs("div", { className: classNames(className, styles$B[baseClass$n]), children: [
      /* @__PURE__ */ jsx(
        "video",
        {
          ref: videoRef,
          src: isInView && url ? url : void 0,
          poster: posterUrl ? `${posterUrl}:1-1?$smartResponsiveAlpha8?wid=1920` : void 0,
          "aria-label": altText,
          playsInline: true,
          muted: true,
          onTimeUpdate: onVideoTimeUpdate,
          onEnded: () => {
            if (videoRef.current) {
              videoRef.current.currentTime = 0.01;
              setTimeout(() => {
                videoRef.current.play();
              }, 0);
            }
          }
        }
      ),
      children,
      /* @__PURE__ */ jsxs("button", { className: styles$B.control, onClick: manuallyPauseAndPlay, children: [
        /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "50", height: "50", viewBox: "0 0 50 50", children: [
          /* @__PURE__ */ jsx(
            "circle",
            {
              fill: "transparent",
              className: styles$B["progress-bg"],
              strokeWidth: "2",
              cx: "25",
              cy: "25",
              r: "20"
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              ref: progressRef,
              fill: "transparent",
              className: mode === "brabus" ? styles$B["progress-brabus"] : styles$B["progress"],
              strokeWidth: "2",
              cx: "25",
              cy: "25",
              r: "20",
              strokeDasharray: "0 1"
            }
          )
        ] }),
        isPlaying ? /* @__PURE__ */ jsxs(
          "svg",
          {
            className: styles$B.pause,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ jsx("path", { d: "M11 7H8V17H11V7Z", fill: "white" }),
              /* @__PURE__ */ jsx("path", { d: "M13 17H16V7H13V17Z", fill: "white" })
            ]
          }
        ) : /* @__PURE__ */ jsx(
          "svg",
          {
            className: styles$B.play,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ jsx("path", { d: "M15 12.3301L9 16.6603L9 8L15 12.3301Z", fill: "white" })
          }
        )
      ] })
    ] });
  }
);
VideoCard.displayName = "VideoCard";
const image$5 = "_image_1fdi9_32";
const styles$A = {
  "highlight-mode": "_highlight-mode_1fdi9_1",
  "highlight-mode--noTopSpacing": "_highlight-mode--noTopSpacing_1fdi9_6",
  "highlight-mode--mobile": "_highlight-mode--mobile_1fdi9_9",
  "highlight-mode__itemsWrapper": "_highlight-mode__itemsWrapper_1fdi9_17",
  "highlight-mode__itemWrapper": "_highlight-mode__itemWrapper_1fdi9_20",
  "highlight-mode__imageWrapper": "_highlight-mode__imageWrapper_1fdi9_25",
  image: image$5,
  "highlight-mode__descWrapper": "_highlight-mode__descWrapper_1fdi9_41",
  "highlight-mode__description": "_highlight-mode__description_1fdi9_49",
  "highlight-mode__cta": "_highlight-mode__cta_1fdi9_70",
  "highlight-mode__pageIndex": "_highlight-mode__pageIndex_1fdi9_91",
  "highlight-mode--pc__container": "_highlight-mode--pc__container_1fdi9_96",
  "highlight-mode--pc": "_highlight-mode--pc_1fdi9_96",
  "highlight-mode__wrapper--up": "_highlight-mode__wrapper--up_1fdi9_113",
  "highlight-mode__wrapper--in": "_highlight-mode__wrapper--in_1fdi9_116",
  "highlight-mode__wrapper--down": "_highlight-mode__wrapper--down_1fdi9_120",
  "highlight-mode__slideContainer": "_highlight-mode__slideContainer_1fdi9_124",
  "highlight-mode__imageWrapper--video": "_highlight-mode__imageWrapper--video_1fdi9_147",
  "highlight-mode__indicator": "_highlight-mode__indicator_1fdi9_173",
  "legal-disclaimer--pc": "_legal-disclaimer--pc_1fdi9_228",
  "legal-disclaimer--mobile": "_legal-disclaimer--mobile_1fdi9_238"
};
const baseClass$m = "highlight-mode";
const imageConfig$5 = [
  {
    aspectRatio: "1-1",
    sizes: "100vw",
    media: `(max-width: ${breakpoints$1.l}px)`
  },
  {
    aspectRatio: "1-1",
    sizes: "62.5vw",
    media: `(min-width: ${breakpoints$1.l}px)`
  }
];
const HighlightMode = ({
  removeTopSpacing: removeTopSpacing2,
  galleryItems,
  legalDisclaimers,
  mode
}) => {
  const galleryRef = useRef(null);
  const isInViewport = useRef(false);
  const [componentPosition, setComponentPosition] = useState("up");
  const componentPostionRef = useRef("up");
  const videoRefs = useRef([]);
  const [windowWidth, setWindowWidth] = useState(1920);
  const [scrollBuffer, setScrollBuffer] = useState(0);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const isPreventSlideItem = useRef(false);
  useEffect(() => {
    const scrollBufferValue = window.innerHeight / 2;
    let oldScroll;
    const playVideo = (index) => {
      for (let i = 0; i < videoRefs.current.length; i++) {
        const video2 = videoRefs.current[i];
        if (video2) {
          if (index === i) {
            video2.play();
          } else {
            video2.pause();
          }
        }
      }
    };
    const pauseVideos = () => {
      for (let i = 0; i < videoRefs.current.length; i++) {
        const video2 = videoRefs.current[i];
        if (video2) {
          video2.pause();
        }
      }
    };
    const slideItem = () => {
      if (!galleryRef.current) {
        return;
      }
      const rect = galleryRef.current.getBoundingClientRect();
      const isScrollingUp = oldScroll < rect.top;
      oldScroll = rect.top;
      if (componentPostionRef.current === "in") {
        setCurrentSlideIndex((prevState) => {
          const preventSlideItem = () => {
            isPreventSlideItem.current = true;
            setTimeout(() => {
              isPreventSlideItem.current = false;
            }, 3e3);
          };
          const autoScroll = (index) => {
            let scrollY = window.scrollY + rect.top + (index === 0 ? 0 : index * window.innerWidth - window.innerHeight);
            if (index === 0) {
              scrollY += scrollBufferValue;
            }
            if (index === galleryItems.length - 1) {
              scrollY -= scrollBufferValue;
            }
            window.scrollTo(0, scrollY);
          };
          if (isPreventSlideItem.current) {
            return prevState;
          }
          if (isScrollingUp && prevState > 0) {
            preventSlideItem();
            autoScroll(prevState - 1);
            playVideo(prevState - 1);
            return prevState - 1;
          }
          if (!isScrollingUp && prevState < galleryItems.length - 1) {
            preventSlideItem();
            autoScroll(prevState + 1);
            playVideo(prevState + 1);
            return prevState + 1;
          }
          return prevState;
        });
      }
    };
    const scrollEvent = () => {
      if (!galleryRef.current || !isInViewport.current || galleryItems.length < 2) {
        return;
      }
      const rect = galleryRef.current.getBoundingClientRect();
      if (rect.top > 0) {
        setComponentPosition("up");
        componentPostionRef.current = "up";
        document.removeEventListener("scroll", slideItem);
      } else if (rect.bottom > window.innerHeight) {
        setComponentPosition("in");
        componentPostionRef.current = "in";
        document.addEventListener("scroll", slideItem);
      } else {
        setComponentPosition("down");
        componentPostionRef.current = "down";
        setCurrentSlideIndex(galleryItems.length - 1);
        document.removeEventListener("scroll", slideItem);
      }
    };
    const handleIntersections = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        isInViewport.current = true;
        playVideo(currentSlideIndex);
        document.addEventListener("scroll", scrollEvent);
      } else {
        isInViewport.current = false;
        pauseVideos();
      }
    };
    const observer = new IntersectionObserver(handleIntersections);
    const el = galleryRef.current;
    if (el) {
      observer.observe(el);
    }
    setScrollBuffer(scrollBufferValue);
    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      if (el) {
        observer.unobserve(el);
        isInViewport.current = false;
      }
    };
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    windowWidth >= breakpoints$1.l && /* @__PURE__ */ jsx(
      "section",
      {
        className: classNames(styles$A[baseClass$m], styles$A[`${baseClass$m}--pc`], {
          [styles$A[`${baseClass$m}--noTopSpacing`]]: removeTopSpacing2,
          "dark-theme": mode === "dark" || mode === "brabus"
        }),
        style: {
          paddingBottom: galleryItems.length > 1 ? `calc(${100 * (galleryItems.length - 1)}vw + 2*${scrollBuffer}px` : 0
        },
        ref: galleryRef,
        children: /* @__PURE__ */ jsxs("div", { className: styles$A[`${baseClass$m}__wrapper--${componentPosition}`], children: [
          /* @__PURE__ */ jsx("div", { className: styles$A[`${baseClass$m}__slideContainer`], children: /* @__PURE__ */ jsx(
            "div",
            {
              className: styles$A[`${baseClass$m}__itemsWrapper`],
              style: {
                transform: `translateX(${0 - 100 * currentSlideIndex}vw)`
              },
              children: galleryItems.map((item2, i) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
                return /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: styles$A[`${baseClass$m}__itemWrapper`],
                    style: {
                      zIndex: 100 - i
                    },
                    children: [
                      /* @__PURE__ */ jsxs(
                        "div",
                        {
                          className: classNames(styles$A[`${baseClass$m}__imageWrapper`], {
                            [styles$A[`${baseClass$m}__imageWrapper--video`]]: item2.contentType === "video"
                          }),
                          style: {
                            transform: `translateX(${i > currentSlideIndex ? "-40%" : "0"})`
                          },
                          children: [
                            item2.contentType === "video" && /* @__PURE__ */ jsx(
                              VideoCard,
                              {
                                ref: (el) => {
                                  if (el) {
                                    videoRefs.current[i] = el;
                                  }
                                },
                                className: styles$A.image,
                                landscapeUrl: ((_a = item2 == null ? void 0 : item2.video) == null ? void 0 : _a.landscapeUrl) || "",
                                portraitUrl: ((_b = item2 == null ? void 0 : item2.video) == null ? void 0 : _b.portraitUrl) || "",
                                altText: (_c = item2 == null ? void 0 : item2.video) == null ? void 0 : _c.altText,
                                posterUrl: (_d = item2 == null ? void 0 : item2.video) == null ? void 0 : _d.posterImageUrl
                              }
                            ),
                            item2.contentType === "image" && /* @__PURE__ */ jsx(
                              DynamicMediaPicture,
                              {
                                className: styles$A.image,
                                imageAltText: ((_e = item2 == null ? void 0 : item2.image) == null ? void 0 : _e.imageAltText) || "",
                                imageUrl: ((_f = item2 == null ? void 0 : item2.image) == null ? void 0 : _f.imageUrl) || "",
                                imageConfigs: imageConfig$5
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ jsxs("div", { className: styles$A[`${baseClass$m}__descWrapper`], children: [
                        item2.copyText && /* @__PURE__ */ jsx("p", { className: styles$A[`${baseClass$m}__description`], children: item2.copyText }),
                        item2.link && /* @__PURE__ */ jsx(
                          "a",
                          {
                            href: (_g = item2 == null ? void 0 : item2.link) == null ? void 0 : _g.href,
                            onClick: (_h = item2 == null ? void 0 : item2.link) == null ? void 0 : _h.onClick,
                            target: (_i = item2 == null ? void 0 : item2.link) == null ? void 0 : _i.target,
                            rel: (_j = item2 == null ? void 0 : item2.link) == null ? void 0 : _j.rel,
                            className: styles$A[`${baseClass$m}__cta`],
                            children: item2.link.label
                          }
                        ),
                        /* @__PURE__ */ jsx("div", { className: styles$A[`${baseClass$m}__pageIndex`], children: /* @__PURE__ */ jsx(PageIndex, { current: i, total: galleryItems.length, mode }) })
                      ] })
                    ]
                  },
                  item2.itemId
                );
              })
            }
          ) }),
          legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$A[`legal-disclaimer--pc`], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
        ] })
      }
    ),
    windowWidth < breakpoints$1.l && /* @__PURE__ */ jsxs(
      "section",
      {
        className: classNames(styles$A[`${baseClass$m}`], styles$A[`${baseClass$m}--mobile`], {
          [styles$A[`${baseClass$m}--noTopSpacing`]]: removeTopSpacing2
        }),
        children: [
          /* @__PURE__ */ jsx(Swiper2, { className: styles$A[`${baseClass$m}__itemsWrapper`], spaceBetween: 0, slidesPerView: 1, children: galleryItems.map((item2, index) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
            return /* @__PURE__ */ jsxs(SwiperSlide, { className: styles$A[`${baseClass$m}__itemWrapper`], children: [
              /* @__PURE__ */ jsxs("div", { className: styles$A[`${baseClass$m}__imageWrapper`], children: [
                item2.contentType === "video" && /* @__PURE__ */ jsx(
                  VideoCard,
                  {
                    ref: (el) => {
                      if (el) {
                        videoRefs.current[index] = el;
                      }
                    },
                    landscapeUrl: ((_a = item2 == null ? void 0 : item2.video) == null ? void 0 : _a.landscapeUrl) || "",
                    portraitUrl: ((_b = item2 == null ? void 0 : item2.video) == null ? void 0 : _b.portraitUrl) || "",
                    altText: ((_c = item2 == null ? void 0 : item2.video) == null ? void 0 : _c.altText) || "",
                    posterUrl: (_d = item2 == null ? void 0 : item2.video) == null ? void 0 : _d.posterImageUrl,
                    observeVideo: true
                  }
                ),
                item2.contentType === "image" && /* @__PURE__ */ jsx(
                  DynamicMediaPicture,
                  {
                    className: styles$A.image,
                    imageAltText: ((_e = item2 == null ? void 0 : item2.image) == null ? void 0 : _e.imageAltText) || "",
                    imageUrl: ((_f = item2 == null ? void 0 : item2.image) == null ? void 0 : _f.imageUrl) || "",
                    imageConfigs: imageConfig$5
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs("div", { className: styles$A[`${baseClass$m}__descWrapper`], children: [
                item2.copyText && /* @__PURE__ */ jsx("p", { className: styles$A[`${baseClass$m}__description`], children: item2.copyText }),
                item2.link && /* @__PURE__ */ jsx(
                  "a",
                  {
                    href: (_g = item2 == null ? void 0 : item2.link) == null ? void 0 : _g.href,
                    onClick: (_h = item2 == null ? void 0 : item2.link) == null ? void 0 : _h.onClick,
                    target: (_i = item2 == null ? void 0 : item2.link) == null ? void 0 : _i.target,
                    rel: (_j = item2 == null ? void 0 : item2.link) == null ? void 0 : _j.rel,
                    className: styles$A[`${baseClass$m}__cta`],
                    children: item2.link.label
                  }
                ),
                /* @__PURE__ */ jsx("div", { className: styles$A[`${baseClass$m}__pageIndex`], children: /* @__PURE__ */ jsx(PageIndex, { current: index, total: galleryItems.length }) })
              ] })
            ] }, item2.itemId);
          }) }),
          legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsxs("div", { className: styles$A[`legal-disclaimer--mobile`], children: [
            /* @__PURE__ */ jsx("hr", {}),
            /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
          ] })
        ]
      }
    )
  ] });
};
const contentWidth$2 = "_contentWidth_13dub_1";
const img$2 = "_img_13dub_53";
const swiper$1 = "_swiper_13dub_212";
const maskWrapper = "_maskWrapper_13dub_220";
const masks$1 = "_masks_13dub_223";
const mask$2 = "_mask_13dub_220";
const styles$z = {
  contentWidth: contentWidth$2,
  "playful-mode": "_playful-mode_13dub_5",
  "playful-mode--noTopSpacing": "_playful-mode--noTopSpacing_13dub_13",
  "playful-mode__componentHeadline": "_playful-mode__componentHeadline_13dub_16",
  "playful-mode__teaserContainer": "_playful-mode__teaserContainer_13dub_33",
  "playful-mode__imageWrapper": "_playful-mode__imageWrapper_13dub_37",
  img: img$2,
  "playful-mode__categoryLabel": "_playful-mode__categoryLabel_13dub_62",
  "playful-mode__categoryLabelText": "_playful-mode__categoryLabelText_13dub_75",
  "playful-mode__copyWrapper": "_playful-mode__copyWrapper_13dub_79",
  "playful-mode__headline": "_playful-mode__headline_13dub_83",
  "playful-mode__copy": "_playful-mode__copy_13dub_79",
  "playful-mode__copy--hasLink": "_playful-mode__copy--hasLink_13dub_142",
  "playful-mode__copy--hastText": "_playful-mode__copy--hastText_13dub_148",
  "playful-mode__link": "_playful-mode__link_13dub_153",
  "table-row": "_table-row_13dub_171",
  "legal-disclaimer": "_legal-disclaimer_13dub_175",
  "playful-mode__arrows": "_playful-mode__arrows_13dub_185",
  "disabled-arrow": "_disabled-arrow_13dub_199",
  swiper: swiper$1,
  maskWrapper,
  masks: masks$1,
  mask: mask$2,
  "mask--left": "_mask--left_13dub_243",
  "mask--brabus-left": "_mask--brabus-left_13dub_247",
  "mask--right": "_mask--right_13dub_251",
  "mask--brabus-right": "_mask--brabus-right_13dub_255"
};
const baseClass$l = "playful-mode";
React__default.createContext({
  changeSlide: void 0
});
const PlayfulMode = ({
  removeTopSpacing: removeTopSpacing2,
  variant,
  componentHeadline: componentHeadline2,
  // aspectRatio,
  galleryItems,
  legalDisclaimers,
  mode
}) => {
  const containerRefs = useRef([]);
  const videoRefs = useRef([]);
  const contentWidthIndicatorRef = useRef(null);
  const masksRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(1920);
  const [marginWidth, setMarginWidth] = useState(0);
  const [swiper2, setSwiper] = useState();
  const [swiperIndex, setSwiperIndex] = useState(0);
  const [tileCount, setTileCount] = useState(0);
  const slidePerView = useMemo(() => {
    let count = 0;
    if (variant === "ample") {
      count = windowWidth <= breakpoints$1.m ? 1 : 1;
    } else if (variant === "playful") {
      count = windowWidth <= breakpoints$1.m ? 1 : 2;
    }
    setTileCount(count);
    const tileWidth = (windowWidth - 2 * marginWidth) / count;
    const n = 2 * marginWidth / tileWidth;
    return count + n;
  }, [windowWidth, marginWidth, variant]);
  const CopyContainer = ({ item: item2 }) => {
    var _a;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(
          styles$z[`${baseClass$l}__copy`],
          {
            [styles$z[`${baseClass$l}__copy--hasLink`]]: windowWidth >= breakpoints$1.l || tileCount === 2
          },
          {
            [styles$z[`${baseClass$l}__copy--hastText`]]: windowWidth <= breakpoints$1.l || tileCount === 1
          }
        ),
        children: [
          item2.copyText && /* @__PURE__ */ jsx(RichText, { mdString: item2.copyText, wrapperElement: "section" }),
          /* @__PURE__ */ jsx("span", { className: styles$z[`${baseClass$l}__link`], children: (_a = item2.link) == null ? void 0 : _a.label })
        ]
      }
    );
  };
  useEffect(() => {
    const setWidth2 = () => {
      setWindowWidth(window.innerWidth);
      if (contentWidthIndicatorRef.current) {
        const width = (window.innerWidth - contentWidthIndicatorRef.current.clientWidth) / 2;
        setMarginWidth(width);
      }
    };
    setWidth2();
    window.addEventListener("resize", () => {
      setWidth2();
    });
    setTimeout(() => {
      var _a;
      const imageHeight = (_a = containerRefs.current[0]) == null ? void 0 : _a.clientHeight;
      const mask2 = masksRef.current;
      if (mask2) {
        mask2.style.height = `${imageHeight}px`;
      }
      if (videoRefs.current[0]) {
        videoRefs.current[0].play();
      }
    }, 500);
  }, []);
  const getAspectRatio = () => {
    let aspectRatio2 = "none";
    let styleRatio2 = "";
    if (variant === "ample") {
      styleRatio2 = windowWidth >= breakpoints$1.l ? "16/9" : "3/4";
      aspectRatio2 = windowWidth >= breakpoints$1.l ? "16-9" : "3-4";
    } else if (variant === "playful") {
      styleRatio2 = "3/4";
      aspectRatio2 = "3-4";
    }
    return { styleRatio: styleRatio2, aspectRatio: aspectRatio2 };
  };
  const { styleRatio, aspectRatio } = getAspectRatio();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: styles$z.contentWidth, ref: contentWidthIndicatorRef }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(styles$z[baseClass$l], {
          [styles$z[`${baseClass$l}--noTopSpacing`]]: removeTopSpacing2,
          "dark-theme": mode === "dark" || mode === "brabus"
        }),
        children: [
          componentHeadline2 && /* @__PURE__ */ jsx("p", { className: styles$z[`${baseClass$l}__componentHeadline`], children: componentHeadline2 }),
          /* @__PURE__ */ jsxs("div", { className: styles$z.maskWrapper, children: [
            /* @__PURE__ */ jsxs("div", { className: styles$z.masks, ref: masksRef, children: [
              swiperIndex > 0 && /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => swiper2 == null ? void 0 : swiper2.slidePrev(),
                  className: classNames(styles$z.mask, styles$z["mask--left"], {
                    [styles$z[`mask--brabus-left`]]: mode === "brabus"
                  })
                }
              ),
              swiperIndex < galleryItems.length - tileCount && /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => swiper2 == null ? void 0 : swiper2.slideNext(),
                  className: classNames(styles$z.mask, styles$z["mask--right"], {
                    [styles$z[`mask--brabus-right`]]: mode === "brabus"
                  })
                }
              )
            ] }),
            /* @__PURE__ */ jsx(
              Swiper2,
              {
                className: styles$z.swiper,
                slidesOffsetBefore: marginWidth,
                slidesOffsetAfter: marginWidth,
                speed: windowWidth <= breakpoints$1.m ? 300 : 500,
                spaceBetween: 4,
                slidesPerView: slidePerView,
                onSwiper: (s) => {
                  setSwiper(s);
                },
                onActiveIndexChange: (swiperCore) => {
                  setSwiperIndex(swiperCore.activeIndex);
                },
                touchEventsTarget: "container",
                children: galleryItems.map((item2, i) => {
                  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
                  return /* @__PURE__ */ jsx(SwiperSlide, { children: /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: classNames(styles$z[`${baseClass$l}__teaserContainer`], {
                        [styles$z[`${baseClass$l}__teaserContainer--hasLink`]]: ((_a = item2.link) == null ? void 0 : _a.href) && ((_b = item2.link) == null ? void 0 : _b.label)
                      }),
                      children: [
                        /* @__PURE__ */ jsxs(
                          "div",
                          {
                            className: classNames(styles$z[`${baseClass$l}__imageWrapper`]),
                            style: {
                              aspectRatio: variant === "ample" ? styleRatio : ""
                            },
                            ref: (el) => containerRefs.current[i] = el,
                            children: [
                              item2.contentType === "image" && /* @__PURE__ */ jsx(
                                DynamicMediaPicture,
                                {
                                  className: styles$z.img,
                                  imageAltText: ((_c = item2.image) == null ? void 0 : _c.imageAltText) || "",
                                  imageUrl: ((_d = item2.image) == null ? void 0 : _d.imageUrl) || "",
                                  imageConfigs: [
                                    {
                                      // eslint-disable-next-line no-nested-ternary
                                      aspectRatio,
                                      sizes: "100vw"
                                    }
                                  ]
                                }
                              ),
                              item2.contentType === "video" && /* @__PURE__ */ jsx(
                                VideoCard,
                                {
                                  ref: (el) => {
                                    if (el) {
                                      videoRefs.current[i] = el;
                                    }
                                  },
                                  className: styles$z.img,
                                  altText: ((_e = item2.video) == null ? void 0 : _e.altText) || "",
                                  landscapeUrl: ((_f = item2 == null ? void 0 : item2.video) == null ? void 0 : _f.landscapeUrl) || "",
                                  portraitUrl: ((_g = item2 == null ? void 0 : item2.video) == null ? void 0 : _g.portraitUrl) || "",
                                  posterUrl: (_h = item2.video) == null ? void 0 : _h.posterImageUrl,
                                  mode,
                                  observeVideo: windowWidth < breakpoints$1.l,
                                  onStart: () => {
                                    videoRefs.current.forEach((video2, index) => {
                                      if (i !== index) {
                                        if (video2.isPlaying()) {
                                          video2.pause();
                                        }
                                      }
                                    });
                                  }
                                }
                              )
                            ]
                          }
                        ),
                        item2.headline && /* @__PURE__ */ jsx("p", { className: styles$z[`${baseClass$l}__headline`], children: item2.headline }),
                        item2.copyText && /* @__PURE__ */ jsx(
                          "a",
                          {
                            onClick: (_i = item2 == null ? void 0 : item2.link) == null ? void 0 : _i.onClick,
                            href: (_j = item2 == null ? void 0 : item2.link) == null ? void 0 : _j.href,
                            target: (_k = item2 == null ? void 0 : item2.link) == null ? void 0 : _k.target,
                            rel: (_l = item2 == null ? void 0 : item2.link) == null ? void 0 : _l.rel,
                            className: styles$z[`${baseClass$l}__copyWrapper`],
                            children: /* @__PURE__ */ jsx(CopyContainer, { item: item2 })
                          }
                        )
                      ]
                    },
                    item2.itemId
                  ) }, `${item2.itemId}-${i}`);
                })
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: styles$z[`${baseClass$l}__arrows`], children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                className: classNames({ [styles$z["disabled-arrow"]]: swiperIndex === 0 }),
                onClick: () => swiper2 == null ? void 0 : swiper2.slidePrev(),
                children: /* @__PURE__ */ jsx(Icon, { name: "arrow-left--medium" })
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                className: classNames({ [styles$z["disabled-arrow"]]: swiperIndex === galleryItems.length - 1 }),
                onClick: () => swiper2 == null ? void 0 : swiper2.slideNext(),
                children: /* @__PURE__ */ jsx(Icon, { name: "arrow-right--medium" })
              }
            )
          ] }),
          legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsxs("div", { className: styles$z[`legal-disclaimer`], children: [
            /* @__PURE__ */ jsx("hr", {}),
            /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
          ] })
        ]
      }
    )
  ] });
};
const ExtendedFlexibleGallery = (props) => /* @__PURE__ */ jsxs(Fragment, { children: [
  props.variant === "highlight" && /* @__PURE__ */ jsx(HighlightMode, { ...props }),
  props.variant === "playful" && /* @__PURE__ */ jsx(PlayfulMode, { ...props }),
  props.variant === "ample" && /* @__PURE__ */ jsx(PlayfulMode, { ...props })
] });
const wrapper$1 = "_wrapper_13tri_1";
const video__heading = "_video__heading_13tri_9";
const styles$y = {
  wrapper: wrapper$1,
  "video--has-legal-disclaimer": "_video--has-legal-disclaimer_13tri_6",
  video__heading,
  "video__video-element": "_video__video-element_13tri_13",
  "legal-disclaimer": "_legal-disclaimer_13tri_18"
};
const baseClass$k = "video";
const Video = ({
  mode,
  className,
  video: video2,
  headline: headline2,
  isInView = false,
  videoRef,
  altText,
  legalDisclaimers
}) => {
  const classes2 = classNames(
    styles$y[baseClass$k],
    { [styles$y[`${baseClass$k}--has-legal-disclaimer`]]: legalDisclaimers },
    className
  );
  return /* @__PURE__ */ jsxs("section", { className: classNames(styles$y.wrapper, { "dark-theme": mode === "dark" || mode === "brabus" }), children: [
    /* @__PURE__ */ jsxs("section", { className: classes2, children: [
      headline2 && /* @__PURE__ */ jsx(Heading, { variant: "display-functional-200", tag: "h2", className: styles$y[`${baseClass$k}__heading`], children: headline2 }),
      /* @__PURE__ */ jsx(
        DynamicMediaVideo,
        {
          videoControls: true,
          ref: videoRef,
          className: styles$y[`${baseClass$k}__video-element`],
          video: video2,
          isInView,
          isBrabusTheme: mode === "brabus",
          altText
        }
      )
    ] }),
    legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$y[`legal-disclaimer`], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
  ] });
};
const navigation = "_navigation_gcfeh_14";
const video$2 = "_video_gcfeh_1";
const headline$e = "_headline_gcfeh_26";
const priceTag$1 = "_priceTag_gcfeh_29";
const cta$7 = "_cta_gcfeh_43";
const content$3 = "_content_gcfeh_46";
const hasNavigation = "_hasNavigation_gcfeh_65";
const styles$x = {
  "video-stage": "_video-stage_gcfeh_1",
  navigation,
  video: video$2,
  headline: headline$e,
  priceTag: priceTag$1,
  cta: cta$7,
  content: content$3,
  hasNavigation,
  "legal-disclaimer": "_legal-disclaimer_gcfeh_82"
};
const baseClass$j = "video-stage";
const VideoStageComponent = forwardRef(
  ({
    headline: headline2,
    landscapeVideoUrl,
    portraitVideoUrl,
    customVideoStylesBaseUrl,
    posterImageUrl,
    altText,
    link: link2,
    priceTag: priceTag2,
    videoControls = false,
    className,
    videoProps = { autoPlay: true, loop: false },
    legalDisclaimers,
    inStageNavigation
  }, forwardedRef) => {
    const isPortrait = useIsPortrait();
    const url = isPortrait ? portraitVideoUrl : landscapeVideoUrl;
    const hasDarkeningLayer = !!(headline2 || link2 || priceTag2 || inStageNavigation);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("section", { className: classNames(styles$x[baseClass$j], className), ref: forwardedRef, children: [
        inStageNavigation && /* @__PURE__ */ jsx(InStageNavigation, { className: styles$x.navigation, items: inStageNavigation }),
        /* @__PURE__ */ jsxs("div", { className: classNames(styles$x.content, { [styles$x.hasNavigation]: inStageNavigation }), children: [
          headline2 && /* @__PURE__ */ jsx(Heading, { withShadow: true, variant: "display-emotional-200", tag: "h1", className: styles$x.headline, children: headline2 }),
          priceTag2 && !inStageNavigation && /* @__PURE__ */ jsx(Heading, { withShadow: true, className: styles$x.priceTag, variant: "headline-functional-300", tag: "span", children: priceTag2 }),
          link2 && /* @__PURE__ */ jsx(TextLink, { ...link2, className: styles$x.cta, variant: "button-secondary-on-media", linkText: link2.label })
        ] }),
        /* @__PURE__ */ jsx(
          DynamicMediaVideo,
          {
            hasDarkeningLayer,
            withoutCenteredButton: true,
            altText,
            className: styles$x.video,
            videoControls,
            video: {
              url,
              customVideoStylesBaseUrl,
              autoPlay: videoProps == null ? void 0 : videoProps.autoPlay,
              mute: true,
              loop: videoProps == null ? void 0 : videoProps.loop,
              posterImageUrl
            },
            "aria-describedby": `${baseClass$j}__visually-hidden`,
            isInView: true,
            fetchPriority: "high"
          }
        )
      ] }),
      legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$x["legal-disclaimer"], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
    ] });
  }
);
VideoStageComponent.displayName = "VideoStage";
const VideoStage = withSetting(VideoStageComponent, "inverted");
const ExternalLinkPopUp = ({
  headline: headline2,
  copyText: copyText2,
  secondaryActionLabel,
  primaryActionLabel,
  isOpen: isOpen2,
  handleOutsideClick
}) => /* @__PURE__ */ jsx(
  Dialog,
  {
    isOpen: isOpen2,
    headline: { tag: "h2", children: headline2 },
    text: copyText2,
    ariaDescription: copyText2,
    outsideClick: handleOutsideClick,
    secondaryCTA: {
      onClick: secondaryActionLabel.onClick,
      children: secondaryActionLabel.label
    },
    primaryCTA: {
      linkText: primaryActionLabel.label,
      href: primaryActionLabel.href,
      onClick: primaryActionLabel.onClick,
      rel: primaryActionLabel.rel,
      target: primaryActionLabel.target,
      isExternal: primaryActionLabel.isExternal
    }
  }
);
const styles$w = {
  "richtext-standalone": "_richtext-standalone_yw9ai_1"
};
const baseClass$i = "richtext-standalone";
const RichtextStandalone = ({ richtext: richtext2 }) => /* @__PURE__ */ jsx(RichText, { className: styles$w[baseClass$i], mdString: richtext2, wrapperElement: "section" });
const open$1 = "_open_1snh4_61";
const logoswrapper$1 = "_logoswrapper_1snh4_238";
const pluscon_tainer$2 = "_pluscon_tainer_1snh4_248";
const plus_sign$2 = "_plus_sign_1snh4_253";
const minus_sign$2 = "_minus_sign_1snh4_261";
const plus_signs$2 = "_plus_signs_1snh4_270";
const reduction$2 = "_reduction_1snh4_273";
const contents$2 = "_contents_1snh4_276";
const unfold$2 = "_unfold_1snh4_282";
const closed$2 = "_closed_1snh4_290";
const icons$1 = "_icons_1snh4_321";
const logo$3 = "_logo_1snh4_238";
const richtext$1 = "_richtext_1snh4_499";
const styles$v = {
  "text-paragraph": "_text-paragraph_1snh4_37",
  "text-paragraph__remove-top-spacing": "_text-paragraph__remove-top-spacing_1snh4_41",
  "text-paragraph__componentHeadline--headline": "_text-paragraph__componentHeadline--headline_1snh4_44",
  open: open$1,
  "text-paragraph__componentHeadline--center": "_text-paragraph__componentHeadline--center_1snh4_64",
  "text-paragraph__content": "_text-paragraph__content_1snh4_68",
  "text-paragraph__richtext": "_text-paragraph__richtext_1snh4_73",
  "text-paragraph__col2": "_text-paragraph__col2_1snh4_130",
  "text-paragraph--right2-3": "_text-paragraph--right2-3_1snh4_133",
  "text-paragraph--right50-50": "_text-paragraph--right50-50_1snh4_133",
  "text-paragraph__link": "_text-paragraph__link_1snh4_147",
  "text-paragraph--left": "_text-paragraph--left_1snh4_152",
  "text-paragraph--center": "_text-paragraph--center_1snh4_157",
  "text-paragraph--offset": "_text-paragraph--offset_1snh4_162",
  "text-paragraph__componentHeadline": "_text-paragraph__componentHeadline_1snh4_44",
  "text-paragraph__componentHeadline--titletext": "_text-paragraph__componentHeadline--titletext_1snh4_170",
  "text-paragraph__link-wrapper": "_text-paragraph__link-wrapper_1snh4_192",
  "text-paragraph__secondary-link": "_text-paragraph__secondary-link_1snh4_204",
  "text-paragraph__primary-link": "_text-paragraph__primary-link_1snh4_217",
  "text-paragraph__body": "_text-paragraph__body_1snh4_225",
  "text-paragraph__bodes": "_text-paragraph__bodes_1snh4_228",
  logoswrapper: logoswrapper$1,
  pluscon_tainer: pluscon_tainer$2,
  plus_sign: plus_sign$2,
  minus_sign: minus_sign$2,
  plus_signs: plus_signs$2,
  "rotate-plus": "_rotate-plus_1snh4_1",
  reduction: reduction$2,
  "rotate-minus": "_rotate-minus_1snh4_1",
  contents: contents$2,
  unfold: unfold$2,
  "fade-in": "_fade-in_1snh4_1",
  closed: closed$2,
  "fade-out": "_fade-out_1snh4_1",
  "log-icos": "_log-icos_1snh4_313",
  "logo-wrappers": "_logo-wrappers_1snh4_316",
  icons: icons$1,
  "text-paragraph__componentHeadline--subtitle": "_text-paragraph__componentHeadline--subtitle_1snh4_415",
  "headlineParts--hl-200": "_headlineParts--hl-200_1snh4_444",
  "headlineParts--hl-300": "_headlineParts--hl-300_1snh4_458",
  "logo-wrapper--desktop": "_logo-wrapper--desktop_1snh4_472",
  "logo-wrapper--mobile": "_logo-wrapper--mobile_1snh4_472",
  logo: logo$3,
  richtext: richtext$1
};
const HeadlineContent = ({ tag = "h2", classnames: classnames2, children }) => {
  const Tag2 = tag;
  return /* @__PURE__ */ jsx(Tag2, { className: classnames2, children });
};
const HeadlineContent$1 = memo(HeadlineContent);
const baseClass$h = "text-paragraph";
const TextParagraph = ({
  layoutAlign = "left",
  title,
  logo: logo2,
  componentHeadline: componentHeadline2,
  headlineTagType = "h2",
  headlineAlign = "left",
  richTextColumn1,
  richTextColumn2,
  link: link2,
  asAccordion,
  useLimeGreen,
  secondaryLink: secondaryLink2,
  removeTopSpacing: removeTopSpacing2,
  mode,
  content: content2,
  size
}) => {
  const [expanded, setExpanded] = useState(false);
  const acquire = useRef(null);
  const contentAcquire = useRef(null);
  const getSizeClass = (s) => {
    const sizeClass = {
      "Headline/200": "hl-200",
      "Headline/300": "hl-300"
    };
    if (s && sizeClass[s]) {
      return sizeClass[s];
    }
    return "hl-300";
  };
  const animationsStyle = (pre) => {
    if (acquire.current) {
      if (pre) {
        acquire.current.classList.remove(styles$v.plus_signs);
        acquire.current.classList.add(styles$v.reduction);
      } else {
        acquire.current.classList.remove(styles$v.reduction);
        acquire.current.classList.add(styles$v.plus_signs);
      }
    }
    if (contentAcquire.current) {
      if (pre) {
        contentAcquire.current.classList.remove(styles$v.unfold);
        contentAcquire.current.classList.add(styles$v.closed);
      } else {
        contentAcquire.current.classList.remove(styles$v.closed);
        contentAcquire.current.classList.add(styles$v.unfold);
      }
    }
  };
  const onClick2 = () => {
    setExpanded((pre) => {
      animationsStyle(pre);
      return !pre;
    });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles$v[baseClass$h], {
        [styles$v[`${baseClass$h}__remove-top-spacing`]]: removeTopSpacing2,
        [`dark-theme`]: mode === "dark" || mode === "brabus"
      }),
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$v[`${baseClass$h}--${layoutAlign}`], children: [
          /* @__PURE__ */ jsxs("div", { className: styles$v[`${baseClass$h}__componentHeadline`], children: [
            title && (layoutAlign === "right2-3" || layoutAlign === "right50-50") && /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames({
                  [styles$v[`${baseClass$h}__componentHeadline--subtitle`]]: layoutAlign === "right2-3"
                }),
                children: [
                  (layoutAlign === "right50-50" || layoutAlign === "right2-3") && title && /* @__PURE__ */ jsx(Text, { variant: "paragraph-100", tag: "p", className: styles$v[`${baseClass$h}__componentHeadline--titletext`], children: title }),
                  layoutAlign === "right2-3" && logo2 && /* @__PURE__ */ jsx("div", { className: styles$v["logo-wrapper--desktop"], children: /* @__PURE__ */ jsx("img", { className: styles$v.logo, src: `${logo2}?wid=640`, alt: "award" }) })
                ]
              }
            ),
            componentHeadline2 && layoutAlign !== "right2-3" && /* @__PURE__ */ jsx(
              HeadlineContent$1,
              {
                classnames: classNames(
                  styles$v[`${baseClass$h}__componentHeadline--headline`],
                  styles$v[`${baseClass$h}__componentHeadline--${headlineAlign}`],
                  {
                    [styles$v.open]: layoutAlign === "right50-50"
                  }
                ),
                tag: headlineTagType === "h1" ? "h1" : "h2",
                children: componentHeadline2
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: styles$v[`${baseClass$h}__body`], children: [
            /* @__PURE__ */ jsx("div", { children: componentHeadline2 && layoutAlign === "right2-3" && /* @__PURE__ */ jsxs("div", { className: styles$v[`${baseClass$h}__bodes`], children: [
              /* @__PURE__ */ jsx(
                HeadlineContent$1,
                {
                  classnames: classNames(
                    styles$v[`${baseClass$h}__componentHeadline--headline`],
                    styles$v[`${baseClass$h}__componentHeadline--${headlineAlign}`],
                    styles$v[`headlineParts--${getSizeClass(size)}`]
                  ),
                  tag: headlineTagType === "h1" ? "h1" : "h2",
                  children: componentHeadline2
                }
              ),
              asAccordion && /* @__PURE__ */ jsx(
                "div",
                {
                  role: "button",
                  className: classNames(styles$v.logoswrapper),
                  onClick: onClick2,
                  onKeyDown: onClick2,
                  tabIndex: 0,
                  onMouseOver: () => {
                  },
                  onFocus: () => {
                  },
                  onMouseLeave: () => {
                  },
                  children: /* @__PURE__ */ jsx("div", { className: styles$v["logo-wrappers"], children: /* @__PURE__ */ jsxs("div", { className: styles$v.pluscon_tainer, children: [
                    /* @__PURE__ */ jsx("div", { className: styles$v.plus_sign }),
                    /* @__PURE__ */ jsx("div", { ref: acquire, className: classNames(styles$v.minus_sign) })
                  ] }) })
                }
              )
            ] }) }),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles$v[`${baseClass$h}__content`],
                style: {
                  width: layoutAlign === "right2-3" ? "var(--col-13)" : ""
                },
                children: [
                  richTextColumn1 && /* @__PURE__ */ jsx(
                    RichText,
                    {
                      className: classNames(
                        styles$v[`${baseClass$h}__richtext`],
                        styles$v[`${baseClass$h}__col1`],
                        styles$v[`headlineParts--${getSizeClass(size)}`]
                      ),
                      mdString: richTextColumn1,
                      wrapperElement: "section"
                    }
                  ),
                  richTextColumn2 && /* @__PURE__ */ jsx(
                    RichText,
                    {
                      className: classNames(styles$v[`${baseClass$h}__richtext`], styles$v[`${baseClass$h}__col2`]),
                      mdString: richTextColumn2,
                      wrapperElement: "section"
                    }
                  )
                ]
              }
            ),
            layoutAlign === "right2-3" && logo2 && /* @__PURE__ */ jsx("div", { className: styles$v["logo-wrapper--mobile"], children: /* @__PURE__ */ jsx("img", { className: styles$v.logo, src: `${logo2}?wid=640`, alt: "award" }) }),
            (link2 || (layoutAlign === "right50-50" || layoutAlign === "right2-3") && secondaryLink2) && /* @__PURE__ */ jsxs("div", { className: styles$v[`${baseClass$h}__link-wrapper`], children: [
              link2 && /* @__PURE__ */ jsx(
                TextLink,
                {
                  ...link2,
                  className: styles$v[`${baseClass$h}__primary-link`],
                  variant: (
                    // eslint-disable-next-line no-nested-ternary
                    useLimeGreen ? mode === "brabus" ? "button-primary-brabus" : "button-primary-lime" : "button-primary"
                  ),
                  linkText: link2.label
                }
              ),
              (layoutAlign === "right50-50" || layoutAlign === "right2-3") && secondaryLink2 && /* @__PURE__ */ jsx(
                TextLink,
                {
                  ...secondaryLink2,
                  className: styles$v[`${baseClass$h}__secondary-link`],
                  variant: "button-secondary",
                  linkText: secondaryLink2.label
                }
              )
            ] })
          ] })
        ] }),
        asAccordion && layoutAlign === "right2-3" && /* @__PURE__ */ jsx(
          "div",
          {
            id: `item__content__${0}`,
            ref: contentAcquire,
            className: classNames(styles$v.contents),
            role: "region",
            "aria-labelledby": `item__button__${0}`,
            "aria-hidden": !expanded,
            children: content2
          }
        )
      ]
    }
  );
};
const logo$2 = "_logo_3wcrl_175";
const styles$u = {
  "text-with-media": "_text-with-media_3wcrl_1",
  "text-with-media__remove-top-spacing": "_text-with-media__remove-top-spacing_3wcrl_13",
  "text-with-media-left": "_text-with-media-left_3wcrl_16",
  "text-with-media__content-wrapper": "_text-with-media__content-wrapper_3wcrl_27",
  "text-with-media-right": "_text-with-media-right_3wcrl_39",
  "text-with-media__content": "_text-with-media__content_3wcrl_27",
  "text-with-media__media": "_text-with-media__media_3wcrl_55",
  "text-with-media__media-container": "_text-with-media__media-container_3wcrl_60",
  "text-with-media__video": "_text-with-media__video_3wcrl_71",
  "text-with-media__headline": "_text-with-media__headline_3wcrl_104",
  "text-with-media__copy-text": "_text-with-media__copy-text_3wcrl_120",
  "text-with-media__secondary-link": "_text-with-media__secondary-link_3wcrl_149",
  "text-with-media__primary-link": "_text-with-media__primary-link_3wcrl_149",
  "text-with-media__link-wrapper": "_text-with-media__link-wrapper_3wcrl_160",
  "legal-disclaimer": "_legal-disclaimer_3wcrl_172",
  "logos-wrapper": "_logos-wrapper_3wcrl_175",
  "logo-wrapper": "_logo-wrapper_3wcrl_181",
  logo: logo$2
};
const baseClass$g = "text-with-media";
const imageConfig$4 = [
  {
    aspectRatio: "4-3",
    sizes: "87.5vw",
    media: `(max-width: ${breakpoints$1.l}px)`
  },
  {
    aspectRatio: "4-3",
    sizes: "61vw",
    media: `(min-width: ${breakpoints$1.l}px)`
  }
];
const TextWithMedia = ({
  alignment,
  contentText,
  secondaryLink: secondaryLink2,
  useLimeGreen,
  primaryLink: primaryLink2,
  logos: logos2,
  image: image2,
  video: video2,
  headline: headline2,
  removeTopSpacing: removeTopSpacing2,
  legalDisclaimers,
  mode
}) => {
  const isPortrait = useIsPortrait();
  const videoRefs = useRef([]);
  const videoUrl = isPortrait ? video2 == null ? void 0 : video2.portraitUrl : video2 == null ? void 0 : video2.landscapeUrl;
  useEffect(() => {
    if (videoRefs.current[0]) {
      videoRefs.current[0].play();
    }
  }, []);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles$u[`${baseClass$g}`], styles$u[`${baseClass$g}-${alignment}`], {
        [styles$u[`${baseClass$g}__remove-top-spacing`]]: removeTopSpacing2,
        [`dark-theme`]: mode === "dark" || mode === "brabus"
      }),
      children: [
        /* @__PURE__ */ jsx("div", { className: styles$u[`${baseClass$g}__content-wrapper`], children: /* @__PURE__ */ jsxs("div", { className: styles$u[`${baseClass$g}__content`], children: [
          headline2 && /* @__PURE__ */ jsx("div", { className: styles$u[`${baseClass$g}__headline`], children: headline2 }),
          contentText && /* @__PURE__ */ jsx(
            RichText,
            {
              className: styles$u[`${baseClass$g}__copy-text`],
              mdString: contentText,
              wrapperElement: "section"
            }
          ),
          logos2 && logos2.length > 0 && /* @__PURE__ */ jsx("div", { className: styles$u["logos-wrapper"], children: /* @__PURE__ */ jsx("div", { className: styles$u["logo-wrapper"], children: /* @__PURE__ */ jsx("img", { className: styles$u.logo, src: `${logos2[0]}?wid=640`, alt: "award" }) }) }),
          (primaryLink2 || secondaryLink2) && /* @__PURE__ */ jsxs("div", { className: styles$u[`${baseClass$g}__link-wrapper`], children: [
            primaryLink2 && /* @__PURE__ */ jsx(
              TextLink,
              {
                ...primaryLink2,
                className: styles$u[`${baseClass$g}__primary-link`],
                variant: (
                  // eslint-disable-next-line no-nested-ternary
                  useLimeGreen ? mode === "brabus" ? "button-primary-brabus" : "button-primary-lime" : "button-primary"
                ),
                linkText: primaryLink2.label
              }
            ),
            secondaryLink2 && /* @__PURE__ */ jsx(
              TextLink,
              {
                ...secondaryLink2,
                className: styles$u[`${baseClass$g}__secondary-link`],
                variant: "button-secondary",
                linkText: secondaryLink2.label
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ jsxs("div", { className: styles$u[`${baseClass$g}__media-container`], children: [
          videoUrl ? /* @__PURE__ */ jsx(
            VideoCard,
            {
              ref: (el) => {
                if (el) {
                  videoRefs.current[0] = el;
                }
              },
              className: styles$u[`${baseClass$g}__video`],
              altText: (video2 == null ? void 0 : video2.mediaAltText) || "",
              landscapeUrl: videoUrl || "",
              portraitUrl: (video2 == null ? void 0 : video2.portraitUrl) || "",
              posterUrl: video2 == null ? void 0 : video2.posterImageUrl,
              mode
            }
          ) : /* @__PURE__ */ jsx(
            DynamicMediaPicture,
            {
              className: styles$u[`${baseClass$g}__media`],
              imageAltText: (image2 == null ? void 0 : image2.imageAltText) || "",
              imageConfigs: imageConfig$4,
              imageUrl: (image2 == null ? void 0 : image2.imageUrl) || "",
              hasImageTransparency: image2 == null ? void 0 : image2.hasImageTransparency
            }
          ),
          legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$u[`legal-disclaimer`], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
        ] })
      ]
    }
  ) });
};
const steps = "_steps_1wo18_1";
const contentContainer = "_contentContainer_1wo18_4";
const headlineContainer = "_headlineContainer_1wo18_13";
const headline$d = "_headline_1wo18_13";
const imageContainer$1 = "_imageContainer_1wo18_28";
const image$4 = "_image_1wo18_28";
const indicatorBar$5 = "_indicatorBar_1wo18_46";
const legal$2 = "_legal_1wo18_54";
const stepItem = "_stepItem_1wo18_63";
const stepItemsCtaContainerWrap = "_stepItemsCtaContainerWrap_1wo18_92";
const numberHeadlineContainer = "_numberHeadlineContainer_1wo18_104";
const stepItemText = "_stepItemText_1wo18_118";
const circle = "_circle_1wo18_122";
const cta$6 = "_cta_1wo18_151";
const stepItemsCtaContainer = "_stepItemsCtaContainer_1wo18_92";
const noMargins = "_noMargins_1wo18_174";
const styles$t = {
  steps,
  contentContainer,
  headlineContainer,
  headline: headline$d,
  imageContainer: imageContainer$1,
  image: image$4,
  indicatorBar: indicatorBar$5,
  legal: legal$2,
  stepItem,
  stepItemsCtaContainerWrap,
  numberHeadlineContainer,
  stepItemText,
  circle,
  cta: cta$6,
  stepItemsCtaContainer,
  noMargins
};
var util;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item2 of items) {
      obj[item2] = item2;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item2 of arr) {
      if (checker(item2))
        return item2;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value2) => {
    if (typeof value2 === "bigint") {
      return value2.toString();
    }
    return value2;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
const getParsedType = (data2) => {
  const t = typeof data2;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data2) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data2)) {
        return ZodParsedType.array;
      }
      if (data2 === null) {
        return ZodParsedType.null;
      }
      if (data2.then && typeof data2.then === "function" && data2.catch && typeof data2.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data2 instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data2 instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data2 instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
const ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
const quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
const errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
let overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (params) => {
  const { data: data2, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data: data2, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: issueData.message || errorMessage
  };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      getErrorMap(),
      errorMap
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      syncPairs.push({
        key: await pair.key,
        value: await pair.value
      });
    }
    return ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value: value2 } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value2.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value2.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value2.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value2.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
});
const DIRTY = (value2) => ({ status: "dirty", value: value2 });
const OK = (value2) => ({ status: "valid", value: value2 });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
class ParseInputLazyPath {
  constructor(parent, value2, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value2;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
}
const handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description: description2 } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description: description2 };
  const customMap = (iss, ctx) => {
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    if (typeof ctx.data === "undefined") {
      return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
    }
    return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
  };
  return { errorMap: customMap, description: description2 };
}
class ZodType {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data2, params) {
    const result = this.safeParse(data2, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data2, params) {
    var _a;
    const ctx = {
      common: {
        issues: [],
        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: data2,
      parsedType: getParsedType(data2)
    };
    const result = this._parseSync({ data: data2, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  async parseAsync(data2, params) {
    const result = await this.safeParseAsync(data2, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data2, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
        async: true
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: data2,
      parsedType: getParsedType(data2)
    };
    const maybeAsyncResult = this._parse({ data: data2, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data2) => {
          if (!data2) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description2) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description: description2
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const datetimeRegex = (args) => {
  if (args.precision) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    }
  } else if (args.precision === 0) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    }
  } else {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
  }
};
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
class ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(
        ctx2,
        {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: ctx2.parsedType
        }
        //
      );
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data2) => regex.test(data2), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message)
    });
  }
  _addCheck(check) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    var _a;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message)
    });
  }
  includes(value2, options) {
    return this._addCheck({
      kind: "includes",
      value: value2,
      position: options === null || options === void 0 ? void 0 : options.position,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  startsWith(value2, message) {
    return this._addCheck({
      kind: "startsWith",
      value: value2,
      ...errorUtil.errToObj(message)
    });
  }
  endsWith(value2, message) {
    return this._addCheck({
      kind: "endsWith",
      value: value2,
      ...errorUtil.errToObj(message)
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message)
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message)
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
}
ZodString.create = (params) => {
  var _a;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value2, message) {
    return this.setLimit("min", value2, true, errorUtil.toString(message));
  }
  gt(value2, message) {
    return this.setLimit("min", value2, false, errorUtil.toString(message));
  }
  lte(value2, message) {
    return this.setLimit("max", value2, true, errorUtil.toString(message));
  }
  lt(value2, message) {
    return this.setLimit("max", value2, false, errorUtil.toString(message));
  }
  setLimit(kind, value2, inclusive, message) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value: value2,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value2, message) {
    return this._addCheck({
      kind: "multipleOf",
      value: value2,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
}
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value2, message) {
    return this.setLimit("min", value2, true, errorUtil.toString(message));
  }
  gt(value2, message) {
    return this.setLimit("min", value2, false, errorUtil.toString(message));
  }
  lte(value2, message) {
    return this.setLimit("max", value2, true, errorUtil.toString(message));
  }
  lt(value2, message) {
    return this.setLimit("max", value2, false, errorUtil.toString(message));
  }
  setLimit(kind, value2, inclusive, message) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value: value2,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value2, message) {
    return this._addCheck({
      kind: "multipleOf",
      value: value2,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
}
ZodBigInt.create = (params) => {
  var _a;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
    ...processCreateParams(params)
  });
};
class ZodBoolean extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
class ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
}
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
class ZodSymbol extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
class ZodUndefined extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
class ZodNull extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
class ZodAny extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
class ZodNever extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
}
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
class ZodVoid extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
class ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item2, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item2, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item2, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item2, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) }
    });
  }
  max(maxLength, message) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    });
  }
  length(len, message) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) }
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
}
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item2) => deepPartialify(item2)));
  } else {
    return schema;
  }
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value2 = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value2, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip")
        ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value2 = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value2, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          syncPairs.push({
            key,
            value: await pair.value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message !== void 0 ? {
        errorMap: (issue, ctx) => {
          var _a, _b, _c, _d;
          const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new ZodObject({
      ...this._def,
      catchall: index
    });
  }
  pick(mask2) {
    const shape = {};
    util.objectKeys(mask2).forEach((key) => {
      if (mask2[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask2) {
    const shape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (!mask2[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask2) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask2 && !mask2[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask2) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (mask2 && !mask2[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
}
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
class ZodUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (types, params) => {
  return new ZodUnion({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
const getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return Object.keys(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else {
    return null;
  }
};
class ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value2 of discriminatorValues) {
        if (optionsMap.has(value2)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value2)}`);
        }
        optionsMap.set(value2, type);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
}
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = { ...a, ...b };
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
class ZodIntersection extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
}
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
class ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item2, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item2, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new ZodTuple({
      ...this._def,
      rest
    });
  }
}
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value2], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value2, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value2 = await pair.value;
          if (key.status === "aborted" || value2.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value2.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value2.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value2 = pair.value;
        if (key.status === "aborted" || value2.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value2.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value2.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
}
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
class ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item2, i) => valueType._parse(new ParseInputLazyPath(ctx, item2, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) }
    });
  }
  max(maxSize, message) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    });
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
}
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error.addIssue(makeArgsIssue(args, e));
          throw error;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e) => {
          error.addIssue(makeReturnsIssue(result, e));
          throw error;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
}
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
class ZodLiteral extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (value2, params) => {
  return new ZodLiteral({
    value: value2,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
class ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (this._def.values.indexOf(input.data) === -1) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values) {
    return ZodEnum.create(values);
  }
  exclude(values) {
    return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
  }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (nativeEnumValues.indexOf(input.data) === -1) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
}
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data2) => {
      return this._def.type.parseAsync(data2, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
}
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.issues.length) {
        return {
          status: "dirty",
          value: ctx.data
        };
      }
      if (ctx.common.async) {
        return Promise.resolve(processed).then((processed2) => {
          return this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
        });
      } else {
        return this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner2 = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner2.status === "aborted")
          return INVALID;
        if (inner2.status === "dirty")
          status.dirty();
        executeRefinement(inner2.value);
        return { status: status.value, value: inner2.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner2) => {
          if (inner2.status === "aborted")
            return INVALID;
          if (inner2.status === "dirty")
            status.dirty();
          return executeRefinement(inner2.value).then(() => {
            return { status: status.value, value: inner2.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util.assertNever(effect);
  }
}
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
class ZodOptional extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
class ZodNullable extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
class ZodDefault extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data2 = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data2 = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data: data2,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
class ZodCatch extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
class ZodNaN extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
}
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data2 = ctx.data;
    return this._def.type._parse({
      data: data2,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
class ZodReadonly extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    if (isValid(result)) {
      result.value = Object.freeze(result.value);
    }
    return result;
  }
}
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
const custom = (check, params = {}, fatal) => {
  if (check)
    return ZodAny.create().superRefine((data2, ctx) => {
      var _a, _b;
      if (!check(data2)) {
        const p = typeof params === "function" ? params(data2) : typeof params === "string" ? { message: params } : params;
        const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
        const p2 = typeof p === "string" ? { message: p } : p;
        ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
      }
    });
  return ZodAny.create();
};
const late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data2) => data2 instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
  string: (arg) => ZodString.create({ ...arg, coerce: true }),
  number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
  boolean: (arg) => ZodBoolean.create({
    ...arg,
    coerce: true
  }),
  bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
  date: (arg) => ZodDate.create({ ...arg, coerce: true })
};
const NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  "enum": enumType,
  "function": functionType,
  "instanceof": instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  "null": nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  "undefined": undefinedType,
  union: unionType,
  unknown: unknownType,
  "void": voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});
const deepExcludeNull = (value2) => {
  if (Array.isArray(value2)) {
    return value2.map(deepExcludeNull).filter((item2) => item2 !== void 0);
  }
  if (isObject(value2)) {
    return Object.fromEntries(
      Object.entries(value2).map((entry) => [
        entry[0],
        deepExcludeNull(entry[1])
      ])
    );
  }
  return value2 === null ? void 0 : value2;
};
const isObject = (value2) => {
  return value2 !== null && typeof value2 === `object`;
};
function sanitizeGraphqlData(schema, data2) {
  return deepExcludeNull(schema.parse(data2));
}
const StepsContentFragment = z.object({
  headline: z.string().nullish(),
  linkDestination: LinkDestination.nullish(),
  linkLabel: z.string().nullish(),
  indicatorBar: z.boolean().nullish(),
  legalDisclaimer: LegalDisclaimers.nullish(),
  items: z.array(
    z.object({
      headline: z.string().nullish(),
      copyText: z.object({ markdown: z.string().nullish() }).nullish()
    })
  ),
  mboxName: z.string().nullish()
}).and(ImageWithTransparencySupportContent);
const createStepsContent = (contentFragment, options) => {
  const {
    image: image2,
    items,
    headline: headline2,
    mboxName,
    linkLabel,
    imageAltText,
    indicatorBar: indicatorBar2,
    linkDestination,
    legalDisclaimer: legalDisclaimer2,
    imageTransparencySupport
  } = sanitizeGraphqlData(StepsContentFragment, contentFragment);
  return {
    type: `steps`,
    id: createId(contentFragment),
    anchorId: createId(contentFragment._path),
    headline: headline2,
    image: createImage({ image: image2, imageAltText, imageTransparencySupport }, options),
    link: createLinkContent({ destination: linkDestination, label: linkLabel }),
    indicatorBar: indicatorBar2,
    legalDisclaimers: legalDisclaimer2 ? createLegalDisclaimerContents(legalDisclaimer2, options) : [],
    items: items.map(
      (item2) => {
        var _a;
        return item2.headline && ((_a = item2.copyText) == null ? void 0 : _a.markdown) ? { headline: item2.headline, copyText: item2.copyText.markdown } : void 0;
      }
    ).filter((item2) => item2 !== void 0),
    mboxName
  };
};
const generateStepItems = (items) => items.map((item2, i) => /* @__PURE__ */ jsxs("div", { className: styles$t.stepItem, children: [
  /* @__PURE__ */ jsxs("div", { className: styles$t.numberHeadlineContainer, children: [
    /* @__PURE__ */ jsx("div", { className: styles$t.circle, children: i + 1 }),
    /* @__PURE__ */ jsx(Heading, { tag: "span", variant: "headline-functional-200", children: item2.headline })
  ] }),
  /* @__PURE__ */ jsx(RichText, { className: styles$t.stepItemText, mdString: item2.copyText })
] }, item2.headline + i));
const Steps = ({ fragment, className, envName, preview = false }) => {
  const classes2 = classNames(styles$t.steps, className);
  const ref = useRef(null);
  const indicatorBarProgress = useScrollIndicatorProgress(ref);
  const { headline: headline2, indicatorBar: indicatorBar2, image: image2, legalDisclaimers, items, link: link2 } = createStepsContent(fragment, {
    envName,
    preview,
    showPrismAnimation: true
  });
  return /* @__PURE__ */ jsxs("section", { className: classes2, children: [
    (headline2 || indicatorBar2) && /* @__PURE__ */ jsxs("div", { className: styles$t.headlineContainer, children: [
      headline2 && /* @__PURE__ */ jsx(Heading, { variant: "display-functional-200", tag: "h2", className: styles$t.headline, children: headline2 }),
      indicatorBar2 && /* @__PURE__ */ jsx(IndicatorBar, { progress: indicatorBarProgress, className: styles$t.indicatorBar, ref })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles$t.contentContainer, children: [
      /* @__PURE__ */ jsxs("div", { className: styles$t.imageContainer, children: [
        /* @__PURE__ */ jsx(
          DynamicMediaPicture,
          {
            imageConfigs: mobileFullDesktopHalfImageConfig,
            imageUrl: image2.imageUrl,
            imageAltText: image2.imageAltText,
            className: styles$t.image,
            hasImageTransparency: image2.hasImageTransparency
          }
        ),
        legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$t.legal, children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
      ] }),
      /* @__PURE__ */ jsx("div", { className: styles$t.stepItemsCtaContainerWrap, children: /* @__PURE__ */ jsxs("div", { className: styles$t.stepItemsCtaContainer, children: [
        generateStepItems(items),
        link2 && /* @__PURE__ */ jsx(TextLink, { href: "", ...link2, variant: "button-primary", className: styles$t.cta, linkText: link2.label })
      ] }) })
    ] })
  ] });
};
const headlineWithImage = "_headlineWithImage_1kusr_1";
const componentHeading = "_componentHeading_1kusr_7";
const noIndicatorBar = "_noIndicatorBar_1kusr_12";
const indicatorBar$4 = "_indicatorBar_1kusr_15";
const heading$2 = "_heading_1kusr_28";
const imageContainer = "_imageContainer_1kusr_33";
const image$3 = "_image_1kusr_33";
const legal$1 = "_legal_1kusr_45";
const cta$5 = "_cta_1kusr_51";
const styles$s = {
  headlineWithImage,
  componentHeading,
  noIndicatorBar,
  indicatorBar: indicatorBar$4,
  heading: heading$2,
  imageContainer,
  image: image$3,
  legal: legal$1,
  cta: cta$5
};
const imageConfig$3 = [
  {
    aspectRatio: "16-9",
    sizes: "100vw"
  }
];
const HeadlineWithImage = ({
  className,
  componentHeadline: componentHeadline2,
  indicatorBar: indicatorBar2,
  headline: headline2,
  image: image2,
  highlight,
  legalDisclaimers,
  link: link2
}) => {
  const componentHeadlineType = highlight ? "display-functional-200" : "display-functional-200-fixed";
  const classes2 = classNames(styles$s.headlineWithImage, { [styles$s.noIndicatorBar]: !indicatorBar2 }, className);
  const indicatorBarRef = useRef(null);
  const indicatorBarProgress = useScrollIndicatorProgress(indicatorBarRef);
  return /* @__PURE__ */ jsxs("div", { className: classes2, children: [
    componentHeadline2 && /* @__PURE__ */ jsx(Heading, { variant: componentHeadlineType, tag: "h2", className: styles$s.componentHeading, children: componentHeadline2 }),
    indicatorBar2 && /* @__PURE__ */ jsx(IndicatorBar, { progress: indicatorBarProgress, ref: indicatorBarRef, className: styles$s.indicatorBar }),
    headline2 && /* @__PURE__ */ jsx(Heading, { variant: "headline-functional-400", tag: "h3", className: styles$s.heading, children: headline2 }),
    /* @__PURE__ */ jsx("div", { className: styles$s.imageContainer, children: /* @__PURE__ */ jsx(
      DynamicMediaPicture,
      {
        className: styles$s.image,
        imageUrl: image2.imageUrl,
        imageAltText: image2.imageAltText,
        imageConfigs: imageConfig$3,
        hasImageTransparency: image2.hasImageTransparency
      }
    ) }),
    legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$s.legal, children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) }),
    link2 && /* @__PURE__ */ jsx(TextLink, { ...link2, variant: "button-primary", className: styles$s.cta, linkText: link2.label })
  ] });
};
const teaserRow = "_teaserRow_zknuz_1";
const componentHeadline$1 = "_componentHeadline_zknuz_7";
const indicatorBar$3 = "_indicatorBar_zknuz_11";
const teaserList$1 = "_teaserList_zknuz_14";
const teaserContainer$1 = "_teaserContainer_zknuz_26";
const button$2 = "_button_zknuz_88";
const iconButton = "_iconButton_zknuz_89";
const picture$5 = "_picture_zknuz_96";
const headline$c = "_headline_zknuz_104";
const styles$r = {
  teaserRow,
  componentHeadline: componentHeadline$1,
  indicatorBar: indicatorBar$3,
  teaserList: teaserList$1,
  teaserContainer: teaserContainer$1,
  button: button$2,
  iconButton,
  picture: picture$5,
  headline: headline$c
};
const imageConfig$2 = [
  {
    aspectRatio: "1-1",
    sizes: "100vw",
    media: `(max-width: ${breakpoints$1.m}px)`
  },
  {
    aspectRatio: "1-1",
    sizes: "45vw",
    media: `(max-width: ${breakpoints$1.xl}px)`
  },
  {
    aspectRatio: "1-1",
    media: `(min-width: ${breakpoints$1.xl}px)`,
    sizes: "25vw"
  }
];
const TeaserRow = ({ className, componentHeadline: componentHeadline2, indicatorBar: indicatorBar2, teaserList: teaserList2 }) => {
  const classes2 = classNames(styles$r.teaserRow, className);
  const indicatorBarRef = useRef(null);
  const indicatorBarProgress = useScrollIndicatorProgress(indicatorBarRef);
  return /* @__PURE__ */ jsxs("div", { className: classes2, children: [
    componentHeadline2 && /* @__PURE__ */ jsx(Heading, { variant: "display-functional-200", tag: "h2", className: styles$r.componentHeadline, children: componentHeadline2 }),
    indicatorBar2 && /* @__PURE__ */ jsx(IndicatorBar, { progress: indicatorBarProgress, ref: indicatorBarRef, className: styles$r.indicatorBar }),
    /* @__PURE__ */ jsx("div", { className: styles$r.teaserList, children: teaserList2.map((teaser, i) => /* @__PURE__ */ jsxs(
      "a",
      {
        href: teaser.link.href,
        onClick: teaser.link.onClick,
        className: styles$r.teaserContainer,
        target: teaser.link.target,
        rel: teaser.link.rel,
        children: [
          /* @__PURE__ */ jsx("div", { className: styles$r.headline, children: teaser.link.label }),
          /* @__PURE__ */ jsx("div", { className: styles$r.iconButton, children: /* @__PURE__ */ jsx(Icon, { name: "arrow-right--small", "aria-hidden": true }) }),
          /* @__PURE__ */ jsx(
            DynamicMediaPicture,
            {
              hasDarkeningLayer: !!teaser.link.label,
              className: styles$r.picture,
              imageConfigs: imageConfig$2,
              imageAltText: teaser.image.imageAltText,
              imageUrl: teaser.image.imageUrl
            }
          )
        ]
      },
      teaser.image.imageAltText + i
    )) })
  ] });
};
const legalDisclaimerStandalone = "_legalDisclaimerStandalone_a6dqy_1";
const styles$q = {
  legalDisclaimerStandalone
};
const LegalDisclaimerStandalone = ({ mode, legalDisclaimers }) => /* @__PURE__ */ jsx(
  "section",
  {
    className: classNames(styles$q.legalDisclaimerStandalone, {
      "dark-theme": mode === "dark" || mode === "brabus"
    }),
    "data-nosnippet": "true",
    children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
  }
);
const teaserRowWithText = "_teaserRowWithText_2dssv_1";
const componentHeadline = "_componentHeadline_2dssv_7";
const indicatorBar$2 = "_indicatorBar_2dssv_11";
const teaserList = "_teaserList_2dssv_14";
const teaserContainer = "_teaserContainer_2dssv_30";
const link$4 = "_link_2dssv_54";
const picture$4 = "_picture_2dssv_62";
const body$2 = "_body_2dssv_67";
const headline$b = "_headline_2dssv_82";
const copy = "_copy_2dssv_97";
const linklabel = "_linklabel_2dssv_113";
const label$2 = "_label_2dssv_129";
const icon = "_icon_2dssv_133";
const styles$p = {
  teaserRowWithText,
  componentHeadline,
  indicatorBar: indicatorBar$2,
  teaserList,
  teaserContainer,
  link: link$4,
  picture: picture$4,
  body: body$2,
  headline: headline$b,
  copy,
  linklabel,
  label: label$2,
  icon
};
const imageConfig$1 = [
  {
    aspectRatio: "4-3",
    sizes: "100vw",
    media: `(max-width: ${breakpoints$1.m / 16}em)`
  },
  {
    aspectRatio: "4-3",
    sizes: "45vw",
    media: `(max-width: ${breakpoints$1.xl / 16}em)`
  },
  {
    aspectRatio: "4-3",
    media: `(min-width: ${breakpoints$1.xl / 16}em)`,
    sizes: "33vw"
  }
];
const TeaserRowWithText = ({
  className,
  componentHeadline: componentHeadline2,
  indicatorBar: indicatorBar2,
  items
}) => {
  const classes2 = classNames(styles$p.teaserRowWithText, className);
  const indicatorBarRef = useRef(null);
  const indicatorBarProgress = useScrollIndicatorProgress(indicatorBarRef);
  const generateTeaserList = () => items.map((teaser, idx) => /* @__PURE__ */ jsx("li", { className: styles$p.teaserContainer, children: /* @__PURE__ */ jsxs(
    "a",
    {
      className: styles$p.link,
      href: teaser.link.href,
      onClick: teaser.link.onClick,
      target: teaser.link.target,
      rel: teaser.link.rel,
      children: [
        /* @__PURE__ */ jsx(
          DynamicMediaPicture,
          {
            className: styles$p.picture,
            imageConfigs: imageConfig$1,
            imageAltText: teaser.image.imageAltText,
            imageUrl: teaser.image.imageUrl
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: styles$p.body, children: [
          /* @__PURE__ */ jsx("span", { className: styles$p.headline, children: teaser.headline }),
          /* @__PURE__ */ jsx("p", { className: styles$p.copy, children: teaser.copyText }),
          /* @__PURE__ */ jsxs("span", { className: styles$p.linklabel, children: [
            /* @__PURE__ */ jsx("span", { className: styles$p.label, children: teaser.link.label }),
            teaser.link.isExternal && /* @__PURE__ */ jsx("span", { className: styles$p.icon, children: /* @__PURE__ */ jsx(Icon, { name: "external-link--small" }) })
          ] })
        ] })
      ]
    }
  ) }, `teaser-li-${idx}-id`));
  return /* @__PURE__ */ jsxs("div", { className: classes2, children: [
    componentHeadline2 && /* @__PURE__ */ jsx(Heading, { variant: "display-functional-200", tag: "h2", className: styles$p.componentHeadline, children: componentHeadline2 }),
    indicatorBar2 && /* @__PURE__ */ jsx(IndicatorBar, { progress: indicatorBarProgress, ref: indicatorBarRef, className: styles$p.indicatorBar }),
    items && !!items.length && /* @__PURE__ */ jsx("ul", { className: styles$p.teaserList, children: generateTeaserList() })
  ] });
};
const imageStage = "_imageStage_1lui1_1";
const content$2 = "_content_1lui1_5";
const heading$1 = "_heading_1lui1_39";
const picture$3 = "_picture_1lui1_44";
const legal = "_legal_1lui1_52";
const styles$o = {
  imageStage,
  content: content$2,
  heading: heading$1,
  picture: picture$3,
  legal
};
const ImageStageSmall = forwardRef(
  ({ headline: headline2, image: image2, legalDisclaimers, className }, forwardedRef) => /* @__PURE__ */ jsxs("section", { className: classNames(styles$o.imageStage, className), ref: forwardedRef, children: [
    /* @__PURE__ */ jsxs("div", { className: styles$o.content, children: [
      /* @__PURE__ */ jsx(Heading, { withShadow: true, className: styles$o.heading, variant: "display-emotional-200", tag: "h2", children: headline2 }),
      /* @__PURE__ */ jsx(
        DynamicMediaPicture,
        {
          hasDarkeningLayer: !!headline2,
          className: styles$o.picture,
          imageAltText: image2.imageAltText,
          imageUrl: image2.imageUrl,
          imageConfigs: fullWidthImageConfigs,
          initialIsInView: true,
          noLoadingLogo: true,
          isObjectFit: true,
          fetchPriority: "high"
        }
      )
    ] }),
    legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$o.legal, children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
  ] })
);
ImageStageSmall.displayName = "ImageStageSmall";
const factsAndFigures = "_factsAndFigures_1q6yw_1";
const headline$a = "_headline_1q6yw_7";
const indicatorBar$1 = "_indicatorBar_1q6yw_11";
const tabs = "_tabs_1q6yw_14";
const hidden$1 = "_hidden_1q6yw_29";
const card = "_card_1q6yw_40";
const body$1 = "_body_1q6yw_45";
const picture$2 = "_picture_1q6yw_58";
const facts = "_facts_1q6yw_1";
const label$1 = "_label_1q6yw_87";
const reference = "_reference_1q6yw_103";
const value = "_value_1q6yw_118";
const buttonContainer = "_buttonContainer_1q6yw_142";
const button$1 = "_button_1q6yw_142";
const legalDisclaimer$1 = "_legalDisclaimer_1q6yw_187";
const styles$n = {
  factsAndFigures,
  headline: headline$a,
  indicatorBar: indicatorBar$1,
  tabs,
  hidden: hidden$1,
  card,
  body: body$1,
  picture: picture$2,
  facts,
  label: label$1,
  reference,
  value,
  buttonContainer,
  button: button$1,
  legalDisclaimer: legalDisclaimer$1
};
const imageConfig = [
  {
    aspectRatio: "4-3",
    sizes: "100vw",
    media: ""
  },
  {
    aspectRatio: "4-3",
    sizes: "50vw",
    media: `(min-width: ${breakpoints$1.m / 16}em)`
  },
  {
    aspectRatio: "4-3",
    sizes: "33vw",
    media: `(min-width: ${breakpoints$1.l / 16}em)`
  }
];
const FactsAndFigures = ({
  componentHeadline: componentHeadline2,
  items: cards,
  indicatorBar: indicatorBar2,
  className
}) => {
  const indicatorBarRef = useRef(null);
  const indicatorBarProgress = useScrollIndicatorProgress$1(indicatorBarRef);
  const generateTabs = () => cards.map((card2) => ({
    headline: card2.tabTitle,
    content: generateCard(card2),
    id: card2.tabTitle.replace(/[^\w]/g, "")
  }));
  const generateCard = (card2) => /* @__PURE__ */ jsxs("article", { className: styles$n.card, children: [
    /* @__PURE__ */ jsx(Heading, { tag: "h3", variant: "headline-emotional-200", className: styles$n.headline, children: card2.headline }),
    /* @__PURE__ */ jsxs("div", { className: styles$n.body, children: [
      /* @__PURE__ */ jsx(
        DynamicMediaPicture,
        {
          className: styles$n.picture,
          imageUrl: card2.image.imageUrl,
          imageConfigs: imageConfig,
          imageAltText: card2.image.imageAltText,
          hasImageTransparency: card2.image.hasImageTransparency
        }
      ),
      /* @__PURE__ */ jsx("dl", { className: styles$n.facts, children: generateFacts(card2.items) })
    ] }),
    (card2.primaryLink || card2.secondaryLink) && /* @__PURE__ */ jsxs("div", { className: styles$n.buttonContainer, children: [
      card2.primaryLink && /* @__PURE__ */ jsx(
        TextLink,
        {
          ...card2.primaryLink,
          variant: "button-primary",
          className: styles$n.button,
          linkText: card2.primaryLink.label
        }
      ),
      card2.secondaryLink && /* @__PURE__ */ jsx(
        TextLink,
        {
          ...card2.secondaryLink,
          variant: "button-secondary",
          className: styles$n.button,
          linkText: card2.secondaryLink.label
        }
      )
    ] }),
    card2.legalDisclaimers && /* @__PURE__ */ jsx("div", { className: styles$n.legalDisclaimer, children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers: card2.legalDisclaimers }) })
  ] });
  const generateFacts = (facts2) => facts2.map((fact, idx) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs("dt", { className: styles$n.label, children: [
      fact.label,
      /* @__PURE__ */ jsx("span", { className: styles$n.reference, children: fact.reference })
    ] }),
    /* @__PURE__ */ jsx("dd", { className: styles$n.value, children: fact.value })
  ] }, idx));
  return /* @__PURE__ */ jsxs("section", { className: classNames(styles$n.factsAndFigures, className), children: [
    componentHeadline2 && /* @__PURE__ */ jsx(Heading, { tag: "h2", variant: "display-functional-200", className: styles$n.headline, children: componentHeadline2 }),
    indicatorBar2 && /* @__PURE__ */ jsx("div", { className: styles$n.indicatorBar, children: /* @__PURE__ */ jsx(IndicatorBar, { progress: indicatorBarProgress, ref: indicatorBarRef }) }),
    /* @__PURE__ */ jsx(Tabs, { className: classNames(styles$n.tabs, { [styles$n.hidden]: cards.length === 1 }), items: generateTabs() })
  ] });
};
const primaryImageConfig = [
  {
    aspectRatio: "1-1",
    sizes: "100vw",
    media: `(max-width: ${breakpoints$1.m / 16}em)`
  },
  {
    aspectRatio: "1-1",
    sizes: "45vw",
    media: `(min-width: ${breakpoints$1.m / 16}em)`
  }
];
const secondaryImageConfig = [
  {
    aspectRatio: "4-3",
    sizes: "40vw",
    media: `(max-width: ${breakpoints$1.m / 16}em)`
  },
  {
    aspectRatio: "4-3",
    sizes: "20vw",
    media: `(min-width: ${breakpoints$1.m / 16}em)`
  }
];
const fullWidthImageConfig = [
  {
    aspectRatio: "9-16",
    sizes: "100vw",
    media: `(max-width: ${breakpoints$1.m / 16}em)`
  },
  {
    aspectRatio: "16-9",
    sizes: "100vw",
    media: `(min-width: ${breakpoints$1.m / 16}em)`
  }
];
const teaserGroupItem = "_teaserGroupItem_r1shd_1";
const trailing = "_trailing_r1shd_11";
const fullWidth$1 = "_fullWidth_r1shd_26";
const image$2 = "_image_r1shd_29";
const body = "_body_r1shd_37";
const headline$9 = "_headline_r1shd_62";
const teaserText = "_teaserText_r1shd_65";
const cta$4 = "_cta_r1shd_68";
const text$4 = "_text_r1shd_100";
const secondaryImage = "_secondaryImage_r1shd_108";
const styles$m = {
  teaserGroupItem,
  trailing,
  fullWidth: fullWidth$1,
  image: image$2,
  body,
  headline: headline$9,
  teaserText,
  cta: cta$4,
  text: text$4,
  secondaryImage
};
const TeaserGroupItem = ({
  headline: headline2,
  image: image2,
  className,
  teaserText: teaserText2,
  hasLeadingImage,
  secondaryImage: secondaryImage2,
  cta: cta2,
  isFullWidth
}) => {
  const picture2 = /* @__PURE__ */ jsx(
    DynamicMediaPicture,
    {
      className: styles$m.image,
      imageUrl: image2.imageUrl,
      imageAltText: image2.imageAltText,
      imageConfigs: isFullWidth ? fullWidthImageConfig : primaryImageConfig,
      hasDarkeningLayer: true
    }
  );
  return /* @__PURE__ */ jsxs(
    "article",
    {
      className: classNames(
        styles$m.teaserGroupItem,
        { [styles$m.trailing]: !hasLeadingImage, [styles$m.fullWidth]: isFullWidth },
        className
      ),
      children: [
        hasLeadingImage && picture2,
        /* @__PURE__ */ jsxs("div", { className: styles$m.body, children: [
          /* @__PURE__ */ jsxs("div", { className: styles$m.text, children: [
            /* @__PURE__ */ jsx(Heading, { className: styles$m.headline, tag: "h3", variant: "headline-functional-300", withShadow: isFullWidth, children: headline2 }),
            teaserText2 && /* @__PURE__ */ jsx(Text, { className: styles$m.teaserText, variant: "paragraph-200", withShadow: isFullWidth, children: teaserText2 })
          ] }),
          !isFullWidth && secondaryImage2 && /* @__PURE__ */ jsx(
            DynamicMediaPicture,
            {
              className: styles$m.secondaryImage,
              imageUrl: secondaryImage2.imageUrl,
              imageAltText: secondaryImage2.imageAltText,
              imageConfigs: secondaryImageConfig
            }
          ),
          cta2 && /* @__PURE__ */ jsx(
            TextLink,
            {
              isExternal: cta2.isExternal,
              className: styles$m.cta,
              linkText: cta2.label,
              href: cta2.href,
              variant: isFullWidth ? "button-secondary-on-media" : "button-secondary"
            }
          )
        ] }),
        !hasLeadingImage && picture2
      ]
    }
  );
};
const teaserGroup = "_teaserGroup_1u4qb_1";
const heading = "_heading_1u4qb_7";
const indicatorBar = "_indicatorBar_1u4qb_11";
const legalDisclaimer = "_legalDisclaimer_1u4qb_14";
const styles$l = {
  teaserGroup,
  heading,
  indicatorBar,
  legalDisclaimer
};
const TeaserGroup = ({
  componentHeadline: componentHeadline2,
  className,
  teaserGroupItems,
  indicatorBar: indicatorBar2,
  highlightHeadline,
  legalDisclaimers
}) => {
  const indicatorBarRef = useRef(null);
  const indicatorBarProgress = useScrollIndicatorProgress$1(indicatorBarRef);
  const generateItems = () => teaserGroupItems.map((val, idx, array) => /* @__PURE__ */ jsx(
    TeaserGroupItem,
    {
      ...val,
      hasLeadingImage: idx % 2 === 0,
      isFullWidth: idx + 1 === array.length
    },
    `teasergroupitem-${idx}`
  ));
  return /* @__PURE__ */ jsxs("section", { className: classNames(styles$l.teaserGroup, className), children: [
    componentHeadline2 && /* @__PURE__ */ jsx(
      Heading,
      {
        tag: "h2",
        className: styles$l.heading,
        variant: highlightHeadline ? "display-functional-200" : "display-functional-300",
        children: componentHeadline2
      }
    ),
    indicatorBar2 && /* @__PURE__ */ jsx("div", { className: styles$l.indicatorBar, children: /* @__PURE__ */ jsx(IndicatorBar, { progress: indicatorBarProgress, ref: indicatorBarRef }) }),
    generateItems(),
    legalDisclaimers && /* @__PURE__ */ jsx("div", { className: styles$l.legalDisclaimer, children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
  ] });
};
const banner = "_banner_tsz7j_37";
const banner__headline = "_banner__headline_tsz7j_47";
const banner__text = "_banner__text_tsz7j_50";
const headline$8 = "_headline_tsz7j_59";
const circularButton = "_circularButton_tsz7j_65";
const circular = "_circular_tsz7j_65";
const pulsecircular = "_pulsecircular_tsz7j_1";
const lightCircular = "_lightCircular_tsz7j_86";
const lightpulsecircular = "_lightpulsecircular_tsz7j_1";
const banner__closeButton = "_banner__closeButton_tsz7j_178";
const banner__close = "_banner__close_tsz7j_178";
const banner__link = "_banner__link_tsz7j_204";
const banner__button = "_banner__button_tsz7j_210";
const styles$k = {
  banner,
  banner__headline,
  banner__text,
  headline: headline$8,
  circularButton,
  circular,
  pulsecircular,
  lightCircular,
  lightpulsecircular,
  banner__closeButton,
  banner__close,
  banner__link,
  banner__button,
  "fade-in": "_fade-in_tsz7j_1",
  "fade-out": "_fade-out_tsz7j_1",
  "rotate-plus": "_rotate-plus_tsz7j_1",
  "rotate-minus": "_rotate-minus_tsz7j_1"
};
const baseClass$f = "banner";
const Banner = ({
  close: close2,
  text: text2,
  headLine: headLine2,
  link: link2,
  showCloseButton,
  closeButtonLabel,
  theme = "dark",
  showBanner = true
}) => /* @__PURE__ */ jsx(Fragment, { children: showBanner && /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames(styles$k.banner, {
      "dark-theme": theme === "dark"
    }),
    children: /* @__PURE__ */ jsx(Text, { variant: "paragraph-200", className: styles$k[`${baseClass$f}__text`], children: /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ jsxs("div", { className: styles$k.circularButton, children: [
        theme === "dark" && /* @__PURE__ */ jsx("div", { className: styles$k.circular }),
        theme === "light" && /* @__PURE__ */ jsx("div", { className: styles$k.lightCircular })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("span", { className: styles$k.headline, children: headLine2 }),
        " ",
        /* @__PURE__ */ jsx("span", { children: text2 }),
        " ",
        (link2 == null ? void 0 : link2.label) && /* @__PURE__ */ jsx("a", { ...link2, className: styles$k[`${baseClass$f}__link`], href: link2.href, children: link2.label })
      ] }),
      showCloseButton && /* @__PURE__ */ jsx(
        "div",
        {
          role: "button",
          tabIndex: 0,
          onKeyDown: close2,
          className: styles$k[`${baseClass$f}__closeButton`],
          onClick: close2,
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: "close-without-circle--small",
              "aria-label": closeButtonLabel,
              className: styles$k[`${baseClass$f}__close`]
            }
          )
        }
      )
    ] }) })
  }
) });
Banner.displayName = "Banner";
const disabledArrow = "_disabledArrow_nflmd_22";
const img$1 = "_img_nflmd_178";
const styles$j = {
  "teaser-row-v2": "_teaser-row-v2_nflmd_1",
  "teaser-row-v2--noTopSpacing": "_teaser-row-v2--noTopSpacing_nflmd_6",
  "teaser-row-v2--scrollable": "_teaser-row-v2--scrollable_nflmd_9",
  "teaser-row-v2__componentHeadline": "_teaser-row-v2__componentHeadline_nflmd_12",
  "legal-disclaimer": "_legal-disclaimer_nflmd_12",
  "teaser-row-v2__arrows": "_teaser-row-v2__arrows_nflmd_15",
  disabledArrow,
  "teaser-row-v2__link-container": "_teaser-row-v2__link-container_nflmd_55",
  "teaser-row-v2__headline": "_teaser-row-v2__headline_nflmd_58",
  "teaser-row-v2__copy": "_teaser-row-v2__copy_nflmd_58",
  "teaser-row-v2__teaserList": "_teaser-row-v2__teaserList_nflmd_62",
  "teaser-row-v2__teaserList--side-by-side": "_teaser-row-v2__teaserList--side-by-side_nflmd_85",
  "teaser-row-v2__teaserContainer": "_teaser-row-v2__teaserContainer_nflmd_85",
  "teaser-row-v2__teaserList--over3Items": "_teaser-row-v2__teaserList--over3Items_nflmd_89",
  "teaser-row-v2__teaserList--2Items-80-20": "_teaser-row-v2__teaserList--2Items-80-20_nflmd_110",
  "teaser-row-v2__imageWrapper": "_teaser-row-v2__imageWrapper_nflmd_114",
  "teaser-row-v2__teaserList--2Items-20-80": "_teaser-row-v2__teaserList--2Items-20-80_nflmd_126",
  "teaser-row-v2__teaserList--2Items-50-50": "_teaser-row-v2__teaserList--2Items-50-50_nflmd_141",
  "teaser-row-v2__teaserList--2ItemsHighlight": "_teaser-row-v2__teaserList--2ItemsHighlight_nflmd_148",
  "teaser-row-v2__imageWrapper--allowScale": "_teaser-row-v2__imageWrapper--allowScale_nflmd_178",
  img: img$1,
  "teaser-row-v2__categoryLabel": "_teaser-row-v2__categoryLabel_nflmd_187",
  "teaser-row-v2__categoryLabelText": "_teaser-row-v2__categoryLabelText_nflmd_200",
  "teaser-row-v2__link-wrapper": "_teaser-row-v2__link-wrapper_nflmd_252",
  "teaser-row-v2__link": "_teaser-row-v2__link_nflmd_55"
};
const aspectRatioMapping = {
  "16-9": 16 / 9,
  "9-16": 9 / 16,
  "4-3": 4 / 3,
  "3-4": 3 / 4,
  "3-2": 3 / 2,
  "1-1": 1 / 1
};
const baseClass$e = "teaser-row-v2";
const TeaserRowTile = ({
  className,
  ctaType,
  links,
  children
}) => {
  if (links && links.length === 1) {
    const link2 = links[0];
    return /* @__PURE__ */ jsxs(
      "a",
      {
        className: classNames(className, styles$j[`${baseClass$e}__link-container`]),
        href: link2.href,
        onClick: link2.onClick,
        target: link2.target,
        rel: link2.rel,
        children: [
          children,
          /* @__PURE__ */ jsx("div", { className: styles$j[`${baseClass$e}__link-wrapper`], children: ctaType === "button" ? /* @__PURE__ */ jsx(
            TextLink,
            {
              className: styles$j[`${baseClass$e}__button`],
              ...link2,
              variant: "button-secondary",
              linkText: link2.label || ""
            }
          ) : /* @__PURE__ */ jsxs("span", { className: styles$j[`${baseClass$e}__link`], children: [
            " ",
            link2.label
          ] }) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs("div", { className, children: [
    children,
    /* @__PURE__ */ jsx("div", { className: styles$j[`${baseClass$e}__link-wrapper`], children: links && links.length > 0 && links.map((link2, index) => /* @__PURE__ */ jsx(Fragment, { children: ctaType === "button" ? /* @__PURE__ */ jsx(
      TextLink,
      {
        className: styles$j[`${baseClass$e}__button`],
        ...link2,
        variant: "button-secondary",
        linkText: link2.label
      }
    ) : /* @__PURE__ */ jsx(
      "a",
      {
        href: link2.href,
        onClick: link2.onClick,
        className: styles$j[`${baseClass$e}__link`],
        target: link2.target,
        rel: link2.rel,
        children: link2.label
      },
      `teaser${link2.label}${index}`
    ) })) })
  ] });
};
const baseClass$d = "teaser-row-v2";
const classMapping = {
  "side by side": "side-by-side",
  "2 items 80/20": "2Items-80-20",
  "2 items 20/80": "2Items-20-80",
  "2 items 50/50": "2Items-50-50",
  "2 items highlight": "2ItemsHighlight"
};
const getImageConfig$1 = (variant, aspectRatio, index) => {
  let ratio = "1-1";
  if (variant === "side by side") {
    ratio = aspectRatio || "1-1";
  }
  if (variant === "2 items 20/80") {
    ratio = index === 0 ? "1-1" : "16-9";
  }
  if (variant === "2 items 80/20") {
    ratio = index === 0 ? "16-9" : "1-1";
  }
  if (variant === "2 items 50/50") {
    ratio = "4-3";
  }
  if (variant === "2 items highlight") {
    ratio = "1-1";
  }
  return [
    {
      aspectRatio: ratio,
      sizes: "100vw",
      media: `(max-width: ${breakpoints$1.l}px)`
    },
    {
      aspectRatio: ratio,
      sizes: "100vw",
      media: `(min-width: ${breakpoints$1.l}px)`
    }
  ];
};
const TeaserRowV2 = ({
  removeTopSpacing: removeTopSpacing2,
  variant,
  componentHeadline: componentHeadline2,
  disableImages,
  teaserList: teaserList2,
  legalDisclaimers,
  mode
}) => {
  const scrollContainerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const { events: events2 } = useDraggable(scrollContainerRef, { isMounted: true });
  const getAspectRatio = (teaser) => {
    if (variant === "side by side") {
      return `${aspectRatioMapping[teaser.aspectRatio || "1-1"]}`;
    }
    return void 0;
  };
  const scroll = (position) => {
    const { current: current2 } = scrollContainerRef;
    const tilePadding = window.innerWidth >= 768 ? 1 / 12 * window.innerWidth : 1 / 16 * window.innerWidth;
    const gap = 4;
    const tileWidth = window.innerWidth - 2 * tilePadding + gap;
    if (current2) {
      current2.scrollBy({
        left: position === "left" ? 0 - tileWidth : tileWidth,
        behavior: "smooth"
      });
    }
  };
  useEffect(() => {
    const { current: current2 } = scrollContainerRef;
    if (variant === "side by side") {
      setIsScrollable(teaserList2.length > 3);
    }
    const event = () => {
      if (current2) {
        const scrollPosition = current2.scrollLeft;
        const scrollWidth = current2.scrollWidth - current2.clientWidth;
        setShowLeftArrow(scrollPosition !== 0);
        setShowRightArrow(scrollPosition !== scrollWidth);
      }
    };
    current2 == null ? void 0 : current2.addEventListener("scroll", event);
    return () => {
      current2 == null ? void 0 : current2.removeEventListener("scroll", event);
    };
  }, [variant, teaserList2]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles$j[baseClass$d], {
        [styles$j[`${baseClass$d}--scrollable`]]: isScrollable,
        [styles$j[`${baseClass$d}--noTopSpacing`]]: removeTopSpacing2,
        "dark-theme": mode === "dark" || mode === "brabus"
      }),
      children: [
        componentHeadline2 && /* @__PURE__ */ jsx(Text, { variant: "paragraph-100", tag: "p", className: styles$j[`${baseClass$d}__componentHeadline`], children: componentHeadline2 }),
        /* @__PURE__ */ jsx(
          "div",
          {
            ref: scrollContainerRef,
            className: classNames(
              styles$j[`${baseClass$d}__teaserList`],
              styles$j[`${baseClass$d}__teaserList--${classMapping[variant]}`],
              {
                [styles$j[`${baseClass$d}__teaserList--over3Items`]]: isScrollable
              }
            ),
            children: (variant === "side by side" ? teaserList2 : teaserList2.slice(0, 2)).map((teaser, i) => {
              var _a;
              return /* @__PURE__ */ jsxs(
                TeaserRowTile,
                {
                  ...teaser,
                  className: styles$j[`${baseClass$d}__teaserContainer`],
                  children: [
                    !disableImages && /* @__PURE__ */ jsxs(
                      "div",
                      {
                        className: classNames(styles$j[`${baseClass$d}__imageWrapper`], {
                          [styles$j[`${baseClass$d}__imageWrapper--allowScale`]]: ((_a = teaser.links) == null ? void 0 : _a.length) === 1
                        }),
                        style: { aspectRatio: getAspectRatio(teaser) },
                        children: [
                          /* @__PURE__ */ jsx("div", { ...events2, onDragStart: (e) => e.preventDefault(), children: /* @__PURE__ */ jsx(
                            DynamicMediaPicture,
                            {
                              className: styles$j.img,
                              imageAltText: teaser.image.imageAltText || "",
                              imageUrl: teaser.image.imageUrl,
                              imageConfigs: getImageConfig$1(variant, teaser.aspectRatio, i)
                            }
                          ) }),
                          teaser.categoryLabel && /* @__PURE__ */ jsx("div", { className: styles$j[`${baseClass$d}__categoryLabel`], children: /* @__PURE__ */ jsx(Text, { variant: "paragraph-200", className: styles$j[`${baseClass$d}__categoryLabelText`], children: teaser.categoryLabel }) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsxs(
                      "div",
                      {
                        onClick: (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        },
                        onKeyDown: (e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.stopPropagation();
                            e.preventDefault();
                          }
                        },
                        role: "button",
                        tabIndex: 0,
                        children: [
                          teaser.headline && /* @__PURE__ */ jsx("p", { className: styles$j[`${baseClass$d}__headline`], children: teaser.headline }),
                          teaser.copyText && /* @__PURE__ */ jsx(
                            RichText,
                            {
                              className: styles$j[`${baseClass$d}__copy`],
                              mdString: teaser.copyText,
                              wrapperElement: "section"
                            }
                          )
                        ]
                      }
                    )
                  ]
                },
                teaser.image.imageAltText + i
              );
            })
          }
        ),
        isScrollable && /* @__PURE__ */ jsxs("div", { className: styles$j[`${baseClass$d}__arrows`], children: [
          /* @__PURE__ */ jsx("button", { onClick: () => scroll("left"), className: classNames({ [styles$j.disabledArrow]: showLeftArrow }), children: /* @__PURE__ */ jsx(Icon, { name: "arrow-left--medium" }) }),
          /* @__PURE__ */ jsx("button", { onClick: () => scroll("right"), className: classNames({ [styles$j.disabledArrow]: showRightArrow }), children: /* @__PURE__ */ jsx(Icon, { name: "arrow-right--medium" }) })
        ] }),
        legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsxs("div", { className: styles$j[`legal-disclaimer`], children: [
          /* @__PURE__ */ jsx("hr", {}),
          /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
        ] })
      ]
    }
  );
};
const contentWidth$1 = "_contentWidth_x7cya_1";
const container$1 = "_container_x7cya_5";
const specs = "_specs_x7cya_92";
const data = "_data_x7cya_97";
const label = "_label_x7cya_111";
const priceAndLeasingOneWrapper = "_priceAndLeasingOneWrapper_x7cya_206";
const imagePaddingContainer = "_imagePaddingContainer_x7cya_219";
const arrows = "_arrows_x7cya_223";
const showArrow = "_showArrow_x7cya_241";
const legalDisclaimerOneContainer = "_legalDisclaimerOneContainer_x7cya_246";
const legalDisclaimerContainer = "_legalDisclaimerContainer_x7cya_249";
const indicatorLayer = "_indicatorLayer_x7cya_283";
const rightIndicator = "_rightIndicator_x7cya_315";
const rightIcon = "_rightIcon_x7cya_326";
const leftIndicator = "_leftIndicator_x7cya_329";
const leftIcon = "_leftIcon_x7cya_339";
const imgtwocard = "_imgtwocard_x7cya_345";
const imageTwoContainer = "_imageTwoContainer_x7cya_350";
const imageOneContainer = "_imageOneContainer_x7cya_351";
const teaserOneContainer = "_teaserOneContainer_x7cya_392";
const contentWrapper = "_contentWrapper_x7cya_397";
const contentOneWrapper = "_contentOneWrapper_x7cya_406";
const imageOneWrapper = "_imageOneWrapper_x7cya_412";
const imageOneWrapperMargin = "_imageOneWrapperMargin_x7cya_418";
const removeTopSpacing = "_removeTopSpacing_x7cya_423";
const styles$i = {
  contentWidth: contentWidth$1,
  container: container$1,
  "teaser-row": "_teaser-row_x7cya_9",
  "teaser-row__teaserContainer": "_teaser-row__teaserContainer_x7cya_24",
  "teaser-row__groupWrapper": "_teaser-row__groupWrapper_x7cya_28",
  "teaser-row__buttonWrapper": "_teaser-row__buttonWrapper_x7cya_29",
  "teaser-row__buttonOneWrapper": "_teaser-row__buttonOneWrapper_x7cya_48",
  "teaser-row__linkWrapper": "_teaser-row__linkWrapper_x7cya_51",
  "teaser-row__title": "_teaser-row__title_x7cya_56",
  "teaser-row__topTitle": "_teaser-row__topTitle_x7cya_57",
  "teaser-row__subTitle": "_teaser-row__subTitle_x7cya_58",
  specs,
  data,
  label,
  "teaser-row__highlightsList": "_teaser-row__highlightsList_x7cya_126",
  "teaser-row__imageWrapper": "_teaser-row__imageWrapper_x7cya_169",
  "teaser-row__priceAndLeasing": "_teaser-row__priceAndLeasing_x7cya_175",
  "teaser-row__leasingPrice": "_teaser-row__leasingPrice_x7cya_191",
  priceAndLeasingOneWrapper,
  imagePaddingContainer,
  arrows,
  showArrow,
  legalDisclaimerOneContainer,
  legalDisclaimerContainer,
  indicatorLayer,
  rightIndicator,
  rightIcon,
  leftIndicator,
  leftIcon,
  imgtwocard,
  imageTwoContainer,
  imageOneContainer,
  teaserOneContainer,
  contentWrapper,
  contentOneWrapper,
  imageOneWrapper,
  imageOneWrapperMargin,
  removeTopSpacing
};
const getImageConfig = (index, radios) => {
  const ratio = radios;
  return [
    {
      aspectRatio: ratio,
      sizes: "100vw",
      media: `(max-width: ${breakpoints$1.l}px)`
    },
    {
      aspectRatio: ratio,
      sizes: "100vw",
      media: `(min-width: ${breakpoints$1.l}px)`
    }
  ];
};
const ProductTeaserCard = ({
  teaserList: teaserList2,
  legalDisclaimers,
  removeTopSpacing: removeTopSpacing2,
  aspectRatio = "4-3"
}) => {
  const contentWidthIndicatorRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(1920);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [swiper2, setSwiper] = useState();
  const [marginWidth, setMarginWidth] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [hotAreaWidth, setHotAreaWidth] = useState(0);
  const [hotAreaHeight, setHotAreaHeight] = useState(0);
  const slidePerView = useMemo(() => {
    const tileCount = windowWidth <= breakpoints$1.m ? 1 : 3;
    const tileWidth = (windowWidth - 2 * marginWidth) / tileCount;
    const n = 2 * marginWidth / tileWidth;
    setHotAreaWidth(windowWidth - windowWidth / (tileCount + n) - marginWidth);
    setHotAreaHeight(windowWidth / (tileCount + n + 1));
    teaserList2.length - activeIndex > 3 && activeIndex > 0 && setHotAreaWidth(windowWidth / 2);
    return tileCount + n;
  }, [windowWidth, marginWidth, teaserList2.length, activeIndex]);
  useEffect(() => {
    const setWidth2 = () => {
      setWindowWidth(window.innerWidth);
      if (contentWidthIndicatorRef.current) {
        const width = (window.innerWidth - contentWidthIndicatorRef.current.clientWidth) / 2;
        setMarginWidth(width);
      }
    };
    setWidth2();
    window.addEventListener("resize", () => {
      setWidth2();
    });
  }, []);
  const baseClass2 = "teaser-row";
  const getProductTeaserCardContent = (teaser, index) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(styles$i.imageOneWrapper, styles$i[`${baseClass2}__imageWrapper`], {
          [styles$i.imageOneWrapperMargin]: teaserList2.length === 1
        }),
        style: { aspectRatio },
        children: /* @__PURE__ */ jsx(
          DynamicMediaPicture,
          {
            imageUrl: teaser.image.imageUrl,
            imageAltText: teaser.image.imageAltText,
            imageConfigs: getImageConfig(index, aspectRatio),
            isObjectFit: true
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(styles$i.contentWrapper, `swiper-no-swiping`, {
          [styles$i.contentOneWrapper]: teaserList2.length === 1
        }),
        children: /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: styles$i[`${baseClass2}__topTitle`], children: teaser.headline }),
          /* @__PURE__ */ jsx("p", { className: styles$i[`${baseClass2}__title`], children: teaser.title }),
          /* @__PURE__ */ jsx("p", { className: styles$i[`${baseClass2}__subTitle`], children: teaser.subTitle }),
          /* @__PURE__ */ jsxs("div", { className: styles$i.specs, children: [
            /* @__PURE__ */ jsxs("div", { children: [
              teaser.highlightValue1 && /* @__PURE__ */ jsx("p", { className: styles$i.data, children: teaser.highlightValue1 }),
              teaser.highlightLabel1 && /* @__PURE__ */ jsx("p", { className: styles$i.label, children: teaser.highlightLabel1 })
            ] }),
            /* @__PURE__ */ jsxs("div", { children: [
              teaser.highlightValue2 && /* @__PURE__ */ jsx("p", { className: styles$i.data, children: teaser.highlightValue2 }),
              teaser.highlightLabel2 && /* @__PURE__ */ jsx("p", { className: styles$i.label, children: teaser.highlightLabel2 })
            ] }),
            /* @__PURE__ */ jsxs("div", { children: [
              teaser.highlightValue3 && /* @__PURE__ */ jsx("p", { className: styles$i.data, children: teaser.highlightValue3 }),
              teaser.highlightLabel3 && /* @__PURE__ */ jsx("p", { className: styles$i.label, children: teaser.highlightLabel3 })
            ] })
          ] }),
          teaser.richText && /* @__PURE__ */ jsx(RichText, { mdString: teaser.richText || "", className: styles$i[`${baseClass2}__highlightsList`] }),
          /* @__PURE__ */ jsxs("div", { className: styles$i[`${baseClass2}__buttonWrapper`], children: [
            teaser.firstLink && /* @__PURE__ */ jsx(TextLink, { variant: "button-secondary", linkText: teaser.firstLink.label, ...teaser.firstLink }),
            teaser.secondLink && /* @__PURE__ */ jsx(TextLink, { linkText: teaser.secondLink.label, variant: "button-ghost", ...teaser.secondLink })
          ] }),
          (teaser.price || teaser.leasingPrice) && /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames(styles$i[`${baseClass2}__priceAndLeasing`], {
                [styles$i.priceAndLeasingOneWrapper]: teaserList2.length === 1
              }),
              children: [
                teaser.price && /* @__PURE__ */ jsx("p", { children: teaser.price }),
                teaser.leasingPrice && /* @__PURE__ */ jsx("p", { className: styles$i[`${baseClass2}__leasingPrice`], children: teaser.leasingPrice })
              ]
            }
          )
        ] })
      }
    )
  ] });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(CursorIcon, { variant: "rotate" }),
    /* @__PURE__ */ jsx("div", { className: styles$i.contentWidth, ref: contentWidthIndicatorRef }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(styles$i.container, {
          [styles$i.removeTopSpacing]: removeTopSpacing2
        }),
        children: [
          /* @__PURE__ */ jsx(
            Swiper2,
            {
              className: classNames(styles$i[`${baseClass2}`]),
              spaceBetween: 4,
              slidesPerView: slidePerView,
              slidesOffsetBefore: marginWidth,
              slidesOffsetAfter: marginWidth,
              speed: windowWidth <= breakpoints$1.l ? 300 : 500,
              onSwiper: (s) => {
                setSwiper(s);
              },
              onActiveIndexChange: (swiperCore) => {
                setActiveIndex(swiperCore.activeIndex);
                setShowLeftArrow(swiperCore.activeIndex > 0);
                setShowRightArrow(teaserList2.length - swiperCore.activeIndex > (windowWidth <= breakpoints$1.m ? 1 : 3));
              },
              touchEventsTarget: "container",
              children: teaserList2.length >= 3 && teaserList2.map((teaser, index) => /* @__PURE__ */ jsx(SwiperSlide, { children: /* @__PURE__ */ jsx("div", { className: styles$i[`${baseClass2}__teaserContainer`], children: getProductTeaserCardContent(teaser, index) }) }, index))
            }
          ),
          /* @__PURE__ */ jsx("div", { className: classNames(styles$i[`${baseClass2}`], styles$i.imagePaddingContainer), children: teaserList2.length < 3 && teaserList2.map((teaser, index) => /* @__PURE__ */ jsx(
            "div",
            {
              className: index === 0 && teaserList2.length !== 1 ? styles$i.imageTwoContainer : styles$i.imageOneContainer,
              children: /* @__PURE__ */ jsx(
                "div",
                {
                  className: classNames(styles$i[`${baseClass2}__teaserContainer`], {
                    [styles$i.teaserOneContainer]: teaserList2.length === 1
                  }),
                  children: getProductTeaserCardContent(teaser, index)
                }
              )
            },
            index
          )) }),
          teaserList2.length > 3 && /* @__PURE__ */ jsxs("div", { className: classNames(styles$i.indicatorLayer), children: [
            /* @__PURE__ */ jsx("div", { className: classNames({ [styles$i.leftIndicator]: activeIndex !== 0 }, styles$i.leftIcon), children: /* @__PURE__ */ jsx(
              "div",
              {
                style: { width: hotAreaWidth, height: hotAreaHeight },
                tabIndex: -1,
                role: "button",
                onKeyDown: () => swiper2 == null ? void 0 : swiper2.slidePrev(),
                onClick: () => swiper2 == null ? void 0 : swiper2.slidePrev()
              }
            ) }),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: classNames(
                  { [styles$i.rightIndicator]: teaserList2.length - activeIndex !== 3 },
                  styles$i.rightIcon
                ),
                children: /* @__PURE__ */ jsx(
                  "div",
                  {
                    tabIndex: -1,
                    role: "button",
                    onKeyDown: () => swiper2 == null ? void 0 : swiper2.slideNext(),
                    style: { width: hotAreaWidth, height: hotAreaHeight },
                    onClick: () => swiper2 == null ? void 0 : swiper2.slideNext()
                  }
                )
              }
            )
          ] }),
          teaserList2.length >= 3 && /* @__PURE__ */ jsxs("div", { className: styles$i.arrows, children: [
            /* @__PURE__ */ jsx("button", { className: classNames({ [styles$i.showArrow]: showLeftArrow }), onClick: () => swiper2 == null ? void 0 : swiper2.slidePrev(), children: /* @__PURE__ */ jsx(Icon, { name: "arrow-left--medium" }) }),
            /* @__PURE__ */ jsx("button", { className: classNames({ [styles$i.showArrow]: showRightArrow }), onClick: () => swiper2 == null ? void 0 : swiper2.slideNext(), children: /* @__PURE__ */ jsx(Icon, { name: "arrow-right--medium" }) })
          ] }),
          legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: classNames(styles$i.legalDisclaimerContainer), children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
        ]
      }
    )
  ] });
};
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(module, exports) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      // Latin-1 Supplement block.
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      // Latin Extended-A block.
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        var value2 = array[index];
        setter(accumulator, value2, iteratee(value2), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index < length) {
        var value2 = array[index];
        if (predicate(value2, index, array)) {
          result[resIndex++] = value2;
        }
      }
      return result;
    }
    function arrayIncludes(array, value2) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value2, 0) > -1;
    }
    function arrayIncludesWith(array, value2, comparator) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (comparator(value2, array[index])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index = -1, length = values.length, offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1, length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string) {
      return string.split("");
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value2, key, collection2) {
        if (predicate(value2, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value2, fromIndex) {
      return value2 === value2 ? strictIndexOf(array, value2, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value2, fromIndex, comparator) {
      var index = fromIndex - 1, length = array.length;
      while (++index < length) {
        if (comparator(array[index], value2)) {
          return index;
        }
      }
      return -1;
    }
    function baseIsNaN(value2) {
      return value2 !== value2;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value2, index, collection2) {
        accumulator = initAccum ? (initAccum = false, value2) : iteratee(accumulator, value2, index, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index = -1, length = array.length;
      while (++index < length) {
        var current2 = iteratee(array[index]);
        if (current2 !== undefined$1) {
          result = result === undefined$1 ? current2 : result + current2;
        }
      }
      return result;
    }
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    function baseUnary(func) {
      return function(value2) {
        return func(value2);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1, length = strSymbols.length;
      while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
      }
      return index;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;
      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
      }
      return index;
    }
    function countHolders(array, placeholder) {
      var length = array.length, result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data2, result = [];
      while (!(data2 = iterator.next()).done) {
        result.push(data2.value);
      }
      return result;
    }
    function mapToArray(map) {
      var index = -1, result = Array(map.size);
      map.forEach(function(value2, key) {
        result[++index] = [key, value2];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index = -1, length = array.length, resIndex = 0, result = [];
      while (++index < length) {
        var value2 = array[index];
        if (value2 === placeholder || value2 === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index = -1, result = Array(set.size);
      set.forEach(function(value2) {
        result[++index] = value2;
      });
      return result;
    }
    function setToPairs(set) {
      var index = -1, result = Array(set.size);
      set.forEach(function(value2) {
        result[++index] = [value2, value2];
      });
      return result;
    }
    function strictIndexOf(array, value2, fromIndex) {
      var index = fromIndex - 1, length = array.length;
      while (++index < length) {
        if (array[index] === value2) {
          return index;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value2, fromIndex) {
      var index = fromIndex + 1;
      while (index--) {
        if (array[index] === value2) {
          return index;
        }
      }
      return index;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {
      }
      return index;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty = objectProto.hasOwnProperty;
      var idCounter2 = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root._;
      var reIsNative = RegExp2(
        "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value2) {
        if (isObjectLike(value2) && !isArray(value2) && !(value2 instanceof LazyWrapper)) {
          if (value2 instanceof LodashWrapper) {
            return value2;
          }
          if (hasOwnProperty.call(value2, "__wrapped__")) {
            return wrapperClone(value2);
          }
        }
        return new LodashWrapper(value2);
      }
      var baseCreate = function() {
        function object() {
        }
        return function(proto) {
          if (!isObject2(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result2 = new object();
          object.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value2, chainAll) {
        this.__wrapped__ = value2;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "escape": reEscape,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "evaluate": reEvaluate,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "interpolate": reInterpolate,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        "variable": "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        "imports": {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value2) {
        this.__wrapped__ = value2;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index += dir;
            var iterIndex = -1, value2 = array[index];
            while (++iterIndex < iterLength) {
              var data2 = iteratees[iterIndex], iteratee2 = data2.iteratee, type = data2.type, computed = iteratee2(value2);
              if (type == LAZY_MAP_FLAG) {
                value2 = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value2;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet(key) {
        var data2 = this.__data__;
        if (nativeCreate) {
          var result2 = data2[key];
          return result2 === HASH_UNDEFINED ? undefined$1 : result2;
        }
        return hasOwnProperty.call(data2, key) ? data2[key] : undefined$1;
      }
      function hashHas(key) {
        var data2 = this.__data__;
        return nativeCreate ? data2[key] !== undefined$1 : hasOwnProperty.call(data2, key);
      }
      function hashSet(key, value2) {
        var data2 = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data2[key] = nativeCreate && value2 === undefined$1 ? HASH_UNDEFINED : value2;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data2 = this.__data__, index = assocIndexOf(data2, key);
        if (index < 0) {
          return false;
        }
        var lastIndex = data2.length - 1;
        if (index == lastIndex) {
          data2.pop();
        } else {
          splice.call(data2, index, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data2 = this.__data__, index = assocIndexOf(data2, key);
        return index < 0 ? undefined$1 : data2[index][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value2) {
        var data2 = this.__data__, index = assocIndexOf(data2, key);
        if (index < 0) {
          ++this.size;
          data2.push([key, value2]);
        } else {
          data2[index][1] = value2;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result2 = getMapData(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value2) {
        var data2 = getMapData(this, key), size2 = data2.size;
        data2.set(key, value2);
        this.size += data2.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index < length) {
          this.add(values2[index]);
        }
      }
      function setCacheAdd(value2) {
        this.__data__.set(value2, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value2) {
        return this.__data__.has(value2);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data2 = this.__data__ = new ListCache(entries);
        this.size = data2.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data2 = this.__data__, result2 = data2["delete"](key);
        this.size = data2.size;
        return result2;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value2) {
        var data2 = this.__data__;
        if (data2 instanceof ListCache) {
          var pairs = data2.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value2]);
            this.size = ++data2.size;
            return this;
          }
          data2 = this.__data__ = new MapCache(pairs);
        }
        data2.set(key, value2);
        this.size = data2.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value2, inherited) {
        var isArr = isArray(value2), isArg = !isArr && isArguments(value2), isBuff = !isArr && !isArg && isBuffer(value2), isType = !isArr && !isArg && !isBuff && isTypedArray(value2), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value2.length, String2) : [], length = result2.length;
        for (var key in value2) {
          if ((inherited || hasOwnProperty.call(value2, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex(key, length)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value2) {
        if (value2 !== undefined$1 && !eq(object[key], value2) || value2 === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value2);
        }
      }
      function assignValue(object, key, value2) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value2)) || value2 === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value2);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value2, key, collection2) {
          setter(accumulator, value2, iteratee2(value2), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value2) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value2,
            "writable": true
          });
        } else {
          object[key] = value2;
        }
      }
      function baseAt(object, paths) {
        var index = -1, length = paths.length, result2 = Array2(length), skip = object == null;
        while (++index < length) {
          result2[index] = skip ? undefined$1 : get(object, paths[index]);
        }
        return result2;
      }
      function baseClamp(number2, lower, upper) {
        if (number2 === number2) {
          if (upper !== undefined$1) {
            number2 = number2 <= upper ? number2 : upper;
          }
          if (lower !== undefined$1) {
            number2 = number2 >= lower ? number2 : lower;
          }
        }
        return number2;
      }
      function baseClone(value2, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object ? customizer(value2, key, object, stack) : customizer(value2);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject2(value2)) {
          return value2;
        }
        var isArr = isArray(value2);
        if (isArr) {
          result2 = initCloneArray(value2);
          if (!isDeep) {
            return copyArray(value2, result2);
          }
        } else {
          var tag = getTag(value2), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value2)) {
            return cloneBuffer(value2, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value2);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value2, baseAssignIn(result2, value2)) : copySymbols(value2, baseAssign(result2, value2));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value2 : {};
            }
            result2 = initCloneByTag(value2, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value2);
        if (stacked) {
          return stacked;
        }
        stack.set(value2, result2);
        if (isSet(value2)) {
          value2.forEach(function(subValue) {
            result2.add(baseClone(subValue, bitmask, customizer, subValue, value2, stack));
          });
        } else if (isMap(value2)) {
          value2.forEach(function(subValue, key2) {
            result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value2, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value2);
        arrayEach(props || value2, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value2[key2];
          }
          assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value2, stack));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (length--) {
          var key = props[length], predicate = source[key], value2 = object[key];
          if (value2 === undefined$1 && !(key in object) || !predicate(value2)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values2, iteratee2, comparator) {
        var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
        if (!length) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index < length) {
            var value2 = array[index], computed = iteratee2 == null ? value2 : iteratee2(value2);
            value2 = comparator || value2 !== 0 ? value2 : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value2);
            } else if (!includes2(values2, computed, comparator)) {
              result2.push(value2);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value2, index, collection2) {
          result2 = !!predicate(value2, index, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index = -1, length = array.length;
        while (++index < length) {
          var value2 = array[index], current2 = iteratee2(value2);
          if (current2 != null && (computed === undefined$1 ? current2 === current2 && !isSymbol(current2) : comparator(current2, computed))) {
            var computed = current2, result2 = value2;
          }
        }
        return result2;
      }
      function baseFill(array, value2, start, end) {
        var length = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value2;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value2, index, collection2) {
          if (predicate(value2, index, collection2)) {
            result2.push(value2);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index = -1, length = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index < length) {
          var value2 = array[index];
          if (depth > 0 && predicate(value2)) {
            if (depth > 1) {
              baseFlatten(value2, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush(result2, value2);
            }
          } else if (!isStrict) {
            result2[result2.length] = value2;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0, length = path.length;
        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }
        return index && index == length ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
      }
      function baseGetTag(value2) {
        if (value2 == null) {
          return value2 === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value2) ? getRawTag(value2) : objectToString(value2);
      }
      function baseGt(value2, other) {
        return value2 > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number2, start, end) {
        return number2 >= nativeMin(start, end) && number2 < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index = -1, seen = caches[0];
        outer:
          while (++index < length && result2.length < maxLength) {
            var value2 = array[index], computed = iteratee2 ? iteratee2(value2) : value2;
            value2 = comparator || value2 !== 0 ? value2 : 0;
            if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value2);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value2, key, object2) {
          setter(accumulator, iteratee2(value2), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value2) {
        return isObjectLike(value2) && baseGetTag(value2) == argsTag;
      }
      function baseIsArrayBuffer(value2) {
        return isObjectLike(value2) && baseGetTag(value2) == arrayBufferTag;
      }
      function baseIsDate(value2) {
        return isObjectLike(value2) && baseGetTag(value2) == dateTag;
      }
      function baseIsEqual(value2, other, bitmask, customizer, stack) {
        if (value2 === other) {
          return true;
        }
        if (value2 == null || other == null || !isObjectLike(value2) && !isObjectLike(other)) {
          return value2 !== value2 && other !== other;
        }
        return baseIsEqualDeep(value2, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value2) {
        return isObjectLike(value2) && getTag(value2) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length, length = index, noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (index--) {
          var data2 = matchData[index];
          if (noCustomizer && data2[2] ? data2[1] !== object[data2[0]] : !(data2[0] in object)) {
            return false;
          }
        }
        while (++index < length) {
          data2 = matchData[index];
          var key = data2[0], objValue = object[key], srcValue = data2[1];
          if (noCustomizer && data2[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value2) {
        if (!isObject2(value2) || isMasked(value2)) {
          return false;
        }
        var pattern = isFunction(value2) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value2));
      }
      function baseIsRegExp(value2) {
        return isObjectLike(value2) && baseGetTag(value2) == regexpTag;
      }
      function baseIsSet(value2) {
        return isObjectLike(value2) && getTag(value2) == setTag;
      }
      function baseIsTypedArray(value2) {
        return isObjectLike(value2) && isLength(value2.length) && !!typedArrayTags[baseGetTag(value2)];
      }
      function baseIteratee(value2) {
        if (typeof value2 == "function") {
          return value2;
        }
        if (value2 == null) {
          return identity;
        }
        if (typeof value2 == "object") {
          return isArray(value2) ? baseMatchesProperty(value2[0], value2[1]) : baseMatches(value2);
        }
        return property(value2);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object) {
        if (!isObject2(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value2, other) {
        return value2 < other;
      }
      function baseMap(collection, iteratee2) {
        var index = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value2, key, collection2) {
          result2[++index] = iteratee2(value2, key, collection2);
        });
        return result2;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject2(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray(iteratee2)) {
              return function(value2) {
                return baseGet(value2, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result2 = baseMap(collection, function(value2, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value2);
          });
          return { "criteria": criteria, "index": ++index, "value": value2 };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value2, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index = -1, length = paths.length, result2 = {};
        while (++index < length) {
          var path = paths[index], value2 = baseGet(object, path);
          if (predicate(value2, path)) {
            baseSet(result2, castPath(path, object), value2);
          }
        }
        return result2;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values2, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
        if (array === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index < length) {
          var fromIndex = 0, value2 = values2[index], computed = iteratee2 ? iteratee2(value2) : value2;
          while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index = indexes[length];
          if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
              splice.call(array, index, 1);
            } else {
              baseUnset(array, index);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
        while (length--) {
          result2[fromRight ? length : ++index] = start;
          start += step;
        }
        return result2;
      }
      function baseRepeat(string, n) {
        var result2 = "";
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result2;
        }
        do {
          if (n % 2) {
            result2 += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);
        return result2;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }
      function baseSet(object, path, value2, customizer) {
        if (!isObject2(object)) {
          return object;
        }
        path = castPath(path, object);
        var index = -1, length = path.length, lastIndex = length - 1, nested = object;
        while (nested != null && ++index < length) {
          var key = toKey(path[index]), newValue = value2;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data2) {
        metaMap.set(func, data2);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function(func, string) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start, end) {
        var index = -1, length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result2 = Array2(length);
        while (++index < length) {
          result2[index] = array[index + start];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value2, index, collection2) {
          result2 = predicate(value2, index, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value2, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value2 == "number" && value2 === value2 && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value2 : computed < value2)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value2, identity, retHighest);
      }
      function baseSortedIndexBy(array, value2, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value2 = iteratee2(value2);
        var valIsNaN = value2 !== value2, valIsNull = value2 === null, valIsSymbol = isSymbol(value2), valIsUndefined = value2 === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value2 : computed < value2;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index < length) {
          var value2 = array[index], computed = iteratee2 ? iteratee2(value2) : value2;
          if (!index || !eq(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value2 === 0 ? 0 : value2;
          }
        }
        return result2;
      }
      function baseToNumber(value2) {
        if (typeof value2 == "number") {
          return value2;
        }
        if (isSymbol(value2)) {
          return NAN;
        }
        return +value2;
      }
      function baseToString(value2) {
        if (typeof value2 == "string") {
          return value2;
        }
        if (isArray(value2)) {
          return arrayMap(value2, baseToString) + "";
        }
        if (isSymbol(value2)) {
          return symbolToString ? symbolToString.call(value2) : "";
        }
        var result2 = value2 + "";
        return result2 == "0" && 1 / value2 == -INFINITY ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set2 = iteratee2 ? null : createSet(array);
          if (set2) {
            return setToArray(set2);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index < length) {
            var value2 = array[index], computed = iteratee2 ? iteratee2(value2) : value2;
            value2 = comparator || value2 !== 0 ? value2 : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value2);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value2);
            }
          }
        return result2;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length, index = fromRight ? length : -1;
        while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
      }
      function baseWrapperValue(value2, actions) {
        var result2 = value2;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index = -1, result2 = Array2(length);
        while (++index < length) {
          var array = arrays[index], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index) {
              result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index = -1, length = props.length, valsLength = values2.length, result2 = {};
        while (++index < length) {
          var value2 = index < valsLength ? values2[index] : undefined$1;
          assignFunc(result2, props[index], value2);
        }
        return result2;
      }
      function castArrayLikeObject(value2) {
        return isArrayLikeObject(value2) ? value2 : [];
      }
      function castFunction(value2) {
        return typeof value2 == "function" ? value2 : identity;
      }
      function castPath(value2, object) {
        if (isArray(value2)) {
          return value2;
        }
        return isKey(value2, object) ? [value2] : stringToPath(toString2(value2));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result2).set(new Uint8Array(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value2, other) {
        if (value2 !== other) {
          var valIsDefined = value2 !== undefined$1, valIsNull = value2 === null, valIsReflexive = value2 === value2, valIsSymbol = isSymbol(value2);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value2 > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value2 < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index < length) {
          var result2 = compareAscending(objCriteria[index], othCriteria[index]);
          if (result2) {
            if (index >= ordersLength) {
              return result2;
            }
            var order = orders[index];
            return result2 * (order == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source, array) {
        var index = -1, length = source.length;
        array || (array = Array2(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1, length = props.length;
        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object2(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index-- : ++index < length) {
            if (iteratee2(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper2() {
          var fn = this && this !== root && this instanceof wrapper2 ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper2;
      }
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString2(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing2 = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing2;
        };
      }
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper2() {
          var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper2);
          while (index--) {
            args[index] = arguments[index];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper2.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length
            );
          }
          var fn = this && this !== root && this instanceof wrapper2 ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper2;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper2 && getFuncName(func) == "wrapper") {
              var wrapper2 = new LodashWrapper([], true);
            }
          }
          index = wrapper2 ? index : length;
          while (++index < length) {
            func = funcs[index];
            var funcName = getFuncName(func), data2 = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data2 && isLaziable(data2[0]) && data2[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data2[4].length && data2[9] == 1) {
              wrapper2 = wrapper2[getFuncName(data2[0])].apply(wrapper2, data2[3]);
            } else {
              wrapper2 = func.length == 1 && isLaziable(func) ? wrapper2[funcName]() : wrapper2.thru(func);
            }
          }
          return function() {
            var args = arguments, value2 = args[0];
            if (wrapper2 && args.length == 1 && isArray(value2)) {
              return wrapper2.plant(value2).value();
            }
            var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value2;
            while (++index2 < length) {
              result2 = funcs[index2].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper2() {
          var length = arguments.length, args = Array2(length), index = length;
          while (index--) {
            args[index] = arguments[index];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper2), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper2.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root && this instanceof wrapper2) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper2;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value2, other) {
          var result2;
          if (value2 === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value2 !== undefined$1) {
            result2 = value2;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value2 == "string" || typeof other == "string") {
              value2 = baseToString(value2);
              other = baseToString(other);
            } else {
              value2 = baseToNumber(value2);
              other = baseToNumber(other);
            }
            result2 = operator(value2, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper2() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper2 ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper2;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value2, other) {
          if (!(typeof value2 == "string" && typeof other == "string")) {
            value2 = toNumber(value2);
            other = toNumber(other);
          }
          return operator(value2, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number2, precision) {
          number2 = toNumber(number2);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number2)) {
            var pair = (toString2(number2) + "e").split("e"), value2 = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString2(value2) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number2);
        };
      }
      var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
        return new Set2(values2);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data2 = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data2) {
          mergeData(newData, data2);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data2 ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value2) {
        return isPlainObject(value2) ? undefined$1 : value2;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index < arrLength) {
          var arrValue = array[index], othValue = other[index];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
        while (length--) {
          var data2 = array[length], otherFunc = data2.func;
          if (otherFunc == null || otherFunc == func) {
            return data2.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData(map2, key) {
        var data2 = map2.__data__;
        return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
      }
      function getMatchData(object) {
        var result2 = keys(object), length = result2.length;
        while (length--) {
          var key = result2[length], value2 = object[key];
          result2[length] = [key, value2, isStrictComparable(value2)];
        }
        return result2;
      }
      function getNative(object, key) {
        var value2 = getValue(object, key);
        return baseIsNative(value2) ? value2 : undefined$1;
      }
      function getRawTag(value2) {
        var isOwn = hasOwnProperty.call(value2, symToStringTag), tag = value2[symToStringTag];
        try {
          value2[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {
        }
        var result2 = nativeObjectToString.call(value2);
        if (unmasked) {
          if (isOwn) {
            value2[symToStringTag] = tag;
          } else {
            delete value2[symToStringTag];
          }
        }
        return result2;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result2 = [];
        while (object) {
          arrayPush(result2, getSymbols(object));
          object = getPrototype(object);
        }
        return result2;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
        getTag = function(value2) {
          var result2 = baseGetTag(value2), Ctor = result2 == objectTag ? value2.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result2;
        };
      }
      function getView(start, end, transforms) {
        var index = -1, length = transforms.length;
        while (++index < length) {
          var data2 = transforms[index], size2 = data2.size;
          switch (data2.type) {
            case "drop":
              start += size2;
              break;
            case "dropRight":
              end -= size2;
              break;
            case "take":
              end = nativeMin(end, start + size2);
              break;
            case "takeRight":
              start = nativeMax(start, end - size2);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1, length = path.length, result2 = false;
        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index != length) {
          return result2;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length, result2 = new array.constructor(length);
        if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value2) {
        return isArray(value2) || isArguments(value2) || !!(spreadableSymbol && value2 && value2[spreadableSymbol]);
      }
      function isIndex(value2, length) {
        var type = typeof value2;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length);
      }
      function isIterateeCall(value2, index, object) {
        if (!isObject2(object)) {
          return false;
        }
        var type = typeof index;
        if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
          return eq(object[index], value2);
        }
        return false;
      }
      function isKey(value2, object) {
        if (isArray(value2)) {
          return false;
        }
        var type = typeof value2;
        if (type == "number" || type == "symbol" || type == "boolean" || value2 == null || isSymbol(value2)) {
          return true;
        }
        return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object != null && value2 in Object2(object);
      }
      function isKeyable(value2) {
        var type = typeof value2;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data2 = getData(other);
        return !!data2 && func === data2[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction : stubFalse;
      function isPrototype(value2) {
        var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value2 === proto;
      }
      function isStrictComparable(value2) {
        return value2 === value2 && !isObject2(value2);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result2.cache;
        return result2;
      }
      function mergeData(data2, source) {
        var bitmask = data2[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data2[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data2;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data2[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value2 = source[3];
        if (value2) {
          var partials = data2[3];
          data2[3] = partials ? composeArgs(partials, value2, source[4]) : value2;
          data2[4] = partials ? replaceHolders(data2[3], PLACEHOLDER) : source[4];
        }
        value2 = source[5];
        if (value2) {
          partials = data2[5];
          data2[5] = partials ? composeArgsRight(partials, value2, source[6]) : value2;
          data2[6] = partials ? replaceHolders(data2[5], PLACEHOLDER) : source[6];
        }
        value2 = source[7];
        if (value2) {
          data2[7] = value2;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data2[8] = data2[8] == null ? source[8] : nativeMin(data2[8], source[8]);
        }
        if (data2[9] == null) {
          data2[9] = source[9];
        }
        data2[0] = source[0];
        data2[1] = newBitmask;
        return data2;
      }
      function nativeKeysIn(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString(value2) {
        return nativeObjectToString.call(value2);
      }
      function overRest(func, start, transform2) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array2(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform2(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
        while (length--) {
          var index = indexes[length];
          array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper2, reference2, bitmask) {
        var source = reference2 + "";
        return setToString(wrapper2, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index = -1, length = array.length, lastIndex = length - 1;
        size2 = size2 === undefined$1 ? length : size2;
        while (++index < size2) {
          var rand = baseRandom(index, lastIndex), value2 = array[rand];
          array[rand] = array[index];
          array[index] = value2;
        }
        array.length = size2;
        return array;
      }
      var stringToPath = memoizeCapped(function(string) {
        var result2 = [];
        if (string.charCodeAt(0) === 46) {
          result2.push("");
        }
        string.replace(rePropName, function(match, number2, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match);
        });
        return result2;
      });
      function toKey(value2) {
        if (typeof value2 == "string" || isSymbol(value2)) {
          return value2;
        }
        var result2 = value2 + "";
        return result2 == "0" && 1 / value2 == -INFINITY ? "-0" : result2;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {
          }
          try {
            return func + "";
          } catch (e) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value2 = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value2)) {
            details.push(value2);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper2) {
        if (wrapper2 instanceof LazyWrapper) {
          return wrapper2.clone();
        }
        var result2 = new LodashWrapper(wrapper2.__wrapped__, wrapper2.__chain__);
        result2.__actions__ = copyArray(wrapper2.__actions__);
        result2.__index__ = wrapper2.__index__;
        result2.__values__ = wrapper2.__values__;
        return result2;
      }
      function chunk(array, size2, guard) {
        if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax(toInteger(size2), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size2 < 1) {
          return [];
        }
        var index = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
        while (index < length) {
          result2[resIndex++] = baseSlice(array, index, index += size2);
        }
        return result2;
      }
      function compact(array) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index < length) {
          var value2 = array[index];
          if (value2) {
            result2[resIndex++] = value2;
          }
        }
        return result2;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array = arguments[0], index = length;
        while (index--) {
          args[index - 1] = arguments[index];
        }
        return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value2, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall(array, value2, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value2, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length - 1;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index < length) {
          var pair = pairs[index];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value2, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseIndexOf(array, value2, index);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value2, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return value2 === value2 ? strictLastIndexOf(array, value2, index) : baseFindIndex(array, baseIsNaN, index, true);
      }
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
      }
      function pullAllBy(array, values2, iteratee2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values2, comparator) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index) {
          return isIndex(index, length) ? +index : index;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index = -1, indexes = [], length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index < length) {
          var value2 = array[index];
          if (predicate(value2, index, array)) {
            result2.push(value2);
            indexes.push(index);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value2) {
        return baseSortedIndex(array, value2);
      }
      function sortedIndexBy(array, value2, iteratee2) {
        return baseSortedIndexBy(array, value2, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value2) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value2);
          if (index < length && eq(array[index], value2)) {
            return index;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value2) {
        return baseSortedIndex(array, value2, true);
      }
      function sortedLastIndexBy(array, value2, iteratee2) {
        return baseSortedIndexBy(array, value2, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value2) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value2, true) - 1;
          if (eq(array[index], value2)) {
            return index;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index) {
          return arrayMap(array, baseProperty(index));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap(result2, function(group) {
          return apply(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value2) {
        var result2 = lodash2(value2);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value2, interceptor) {
        interceptor(value2);
        return value2;
      }
      function thru(value2, interceptor) {
        return interceptor(value2);
      }
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length, start = length ? paths[0] : 0, value2 = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths);
        };
        if (length > 1 || this.__actions__.length || !(value2 instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value2 = value2.slice(start, +start + (length ? 1 : 0));
        value2.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value2, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value2 = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value2 };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value2) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone3 = wrapperClone(parent2);
          clone3.__index__ = 0;
          clone3.__values__ = undefined$1;
          if (result2) {
            previous.__wrapped__ = clone3;
          } else {
            result2 = clone3;
          }
          var previous = clone3;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value2;
        return result2;
      }
      function wrapperReverse() {
        var value2 = this.__wrapped__;
        if (value2 instanceof LazyWrapper) {
          var wrapped = value2;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value2, key) {
        if (hasOwnProperty.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value2, key) {
        if (hasOwnProperty.call(result2, key)) {
          result2[key].push(value2);
        } else {
          baseAssignValue(result2, key, [value2]);
        }
      });
      function includes(collection, value2, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection) ? fromIndex <= length && collection.indexOf(value2, fromIndex) > -1 : !!length && baseIndexOf(collection, value2, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value2) {
          result2[++index] = isFunc ? apply(path, value2, args) : baseInvoke(value2, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value2, key) {
        baseAssignValue(result2, key, value2);
      });
      function map(collection, iteratee2) {
        var func = isArray(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value2, key) {
        result2[key ? 0 : 1].push(value2);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }
      function shuffle(collection) {
        var func = isArray(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now2 = ctxNow || function() {
        return root.Date.now();
      };
      function after(n, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }
      function before(n, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing2 = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing2 = "trailing" in options ? !!options.trailing : trailing2;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now2();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing2 && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now2());
        }
        function debounced() {
          var time = now2(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip2(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache.set(key, result2) || cache;
          return result2;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index = -1, length = nativeMin(args.length, funcsLength);
          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }
      function spread(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function(args) {
          var array = args[start], otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true, trailing2 = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing2 = "trailing" in options ? !!options.trailing : trailing2;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing2
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value2, wrapper2) {
        return partial(castFunction(wrapper2), value2);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value2 = arguments[0];
        return isArray(value2) ? value2 : [value2];
      }
      function clone2(value2) {
        return baseClone(value2, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value2, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value2) {
        return baseClone(value2, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value2, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }
      function eq(value2, other) {
        return value2 === other || value2 !== value2 && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value2, other) {
        return value2 >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value2) {
        return isObjectLike(value2) && hasOwnProperty.call(value2, "callee") && !propertyIsEnumerable.call(value2, "callee");
      };
      var isArray = Array2.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value2) {
        return value2 != null && isLength(value2.length) && !isFunction(value2);
      }
      function isArrayLikeObject(value2) {
        return isObjectLike(value2) && isArrayLike(value2);
      }
      function isBoolean(value2) {
        return value2 === true || value2 === false || isObjectLike(value2) && baseGetTag(value2) == boolTag;
      }
      var isBuffer = nativeIsBuffer || stubFalse;
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value2) {
        return isObjectLike(value2) && value2.nodeType === 1 && !isPlainObject(value2);
      }
      function isEmpty(value2) {
        if (value2 == null) {
          return true;
        }
        if (isArrayLike(value2) && (isArray(value2) || typeof value2 == "string" || typeof value2.splice == "function" || isBuffer(value2) || isTypedArray(value2) || isArguments(value2))) {
          return !value2.length;
        }
        var tag = getTag(value2);
        if (tag == mapTag || tag == setTag) {
          return !value2.size;
        }
        if (isPrototype(value2)) {
          return !baseKeys(value2).length;
        }
        for (var key in value2) {
          if (hasOwnProperty.call(value2, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value2, other) {
        return baseIsEqual(value2, other);
      }
      function isEqualWith(value2, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value2, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual(value2, other, undefined$1, customizer) : !!result2;
      }
      function isError(value2) {
        if (!isObjectLike(value2)) {
          return false;
        }
        var tag = baseGetTag(value2);
        return tag == errorTag || tag == domExcTag || typeof value2.message == "string" && typeof value2.name == "string" && !isPlainObject(value2);
      }
      function isFinite2(value2) {
        return typeof value2 == "number" && nativeIsFinite(value2);
      }
      function isFunction(value2) {
        if (!isObject2(value2)) {
          return false;
        }
        var tag = baseGetTag(value2);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value2) {
        return typeof value2 == "number" && value2 == toInteger(value2);
      }
      function isLength(value2) {
        return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
      }
      function isObject2(value2) {
        var type = typeof value2;
        return value2 != null && (type == "object" || type == "function");
      }
      function isObjectLike(value2) {
        return value2 != null && typeof value2 == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN2(value2) {
        return isNumber(value2) && value2 != +value2;
      }
      function isNative(value2) {
        if (isMaskable(value2)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value2);
      }
      function isNull(value2) {
        return value2 === null;
      }
      function isNil(value2) {
        return value2 == null;
      }
      function isNumber(value2) {
        return typeof value2 == "number" || isObjectLike(value2) && baseGetTag(value2) == numberTag;
      }
      function isPlainObject(value2) {
        if (!isObjectLike(value2) || baseGetTag(value2) != objectTag) {
          return false;
        }
        var proto = getPrototype(value2);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value2) {
        return isInteger(value2) && value2 >= -MAX_SAFE_INTEGER && value2 <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString(value2) {
        return typeof value2 == "string" || !isArray(value2) && isObjectLike(value2) && baseGetTag(value2) == stringTag;
      }
      function isSymbol(value2) {
        return typeof value2 == "symbol" || isObjectLike(value2) && baseGetTag(value2) == symbolTag;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined(value2) {
        return value2 === undefined$1;
      }
      function isWeakMap(value2) {
        return isObjectLike(value2) && getTag(value2) == weakMapTag;
      }
      function isWeakSet(value2) {
        return isObjectLike(value2) && baseGetTag(value2) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value2, other) {
        return value2 <= other;
      });
      function toArray2(value2) {
        if (!value2) {
          return [];
        }
        if (isArrayLike(value2)) {
          return isString(value2) ? stringToArray(value2) : copyArray(value2);
        }
        if (symIterator && value2[symIterator]) {
          return iteratorToArray(value2[symIterator]());
        }
        var tag = getTag(value2), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value2);
      }
      function toFinite(value2) {
        if (!value2) {
          return value2 === 0 ? value2 : 0;
        }
        value2 = toNumber(value2);
        if (value2 === INFINITY || value2 === -INFINITY) {
          var sign = value2 < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value2 === value2 ? value2 : 0;
      }
      function toInteger(value2) {
        var result2 = toFinite(value2), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value2) {
        return value2 ? baseClamp(toInteger(value2), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value2) {
        if (typeof value2 == "number") {
          return value2;
        }
        if (isSymbol(value2)) {
          return NAN;
        }
        if (isObject2(value2)) {
          var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
          value2 = isObject2(other) ? other + "" : other;
        }
        if (typeof value2 != "string") {
          return value2 === 0 ? value2 : +value2;
        }
        value2 = baseTrim(value2);
        var isBinary = reIsBinary.test(value2);
        return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
      }
      function toPlainObject(value2) {
        return copyObject(value2, keysIn(value2));
      }
      function toSafeInteger(value2) {
        return value2 ? baseClamp(toInteger(value2), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value2 === 0 ? value2 : 0;
      }
      function toString2(value2) {
        return value2 == null ? "" : baseToString(value2);
      }
      var assign = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype, properties) {
        var result2 = baseCreate(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults2 = baseRest(function(object, sources) {
        object = Object2(object);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value2 = object[key];
            if (value2 === undefined$1 || eq(value2, objectProto[key]) && !hasOwnProperty.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result2 = object == null ? undefined$1 : baseGet(object, path);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has2(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result2, value2, key) {
        if (value2 != null && typeof value2.toString != "function") {
          value2 = nativeObjectToString.call(value2);
        }
        result2[value2] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value2, key) {
        if (value2 != null && typeof value2.toString != "function") {
          value2 = nativeObjectToString.call(value2);
        }
        if (hasOwnProperty.call(result2, value2)) {
          result2[value2].push(key);
        } else {
          result2[value2] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value2, key, object2) {
          baseAssignValue(result2, iteratee2(value2, key, object2), value2);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value2, key, object2) {
          baseAssignValue(result2, key, iteratee2(value2, key, object2));
        });
        return result2;
      }
      var merge = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result2);
        if (isDeep) {
          result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result2, paths[length]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value2, path) {
          return predicate(value2, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index = -1, length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index < length) {
          var value2 = object == null ? undefined$1 : object[toKey(path[index])];
          if (value2 === undefined$1) {
            index = length;
            value2 = defaultValue;
          }
          object = isFunction(value2) ? value2.call(object) : value2;
        }
        return object;
      }
      function set(object, path, value2) {
        return object == null ? object : baseSet(object, path, value2);
      }
      function setWith(object, path, value2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value2, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value2, index, object2) {
          return iteratee2(accumulator, value2, index, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update2(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number2, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number2), lower, upper);
      }
      function inRange(number2, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number2 = toNumber(number2);
        return baseInRange(number2, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index) {
        word = word.toLowerCase();
        return result2 + (index ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString2(string).toLowerCase());
      }
      function deburr(string) {
        string = toString2(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string, target, position) {
        string = toString2(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }
      function escape(string) {
        string = toString2(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString2(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
      }
      var kebabCase = createCompounder(function(result2, word, index) {
        return result2 + (index ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index) {
        return result2 + (index ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string, length, chars) {
        string = toString2(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString2(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString2(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt2(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString2(string).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString2(string), n);
      }
      function replace() {
        var args = arguments, string = toString2(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index) {
        return result2 + (index ? "_" : "") + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString2(string);
        if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index) {
        return result2 + (index ? " " : "") + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString2(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString2(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2(
          (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index = offset + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result2.source = source;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value2) {
        return toString2(value2).toLowerCase();
      }
      function toUpper(value2) {
        return toString2(value2).toUpperCase();
      }
      function trim(string, chars, guard) {
        string = toString2(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string, chars, guard) {
        string = toString2(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string, chars, guard) {
        string = toString2(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, "");
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string = toString2(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString2(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index = result2.lastIndexOf(separator);
          if (index > -1) {
            result2 = result2.slice(0, index);
          }
        }
        return result2 + omission;
      }
      function unescape(string) {
        string = toString2(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function(result2, word, index) {
        return result2 + (index ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string, pattern, guard) {
        string = toString2(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error2(e);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index = -1;
          while (++index < length) {
            var pair = pairs[index];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value2) {
        return function() {
          return value2;
        };
      }
      function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value2) {
        return value2;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop() {
      }
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function(args) {
          return baseNth(args, n);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n, iteratee2) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes(length, iteratee2);
        while (++index < n) {
          iteratee2(index);
        }
        return result2;
      }
      function toPath(value2) {
        if (isArray(value2)) {
          return arrayMap(value2, toKey);
        }
        return isSymbol(value2) ? [value2] : copyArray(stringToPath(toString2(value2)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter2;
        return toString2(prefix) + id;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip2;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys;
      lodash2.keysIn = keysIn;
      lodash2.map = map;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize;
      lodash2.merge = merge;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update2;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone2;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq;
      lodash2.escape = escape;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has2;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray;
      lodash2.isArrayBuffer = isArrayBuffer;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean;
      lodash2.isBuffer = isBuffer;
      lodash2.isDate = isDate;
      lodash2.isElement = isElement;
      lodash2.isEmpty = isEmpty;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike;
      lodash2.isPlainObject = isPlainObject;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString;
      lodash2.isSymbol = isSymbol;
      lodash2.isTypedArray = isTypedArray;
      lodash2.isUndefined = isUndefined;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop;
      lodash2.now = now2;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace;
      lodash2.result = result;
      lodash2.round = round;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString2;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index) {
        LazyWrapper.prototype[methodName] = function(n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
        var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index) {
        var takeName = "take" + (index ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index) {
        var dropName = "drop" + (index ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value2) {
          return baseInvoke(value2, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);
        var result2 = this;
        if (result2.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start < 0) {
          result2 = result2.takeRight(-start);
        } else if (start) {
          result2 = result2.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value2 = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value2 instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value2);
          var interceptor = function(value3) {
            var result3 = lodashFunc.apply(lodash2, arrayPush([value3], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value2 = onlyLazy ? value2 : new LazyWrapper(this);
            var result2 = func.apply(value2, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value2 = this.value();
            return func.apply(isArray(value2) ? value2 : [], args);
          }
          return this[chainName](function(value3) {
            return func.apply(isArray(value3) ? value3 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _ = runInContext();
    if (freeModule) {
      (freeModule.exports = _)._ = _;
      freeExports._ = _;
    } else {
      root._ = _;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports;
const scrollytelling = "_scrollytelling_1tnoi_1";
const scrollytelling__container = "_scrollytelling__container_1tnoi_9";
const scrollytelling__darkTheme = "_scrollytelling__darkTheme_1tnoi_13";
const pointer = "_pointer_1tnoi_29";
const pcPointer = "_pcPointer_1tnoi_67";
const brabus = "_brabus_1tnoi_72";
const activePointer = "_activePointer_1tnoi_76";
const circlePointer = "_circlePointer_1tnoi_81";
const progress$1 = "_progress_1tnoi_120";
const ring1 = "_ring1_1tnoi_135";
const ring2 = "_ring2_1tnoi_136";
const ring3 = "_ring3_1tnoi_137";
const pcRing = "_pcRing_1tnoi_147";
const ringScrollIn = "_ringScrollIn_1tnoi_180";
const scaledRing = "_scaledRing_1tnoi_184";
const pcCursor = "_pcCursor_1tnoi_189";
const scrollytelling__wrapper = "_scrollytelling__wrapper_1tnoi_197";
const scrollytellingSwiper = "_scrollytellingSwiper_1tnoi_200";
const swiperMask = "_swiperMask_1tnoi_207";
const scrollytellingImage = "_scrollytellingImage_1tnoi_213";
const scrollytelling__slideContainer = "_scrollytelling__slideContainer_1tnoi_218";
const scrollytelling__itemsWrapper = "_scrollytelling__itemsWrapper_1tnoi_222";
const scrollytelling__itemWrapper = "_scrollytelling__itemWrapper_1tnoi_228";
const mobileCursor = "_mobileCursor_1tnoi_235";
const showItemWrapper = "_showItemWrapper_1tnoi_240";
const scrollytelling__imageWrapper = "_scrollytelling__imageWrapper_1tnoi_243";
const image$1 = "_image_1tnoi_253";
const scrollytelling__indicator = "_scrollytelling__indicator_1tnoi_262";
const scrollytelling__description = "_scrollytelling__description_1tnoi_270";
const scrollytelling__cta = "_scrollytelling__cta_1tnoi_291";
const scrollytelling__pageIndex = "_scrollytelling__pageIndex_1tnoi_312";
const content$1 = "_content_1tnoi_318";
const headline$7 = "_headline_1tnoi_334";
const description = "_description_1tnoi_354";
const listTitle = "_listTitle_1tnoi_375";
const typeList = "_typeList_1tnoi_395";
const highlights = "_highlights_1tnoi_433";
const highlightTitle = "_highlightTitle_1tnoi_438";
const highlightData = "_highlightData_1tnoi_463";
const unit = "_unit_1tnoi_487";
const highlightLabel = "_highlightLabel_1tnoi_502";
const boxBottomBar = "_boxBottomBar_1tnoi_522";
const bottomBar = "_bottomBar_1tnoi_542";
const scrollIn = "_scrollIn_1tnoi_565";
const control = "_control_1tnoi_570";
const volumeControl = "_volumeControl_1tnoi_571";
const currentIndex = "_currentIndex_1tnoi_602";
const nextIndex = "_nextIndex_1tnoi_603";
const soundLabel = "_soundLabel_1tnoi_604";
const noIndex = "_noIndex_1tnoi_649";
const play$1 = "_play_1tnoi_657";
const hotArea = "_hotArea_1tnoi_667";
const shadeMask = "_shadeMask_1tnoi_675";
const scrollShadeMask = "_scrollShadeMask_1tnoi_698";
const textScrollIn = "_textScrollIn_1tnoi_711";
const muteButton = "_muteButton_1tnoi_728";
const hideContent = "_hideContent_1tnoi_738";
const brabusLight = "_brabusLight_1tnoi_743";
const outOfTarget = "_outOfTarget_1tnoi_748";
const bottomIndicator = "_bottomIndicator_1tnoi_753";
const pause$1 = "_pause_1tnoi_861";
const firstFrame = "_firstFrame_1tnoi_879";
const styles$h = {
  scrollytelling,
  scrollytelling__container,
  scrollytelling__darkTheme,
  "scrollytelling--noTopSpacing": "_scrollytelling--noTopSpacing_1tnoi_16",
  "scrollytelling--pc__container": "_scrollytelling--pc__container_1tnoi_19",
  "scrollytelling--pc": "_scrollytelling--pc_1tnoi_19",
  pointer,
  pcPointer,
  brabus,
  activePointer,
  circlePointer,
  "progress-bg": "_progress-bg_1tnoi_120",
  progress: progress$1,
  "progress-brabus": "_progress-brabus_1tnoi_130",
  ring1,
  ring2,
  ring3,
  pcRing,
  ringScrollIn,
  scaledRing,
  pcCursor,
  scrollytelling__wrapper,
  scrollytellingSwiper,
  swiperMask,
  scrollytellingImage,
  scrollytelling__slideContainer,
  scrollytelling__itemsWrapper,
  scrollytelling__itemWrapper,
  mobileCursor,
  showItemWrapper,
  scrollytelling__imageWrapper,
  "scrollytelling__imageWrapper--video": "_scrollytelling__imageWrapper--video_1tnoi_250",
  image: image$1,
  scrollytelling__indicator,
  scrollytelling__description,
  scrollytelling__cta,
  scrollytelling__pageIndex,
  content: content$1,
  headline: headline$7,
  description,
  listTitle,
  typeList,
  highlights,
  highlightTitle,
  highlightData,
  "highlightData--multiple": "_highlightData--multiple_1tnoi_472",
  unit,
  highlightLabel,
  boxBottomBar,
  bottomBar,
  scrollIn,
  control,
  volumeControl,
  currentIndex,
  nextIndex,
  soundLabel,
  noIndex,
  play: play$1,
  hotArea,
  shadeMask,
  scrollShadeMask,
  textScrollIn,
  muteButton,
  hideContent,
  brabusLight,
  outOfTarget,
  bottomIndicator,
  "video-slide": "_video-slide_1tnoi_760",
  pause: pause$1,
  firstFrame
};
const baseClass$c = "video-slide";
const VideoSlide = forwardRef(
  ({ landscapeUrl, portraitUrl, altText, className, isMuted, onTimeUpdate, children }, forwardedRef) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const isPortrait = useIsPortrait();
    const url = isPortrait ? portraitUrl : landscapeUrl;
    const play2 = () => {
      const video2 = videoRef.current;
      if (video2 && !isPlaying) {
        setIsPlaying(true);
      }
    };
    const pause2 = () => {
      const video2 = videoRef.current;
      if (video2 && isPlaying) {
        setIsPlaying(false);
      }
    };
    useEffect(() => {
      const video2 = videoRef.current;
      if (video2) {
        if (isPlaying) {
          video2.play();
        } else {
          video2.pause();
        }
      }
    }, [isPlaying]);
    useImperativeHandle(forwardedRef, () => ({
      isPlaying: () => isPlaying,
      play: play2,
      pause: pause2
    }));
    return /* @__PURE__ */ jsxs("div", { className: classNames(className, styles$h[baseClass$c]), children: [
      /* @__PURE__ */ jsx(
        "video",
        {
          ref: videoRef,
          preload: "metadata",
          src: url ? `${url}#t=0.5` : void 0,
          "aria-label": altText,
          playsInline: true,
          loop: true,
          muted: isMuted,
          onTimeUpdate
        }
      ),
      children
    ] });
  }
);
VideoSlide.displayName = "VideoSlide";
const baseClass$b = "scrollytelling";
const Scrollytelling = ({ removeTopSpacing: removeTopSpacing2, scrollyList, maskControl, mode }) => {
  var _a, _b;
  const initialScale = 0.9;
  const galleryRef = useRef(null);
  const bottomIndicatorRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(1920);
  const isInViewport = useRef(false);
  const [scrollRatio, setScrollRatio] = useState(initialScale);
  const preventScrollTemporarily = useRef(false);
  const [hideCursor, setHideCursor] = useState(false);
  const [mouseDown, setMouseDown] = useState(false);
  const videoRefs = useRef([]);
  const [currentIndex2, setCurrentIndex] = useState(null);
  const [isMuted, setIsMuted] = useState(true);
  const progressRefs = useRef([]);
  const swiperRef = useRef(null);
  const onVideoTimeUpdate = (e) => {
    const video2 = e.target;
    const percent = video2.duration ? video2.currentTime / video2.duration : 0;
    const circle2 = progressRefs.current[currentIndex2];
    if (circle2 && holdIcon) {
      const perimeter = circle2.getTotalLength();
      circle2.setAttribute("stroke-dasharray", `${perimeter * percent} ${perimeter * (1 - percent)}`);
    }
  };
  const [outOfTarget2, setOutOfTarget] = useState(true);
  const [mouseX, setMouseX] = useState();
  const [mouseY, setMouseY] = useState();
  const [holdIcon, setHoldIcon] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const isPortrait = useIsPortrait();
  const elementsRefs = useRef([]);
  const elementsListRefs = useRef([]);
  const [shadeMaskIndex, setShadeMaskIndex] = useState(0);
  const [scrollyTellingList, setScrollyTellingList] = useState(new Array(scrollyList.length).fill(false));
  const [contentTransitionDelay, setContentTransitionDelay] = useState("1.1s");
  const playVideo = (index) => {
    for (let i = 0; i < videoRefs.current.length; i++) {
      const video2 = videoRefs.current[i];
      if (video2) {
        if (index === i) {
          video2.play();
        } else {
          video2.pause();
        }
      }
    }
  };
  const pauseVideos = () => {
    for (let i = 0; i < videoRefs.current.length; i++) {
      const video2 = videoRefs.current[i];
      if (video2) {
        video2.pause();
      }
    }
  };
  const timeout = useRef();
  useEffect(() => {
    document.addEventListener("mousemove", (event) => {
      var _a2;
      const e = event || window.event;
      const rect = (_a2 = galleryRef.current) == null ? void 0 : _a2.getBoundingClientRect();
      if (galleryRef.current) {
        setMouseX(e.clientX);
        setMouseY(e.clientY);
        if (rect.top > 0) {
          setOutOfTarget((e.clientY || 0) < rect.top + 50);
        } else {
          setOutOfTarget((e.clientY + 100 || 0) > rect.bottom + 60);
        }
      }
    });
    const setWidth2 = () => {
      setWindowWidth(window.innerWidth);
    };
    setWidth2();
    window.addEventListener("resize", () => {
      setWidth2();
    });
  }, []);
  useEffect(() => {
    let lastScrollTop = 0;
    const scrollEvent = () => {
      var _a2, _b2;
      if (!galleryRef.current || !isInViewport.current || preventScrollTemporarily.current) {
        return;
      }
      const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
      const isScrollingDown = currentScrollTop > lastScrollTop;
      lastScrollTop = currentScrollTop;
      const rect = (_a2 = galleryRef.current) == null ? void 0 : _a2.getBoundingClientRect();
      const topDistance = window.innerHeight - rect.top;
      if (rect.top >= 0) {
        const endRatio = galleryRef.current.clientWidth / window.innerWidth;
        setScrollRatio(0.9 + topDistance * (endRatio - 0.9) / window.innerHeight);
      } else {
        setScrollRatio(1);
      }
      const bottomDistance = window.innerHeight - rect.bottom;
      if (Math.abs(rect.top) >= rect.height - 1e3 && bottomDistance <= window.innerHeight) {
        setScrollRatio(Math.min(1, 1 - 0.1 * (bottomDistance / window.innerHeight)));
      }
      if (!isScrollingDown) {
        elementsListRefs.current.forEach((ref) => {
          ref.style.opacity = `0`;
        });
      } else {
        if (shadeMaskIndex > 0) {
          const element = (_b2 = elementsListRefs.current[shadeMaskIndex]) == null ? void 0 : _b2.getBoundingClientRect();
          const topDistances = window.innerHeight - element.top;
          const endRatio = element.width / window.innerWidth;
          const scrollshadeMaskRatio = Math.min(0.8, topDistances * (endRatio - 0.1) / window.innerHeight);
          elementsListRefs.current[shadeMaskIndex - 1].style.opacity = `${scrollshadeMaskRatio}`;
        }
      }
    };
    let scroll = lodashExports.throttle(scrollEvent, 200);
    const handleIntersections = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        isInViewport.current = true;
        document.addEventListener("scroll", scroll);
      } else {
        isInViewport.current = false;
      }
    };
    const observer = new IntersectionObserver(handleIntersections);
    const el = swiperRef.current;
    if (el) {
      observer.observe(el);
    }
    return () => {
      if (el) {
        observer.unobserve(el);
        document.removeEventListener("scroll", scroll);
        isInViewport.current = false;
      }
    };
  }, [shadeMaskIndex]);
  useEffect(() => {
    const handleScroll2 = () => {
      var _a2;
      if (!galleryRef.current || !mouseY) {
        return;
      }
      const rect = (_a2 = galleryRef.current) == null ? void 0 : _a2.getBoundingClientRect();
      setOutOfTarget(rect.top + 50 >= mouseY || rect.bottom - 100 <= mouseY);
    };
    document.addEventListener("scroll", handleScroll2);
    return () => {
      document.removeEventListener("scroll", handleScroll2);
    };
  }, [mouseY]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            const intersectionRatio = entry.intersectionRatio;
            if (intersectionRatio >= 0.1) {
              setShadeMaskIndex(index);
            }
            if (intersectionRatio >= 0.5) {
              setScrollyTellingList((prevScrollIn) => {
                const newScrollIn = [...prevScrollIn];
                newScrollIn[index] = true;
                setCurrentIndex(index);
                return newScrollIn;
              });
            } else if (intersectionRatio >= 0.9) {
              setScrollyTellingList((prevScrollIn) => {
                const newScrollIn = [...prevScrollIn];
                newScrollIn[index] = false;
                return newScrollIn;
              });
            }
          }
        });
      },
      {
        threshold: [0.1, 0.5, 0.9]
      }
    );
    elementsRefs.current.forEach((ref) => {
      if (ref) {
        observer.observe(ref);
      }
    });
    return () => {
      elementsRefs.current.forEach((ref) => {
        if (ref) {
          observer.unobserve(ref);
        }
      });
    };
  }, [scrollyTellingList, currentIndex2]);
  useEffect(() => {
    setMouseDown(false);
    setHoldIcon(false);
    pauseVideos();
    if (currentIndex2 === 0) {
      setTimeout(() => {
        setContentTransitionDelay("0s");
      }, 1100);
    }
  }, [currentIndex2]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    "section",
    {
      className: classNames(styles$h[baseClass$b], styles$h[`${baseClass$b}--pc`], {
        [styles$h[`${baseClass$b}--noTopSpacing`]]: removeTopSpacing2,
        [styles$h[`${baseClass$b}__darkTheme`]]: mode === "dark" || mode === "brabus"
      }),
      role: "button",
      tabIndex: -1,
      onMouseDown: (e) => {
        var _a2;
        if (windowWidth > breakpoints$1.l && ((_a2 = scrollyList[currentIndex2]) == null ? void 0 : _a2.videoLandscape)) {
          playVideo(currentIndex2);
          timeout.current = setTimeout(() => {
            setHoldIcon(true);
          }, 2e3);
          setStartTime(e.timeStamp);
          setMouseDown(true);
        }
      },
      onMouseUp: (e) => {
        if (windowWidth > breakpoints$1.l) {
          if (e.timeStamp - startTime < 2e3) {
            setHoldIcon(false);
            pauseVideos();
          }
          clearTimeout(timeout.current);
          setMouseDown(false);
        }
      },
      children: [
        /* @__PURE__ */ jsx("div", { ref: bottomIndicatorRef, className: styles$h.bottomIndicator }),
        /* @__PURE__ */ jsx(
          "div",
          {
            ref: galleryRef,
            className: classNames(styles$h[`${baseClass$b}__container`], {
              [styles$h[`${baseClass$b}__darkTheme`]]: mode === "dark" || mode === "brabus"
            }),
            children: /* @__PURE__ */ jsxs("div", { style: { scale: `${scrollRatio}` }, className: classNames(styles$h[`${baseClass$b}__wrapper`]), children: [
              /* @__PURE__ */ jsx("div", { className: styles$h.swiperMask }),
              /* @__PURE__ */ jsxs("div", { className: styles$h.scrollytellingSwiper, ref: swiperRef, children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: classNames(styles$h.bottomBar, {
                      [styles$h.scrollRight]: holdIcon
                    }),
                    style: {
                      display: ((_a = scrollyList[currentIndex2]) == null ? void 0 : _a.landscapeImage) || windowWidth < breakpoints$1.l ? "none" : "flex",
                      position: scrollRatio <= 0.95 ? "absolute" : "sticky"
                    },
                    children: /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: styles$h.hotArea,
                        onMouseEnter: () => {
                          setHideCursor(true);
                        },
                        onMouseLeave: () => {
                          setHideCursor(false);
                        },
                        children: /* @__PURE__ */ jsx(
                          "button",
                          {
                            className: styles$h.volumeControl,
                            onClick: () => {
                              setIsMuted(!isMuted);
                            },
                            onMouseDown: (e) => {
                              e.stopPropagation();
                            },
                            children: /* @__PURE__ */ jsx("div", { className: styles$h.muteButton, children: /* @__PURE__ */ jsx(Icon, { className: styles$h.muteButton, name: isMuted ? "volume-off--small" : "volume-on--small" }) })
                          }
                        )
                      }
                    )
                  }
                ),
                scrollyList.map((item2, index) => {
                  var _a2, _b2, _c, _d, _e, _f, _g;
                  return /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: classNames(styles$h[`${baseClass$b}__itemWrapper`], {
                        [styles$h.showItemWrapper]: (_a2 = scrollyList[currentIndex2]) == null ? void 0 : _a2.videoLandscape
                      }),
                      ref: (el) => {
                        if (el) {
                          elementsRefs.current[index] = el;
                        }
                      },
                      children: [
                        /* @__PURE__ */ jsxs(
                          "div",
                          {
                            className: classNames(styles$h.content, {
                              [styles$h.textScrollIn]: scrollyTellingList[index],
                              [styles$h.hideContent]: mouseDown || holdIcon
                            }),
                            style: { transitionDelay: contentTransitionDelay },
                            children: [
                              item2.headline && /* @__PURE__ */ jsx("p", { className: styles$h.headline, children: item2.headline }),
                              item2.description && /* @__PURE__ */ jsx("p", { className: styles$h.description, children: item2.description }),
                              /* @__PURE__ */ jsxs("div", { className: styles$h.highlights, children: [
                                /* @__PURE__ */ jsxs("div", { children: [
                                  item2.highlightTitle && /* @__PURE__ */ jsx(RichText, { className: styles$h.highlightTitle, mdString: item2.highlightTitle || "" }),
                                  item2.highlightData && /* @__PURE__ */ jsxs(
                                    "p",
                                    {
                                      className: classNames(styles$h.highlightData, {
                                        [styles$h["highlightData--multiple"]]: item2.highlightData && item2.highlight2Data
                                      }),
                                      children: [
                                        /* @__PURE__ */ jsx("span", { className: styles$h.data, children: item2.highlightData }),
                                        /* @__PURE__ */ jsx("span", { className: styles$h.unit, children: item2.highlightDataUnit })
                                      ]
                                    }
                                  ),
                                  item2.highlightDescription && /* @__PURE__ */ jsx(RichText, { className: styles$h.highlightLabel, mdString: item2.highlightDescription || "" })
                                ] }),
                                /* @__PURE__ */ jsxs("div", { children: [
                                  item2.highlight2Title && /* @__PURE__ */ jsx(RichText, { className: styles$h.highlightTitle, mdString: item2.highlight2Title || "" }),
                                  item2.highlight2Data && /* @__PURE__ */ jsxs(
                                    "p",
                                    {
                                      className: classNames(styles$h.highlightData, {
                                        [styles$h["highlightData--multiple"]]: item2.highlightData && item2.highlight2Data
                                      }),
                                      children: [
                                        /* @__PURE__ */ jsx("span", { className: styles$h.data, children: item2.highlight2Data }),
                                        /* @__PURE__ */ jsx("span", { className: styles$h.unit, children: item2.highlight2DataUnit })
                                      ]
                                    }
                                  ),
                                  item2.highlight2Description && /* @__PURE__ */ jsx(RichText, { className: styles$h.highlightLabel, mdString: item2.highlight2Description || "" })
                                ] })
                              ] })
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: classNames(styles$h.shadeMask, styles$h.textScrollIn, {
                              [styles$h.hideContent]: (mouseDown || holdIcon) && index === currentIndex2
                            }),
                            style: {
                              display: maskControl ? "block" : "none"
                            },
                            onContextMenu: (e) => {
                              e.preventDefault();
                            }
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: classNames(styles$h.scrollShadeMask),
                            style: {
                              transitionDelay: contentTransitionDelay
                            },
                            ref: (el) => {
                              if (el) {
                                elementsListRefs.current[index] = el;
                              }
                            }
                          }
                        ),
                        item2.landscapeImage && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
                          DynamicMediaPicture,
                          {
                            className: styles$h["scrollytellingImage"],
                            imageAltText: isPortrait ? ((_b2 = item2.portraitImage) == null ? void 0 : _b2.imageAltText) || "" : (_c = item2.landscapeImage) == null ? void 0 : _c.imageAltText,
                            imageUrl: isPortrait ? ((_d = item2.portraitImage) == null ? void 0 : _d.imageUrl) || ((_e = item2.landscapeImage) == null ? void 0 : _e.imageUrl) : (_f = item2.landscapeImage) == null ? void 0 : _f.imageUrl,
                            initialIsInView: true,
                            imageConfigs: [
                              {
                                aspectRatio: isPortrait ? "9-16" : "16-9",
                                sizes: "100vw"
                              }
                            ]
                          }
                        ) }),
                        item2.videoLandscape && /* @__PURE__ */ jsx(
                          VideoSlide,
                          {
                            ref: (el) => {
                              if (el) {
                                videoRefs.current[index] = el;
                              }
                            },
                            currentIndex: index,
                            className: styles$h.image,
                            landscapeUrl: (item2 == null ? void 0 : item2.videoLandscape) || "",
                            portraitUrl: (item2 == null ? void 0 : item2.videoPortrait) || "",
                            altText: item2 == null ? void 0 : item2.videoAltText,
                            sendMutedStatus: (muted) => {
                              setIsMuted(muted);
                            },
                            isMuted,
                            onTimeUpdate: onVideoTimeUpdate
                          }
                        ),
                        /* @__PURE__ */ jsx("div", { className: styles$h.boxBottomBar, children: /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: classNames(styles$h.bottomBar, {
                              [styles$h.scrollRight]: holdIcon
                            }),
                            style: {
                              display: ((_g = scrollyList[currentIndex2]) == null ? void 0 : _g.landscapeImage) || windowWidth >= breakpoints$1.l ? "none" : "flex"
                            },
                            children: /* @__PURE__ */ jsx(
                              "div",
                              {
                                className: styles$h.hotArea,
                                onMouseEnter: () => {
                                  setHideCursor(true);
                                },
                                onMouseLeave: () => {
                                  setHideCursor(false);
                                },
                                children: /* @__PURE__ */ jsx(
                                  "button",
                                  {
                                    className: styles$h.volumeControl,
                                    onClick: () => {
                                      setIsMuted(!isMuted);
                                    },
                                    onMouseDown: (e) => {
                                      e.stopPropagation();
                                    },
                                    children: /* @__PURE__ */ jsx("div", { className: styles$h.muteButton, children: /* @__PURE__ */ jsx(
                                      Icon,
                                      {
                                        className: styles$h.muteButton,
                                        name: isMuted ? "volume-off--small" : "volume-on--small"
                                      }
                                    ) })
                                  }
                                )
                              }
                            )
                          }
                        ) }),
                        windowWidth <= breakpoints$1.l && !item2.landscapeImage && (holdIcon ? /* @__PURE__ */ jsxs(
                          "button",
                          {
                            className: styles$h.circlePointer,
                            onClick: () => {
                              setHoldIcon(false);
                              setMouseDown(false);
                              pauseVideos();
                            },
                            children: [
                              /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "70", height: "70", viewBox: "0 0 50 50", children: [
                                /* @__PURE__ */ jsx(
                                  "circle",
                                  {
                                    fill: "transparent",
                                    className: styles$h["progress-bg"],
                                    strokeWidth: "2",
                                    cx: "25",
                                    cy: "25",
                                    r: "20"
                                  }
                                ),
                                /* @__PURE__ */ jsx(
                                  "circle",
                                  {
                                    ref: (el) => {
                                      if (el)
                                        progressRefs.current[index] = el;
                                    },
                                    fill: "transparent",
                                    className: mode === "brabus" ? styles$h["progress-brabus"] : styles$h["progress"],
                                    strokeWidth: "2",
                                    cx: "25",
                                    cy: "25",
                                    r: "20",
                                    strokeDasharray: "0 1"
                                  }
                                )
                              ] }),
                              /* @__PURE__ */ jsxs(
                                "svg",
                                {
                                  className: styles$h.pause,
                                  width: "30",
                                  height: "30",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  children: [
                                    /* @__PURE__ */ jsx("path", { d: "M11 7H8V17H11V7Z", fill: "white" }),
                                    /* @__PURE__ */ jsx("path", { d: "M13 17H16V7H13V17Z", fill: "white" })
                                  ]
                                }
                              )
                            ]
                          }
                        ) : /* @__PURE__ */ jsx("div", { className: styles$h.mobileCursor, children: /* @__PURE__ */ jsxs(
                          "button",
                          {
                            className: classNames(styles$h.pointer, {
                              [styles$h.brabus]: mode === "brabus",
                              [styles$h.ringScrollIn]: index === currentIndex2,
                              [styles$h.activePointer]: mouseDown
                            }),
                            onTouchStart: (e) => {
                              playVideo(index);
                              timeout.current = setTimeout(() => {
                                setHoldIcon(true);
                              }, 2e3);
                              setStartTime(e.timeStamp);
                              setMouseDown(true);
                            },
                            onTouchEnd: (e) => {
                              if (e.timeStamp - startTime < 2e3) {
                                setHoldIcon(false);
                                pauseVideos();
                              }
                              clearTimeout(timeout.current);
                              setMouseDown(false);
                            },
                            onContextMenu: (e) => {
                              e.preventDefault();
                            },
                            children: [
                              /* @__PURE__ */ jsx("span", { children: mouseDown ? item2.cursorDownText : item2.cursorText }),
                              /* @__PURE__ */ jsx(
                                "div",
                                {
                                  className: classNames(styles$h.ring1, {
                                    [styles$h.ringScrollIn]: index === currentIndex2,
                                    [styles$h.scaledRing]: mouseDown
                                  })
                                }
                              ),
                              /* @__PURE__ */ jsx(
                                "div",
                                {
                                  className: classNames(styles$h.ring2, {
                                    [styles$h.ringScrollIn]: index === currentIndex2,
                                    [styles$h.scaledRing]: mouseDown
                                  })
                                }
                              )
                            ]
                          }
                        ) }))
                      ]
                    },
                    item2.itemId
                  );
                })
              ] })
            ] })
          }
        ),
        windowWidth > breakpoints$1.l && ((_b = scrollyList[currentIndex2]) == null ? void 0 : _b.videoLandscape) && /* @__PURE__ */ jsx("div", { className: classNames({ [styles$h.outOfTarget]: outOfTarget2 }), children: holdIcon ? /* @__PURE__ */ jsxs(
          "div",
          {
            className: styles$h.circlePointer,
            style: {
              translate: `${mouseX}px ${mouseY}px`,
              visibility: hideCursor ? "hidden" : "visible"
            },
            children: [
              /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "50", height: "50", viewBox: "0 0 50 50", children: [
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    fill: "transparent",
                    className: styles$h["progress-bg"],
                    strokeWidth: "2",
                    cx: "25",
                    cy: "25",
                    r: "20"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    ref: (el) => {
                      if (el)
                        progressRefs.current[currentIndex2] = el;
                    },
                    fill: "transparent",
                    className: mode === "brabus" ? styles$h["progress-brabus"] : styles$h["progress"],
                    strokeWidth: "2",
                    cx: "25",
                    cy: "25",
                    r: "20",
                    strokeDasharray: "0 1"
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs(
                "svg",
                {
                  className: styles$h.pause,
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ jsx("path", { d: "M11 7H8V17H11V7Z", fill: "white" }),
                    /* @__PURE__ */ jsx("path", { d: "M13 17H16V7H13V17Z", fill: "white" })
                  ]
                }
              )
            ]
          }
        ) : /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "fixed",
              left: 0,
              top: 0,
              translate: `${mouseX}px ${mouseY}px`,
              zIndex: 1,
              visibility: hideCursor ? "hidden" : "visible"
            },
            children: /* @__PURE__ */ jsxs(
              "button",
              {
                className: classNames(styles$h.pointer, styles$h.pcPointer, {
                  [styles$h.brabus]: mode === "brabus",
                  [styles$h.activePointer]: mouseDown
                }),
                children: [
                  /* @__PURE__ */ jsx("span", { children: mouseDown ? scrollyList[currentIndex2].cursorDownText : scrollyList[currentIndex2].cursorText }),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames(styles$h.ring1, styles$h.pcRing, {
                        [styles$h.scaledRing]: mouseDown
                      })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames(styles$h.ring2, styles$h.pcRing, {
                        [styles$h.scaledRing]: mouseDown
                      })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames(styles$h.ring3, styles$h.pcRing, {
                        [styles$h.scaledRing]: mouseDown
                      })
                    }
                  )
                ]
              }
            )
          }
        ) })
      ]
    }
  ) });
};
const price$2 = "_price_1dz2o_191";
const headline$6 = "_headline_1dz2o_234";
const contentTag$1 = "_contentTag_1dz2o_269";
const headlineWrapper$1 = "_headlineWrapper_1dz2o_272";
const logoWrapper = "_logoWrapper_1dz2o_291";
const subHeadline$3 = "_subHeadline_1dz2o_294";
const primaryLink$1 = "_primaryLink_1dz2o_346";
const secondaryLink = "_secondaryLink_1dz2o_356";
const subText = "_subText_1dz2o_366";
const videoMask = "_videoMask_1dz2o_408";
const video$1 = "_video_1dz2o_408";
const award = "_award_1dz2o_418";
const pureBackground = "_pureBackground_1dz2o_442";
const controlBar = "_controlBar_1dz2o_460";
const pagination = "_pagination_1dz2o_475";
const dotOuter = "_dotOuter_1dz2o_486";
const dotWrapperContainer = "_dotWrapperContainer_1dz2o_497";
const dotWrapper = "_dotWrapper_1dz2o_497";
const current = "_current_1dz2o_518";
const thumbnailBackground = "_thumbnailBackground_1dz2o_522";
const progress = "_progress_1dz2o_533";
const btnWrapper = "_btnWrapper_1dz2o_546";
const bottomArrow = "_bottomArrow_1dz2o_551";
const mobileArrow = "_mobileArrow_1dz2o_565";
const dot = "_dot_1dz2o_486";
const play = "_play_1dz2o_629";
const pause = "_pause_1dz2o_610";
const picture$1 = "_picture_1dz2o_659";
const styles$g = {
  "content-animation": "_content-animation_1dz2o_37",
  "slide-up": "_slide-up_1dz2o_1",
  "link-animation": "_link-animation_1dz2o_51",
  "primary-hero-wrapper": "_primary-hero-wrapper_1dz2o_67",
  "legal-disclaimer": "_legal-disclaimer_1dz2o_71",
  "primary-hero-wrapper--showBanner": "_primary-hero-wrapper--showBanner_1dz2o_75",
  "primary-hero": "_primary-hero_1dz2o_67",
  "primary-hero--normal": "_primary-hero--normal_1dz2o_93",
  "primary-hero__slideButton": "_primary-hero__slideButton_1dz2o_104",
  "primary-hero__slideButton--left": "_primary-hero__slideButton--left_1dz2o_118",
  "primary-hero__slideButton--right": "_primary-hero__slideButton--right_1dz2o_122",
  "primary-hero__itemsWrapper": "_primary-hero__itemsWrapper_1dz2o_127",
  "primary-hero__itemWrapper": "_primary-hero__itemWrapper_1dz2o_131",
  "primary-hero__bottomGradient": "_primary-hero__bottomGradient_1dz2o_135",
  "primary-hero__content": "_primary-hero__content_1dz2o_147",
  "primary-hero__content--multipleSlides": "_primary-hero__content--multipleSlides_1dz2o_173",
  price: price$2,
  "price-origin": "_price-origin_1dz2o_219",
  headline: headline$6,
  "headline--with-price": "_headline--with-price_1dz2o_251",
  contentTag: contentTag$1,
  headlineWrapper: headlineWrapper$1,
  logoWrapper,
  subHeadline: subHeadline$3,
  "subHeadline--with-price": "_subHeadline--with-price_1dz2o_317",
  "link-group": "_link-group_1dz2o_333",
  primaryLink: primaryLink$1,
  secondaryLink,
  subText,
  "subText--with-price": "_subText--with-price_1dz2o_389",
  "mid-banner-picture": "_mid-banner-picture_1dz2o_403",
  videoMask,
  video: video$1,
  award,
  "award-picture-wrapper": "_award-picture-wrapper_1dz2o_424",
  pureBackground,
  "pureBackground-picture-wrapper": "_pureBackground-picture-wrapper_1dz2o_447",
  controlBar,
  pagination,
  "thumbnail-video": "_thumbnail-video_1dz2o_481",
  dotOuter,
  dotWrapperContainer,
  dotWrapper,
  current,
  thumbnailBackground,
  "progress-bg": "_progress-bg_1dz2o_533",
  progress,
  "progress--brabus": "_progress--brabus_1dz2o_543",
  btnWrapper,
  bottomArrow,
  mobileArrow,
  "button-disabled": "_button-disabled_1dz2o_593",
  dot,
  "pause-play-wrapper": "_pause-play-wrapper_1dz2o_610",
  play,
  pause,
  picture: picture$1,
  "fade-in": "_fade-in_1dz2o_1",
  "fade-out": "_fade-out_1dz2o_1",
  "rotate-plus": "_rotate-plus_1dz2o_1",
  "rotate-minus": "_rotate-minus_1dz2o_1"
};
const ItemImage = React__default.memo(({ landscapeImage, portraitImage }) => {
  const isPortrait = useIsPortrait();
  const imageUrl = isPortrait ? (portraitImage == null ? void 0 : portraitImage.imageUrl) || (landscapeImage == null ? void 0 : landscapeImage.imageUrl) : landscapeImage == null ? void 0 : landscapeImage.imageUrl;
  return /* @__PURE__ */ jsx(
    DynamicMediaPicture,
    {
      className: styles$g.picture,
      imageAltText: (landscapeImage == null ? void 0 : landscapeImage.imageAltText) || "",
      imageUrl: imageUrl || "",
      imageConfigs: fullWidthImageConfigs,
      initialIsInView: true,
      noLoadingLogo: true,
      isObjectFit: true,
      fetchPriority: "high"
    }
  );
});
const ItemVideo = React__default.memo(
  ({ video: video2, customVideoStylesBaseUrl = "", headline: headline2, primaryLink: primaryLink2, secondaryLink: secondaryLink2, subText: subText2 }) => {
    const isPortrait = useIsPortrait();
    const portrait = (video2 == null ? void 0 : video2.portraitUrl) || (video2 == null ? void 0 : video2.landscapeUrl);
    const url = isPortrait ? portrait : video2 == null ? void 0 : video2.landscapeUrl;
    const hasDarkeningLayer = !!(headline2 || primaryLink2 || secondaryLink2 || subText2);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: styles$g.videoMask }),
      /* @__PURE__ */ jsx(
        DynamicMediaVideo,
        {
          hasDarkeningLayer,
          altText: (video2 == null ? void 0 : video2.altText) || "",
          className: styles$g.video,
          video: {
            url: url || "",
            customVideoStylesBaseUrl,
            autoPlay: true,
            mute: true,
            loop: true,
            posterImageUrl: video2 == null ? void 0 : video2.posterImageUrl
          },
          videoControls: false,
          isInView: true,
          fetchPriority: "high"
        }
      )
    ] });
  }
);
const styles$f = {
  "logo-container": "_logo-container_mh7fg_1",
  "logo-container--nope-link": "_logo-container--nope-link_mh7fg_8",
  "logo-container--large": "_logo-container--large_mh7fg_11",
  "logo-container--medium": "_logo-container--medium_mh7fg_14",
  "logo-container--small": "_logo-container--small_mh7fg_17",
  "logo-container--disclaimer": "_logo-container--disclaimer_mh7fg_20"
};
const baseClass$a = "logo-container";
const LogoContainer = React__default.memo(
  ({ url, size = "medium", className, imageAltText, link: link2, logoDisclaimerReference }) => /* @__PURE__ */ jsxs(
    "a",
    {
      ...link2,
      className: classNames(className, styles$f[baseClass$a], {
        [styles$f[`${baseClass$a}--nope-link`]]: !link2,
        [styles$f[`${baseClass$a}--large`]]: size === "large",
        [styles$f[`${baseClass$a}--medium`]]: size === "medium",
        [styles$f[`${baseClass$a}--small`]]: size === "small",
        [styles$f[`${baseClass$a}--disclaimer`]]: logoDisclaimerReference
      }),
      "data-testid": "logo-container-component",
      children: [
        /* @__PURE__ */ jsx("img", { src: url, alt: imageAltText }),
        logoDisclaimerReference && /* @__PURE__ */ jsx("sup", { children: logoDisclaimerReference })
      ]
    }
  )
);
const baseClass$9 = "primary-hero";
const SlideButton = React__default.memo(({ position, swiper: swiper2 }) => {
  const { changeSlide } = React__default.useContext(GlobalFieldsContext);
  const slide2 = (e) => {
    if (position === "left") {
      changeSlide && changeSlide(swiper2.activeIndex - 1, swiper2);
    } else {
      changeSlide && changeSlide(swiper2.activeIndex + 1, swiper2);
    }
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "button",
      className: classNames(styles$g[`${baseClass$9}__slideButton`], styles$g[`${baseClass$9}__slideButton--${position}`]),
      onClick: slide2,
      onKeyDown: slide2,
      tabIndex: -1
    }
  );
});
const baseClass$8 = "primary-hero";
const ItemContents = React__default.forwardRef(({ items, currentIndex: currentIndex2, swiper: swiper2, mode, item: item2, itemIndex }, forwardedRef) => {
  const globalFields = useContext(GlobalFieldsContext);
  const contentRef = useRef(null);
  const textRef = useRef(null);
  const priceRef = useRef(null);
  const headlineRef = useRef(null);
  const subHeadlineRef = useRef(null);
  const subTextRef = useRef(null);
  const linksRef = useRef(null);
  const getTextHeight = () => {
    var _a;
    return ((_a = textRef.current) == null ? void 0 : _a.clientHeight) || 0;
  };
  const getTextContainerHeight = () => {
    var _a;
    return ((_a = contentRef.current) == null ? void 0 : _a.clientHeight) || 0;
  };
  const elementSet = /* @__PURE__ */ new Set([priceRef == null ? void 0 : priceRef.current, headlineRef == null ? void 0 : headlineRef.current, subHeadlineRef.current, subTextRef.current]);
  const animateContent = (nextIndex2) => {
    const isNext = itemIndex <= nextIndex2;
    elementSet.forEach((element) => {
      if (element) {
        isNext ? element.classList.add(styles$g["content-animation"]) : element.classList.remove(styles$g["content-animation"]);
      }
    });
    if (linksRef.current) {
      isNext ? linksRef.current.classList.add(styles$g["link-animation"]) : linksRef.current.classList.remove(styles$g["link-animation"]);
    }
  };
  useImperativeHandle(forwardedRef, () => ({
    getTextHeight,
    getTextContainerHeight,
    animateContent
  }));
  const { price: price2, headline: headline2, subHeadline: subHeadline2, primaryLink: primaryLink2, secondaryLink: secondaryLink2, subText: subText2 } = item2;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: contentRef,
      className: classNames(
        {
          "dark-theme": item2.template === "campaign" || item2.template === "offer" && item2.backgroundColorOption === "brabus"
        },
        styles$g[`${baseClass$8}__content`],
        { [styles$g[`${baseClass$8}__content--multipleSlides`]]: !!(items == null ? void 0 : items.length) },
        styles$g[`${baseClass$8}__content--${globalFields.isFullHeight ? "full" : "normal"}`]
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { ref: textRef, children: [
          item2.template === "campaign" && item2.contentTag && /* @__PURE__ */ jsx(Tag, { className: styles$g.contentTag, variant: item2.contentTag.variant, children: item2.contentTag.label }),
          (price2 || headline2 || subHeadline2) && /* @__PURE__ */ jsxs("div", { className: styles$g.headlineWrapper, children: [
            (item2 == null ? void 0 : item2.template) === "award" && (item2 == null ? void 0 : item2.logo) && /* @__PURE__ */ jsx("div", { className: styles$g.logoWrapper, children: /* @__PURE__ */ jsx(LogoContainer, { ...item2.logo }) }),
            price2 && /* @__PURE__ */ jsx("div", { className: styles$g.price, children: /* @__PURE__ */ jsxs("div", { ref: priceRef, children: [
              /* @__PURE__ */ jsx("div", { className: styles$g["price-origin"], children: item2.fromLabel }),
              price2
            ] }) }),
            headline2 && /* @__PURE__ */ jsx("div", { className: styles$g.headline, children: /* @__PURE__ */ jsx("h1", { className: classNames({ [styles$g["headline--with-price"]]: !!price2 }), ref: headlineRef, children: headline2 }) }),
            subHeadline2 && /* @__PURE__ */ jsx("div", { className: classNames(styles$g.subHeadline, { [styles$g["subHeadline--with-price"]]: !!price2 }), children: /* @__PURE__ */ jsx("div", { ref: subHeadlineRef, children: subHeadline2 }) })
          ] }),
          subText2 && /* @__PURE__ */ jsx("div", { className: classNames(styles$g.subText, { [styles$g["subText--with-price"]]: !!price2 }), children: /* @__PURE__ */ jsx("div", { ref: subTextRef, children: subText2 }) }),
          /* @__PURE__ */ jsxs("div", { className: styles$g["link-group"], ref: linksRef, children: [
            primaryLink2 && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
              TextLink,
              {
                ...primaryLink2,
                className: styles$g.primaryLink,
                variant: mode === "brabus" ? "button-primary-brabus" : "button-primary",
                linkText: (primaryLink2 == null ? void 0 : primaryLink2.label) || ""
              }
            ) }),
            secondaryLink2 && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
              TextLink,
              {
                ...secondaryLink2,
                className: styles$g.secondaryLink,
                variant: "button-secondary",
                linkText: (secondaryLink2 == null ? void 0 : secondaryLink2.label) || ""
              }
            ) })
          ] })
        ] }),
        swiper2 && /* @__PURE__ */ jsxs(Fragment, { children: [
          currentIndex2 > 0 && /* @__PURE__ */ jsx(SlideButton, { position: "left", swiper: swiper2 }),
          currentIndex2 < items.length - 1 && /* @__PURE__ */ jsx(SlideButton, { position: "right", swiper: swiper2 })
        ] })
      ]
    }
  );
});
ItemContents.displayName = "ItemContents";
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {};
  if (color instanceof tinycolor) {
    return color;
  }
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }
  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType;
  if (this._r < 1)
    this._r = Math.round(this._r);
  if (this._g < 1)
    this._g = Math.round(this._g);
  if (this._b < 1)
    this._b = Math.round(this._b);
  this._ok = rgb.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid2() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
  },
  getLuminance: function getLuminance() {
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928)
      R = RsRGB / 12.92;
    else
      R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928)
      G = GsRGB / 12.92;
    else
      G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928)
      B = BsRGB / 12.92;
    else
      B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  },
  setAlpha: function setAlpha(value2) {
    this._a = boundAlpha(value2);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
    if (needsAlphaFormat) {
      if (format === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};
tinycolor.fromRatio = function(color, opts) {
  if (_typeof$1(color) == "object") {
    var newColor = {};
    for (var i in color) {
      if (color.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color[i];
        } else {
          newColor[i] = convertToPercentage(color[i]);
        }
      }
    }
    color = newColor;
  }
  return tinycolor(color, opts);
};
function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;
  if (typeof color == "string") {
    color = stringInputToObject(color);
  }
  if (_typeof$1(color) == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }
    if (color.hasOwnProperty("a")) {
      a = color.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a
  };
}
function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b), min = Math.min(r, g, b);
  var h, s, l = (max + min) / 2;
  if (max == min) {
    h = s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    l
  };
}
function hslToRgb(h, s, l) {
  var r, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  function hue2rgb(p2, q2, t) {
    if (t < 0)
      t += 1;
    if (t > 1)
      t -= 1;
    if (t < 1 / 6)
      return p2 + (q2 - p2) * 6 * t;
    if (t < 1 / 2)
      return q2;
    if (t < 2 / 3)
      return p2 + (q2 - p2) * (2 / 3 - t) * 6;
    return p2;
  }
  if (s === 0) {
    r = g = b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}
function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b), min = Math.min(r, g, b);
  var h, s, v = max;
  var d = max - min;
  s = max === 0 ? 0 : d / max;
  if (max == min) {
    h = 0;
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    v
  };
}
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [v, q, p, p, t, v][mod], g = [t, v, v, q, p, p][mod], b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}
function rgbToHex(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}
function rgbaToHex(r, g, b, a, allow4Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];
  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}
function rgbaToArgbHex(r, g, b, a) {
  var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex.join("");
}
tinycolor.equals = function(color1, color2) {
  if (!color1 || !color2)
    return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function() {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}
function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}
function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
}
function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}
function polyad(color, number2) {
  if (isNaN(number2) || number2 <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number2;
  for (var i = 1; i < number2; i++) {
    result.push(tinycolor({
      h: (hsl.h + i * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }
  return result;
}
function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}
function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];
  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }
  return ret;
}
function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h = hsv.h, s = hsv.s, v = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h,
      s,
      v
    }));
    v = (v + modification) % 1;
  }
  return ret;
}
tinycolor.mix = function(color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba);
};
tinycolor.readability = function(color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
tinycolor.isReadable = function(color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};
tinycolor.mostReadable = function(baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;
  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level,
    size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
var hexNames = tinycolor.hexNames = flip(names);
function flip(o) {
  var flipped = {};
  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }
  return flipped;
}
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}
function bound01(n, max) {
  if (isOnePointZero(n))
    n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n)));
  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  }
  if (Math.abs(n - max) < 1e-6) {
    return 1;
  }
  return n % max / parseFloat(max);
}
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
}
function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
}
function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }
  return n;
}
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
var matchers = function() {
  var CSS_INTEGER = "[-\\+]?\\d+%?";
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
}
function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }
  var match;
  if (match = matchers.rgb.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }
  if (match = matchers.rgba.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsl.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }
  if (match = matchers.hsla.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsv.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }
  if (match = matchers.hsva.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }
  if (match = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size !== "small" && size !== "large") {
    size = "small";
  }
  return {
    level,
    size
  };
}
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(void 0);
  useEffect(() => {
    setIsMobile(window.innerWidth < breakpoints$1.l);
  }, []);
  return isMobile;
};
const suffix = ":1-1?$smartResponsiveAlpha8$&wid=800&hei=800";
const Thumbnail = ({ video: video2, portraitImage, imageAltText, template, landscapeImage }) => {
  const isPortrait = useIsPortrait();
  const getAttributes = () => {
    const imageUrl = isPortrait ? (portraitImage == null ? void 0 : portraitImage.imageUrl) || (landscapeImage == null ? void 0 : landscapeImage.imageUrl) : landscapeImage == null ? void 0 : landscapeImage.imageUrl;
    const portrait = (video2 == null ? void 0 : video2.portraitUrl) || (video2 == null ? void 0 : video2.landscapeUrl);
    const src = isPortrait ? portrait : video2 == null ? void 0 : video2.landscapeUrl;
    const backgroundUrl = isPortrait ? (portraitImage == null ? void 0 : portraitImage.imageUrl) || (landscapeImage == null ? void 0 : landscapeImage.imageUrl) : landscapeImage == null ? void 0 : landscapeImage.imageUrl;
    switch (template) {
      case "campaign":
        if (video2) {
          return { src, controls: false, playsInline: true, muted: true };
        }
        return { src: imageUrl + suffix || "", width: "100%", height: "100%" };
      case "offer":
        return {
          src: `${backgroundUrl || ""}${suffix}`,
          className: styles$g.thumbnailBackground
        };
      case "award":
        return {
          src: `${backgroundUrl || ""}${suffix}`,
          width: "100%"
        };
      case "model":
        return null;
    }
  };
  return !video2 ? /* @__PURE__ */ jsx("img", { style: { objectFit: "cover" }, ...getAttributes(), alt: imageAltText }) : /* @__PURE__ */ jsx("video", { ...getAttributes(), className: styles$g["thumbnail-video"] });
};
const Thumbnail$1 = memo(Thumbnail);
const getThumbnailColor = (option, isDarken) => {
  const colorMapping2 = {
    "premium #1": "#BCC9C4",
    "premium #3": "#AAC1CD",
    brabus: "#3A3C3F",
    pulse: "#799DC9",
    "pro+": "#DED774",
    "pro,pure+,pure": "#E4E8EB"
  };
  const selectedColor = colorMapping2[option] ?? "#BCC9C4";
  if (isDarken) {
    switch (option) {
      case "brabus":
        return tinycolor(selectedColor).darken(-15).toString();
      default:
        return tinycolor(selectedColor).darken(10).toString();
    }
  } else {
    return selectedColor;
  }
};
const Pagination = ({ items, activeIndex, mode, swiper: swiper2 }) => {
  const { changeSlide } = React.useContext(GlobalFieldsContext);
  const isMobile = useIsMobile();
  const currentIndex2 = React.useMemo(() => {
    if (activeIndex === items.length - 1) {
      return 0;
    }
    return activeIndex + 1;
  }, [activeIndex, items]);
  const element = (item2, i) => {
    const isOfferTemplate = (item2 == null ? void 0 : item2.template) === "offer";
    const isAwardTemplate = (item2 == null ? void 0 : item2.template) === "award";
    const isBrabusOrPulse = isOfferTemplate && ["brabus", "pulse"].includes(item2.backgroundColorOption);
    const isActive2 = i === activeIndex;
    const handleClick = () => {
      if (changeSlide && swiper2) {
        changeSlide(i, swiper2);
      }
    };
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        changeSlide && swiper2 && changeSlide(i, swiper2);
      }
    };
    const getBackgroundColor = () => {
      if (isOfferTemplate) {
        return getThumbnailColor(item2.backgroundColorOption, true) || "none";
      } else if (isAwardTemplate) {
        return tinycolor("#F2F2F2").darken(10).toString() || "none";
      } else {
        return "none";
      }
    };
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(styles$g.dotOuter, {
          [styles$g["current"]]: isActive2,
          "dark-theme": isOfferTemplate && !isBrabusOrPulse || isAwardTemplate
        }),
        tabIndex: 0,
        onClick: handleClick,
        role: "button",
        onKeyDown: handleKeyDown,
        children: /* @__PURE__ */ jsx("div", { className: classNames(styles$g.dotWrapperContainer), children: /* @__PURE__ */ jsx("div", { style: { background: getBackgroundColor() }, className: styles$g["dotWrapper"], children: /* @__PURE__ */ jsx(Thumbnail$1, { ...item2, isActive: isActive2 }) }) })
      },
      `${item2.headline}-pagination-${i}`
    );
  };
  return /* @__PURE__ */ jsx("div", { className: styles$g.pagination, children: items.map((item2, i) => isMobile && i === currentIndex2 || isMobile === false ? element(item2, i) : null) });
};
const Pagination$1 = React.memo(Pagination);
const ItemPureBackground = React__default.forwardRef(({ backgroundColor, portraitImage, landscapeImage }, forwardedRef) => {
  const backgroundRef = useRef(null);
  const setBackgroundTop = (gap) => {
    if (backgroundRef.current) {
      backgroundRef.current.style.top = gap / 2 + "px";
      backgroundRef.current.style.transform = "translateY(-50%)";
    }
  };
  useImperativeHandle(forwardedRef, () => ({
    setBackgroundTop
  }));
  const isPortrait = useIsPortrait();
  const imageUrl = isPortrait ? (portraitImage == null ? void 0 : portraitImage.imageUrl) || (landscapeImage == null ? void 0 : landscapeImage.imageUrl) : landscapeImage == null ? void 0 : landscapeImage.imageUrl;
  const imageConfig2 = [
    {
      aspectRatio: "1-1",
      sizes: "100vw",
      media: `(max-width: ${breakpoints$1.l}px)`
    },
    {
      aspectRatio: "1-1",
      sizes: "62.5vw",
      media: `(min-width: ${breakpoints$1.l}px)`
    }
  ];
  return /* @__PURE__ */ jsx("div", { className: styles$g.pureBackground, style: { backgroundColor }, children: /* @__PURE__ */ jsx("div", { className: styles$g["pureBackground-picture-wrapper"], ref: backgroundRef, children: /* @__PURE__ */ jsx(
    DynamicMediaPicture,
    {
      className: styles$g["pureBackground-picture"],
      imageAltText: (landscapeImage == null ? void 0 : landscapeImage.imageAltText) || "",
      imageUrl: imageUrl || "",
      imageConfigs: imageConfig2,
      hasImageTransparency: true,
      initialIsInView: true,
      noLoadingLogo: true,
      isObjectFit: true,
      fetchPriority: "high"
    }
  ) }) });
});
const ProgressBar = React__default.forwardRef(({ mode, className }, forwardedRef) => {
  const progressRef = React__default.useRef(null);
  const { pauseAutoplay, isAutoplayPaused, resumeAutoplay } = React__default.useContext(GlobalFieldsContext);
  const setProgress = (percent) => {
    const circle2 = progressRef.current;
    if (circle2) {
      const perimeter = circle2.getTotalLength();
      circle2.setAttribute("stroke-dasharray", `${perimeter * percent} ${perimeter * (1 - percent)}`);
    }
  };
  useImperativeHandle(forwardedRef, () => ({
    setProgress
  }));
  return /* @__PURE__ */ jsxs("div", { tabIndex: -1, className: classNames(styles$g["pause-play-wrapper"], className), children: [
    /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50", children: /* @__PURE__ */ jsx(
      "circle",
      {
        ref: progressRef,
        fill: "transparent",
        className: classNames(styles$g["progress"], {
          [styles$g["progress--brabus"]]: mode === "brabus"
        }),
        strokeWidth: "2",
        cx: "25",
        cy: "25",
        r: "20",
        strokeDasharray: "0 1"
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: styles$g["dot"], children: isAutoplayPaused ? /* @__PURE__ */ jsxs(
      "svg",
      {
        className: styles$g.play,
        onClick: resumeAutoplay,
        fill: `var(${mode === "brabus" ? "--brabus" : "--c-high-contrast"})`,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "mask0_3416_30485",
              style: { maskType: "alpha" },
              maskUnits: "userSpaceOnUse",
              x: "1",
              y: "0",
              width: "16",
              height: "16",
              children: /* @__PURE__ */ jsx("path", { d: "M15.2705 6.83154L3.59717 1.11377C3.44678 1.03955 3.27783 1.00049 3.10889 1.00049C2.49756 1.00049 2 1.49805 2 2.10938V13.8916C2 14.5029 2.49756 15.0005 3.10889 15.0005C3.27783 15.0005 3.44678 14.9614 3.59668 14.8877L15.27 9.16943C15.7134 8.95312 16 8.49414 16 8.00049C16 7.50684 15.7134 7.04785 15.2705 6.83154ZM14.8311 8.271L3.10889 14.0005C3.04883 14.0005 3 13.9517 3 13.8916V2.10938C3 2.05518 3.04004 2.00977 3.12744 2.00977C3.13672 2.00977 3.14648 2.01025 3.15723 2.01172L14.8315 7.72998C14.9336 7.78027 15 7.88623 15 8.00049C15 8.11475 14.9336 8.2207 14.8311 8.271Z" })
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#mask0_3416_30485)", children: /* @__PURE__ */ jsx("rect", { y: "0.000488281", width: "16", height: "16" }) })
        ]
      }
    ) : /* @__PURE__ */ jsxs(
      "svg",
      {
        className: styles$g.pause,
        onClick: pauseAutoplay,
        fill: `var(${mode === "brabus" ? "--brabus" : "--c-high-contrast"})`,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "mask0_3416_30448",
              style: { maskType: "alpha" },
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: "16",
              height: "16",
              children: /* @__PURE__ */ jsx(
                "path",
                {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M4.5 1C4.22386 1 4 1.22386 4 1.5V14.5C4 14.7761 4.22386 15 4.5 15H5C5.27614 15 5.5 14.7761 5.5 14.5V1.5C5.5 1.22386 5.27614 1 5 1H4.5ZM11 1C10.7239 1 10.5 1.22386 10.5 1.5V14.5C10.5 14.7761 10.7239 15 11 15H11.5C11.7761 15 12 14.7761 12 14.5V1.5C12 1.22386 11.7761 1 11.5 1H11Z"
                }
              )
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#mask0_3416_30448)", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16" }) })
        ]
      }
    ) })
  ] });
});
const ProgressBar$1 = React__default.memo(ProgressBar);
const ItemAward = React__default.memo(({ portraitImage, landscapeImage }) => {
  const isPortrait = useIsPortrait();
  const imageUrl = isPortrait ? (portraitImage == null ? void 0 : portraitImage.imageUrl) || (landscapeImage == null ? void 0 : landscapeImage.imageUrl) : landscapeImage == null ? void 0 : landscapeImage.imageUrl;
  const imageConfig2 = [
    {
      aspectRatio: "1-1",
      sizes: "100vw",
      media: `(max-width: ${breakpoints$1.l}px)`
    },
    {
      aspectRatio: "1-1",
      sizes: "62.5vw",
      media: `(min-width: ${breakpoints$1.l}px)`
    }
  ];
  return /* @__PURE__ */ jsx("div", { className: styles$g.award, children: /* @__PURE__ */ jsx("div", { className: styles$g["award-picture-wrapper"], children: /* @__PURE__ */ jsx(
    DynamicMediaPicture,
    {
      className: styles$g["award-picture"],
      imageAltText: (landscapeImage == null ? void 0 : landscapeImage.imageAltText) || "",
      imageUrl: imageUrl || "",
      imageConfigs: imageConfig2,
      hasImageTransparency: true,
      initialIsInView: true,
      noLoadingLogo: true,
      isObjectFit: true,
      fetchPriority: "high"
    }
  ) }) });
});
const baseClass$7 = "primary-hero";
const GlobalFieldsContext = React__default.createContext({
  isFullHeight: true,
  showBottomArrowIndicator: false,
  activeIndex: 0,
  items: [],
  isAutoplayPaused: false
});
const PrimaryHero = forwardRef(
  ({
    setHeaderBackground = () => {
    },
    isFullHeight = true,
    showBottomArrowIndicator = false,
    items,
    className,
    legalDisclaimers,
    mode,
    isBannerVisible,
    isFirstContentOnPage
  }, forwardedRef) => {
    const isMobile = useIsMobile();
    const [swiper2, setSwiper] = useState();
    const [activeIndex, setActiveIndex] = useState(0);
    const progressRef = React__default.useRef(null);
    const [isAutoplayPaused, setIsAutoplayPaused] = useState(false);
    const isAutoplayPausedRef = useRef(false);
    const activeIndexRef = useRef(0);
    const contentsRef = useRef([]);
    const backgroundsRef = useRef([]);
    const times = useRef(0);
    const intervalId = useRef();
    const progressInterval = 50;
    const progressTotal = 8e3;
    const intervalTimes = progressTotal / progressInterval;
    const scrollDown = () => {
      window.scrollBy({
        top: window.innerHeight * 0.5,
        left: 0,
        behavior: "smooth"
      });
    };
    const interval = (s) => {
      intervalId.current = setInterval(() => {
        if (times.current === intervalTimes) {
          clearInterval(intervalId.current);
          if (activeIndexRef.current >= items.length - 1) {
            changeSlide(0, s);
          } else {
            changeSlide(activeIndexRef.current + 1, s);
          }
        }
        if (progressRef.current) {
          progressRef.current.setProgress(times.current / intervalTimes);
        }
        times.current += 1;
      }, progressInterval);
    };
    const animateContent = (nextIndex2) => {
      contentsRef.current.forEach((c) => {
        c.animateContent(nextIndex2);
      });
    };
    const changeSlide = (nextIndex2, s, enableInterval = true) => {
      if (s.destroyed)
        return;
      const direction = nextIndex2 >= activeIndex ? "next" : "prev";
      if (direction === "prev" && activeIndex === 0 || direction === "next" && activeIndex === items.length - 1) {
        return;
      }
      if (contentsRef.current && s) {
        setActiveIndex(nextIndex2);
        s.slideTo(nextIndex2, void 0, false);
        times.current = 0;
        animateContent(nextIndex2);
        setTimeout(() => {
          activeIndexRef.current = nextIndex2;
          clearInterval(intervalId.current);
          if (enableInterval && !isAutoplayPausedRef.current) {
            interval(s);
          }
        }, 500);
      }
    };
    const pauseAutoplay = () => {
      setIsAutoplayPaused(true);
      isAutoplayPausedRef.current = true;
      clearInterval(intervalId.current);
    };
    const resumeAutoplay = () => {
      setIsAutoplayPaused(false);
      isAutoplayPausedRef.current = false;
      swiper2 && interval(swiper2);
    };
    useEffect(() => {
      if (items.length) {
        const { heroTemplate, color } = getHeaderBackground(items[0]);
        setHeaderBackground(heroTemplate, color);
      }
      animateContent(0);
      setTimeout(() => {
        document.querySelectorAll(".swiper-wrapper a").forEach((item2) => {
          item2.tabIndex = -1;
        });
      }, 0);
      if (window.innerWidth < breakpoints$1.l) {
        const content2 = contentsRef.current;
        if (content2) {
          items.forEach((e, i) => {
            if (items[i].template === "offer") {
              const gap = content2[i].getTextContainerHeight() - content2[i].getTextHeight();
              backgroundsRef.current[i].setBackgroundTop(gap);
            }
          });
        }
      }
    }, []);
    useEffect(() => {
      if (swiper2 && (items == null ? void 0 : items.length) > 1) {
        interval(swiper2);
      }
    }, [swiper2]);
    const getSlideBackground = (item2, index) => {
      const gradient = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", { className: styles$g[`${baseClass$7}__bottomGradient`] }) });
      if (item2.template === "offer") {
        return /* @__PURE__ */ jsx(
          ItemPureBackground,
          {
            ref: (el) => {
              if (el)
                backgroundsRef.current[index] = el;
            },
            ...item2,
            backgroundColor: getBackgroundColor(item2.backgroundColorOption)
          }
        );
      } else if (item2.template === "campaign") {
        return item2.video ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(ItemVideo, { ...item2 }),
          gradient
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(ItemImage, { ...item2 }),
          gradient
        ] });
      }
      return /* @__PURE__ */ jsx(ItemAward, { ...item2 });
    };
    const getBackgroundColor = (option) => {
      const colorMapping2 = {
        "premium #1": "#BCC9C4",
        "premium #3": "#AAC1CD",
        brabus: "#3A3C3F",
        pulse: "#799DC9",
        "pro+": "#DED774",
        "pro,pure+,pure": "#E4E8EB"
      };
      if (!colorMapping2[option]) {
        return "#BCC9C4";
      }
      return colorMapping2[option];
    };
    return /* @__PURE__ */ jsx(
      GlobalFieldsContext.Provider,
      {
        value: {
          isFullHeight,
          showBottomArrowIndicator,
          activeIndex,
          items,
          changeSlide,
          isAutoplayPaused,
          setActiveIndex,
          pauseAutoplay,
          resumeAutoplay
        },
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(styles$g[`${baseClass$7}-wrapper`], {
              [styles$g[`${baseClass$7}-wrapper--showBanner`]]: isBannerVisible && isFirstContentOnPage
            }),
            children: [
              /* @__PURE__ */ jsxs(
                "section",
                {
                  className: classNames(styles$g[baseClass$7], className || "", styles$g[`${baseClass$7}--normal`]),
                  onClick: (e) => {
                    e.stopPropagation();
                  },
                  "aria-hidden": true,
                  ref: forwardedRef,
                  children: [
                    /* @__PURE__ */ jsx(
                      Swiper2,
                      {
                        a11y: { enabled: false },
                        modules: [EffectCreative],
                        effect: "creative",
                        creativeEffect: {
                          prev: {
                            translate: ["-50%", 0, 0]
                          },
                          next: {
                            translate: ["100%", 0, 0]
                          }
                        },
                        className: styles$g[`${baseClass$7}__itemsWrapper`],
                        speed: 1100,
                        spaceBetween: 0,
                        slidesPerView: 1,
                        onSwiper: (s) => {
                          setSwiper(s);
                        },
                        onSlideChange: (s) => {
                          if (items[s.activeIndex]) {
                            const { heroTemplate, color } = getHeaderBackground(items[s.activeIndex]);
                            setTimeout(() => setHeaderBackground(heroTemplate, color), 500);
                          }
                          if (activeIndex !== s.activeIndex)
                            changeSlide(s.activeIndex, s);
                        },
                        children: items.map((item2, index) => /* @__PURE__ */ jsxs(
                          SwiperSlide,
                          {
                            className: classNames(styles$g[`${baseClass$7}__itemWrapper`], {
                              "dark-theme": item2.template === "campaign" || item2.template === "offer" && item2.backgroundColorOption === "brabus"
                            }),
                            tabIndex: -1,
                            children: [
                              /* @__PURE__ */ jsx(
                                ItemContents,
                                {
                                  mode,
                                  item: item2,
                                  itemIndex: index,
                                  swiper: swiper2,
                                  ref: (el) => {
                                    if (el)
                                      contentsRef.current[index] = el;
                                  },
                                  items,
                                  currentIndex: activeIndex
                                }
                              ),
                              /* @__PURE__ */ jsx("div", { className: styles$g[`${baseClass$7}__itemWrapper`], children: getSlideBackground(item2, index) })
                            ]
                          },
                          `${item2.headline}-${index}`
                        ))
                      }
                    ),
                    showBottomArrowIndicator && /* @__PURE__ */ jsx("button", { onClick: scrollDown, className: styles$g.btnWrapper, children: /* @__PURE__ */ jsx(Icon, { name: "chevron-down--medium", className: styles$g.bottomArrow }) }),
                    items.length > 1 && /* @__PURE__ */ jsxs(
                      "div",
                      {
                        tabIndex: -1,
                        className: classNames(styles$g.mobileArrow, {
                          "dark-theme": items[activeIndex].template === "campaign" || items[activeIndex].template === "offer" && items[activeIndex].backgroundColorOption === "brabus"
                        }),
                        children: [
                          /* @__PURE__ */ jsx(
                            "button",
                            {
                              className: classNames({ [styles$g["button-disabled"]]: activeIndex === 0 }),
                              onClick: () => {
                                if (activeIndex === 0) {
                                  return;
                                }
                                if (swiper2) {
                                  changeSlide(activeIndex - 1, swiper2);
                                }
                              },
                              children: /* @__PURE__ */ jsx(Icon, { name: "arrow-left--small" })
                            }
                          ),
                          /* @__PURE__ */ jsx(
                            "button",
                            {
                              className: classNames({ [styles$g["button-disabled"]]: activeIndex === items.length - 1 }),
                              onClick: () => {
                                if (activeIndex === items.length - 1) {
                                  return;
                                }
                                if (swiper2) {
                                  changeSlide(activeIndex + 1, swiper2);
                                }
                              },
                              children: /* @__PURE__ */ jsx(Icon, { name: "arrow-right--small" })
                            }
                          ),
                          isMobile && (items == null ? void 0 : items.length) > 1 && /* @__PURE__ */ jsx(
                            ProgressBar$1,
                            {
                              className: items[activeIndex].template === "campaign" || items[activeIndex].template === "offer" && items[activeIndex].backgroundColorOption === "brabus" ? "dark-theme" : "",
                              mode,
                              ref: progressRef
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsxs("div", { className: styles$g.controlBar, children: [
                      !isMobile && (items == null ? void 0 : items.length) > 1 && /* @__PURE__ */ jsx(
                        ProgressBar$1,
                        {
                          className: items[activeIndex].template === "campaign" || items[activeIndex].template === "offer" && items[activeIndex].backgroundColorOption === "brabus" ? "dark-theme" : "",
                          mode,
                          ref: progressRef
                        }
                      ),
                      items.length > 1 && /* @__PURE__ */ jsx(Pagination$1, { mode, items, activeIndex, swiper: swiper2 })
                    ] })
                  ]
                }
              ),
              legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx(
                "div",
                {
                  tabIndex: -1,
                  className: classNames(styles$g["legal-disclaimer"], { "dark-theme": mode === "dark" || mode === "brabus" }),
                  children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
                }
              )
            ]
          }
        )
      }
    );
  }
);
const badges = "_badges_1vxtj_1";
const styles$e = {
  badges,
  "badges-content--list": "_badges-content--list_1vxtj_5",
  "badges--row": "_badges--row_1vxtj_9",
  "badges--list": "_badges--list_1vxtj_13"
};
const baseClass$6 = "badges";
const Badges = React__default.memo(({ firstBadgeItem, secondBadgeItem, layout = "row" }) => /* @__PURE__ */ jsxs(
  "div",
  {
    className: classNames(styles$e[baseClass$6], {
      [styles$e[`${baseClass$6}-content--list`]]: layout === "list"
    }),
    children: [
      /* @__PURE__ */ jsx("a", { ...firstBadgeItem == null ? void 0 : firstBadgeItem.link, "data-testid": "badges-component", children: /* @__PURE__ */ jsx(
        "img",
        {
          src: firstBadgeItem == null ? void 0 : firstBadgeItem.image,
          className: classNames(styles$e[`${baseClass$6}--row`], {
            [styles$e[`${baseClass$6}--list`]]: layout === "list",
            [styles$e[`${baseClass$6}--row`]]: layout === "row"
          }),
          alt: firstBadgeItem == null ? void 0 : firstBadgeItem.imageAltText
        }
      ) }),
      /* @__PURE__ */ jsx("a", { ...secondBadgeItem == null ? void 0 : secondBadgeItem.link, "data-testid": "badges-component", children: /* @__PURE__ */ jsx(
        "img",
        {
          src: secondBadgeItem == null ? void 0 : secondBadgeItem.image,
          className: classNames(styles$e[`${baseClass$6}--row`], {
            [styles$e[`${baseClass$6}--list`]]: layout === "list",
            [styles$e[`${baseClass$6}--row`]]: layout === "row"
          }),
          alt: secondBadgeItem == null ? void 0 : secondBadgeItem.imageAltText
        }
      ) })
    ]
  }
));
const subline$3 = "_subline_1yth8_11";
const headline$5 = "_headline_1yth8_28";
const subHeadline$2 = "_subHeadline_1yth8_49";
const video = "_video_1yth8_89";
const discoverMore = "_discoverMore_1yth8_99";
const text$3 = "_text_1yth8_115";
const arrow = "_arrow_1yth8_131";
const styles$d = {
  "secondary-hero": "_secondary-hero_1yth8_1",
  "secondary-hero--firstContentWithoutBanner": "_secondary-hero--firstContentWithoutBanner_1yth8_5",
  "secondary-hero--firstContentWithBanner": "_secondary-hero--firstContentWithBanner_1yth8_8",
  subline: subline$3,
  headline: headline$5,
  subHeadline: subHeadline$2,
  "link-group": "_link-group_1yth8_71",
  "media-wrapper": "_media-wrapper_1yth8_82",
  video,
  discoverMore,
  text: text$3,
  arrow,
  "legal-disclaimer": "_legal-disclaimer_1yth8_138"
};
const baseClass$5 = "secondary-hero";
const SecondaryHero = ({
  showBottomArrowIndicator = false,
  discoverMoreText,
  items,
  legalDisclaimers,
  mode,
  isBannerVisible,
  isFirstContentOnPage
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const item2 = items[0];
  const { subline: subline2, headline: headline2, subHeadline: subHeadline2, linkType, badges: badges2, primaryLink: primaryLink2, secondaryLink: secondaryLink2, template, video: video2 } = item2;
  const isPortrait = useIsPortrait();
  const mediaWrapperRef = useRef(null);
  const discoverMoreRef = useRef(null);
  const imageConfigs = [
    {
      aspectRatio: "1-1",
      sizes: "100vw",
      media: `(max-width: ${breakpoints$1.l}px)`
    },
    {
      aspectRatio: "16-9",
      sizes: "100vw",
      media: `(min-width: ${breakpoints$1.l}px)`
    }
  ];
  const isTextLinkProps = (param) => typeof param !== "string";
  const scrollDown = () => {
    if (discoverMoreRef.current) {
      const discoverMore2 = discoverMoreRef.current;
      discoverMore2.ontransitionend = () => {
        discoverMore2.style.display = "none";
        discoverMore2.ontransitionend = null;
      };
      discoverMore2.style.opacity = "0";
    }
    const rect = mediaWrapperRef.current.getBoundingClientRect();
    const bottomDistance = window.innerHeight - rect.bottom;
    window.scrollBy({
      top: window.innerHeight * 0.5 - bottomDistance,
      left: 0,
      behavior: "smooth"
    });
  };
  const isMediaValid = (stageItem) => {
    var _a2, _b2;
    return stageItem.template === "campaign" && ((_a2 = stageItem == null ? void 0 : stageItem.video) == null ? void 0 : _a2.landscapeUrl) || stageItem.template === "campaign" && ((_b2 = stageItem == null ? void 0 : stageItem.landscapeImage) == null ? void 0 : _b2.imageUrl);
  };
  useEffect(() => {
    const scrollDownEvent = () => {
      if (!mediaWrapperRef.current || !discoverMoreRef.current)
        return;
      const rect = mediaWrapperRef.current.getBoundingClientRect();
      const bottomDistance = window.innerHeight - rect.bottom;
      discoverMoreRef.current.style.position = bottomDistance >= 0 ? "absolute" : "fixed";
    };
    scrollDownEvent();
    window.addEventListener("scroll", scrollDownEvent);
    return () => {
      window.removeEventListener("scroll", scrollDownEvent);
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles$d[baseClass$5], {
        [styles$d[`${baseClass$5}--firstContentWithoutBanner`]]: isFirstContentOnPage && !isBannerVisible,
        [styles$d[`${baseClass$5}--firstContentWithBanner`]]: isFirstContentOnPage && isBannerVisible,
        "dark-theme": mode === "dark" || mode === "brabus"
      }),
      children: [
        subline2 && (isTextLinkProps(subline2) ? /* @__PURE__ */ jsx(
          TextLink,
          {
            ...subline2,
            variant: "hyperlink-legal",
            linkText: (subline2 == null ? void 0 : subline2.label) || "",
            className: styles$d.subline
          }
        ) : /* @__PURE__ */ jsx("div", { className: styles$d.subline, children: subline2 })),
        /* @__PURE__ */ jsx("h1", { className: styles$d.headline, children: headline2 }),
        /* @__PURE__ */ jsx("h2", { className: styles$d.subHeadline, children: subHeadline2 }),
        /* @__PURE__ */ jsxs("div", { className: styles$d["link-group"], children: [
          primaryLink2 && linkType === "link" && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
            TextLink,
            {
              ...primaryLink2,
              className: styles$d.primaryLink,
              variant: mode === "brabus" ? "button-primary-brabus" : "button-primary-lime",
              linkText: (primaryLink2 == null ? void 0 : primaryLink2.label) || ""
            }
          ) }),
          secondaryLink2 && linkType === "link" && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
            TextLink,
            {
              ...secondaryLink2,
              className: styles$d.secondaryLink,
              variant: "button-secondary",
              linkText: (secondaryLink2 == null ? void 0 : secondaryLink2.label) || ""
            }
          ) }),
          badges2 && linkType === "badge" && /* @__PURE__ */ jsx(
            Badges,
            {
              layout: badges2 == null ? void 0 : badges2.layout,
              firstBadgeItem: badges2 == null ? void 0 : badges2.firstBadgeItem,
              secondBadgeItem: badges2 == null ? void 0 : badges2.secondBadgeItem
            }
          )
        ] }),
        isMediaValid(item2) && /* @__PURE__ */ jsxs("div", { className: styles$d["media-wrapper"], ref: mediaWrapperRef, children: [
          video2 ? /* @__PURE__ */ jsx(
            DynamicMediaVideo,
            {
              hasDarkeningLayer: true,
              altText: ((_a = item2.video) == null ? void 0 : _a.altText) || "",
              className: styles$d.video,
              video: {
                url: (isPortrait ? (_b = item2.video) == null ? void 0 : _b.portraitUrl : (_c = item2.video) == null ? void 0 : _c.landscapeUrl) || "",
                customVideoStylesBaseUrl: item2.customVideoStylesBaseUrl || "",
                autoPlay: true,
                mute: true,
                loop: true
              },
              videoControls: false,
              isInView: true,
              fetchPriority: "high"
            }
          ) : template === "campaign" && /* @__PURE__ */ jsx(
            DynamicMediaPicture,
            {
              imageAltText: ((_d = item2.landscapeImage) == null ? void 0 : _d.imageAltText) || "",
              imageUrl: (isPortrait ? ((_e = item2.portraitImage) == null ? void 0 : _e.imageUrl) || ((_f = item2.landscapeImage) == null ? void 0 : _f.imageUrl) : (_g = item2.landscapeImage) == null ? void 0 : _g.imageUrl) || "",
              imageConfigs
            }
          ),
          showBottomArrowIndicator && /* @__PURE__ */ jsxs(
            "div",
            {
              ref: discoverMoreRef,
              role: "button",
              className: styles$d.discoverMore,
              onClick: scrollDown,
              onKeyDown: scrollDown,
              tabIndex: 0,
              children: [
                /* @__PURE__ */ jsx("span", { className: styles$d.text, children: discoverMoreText }),
                /* @__PURE__ */ jsx(Icon, { name: "chevron-down--medium", className: styles$d.arrow })
              ]
            }
          )
        ] }),
        legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$d["legal-disclaimer"], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
      ]
    }
  );
};
const headlineWrapper = "_headlineWrapper_12wfj_92";
const headline$4 = "_headline_12wfj_92";
const subHeadline$1 = "_subHeadline_12wfj_114";
const price$1 = "_price_12wfj_130";
const hightlightWraper = "_hightlightWraper_12wfj_173";
const divider = "_divider_12wfj_232";
const logos$1 = "_logos_12wfj_269";
const logosWraper = "_logosWraper_12wfj_283";
const picture = "_picture_12wfj_308";
const styles$c = {
  "model-hero-wrapper": "_model-hero-wrapper_12wfj_37",
  "legal-disclaimer": "_legal-disclaimer_12wfj_40",
  "model-hero-wrapper--showBanner": "_model-hero-wrapper--showBanner_12wfj_44",
  "model-hero__itemWrapper": "_model-hero__itemWrapper_12wfj_54",
  "model-hero__imageContainer": "_model-hero__imageContainer_12wfj_57",
  "model-hero__showHilights": "_model-hero__showHilights_12wfj_69",
  "model-hero__infoWrapper": "_model-hero__infoWrapper_12wfj_72",
  "title-info": "_title-info_12wfj_79",
  headlineWrapper,
  headline: headline$4,
  subHeadline: subHeadline$1,
  price: price$1,
  "logo-small": "_logo-small_12wfj_147",
  "hightlight-info": "_hightlight-info_12wfj_155",
  hightlightWraper,
  "hightligh-value": "_hightligh-value_12wfj_188",
  "hightligh-label": "_hightligh-label_12wfj_204",
  "hightligh-lines": "_hightligh-lines_12wfj_220",
  "logo-large": "_logo-large_12wfj_224",
  divider,
  "show-hightlight-info": "_show-hightlight-info_12wfj_242",
  "top-gradient": "_top-gradient_12wfj_250",
  "bottom-gradient": "_bottom-gradient_12wfj_255",
  logos: logos$1,
  logosWraper,
  picture,
  "fade-in": "_fade-in_12wfj_1",
  "fade-out": "_fade-out_12wfj_1",
  "rotate-plus": "_rotate-plus_12wfj_1",
  "rotate-minus": "_rotate-minus_12wfj_1"
};
const baseClass$4 = "model-hero";
const ModelHero = forwardRef(
  ({ items, className, legalDisclaimers, mode, isBannerVisible, isFirstContentOnPage }, forwardedRef) => {
    const { logos: logos2, priceRichText, subHeadline: subHeadline2, headline: headline2, contentTag: contentTag2, highlights: highlights2 } = items[0];
    const Logos = ({ logoClassName }) => /* @__PURE__ */ jsx("div", { className: classNames(styles$c[`logosWraper`], logoClassName), children: (logos2 == null ? void 0 : logos2.length) ? logos2 == null ? void 0 : logos2.map((v, index) => /* @__PURE__ */ jsx(
      LogoContainer,
      {
        size: "small",
        ...v,
        url: `${v.url}?$smartResponsiveAlpha8$&wid=210&hei=120`
      },
      `${v.url}${index}`
    )) : null });
    const hasHightlights = highlights2 && Object.keys(highlights2).length > 0;
    const HightLightItem = ({
      hightLightClassName,
      value: value2,
      label: label2
    }) => value2 && label2 ? /* @__PURE__ */ jsxs("div", { className: classNames(styles$c[`hightlightWraper`], hightLightClassName), children: [
      /* @__PURE__ */ jsx("div", { className: styles$c[`hightligh-value`], children: value2 }),
      /* @__PURE__ */ jsx("div", { className: styles$c[`hightligh-label`], children: label2 })
    ] }) : /* @__PURE__ */ jsx(Fragment, {});
    const Divider = ({ top, bottom }) => /* @__PURE__ */ jsx("div", { style: { marginTop: top, marginBottom: bottom }, className: styles$c[`divider`] });
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(styles$c[`${baseClass$4}-wrapper`], {
          [styles$c[`${baseClass$4}-wrapper--showBanner`]]: isBannerVisible && isFirstContentOnPage,
          "dark-theme": mode === "dark" || mode === "brabus"
        }),
        children: [
          /* @__PURE__ */ jsx(
            "section",
            {
              className: classNames(styles$c[baseClass$4], className || ""),
              onClick: (e) => {
                e.stopPropagation();
              },
              "aria-hidden": true,
              ref: forwardedRef,
              children: /* @__PURE__ */ jsxs("div", { className: styles$c[`${baseClass$4}__itemWrapper`], children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: classNames(styles$c[`${baseClass$4}__imageContainer`], {
                      [styles$c[`${baseClass$4}__showHilights`]]: !hasHightlights
                    }),
                    children: /* @__PURE__ */ jsx(ItemImage, { ...items[0] })
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: styles$c[`${baseClass$4}__infoWrapper`], children: [
                  /* @__PURE__ */ jsx("div", { className: styles$c[`top-gradient`] }),
                  /* @__PURE__ */ jsxs("div", { className: styles$c[`bottom-gradient`], children: [
                    /* @__PURE__ */ jsxs("div", { className: styles$c[`title-info`], children: [
                      /* @__PURE__ */ jsxs("div", { className: styles$c[`headlineWrapper`], children: [
                        /* @__PURE__ */ jsx("div", { className: styles$c[`headline`], children: headline2 }),
                        contentTag2 && /* @__PURE__ */ jsx(Tag, { className: styles$c.contentTag, variant: contentTag2.variant, children: contentTag2.label })
                      ] }),
                      /* @__PURE__ */ jsx("div", { className: styles$c[`subHeadline`], children: subHeadline2 }),
                      /* @__PURE__ */ jsx(RichText, { mdString: priceRichText || "", className: styles$c[`price`] })
                    ] }),
                    /* @__PURE__ */ jsx("div", { className: styles$c[`logos`], children: /* @__PURE__ */ jsx(Logos, { logoClassName: styles$c[`logo-small`] }) }),
                    /* @__PURE__ */ jsxs(
                      "div",
                      {
                        className: classNames(styles$c[`hightlight-info`], {
                          [styles$c[`show-hightlight-info`]]: !hasHightlights
                        }),
                        children: [
                          hasHightlights && /* @__PURE__ */ jsx(Divider, { bottom: "var(--spacing-200)" }),
                          /* @__PURE__ */ jsx(HightLightItem, { value: highlights2 == null ? void 0 : highlights2.rangeValue, label: highlights2 == null ? void 0 : highlights2.rangeLabel }),
                          /* @__PURE__ */ jsx(HightLightItem, { value: highlights2 == null ? void 0 : highlights2.chargeTimeValue, label: highlights2 == null ? void 0 : highlights2.chargeTimeLabel }),
                          hasHightlights && /* @__PURE__ */ jsx(Divider, { top: "var(--spacing-200)", bottom: "var(--spacing-200)" }),
                          /* @__PURE__ */ jsx(HightLightItem, { value: highlights2 == null ? void 0 : highlights2.deliveryTimeValue, label: highlights2 == null ? void 0 : highlights2.deliveryTimeLabel }),
                          /* @__PURE__ */ jsx(
                            HightLightItem,
                            {
                              hightLightClassName: styles$c[`hightligh-lines`],
                              value: highlights2 == null ? void 0 : highlights2.availableValue,
                              label: highlights2 == null ? void 0 : highlights2.availableLabel
                            }
                          ),
                          hasHightlights && /* @__PURE__ */ jsx(Divider, { top: "var(--spacing-200)", bottom: "var(--spacing-400)" }),
                          (logos2 == null ? void 0 : logos2.length) && /* @__PURE__ */ jsx(Logos, { logoClassName: styles$c[`logo-large`] })
                        ]
                      }
                    )
                  ] })
                ] })
              ] })
            }
          ),
          legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx(
            "div",
            {
              tabIndex: -1,
              className: classNames(styles$c["legal-disclaimer"], { "dark-theme": mode === "dark" || mode === "brabus" }),
              children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
            }
          )
        ]
      }
    );
  }
);
const HeroStage = forwardRef((props, forwardedRef) => {
  let HeroComponent;
  switch (props.variant) {
    case "secondary":
      HeroComponent = SecondaryHero;
      break;
    case "modelHero":
      HeroComponent = ModelHero;
      break;
    default:
      HeroComponent = PrimaryHero;
      break;
  }
  return /* @__PURE__ */ jsx(HeroComponent, { ref: forwardedRef, ...props });
});
const getHeaderBackground = (item2) => {
  const heroTemplate = item2.template;
  switch (heroTemplate) {
    case "offer":
      return { heroTemplate, color: getThumbnailColor(item2.backgroundColorOption) };
    case "award":
      return { heroTemplate, color: "#F2F2F2" };
    case "campaign":
      return {
        heroTemplate
      };
    case "model":
      return {
        heroTemplate
      };
  }
};
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ref, value2) {
  if (typeof ref === "function") {
    ref(value2);
  } else if (ref) {
    ref.current = value2;
  }
  return ref;
}
function useCallbackRef(initialValue, callback) {
  var ref = useState(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value2) {
          var last = ref.value;
          if (last !== value2) {
            ref.value = value2;
            ref.callback(value2, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
function useMergeRefs(refs, defaultValue) {
  return useCallbackRef(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
}
function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults2, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults2;
    },
    useMedium: function(data2) {
      var item2 = middleware(data2, assigned);
      buffer.push(item2);
      return function() {
        buffer = buffer.filter(function(x) {
          return x !== item2;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x) {
          return cb(x);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createMedium(defaults2, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  return innerCreateMedium(defaults2, middleware);
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}
var SideCar$1 = function(_a) {
  var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React.createElement(Target, __assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$1;
}
var effectCar$1 = createSidecarMedium();
var nothing = function() {
  return;
};
var RemoveScroll = React.forwardRef(function(props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React.createElement(
    React.Fragment,
    null,
    enabled && React.createElement(SideCar2, { sideCar: effectCar$1, removeScrollBar, shards, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode }),
    forwardProps ? React.cloneElement(React.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : React.createElement(Container, __assign({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z2(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z2(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z2(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z2(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z2(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z2(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z2(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z2(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z2(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z2(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z2(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z2(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z2(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs)
    return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas)
    return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data2) {
      this.message = message;
      this.data = data2 && typeof data2 === "object" ? data2 : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value2) {
          var type = getPreciseType(value2);
          if (type === "symbol") {
            return String(value2);
          }
          return value2;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value2) {
      var type = getPreciseType(value2);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var FOCUS_GROUP = "data-focus-lock";
var FOCUS_DISABLED = "data-focus-lock-disabled";
var FOCUS_ALLOW = "data-no-focus-lock";
var FOCUS_AUTO = "data-autofocus-inside";
var FOCUS_NO_AUTOFOCUS = "data-no-autofocus";
var hiddenGuard = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
var mediumFocus = createMedium({}, function(_ref) {
  var target = _ref.target, currentTarget = _ref.currentTarget;
  return {
    target,
    currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true
  // focus-lock sidecar is not required on the server
  // however, it might be required for JSDOM tests
  // ssr: true,
});
var emptyArray = [];
var FocusLock = /* @__PURE__ */ React.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;
  var _React$useState = React.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
  var observed = React.useRef();
  var isActive2 = React.useRef(false);
  var originalFocusedElement = React.useRef(null);
  var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar2 = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
  var _React$useState2 = React.useState({}), id = _React$useState2[0];
  var onActivation = React.useCallback(function() {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive2.current = true;
  }, [onActivationCallback]);
  var onDeactivation = React.useCallback(function() {
    isActive2.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  useEffect(function() {
    if (!disabled) {
      originalFocusedElement.current = null;
    }
  }, []);
  var returnFocus = React.useCallback(function(allowDefer) {
    var returnFocusTo = originalFocusedElement.current;
    if (returnFocusTo && returnFocusTo.focus) {
      var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : void 0;
        originalFocusedElement.current = null;
        if (allowDefer) {
          Promise.resolve().then(function() {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]);
  var onFocus3 = React.useCallback(function(event) {
    if (isActive2.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur3 = mediumBlur.useMedium;
  var setObserveNode = React.useCallback(function(newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  if (process.env.NODE_ENV !== "production") {
    if (typeof allowTextSelection !== "undefined") {
      console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default");
    }
    React.useEffect(function() {
      if (!observed.current && typeof Container !== "string") {
        console.error("FocusLock: could not obtain ref to internal node");
      }
    }, []);
  }
  var lockProps = _extends((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && "disabled", _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, hasLeadingGuards && [
    // nearest focus guard
    /* @__PURE__ */ React.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hiddenGuard
    }),
    // first tabbed element guard
    hasPositiveIndices ? /* @__PURE__ */ React.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: hiddenGuard
    }) : null
  ], !disabled && /* @__PURE__ */ React.createElement(SideCar2, {
    id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled,
    persistentFocus,
    crossFrame,
    autoFocus,
    whiteList,
    shards,
    onActivation,
    onDeactivation,
    returnFocus,
    focusOptions
  }), /* @__PURE__ */ React.createElement(Container, _extends({
    ref: mergedRef
  }, lockProps, {
    className,
    onBlur: onBlur3,
    onFocus: onFocus3
  }), children), hasTailingGuards && /* @__PURE__ */ React.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypesExports.node,
  disabled: propTypesExports.bool,
  returnFocus: propTypesExports.oneOfType([propTypesExports.bool, propTypesExports.object, propTypesExports.func]),
  focusOptions: propTypesExports.object,
  noFocusGuards: propTypesExports.bool,
  hasPositiveIndices: propTypesExports.bool,
  allowTextSelection: propTypesExports.bool,
  autoFocus: propTypesExports.bool,
  persistentFocus: propTypesExports.bool,
  crossFrame: propTypesExports.bool,
  group: propTypesExports.string,
  className: propTypesExports.string,
  whiteList: propTypesExports.func,
  shards: propTypesExports.arrayOf(propTypesExports.any),
  as: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.func, propTypesExports.object]),
  lockProps: propTypesExports.object,
  onActivation: propTypesExports.func,
  onDeactivation: propTypesExports.func,
  sideCar: propTypesExports.any.isRequired
} : {};
FocusLock.defaultProps = {
  children: void 0,
  disabled: false,
  returnFocus: false,
  focusOptions: void 0,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  crossFrame: true,
  hasPositiveIndices: void 0,
  allowTextSelection: void 0,
  group: void 0,
  className: void 0,
  whiteList: void 0,
  shards: void 0,
  as: "div",
  lockProps: {},
  onActivation: void 0,
  onDeactivation: void 0
};
const FocusLockUI2 = FocusLock;
function deferAction(action) {
  setTimeout(action, 1);
}
var effectCar = createSidecarMedium();
var focusHiddenMarker = "data-focus-on-hidden";
var PREVENT_SCROLL = { preventScroll: true };
var FocusOn$1 = React.forwardRef(function(props, parentRef) {
  var _a = React.useState(false), lockProps = _a[0], setLockProps = _a[1];
  var children = props.children, autoFocus = props.autoFocus, shards = props.shards, crossFrame = props.crossFrame, _b = props.enabled, enabled = _b === void 0 ? true : _b, _c = props.scrollLock, scrollLock = _c === void 0 ? true : _c, _d = props.focusLock, focusLock = _d === void 0 ? true : _d, _e = props.returnFocus, returnFocus = _e === void 0 ? true : _e, inert = props.inert, allowPinchZoom = props.allowPinchZoom, sideCar = props.sideCar, className = props.className, shouldIgnore = props.shouldIgnore, preventScrollOnFocus = props.preventScrollOnFocus, style = props.style, as = props.as, gapMode = props.gapMode, rest = __rest(props, ["children", "autoFocus", "shards", "crossFrame", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]);
  var SideCar2 = sideCar;
  var onActivation = lockProps.onActivation, onDeactivation = lockProps.onDeactivation, restProps = __rest(lockProps, ["onActivation", "onDeactivation"]);
  var appliedLockProps = __assign(__assign({}, restProps), {
    as,
    style,
    sideCar,
    shards,
    allowPinchZoom,
    gapMode,
    inert,
    enabled: enabled && scrollLock
  });
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(FocusLockUI2, { ref: parentRef, sideCar, disabled: !(lockProps && enabled && focusLock), returnFocus, autoFocus, shards, crossFrame, onActivation, onDeactivation, className, whiteList: shouldIgnore, lockProps: appliedLockProps, focusOptions: preventScrollOnFocus ? PREVENT_SCROLL : void 0, as: RemoveScroll }, children),
    enabled && React.createElement(SideCar2, __assign({}, rest, { sideCar: effectCar, setLockProps, shards }))
  );
});
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function withSideEffect(reducePropsToState2, handleStateChangeOnClient2) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof reducePropsToState2 !== "function") {
      throw new Error("Expected reducePropsToState to be a function.");
    }
    if (typeof handleStateChangeOnClient2 !== "function") {
      throw new Error("Expected handleStateChangeOnClient to be a function.");
    }
  }
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }
  return function wrap(WrappedComponent) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof WrappedComponent !== "function") {
        throw new Error("Expected WrappedComponent to be a React component.");
      }
    }
    var mountedInstances = [];
    var state;
    function emitChange() {
      state = reducePropsToState2(mountedInstances.map(function(instance) {
        return instance.props;
      }));
      handleStateChangeOnClient2(state);
    }
    var SideEffect = /* @__PURE__ */ function(_PureComponent) {
      _inheritsLoose(SideEffect2, _PureComponent);
      function SideEffect2() {
        return _PureComponent.apply(this, arguments) || this;
      }
      SideEffect2.peek = function peek() {
        return state;
      };
      var _proto = SideEffect2.prototype;
      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };
      _proto.render = function render() {
        return /* @__PURE__ */ React__default.createElement(WrappedComponent, this.props);
      };
      return SideEffect2;
    }(PureComponent);
    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
    return SideEffect;
  };
}
var toArray = function(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};
var asArray = function(a) {
  return Array.isArray(a) ? a : [a];
};
var getFirst = function(a) {
  return Array.isArray(a) ? a[0] : a;
};
var isElementHidden = function(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  var computedStyle = window.getComputedStyle(node, null);
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var getParentNode = function(node) {
  return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    node.parentNode.host
  ) : node.parentNode;
};
var isTopNode = function(node) {
  return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var isVisibleUncached = function(node, checkParent) {
  return !node || isTopNode(node) || !isElementHidden(node) && checkParent(getParentNode(node));
};
var isVisibleCached = function(visibilityCache, node) {
  var cached = visibilityCache.get(node);
  if (cached !== void 0) {
    return cached;
  }
  var result = isVisibleUncached(node, isVisibleCached.bind(void 0, visibilityCache));
  visibilityCache.set(node, result);
  return result;
};
var isAutoFocusAllowedUncached = function(node, checkParent) {
  return node && !isTopNode(node) ? isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false : true;
};
var isAutoFocusAllowedCached = function(cache, node) {
  var cached = cache.get(node);
  if (cached !== void 0) {
    return cached;
  }
  var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(void 0, cache));
  cache.set(node, result);
  return result;
};
var getDataset = function(node) {
  return node.dataset;
};
var isHTMLButtonElement = function(node) {
  return node.tagName === "BUTTON";
};
var isHTMLInputElement = function(node) {
  return node.tagName === "INPUT";
};
var isRadioElement = function(node) {
  return isHTMLInputElement(node) && node.type === "radio";
};
var notHiddenInput = function(node) {
  return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === "hidden" || node.disabled));
};
var isAutoFocusAllowed = function(node) {
  var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![true, "true", ""].includes(attribute);
};
var isGuard = function(node) {
  var _a;
  return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var isNotAGuard = function(node) {
  return !isGuard(node);
};
var isDefined = function(x) {
  return Boolean(x);
};
var tabSort = function(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;
  if (tabDiff) {
    if (!a.tabIndex) {
      return 1;
    }
    if (!b.tabIndex) {
      return -1;
    }
  }
  return tabDiff || indexDiff;
};
var orderByTabIndex = function(nodes, filterNegative, keepGuards) {
  return toArray(nodes).map(function(node, index) {
    return {
      node,
      index,
      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
    };
  }).filter(function(data2) {
    return !filterNegative || data2.tabIndex >= 0;
  }).sort(tabSort);
};
var tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
];
var queryTabbables = tabbables.join(",");
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function(parent, withGuards) {
  return toArray((parent.shadowRoot || parent).children).reduce(function(acc, child) {
    return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
  }, []);
};
var getFocusablesWithIFrame = function(parent, withGuards) {
  var _a;
  if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
    return getFocusables([parent.contentDocument.body], withGuards);
  }
  return [parent];
};
var getFocusables = function(parents, withGuards) {
  return parents.reduce(function(acc, parent) {
    var _a;
    var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
    var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
      return getFocusablesWithIFrame(node, withGuards);
    }));
    return acc.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      focusableWithIframes,
      // add if node is tabbable itself
      parent.parentNode ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function(node) {
        return node === parent;
      }) : []
    );
  }, []);
};
var getParentAutofocusables = function(parent) {
  var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray(parentFocus).map(function(node) {
    return getFocusables([node]);
  }).reduce(function(acc, nodes) {
    return acc.concat(nodes);
  }, []);
};
var filterFocusable = function(nodes, visibilityCache) {
  return toArray(nodes).filter(function(node) {
    return isVisibleCached(visibilityCache, node);
  }).filter(function(node) {
    return notHiddenInput(node);
  });
};
var filterAutoFocusable = function(nodes, cache) {
  if (cache === void 0) {
    cache = /* @__PURE__ */ new Map();
  }
  return toArray(nodes).filter(function(node) {
    return isAutoFocusAllowedCached(cache, node);
  });
};
var getTabbableNodes = function(topNodes, visibilityCache, withGuards) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
var getFocusableNodes = function(topNodes, visibilityCache) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
var parentAutofocusables = function(topNode, visibilityCache) {
  return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
var contains = function(scope, element) {
  if (scope.shadowRoot) {
    return contains(scope.shadowRoot, element);
  } else {
    if (Object.getPrototypeOf(scope).contains !== void 0 && Object.getPrototypeOf(scope).contains.call(scope, element)) {
      return true;
    }
    return toArray(scope.children).some(function(child) {
      var _a;
      if (child instanceof HTMLIFrameElement) {
        var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
        if (iframeBody) {
          return contains(iframeBody, element);
        }
        return false;
      }
      return contains(child, element);
    });
  }
};
var filterNested = function(nodes) {
  var contained = /* @__PURE__ */ new Set();
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    for (var j = i + 1; j < l; j += 1) {
      var position = nodes[i].compareDocumentPosition(nodes[j]);
      if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
        contained.add(j);
      }
      if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
        contained.add(i);
      }
    }
  }
  return nodes.filter(function(_, index) {
    return !contained.has(index);
  });
};
var getTopParent = function(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};
var getAllAffectedNodes = function(node) {
  var nodes = asArray(node);
  return nodes.filter(Boolean).reduce(function(acc, currentNode) {
    var group = currentNode.getAttribute(FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, '="').concat(group, '"]:not([').concat(FOCUS_DISABLED, '="disabled"])')))) : [currentNode]);
    return acc;
  }, []);
};
var safeProbe = function(cb) {
  try {
    return cb();
  } catch (e) {
    return void 0;
  }
};
var getActiveElement = function(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  if (!inDocument || !inDocument.activeElement) {
    return void 0;
  }
  var activeElement = inDocument.activeElement;
  return activeElement.shadowRoot ? getActiveElement(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && safeProbe(function() {
    return activeElement.contentWindow.document;
  }) ? getActiveElement(activeElement.contentWindow.document) : activeElement;
};
var focusInFrame = function(frame, activeElement) {
  return frame === activeElement;
};
var focusInsideIframe = function(topNode, activeElement) {
  return Boolean(toArray(topNode.querySelectorAll("iframe")).some(function(node) {
    return focusInFrame(node, activeElement);
  }));
};
var focusInside = function(topNode, activeElement) {
  if (activeElement === void 0) {
    activeElement = getActiveElement(getFirst(topNode).ownerDocument);
  }
  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return getAllAffectedNodes(topNode).some(function(node) {
    return contains(node, activeElement) || focusInsideIframe(node, activeElement);
  });
};
var focusIsHidden = function(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  var activeElement = getActiveElement(inDocument);
  if (!activeElement) {
    return false;
  }
  return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function(node) {
    return contains(node, activeElement);
  });
};
var findSelectedRadio = function(node, nodes) {
  return nodes.filter(isRadioElement).filter(function(el) {
    return el.name === node.name;
  }).filter(function(el) {
    return el.checked;
  })[0] || node;
};
var correctNode = function(node, nodes) {
  if (isRadioElement(node) && node.name) {
    return findSelectedRadio(node, nodes);
  }
  return node;
};
var correctNodes = function(nodes) {
  var resultSet = /* @__PURE__ */ new Set();
  nodes.forEach(function(node) {
    return resultSet.add(correctNode(node, nodes));
  });
  return nodes.filter(function(node) {
    return resultSet.has(node);
  });
};
var pickFirstFocus = function(nodes) {
  if (nodes[0] && nodes.length > 1) {
    return correctNode(nodes[0], nodes);
  }
  return nodes[0];
};
var pickFocusable = function(nodes, index) {
  if (nodes.length > 1) {
    return nodes.indexOf(correctNode(nodes[index], nodes));
  }
  return index;
};
var NEW_FOCUS = "NEW_FOCUS";
var newFocus = function(innerNodes, outerNodes, activeElement, lastNode) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);
  if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
    return void 0;
  }
  var activeIndex = activeElement !== void 0 ? outerNodes.indexOf(activeElement) : -1;
  var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
  var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);
  var correctedNodes = correctNodes(outerNodes);
  var correctedIndex = activeElement !== void 0 ? correctedNodes.indexOf(activeElement) : -1;
  var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
  var returnFirstNode = pickFocusable(innerNodes, 0);
  var returnLastNode = pickFocusable(innerNodes, cnt - 1);
  if (activeIndex === -1 || lastNodeInside === -1) {
    return NEW_FOCUS;
  }
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
    return lastNodeInside;
  }
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  return void 0;
};
var findAutoFocused = function(autoFocusables) {
  return function(node) {
    var _a;
    var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
    return (
      // @ts-expect-error
      node.autofocus || //
      autofocus !== void 0 && autofocus !== "false" || //
      autoFocusables.indexOf(node) >= 0
    );
  };
};
var pickAutofocus = function(nodesIndexes, orderedNodes, groups) {
  var nodes = nodesIndexes.map(function(_a) {
    var node = _a.node;
    return node;
  });
  var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
  if (autoFocusable && autoFocusable.length) {
    return pickFirstFocus(autoFocusable);
  }
  return pickFirstFocus(filterAutoFocusable(orderedNodes));
};
var getParents = function(node, parents) {
  if (parents === void 0) {
    parents = [];
  }
  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode.host || node.parentNode, parents);
  }
  return parents;
};
var getCommonParent = function(nodeA, nodeB) {
  var parentsA = getParents(nodeA);
  var parentsB = getParents(nodeB);
  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};
var getTopCommonParent = function(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = asArray(baseActiveElement);
  var leftEntries = asArray(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = false;
  leftEntries.filter(Boolean).forEach(function(entry) {
    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function(subEntry) {
      var common = getCommonParent(activeElement, subEntry);
      if (common) {
        if (!topCommon || contains(common, topCommon)) {
          topCommon = common;
        } else {
          topCommon = getCommonParent(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};
var allParentAutofocusables = function(entries, visibilityCache) {
  return entries.reduce(function(acc, node) {
    return acc.concat(parentAutofocusables(node, visibilityCache));
  }, []);
};
var reorderNodes = function(srcNodes, dstNodes) {
  var remap = /* @__PURE__ */ new Map();
  dstNodes.forEach(function(entity) {
    return remap.set(entity.node, entity);
  });
  return srcNodes.map(function(node) {
    return remap.get(node);
  }).filter(isDefined);
};
var focusSolver = function(topNode, lastNode) {
  var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
  var visibilityCache = /* @__PURE__ */ new Map();
  var anyFocusable = getFocusableNodes(entries, visibilityCache);
  var innerElements = getTabbableNodes(entries, visibilityCache).filter(function(_a) {
    var node = _a.node;
    return isNotAGuard(node);
  });
  if (!innerElements[0]) {
    innerElements = anyFocusable;
    if (!innerElements[0]) {
      return void 0;
    }
  }
  var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function(_a) {
    var node = _a.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function(_a) {
    var node = _a.node;
    return node;
  });
  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);
  if (newId === NEW_FOCUS) {
    var focusNode = pickAutofocus(anyFocusable, innerNodes, allParentAutofocusables(entries, visibilityCache));
    if (focusNode) {
      return { node: focusNode };
    } else {
      console.warn("focus-lock: cannot find any node to move focus into");
      return void 0;
    }
  }
  if (newId === void 0) {
    return newId;
  }
  return orderedInnerElements[newId];
};
var expandFocusableNodes = function(topNode) {
  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var visibilityCache = /* @__PURE__ */ new Map();
  var outerNodes = getTabbableNodes([commonParent], visibilityCache, true);
  var innerElements = getTabbableNodes(entries, visibilityCache).filter(function(_a) {
    var node = _a.node;
    return isNotAGuard(node);
  }).map(function(_a) {
    var node = _a.node;
    return node;
  });
  return outerNodes.map(function(_a) {
    var node = _a.node, index = _a.index;
    return {
      node,
      index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node)
    };
  });
};
var focusOn = function(target, focusOptions) {
  if ("focus" in target) {
    target.focus(focusOptions);
  }
  if ("contentWindow" in target && target.contentWindow) {
    target.contentWindow.focus();
  }
};
var guardCount = 0;
var lockDisabled = false;
var moveFocusInside = function(topNode, lastNode, options) {
  if (options === void 0) {
    options = {};
  }
  var focusable = focusSolver(topNode, lastNode);
  if (lockDisabled) {
    return;
  }
  if (focusable) {
    if (guardCount > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
      lockDisabled = true;
      setTimeout(function() {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node, options.focusOptions);
    guardCount--;
  }
};
var focusOnBody = function focusOnBody2() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus2() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist2() {
  return true;
};
var focusWhitelisted = function focusWhitelisted2(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal2(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode,
    portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair2(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;
  do {
    var item2 = allNodes[i];
    if (item2.guard) {
      if (item2.node.dataset.focusAutoGuard) {
        lastGuard = item2;
      }
    } else if (item2.lockItem) {
      if (i !== startIndex) {
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var extractRef$2 = function extractRef(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var focusWasOutside = function focusWasOutside2(crossFrameOption) {
  if (crossFrameOption) {
    return Boolean(focusWasOutsideWindow);
  }
  return focusWasOutsideWindow === "meanwhile";
};
var checkInHost = function checkInHost2(check, el, boundary) {
  return el && // find host equal to active element and check nested active element
  (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost2(check, el.parentNode, boundary));
};
var withinHost = function withinHost2(activeElement, workingArea) {
  return workingArea.some(function(area) {
    return checkInHost(activeElement, area, area);
  });
};
var activateTrap = function activateTrap2() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef$2).filter(Boolean));
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !// active element is "inside" working area
          (focusInside(workingArea) || // check for shadow-dom contained elements
          activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              if (activeElement.blur) {
                activeElement.blur();
              }
              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions
              });
              lastPortaledElement = {};
            }
          }
          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }
      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function(_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);
        if (focusedIndex > -1) {
          allNodes.filter(function(_ref2) {
            var guard = _ref2.guard, node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function(_ref3) {
            var node = _ref3.node;
            return node.removeAttribute("tabIndex");
          });
          autoGuard(focusedIndex, allNodes.length, 1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap2(event) {
  if (activateTrap() && event) {
    event.stopPropagation();
    event.preventDefault();
  }
};
var onBlur = function onBlur2() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus2(event) {
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher2() {
  return null;
};
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};
var onWindowBlur = function onWindowBlur2() {
  focusWasOutsideWindow = "just";
  deferAction(function() {
    focusWasOutsideWindow = "meanwhile";
  });
};
var attachHandler = function attachHandler2() {
  document.addEventListener("focusin", onTrap);
  document.addEventListener("focusout", onBlur);
  window.addEventListener("blur", onWindowBlur);
};
var detachHandler = function detachHandler2() {
  document.removeEventListener("focusin", onTrap);
  document.removeEventListener("focusout", onBlur);
  window.removeEventListener("blur", onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function(_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
    if (!traps.filter(function(_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }
    activateTrap();
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function(cb) {
  return cb({
    moveFocusInside,
    focusInside
  });
});
const FocusTrap = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);
exportSidecar(mediumSidecar, FocusTrap);
var currentNonce;
var getNonce = function() {
  if (currentNonce) {
    return currentNonce;
  }
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function() {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles2, isDynamic) {
    React.useEffect(function() {
      sheet.add(styles2);
      return function() {
        sheet.remove();
      };
    }, [styles2 && isDynamic]);
  };
};
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet = function(_a) {
    var styles2 = _a.styles, dynamic = _a.dynamic;
    useStyle(styles2, dynamic);
    return null;
  };
  return Sheet;
};
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function(x) {
  return parseInt(x || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
var Style$1 = styleSingleton();
var getStyles = function(_a, allowRelative, gapMode, important) {
  var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var RemoveScrollBar = function(props) {
  var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
  var gap = React.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React.createElement(Style$1, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    var options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var nonPassive = passiveSupported ? { passive: false } : false;
var alwaysContainsScroll = function(node) {
  return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node, overflow) {
  var styles2 = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles2[overflow] !== "hidden" && // contains scroll inside self
    !(styles2.overflowY === styles2.overflowX && !alwaysContainsScroll(node) && styles2[overflow] === "visible")
  );
};
var elementCouldBeVScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function(axis, node) {
  var ownerDocument = node.ownerDocument;
  var current2 = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current2 instanceof ShadowRoot) {
      current2 = current2.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current2);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current2), s = _a[1], d = _a[2];
      if (s > d) {
        return true;
      }
    }
    current2 = current2.parentNode;
  } while (current2 && current2 !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    if (target instanceof ShadowRoot) {
      target = target.host;
    } else {
      target = target.parentNode;
    }
  } while (
    // portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target)
  );
  if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef$1 = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x, y) {
  return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id = React.useState(idCounter++)[0];
  var Style2 = React.useState(styleSingleton)[0];
  var lastProps = React.useRef(props);
  React.useEffect(function() {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef$1), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e) {
      return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef$1).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should, shadowParent: getOutermostShadowParent(target) };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return React.createElement(
    React.Fragment,
    null,
    inert ? React.createElement(Style2, { styles: generateStyle(id) }) : null,
    removeScrollBar ? React.createElement(RemoveScrollBar, { gapMode: props.gapMode }) : null
  );
}
function getOutermostShadowParent(node) {
  var shadowParent = null;
  while (node !== null) {
    if (node instanceof ShadowRoot) {
      shadowParent = node.host;
      node = node.host;
    }
    node = node.parentNode;
  }
  return shadowParent;
}
exportSidecar(effectCar$1, RemoveScrollSideCar);
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x) {
    return Boolean(x);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        var attr = node.getAttribute(controlAttribute);
        var alreadyHidden = attr !== null && attr !== "false";
        var counterValue = (counterMap.get(node) || 0) + 1;
        var markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenNodes.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledNodes.set(node, true);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, "true");
        }
        if (!alreadyHidden) {
          node.setAttribute(controlAttribute, "true");
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var Style = styleSingleton();
var styles$b = "\n [" + focusHiddenMarker + "] {\n   pointer-events: none !important;\n }\n";
var InteractivityDisabler = function() {
  return React.createElement(Style, { styles: styles$b });
};
var extractRef2 = function(ref) {
  return "current" in ref ? ref.current : ref;
};
function Effect(_a) {
  var setLockProps = _a.setLockProps, onEscapeKey = _a.onEscapeKey, onClickOutside = _a.onClickOutside, shards = _a.shards, onActivation = _a.onActivation, onDeactivation = _a.onDeactivation, noIsolation = _a.noIsolation;
  var _b = useState(void 0), activeNode = _b[0], setActiveNode = _b[1];
  var lastEventTarget = useRef(null);
  var mouseTouches = useRef(0);
  React.useEffect(function() {
    var onKeyDown = function(event) {
      if (!event.defaultPrevented) {
        if ((event.code === "Escape" || event.key === "Escape" || event.keyCode === 27) && onEscapeKey) {
          onEscapeKey(event);
        }
      }
    };
    var onMouseDown = function(event) {
      if (event.defaultPrevented || event.target === lastEventTarget.current || event instanceof MouseEvent && event.button !== 0) {
        return;
      }
      if (shards && shards.map(extractRef2).some(function(node) {
        return node && node.contains(event.target) || node === event.target;
      })) {
        return;
      }
      if (onClickOutside) {
        onClickOutside(event);
      }
    };
    var onTouchStart2 = function(event) {
      onMouseDown(event);
      mouseTouches.current = event.touches.length;
    };
    var onTouchEnd2 = function(event) {
      mouseTouches.current = event.touches.length;
    };
    if (activeNode) {
      document.addEventListener("keydown", onKeyDown);
      document.addEventListener("mousedown", onMouseDown);
      document.addEventListener("touchstart", onTouchStart2);
      document.addEventListener("touchend", onTouchEnd2);
      return function() {
        document.removeEventListener("keydown", onKeyDown);
        document.removeEventListener("mousedown", onMouseDown);
        document.removeEventListener("touchstart", onTouchStart2);
        document.removeEventListener("touchend", onTouchEnd2);
      };
    }
  }, [activeNode, onClickOutside, onEscapeKey]);
  useEffect(function() {
    if (activeNode) {
      if (onActivation) {
        onActivation(activeNode);
      }
      return function() {
        if (onDeactivation) {
          onDeactivation();
        }
      };
    }
  }, [!!activeNode]);
  useEffect(function() {
    var _undo = function() {
      return null;
    };
    var unmounted = false;
    var onNodeActivation = function(node) {
      if (!noIsolation) {
        _undo = hideOthers(__spreadArrays([node], (shards || []).map(extractRef2)), document.body, focusHiddenMarker);
      }
      setActiveNode(function() {
        return node;
      });
    };
    var onNodeDeactivation = function() {
      _undo();
      if (!unmounted) {
        setActiveNode(null);
      }
    };
    setLockProps({
      onMouseDown: function(e) {
        lastEventTarget.current = e.target;
      },
      onTouchStart: function(e) {
        lastEventTarget.current = e.target;
      },
      onActivation: onNodeActivation,
      onDeactivation: onNodeDeactivation
    });
    return function() {
      unmounted = true;
      setLockProps(false);
    };
  }, []);
  return React.createElement(InteractivityDisabler, null);
}
const SideCar = exportSidecar(effectCar, Effect);
var RequireSideCar = function(props) {
  return React.createElement(SideCar, __assign({}, props));
};
var FocusOn = React.forwardRef(function(props, ref) {
  return React.createElement(FocusOn$1, __assign({}, props, { ref, sideCar: RequireSideCar }));
});
const header = "_header_c35cs_37";
const visibledropdownshow = "_visibledropdownshow_c35cs_53";
const visibleLinkItem = "_visibleLinkItem_c35cs_53";
const visibleButton = "_visibleButton_c35cs_54";
const burgerMenu = "_burgerMenu_c35cs_55";
const close = "_close_c35cs_56";
const languageSelector__select = "_languageSelector__select_c35cs_57";
const languageSelector__icon = "_languageSelector__icon_c35cs_58";
const greetingText = "_greetingText_c35cs_59";
const wishlistCarSelect = "_wishlistCarSelect_c35cs_60";
const accountLink = "_accountLink_c35cs_61";
const shoppingLink = "_shoppingLink_c35cs_62";
const logoLink = "_logoLink_c35cs_65";
const inner = "_inner_c35cs_68";
const languageSelector = "_languageSelector_c35cs_57";
const optionListShow = "_optionListShow_c35cs_124";
const languageSelector__option = "_languageSelector__option_c35cs_127";
const iconPR8 = "_iconPR8_c35cs_212";
const selected = "_selected_c35cs_218";
const optionsHide = "_optionsHide_c35cs_225";
const pointerEvents = "_pointerEvents_c35cs_228";
const selectorHide = "_selectorHide_c35cs_231";
const languageWrapper = "_languageWrapper_c35cs_251";
const mobileSelector = "_mobileSelector_c35cs_256";
const backIcon = "_backIcon_c35cs_270";
const menuButton = "_menuButton_c35cs_279";
const flyout = "_flyout_c35cs_315";
const firstMenuButton = "_firstMenuButton_c35cs_315";
const secondMenuButton = "_secondMenuButton_c35cs_316";
const visibleList = "_visibleList_c35cs_359";
const isHovered = "_isHovered_c35cs_392";
const mr32 = "_mr32_c35cs_397";
const visibleButtonIcon = "_visibleButtonIcon_c35cs_427";
const rotateIcon = "_rotateIcon_c35cs_433";
const visibleDropdownList = "_visibleDropdownList_c35cs_439";
const visibleDropdownShow = "_visibleDropdownShow_c35cs_454";
const headlineText = "_headlineText_c35cs_467";
const launchText = "_launchText_c35cs_468";
const tileAnimation0 = "_tileAnimation0_c35cs_474";
const tileAnimation1 = "_tileAnimation1_c35cs_477";
const tileAnimation2 = "_tileAnimation2_c35cs_480";
const tileAnimation3 = "_tileAnimation3_c35cs_483";
const tileAnimation4 = "_tileAnimation4_c35cs_486";
const tileAnimation5 = "_tileAnimation5_c35cs_489";
const visibleTile2 = "_visibleTile2_c35cs_492";
const visibleTile3 = "_visibleTile3_c35cs_495";
const visibleTile4 = "_visibleTile4_c35cs_498";
const visibleTile5 = "_visibleTile5_c35cs_501";
const visibleTile6 = "_visibleTile6_c35cs_504";
const carTile = "_carTile_c35cs_507";
const contentTileWrapper = "_contentTileWrapper_c35cs_510";
const arrowRight = "_arrowRight_c35cs_550";
const contentTile = "_contentTile_c35cs_510";
const visibleSubItems = "_visibleSubItems_c35cs_570";
const visibleButtonItem = "_visibleButtonItem_c35cs_594";
const cursorPointer = "_cursorPointer_c35cs_626";
const tileTop = "_tileTop_c35cs_647";
const modelName = "_modelName_c35cs_663";
const priceTag = "_priceTag_c35cs_680";
const carTileImgPosition = "_carTileImgPosition_c35cs_706";
const contentTag = "_contentTag_c35cs_724";
const multiRow = "_multiRow_c35cs_729";
const wishlistAccountContainer = "_wishlistAccountContainer_c35cs_743";
const badge = "_badge_c35cs_751";
const wishlistBadge = "_wishlistBadge_c35cs_776";
const shoppingBadge = "_shoppingBadge_c35cs_776";
const iconContainer = "_iconContainer_c35cs_786";
const smallIcon = "_smallIcon_c35cs_791";
const mediumIcon = "_mediumIcon_c35cs_824";
const mobileSecondPage = "_mobileSecondPage_c35cs_925";
const list$1 = "_list_c35cs_943";
const link$3 = "_link_c35cs_943";
const navItemButton = "_navItemButton_c35cs_944";
const navCategory = "_navCategory_c35cs_945";
const secondLevel = "_secondLevel_c35cs_946";
const linkItem = "_linkItem_c35cs_952";
const item$2 = "_item_c35cs_960";
const isActive = "_isActive_c35cs_963";
const compactIcon = "_compactIcon_c35cs_998";
const logoutButton = "_logoutButton_c35cs_1017";
const previewImage = "_previewImage_c35cs_1075";
const campaignSpot = "_campaignSpot_c35cs_1093";
const campaignHeadline = "_campaignHeadline_c35cs_1099";
const campaignLinkLabel = "_campaignLinkLabel_c35cs_1100";
const campaignText = "_campaignText_c35cs_1159";
const logos = "_logos_c35cs_1173";
const offerText = "_offerText_c35cs_1176";
const awardText = "_awardText_c35cs_1179";
const campaignSubline = "_campaignSubline_c35cs_1197";
const campaignTitle = "_campaignTitle_c35cs_1198";
const awardSubline = "_awardSubline_c35cs_1202";
const awardTitle = "_awardTitle_c35cs_1203";
const offerTitle = "_offerTitle_c35cs_1204";
const offersubtitle = "_offersubtitle_c35cs_1205";
const offerSubline = "_offerSubline_c35cs_1206";
const subtitle = "_subtitle_c35cs_1209";
const awardHeadline = "_awardHeadline_c35cs_1212";
const offertitle = "_offertitle_c35cs_1229";
const offerBrabusSubtitle = "_offerBrabusSubtitle_c35cs_1263";
const offerBrabusTitle = "_offerBrabusTitle_c35cs_1264";
const offerBrabusSubline = "_offerBrabusSubline_c35cs_1265";
const offerBrabusParagraph = "_offerBrabusParagraph_c35cs_1268";
const paragraph$2 = "_paragraph_c35cs_1271";
const awardParagraph = "_awardParagraph_c35cs_1287";
const offerparagraph = "_offerparagraph_c35cs_1288";
const awardcta = "_awardcta_c35cs_1320";
const offercta = "_offercta_c35cs_1321";
const cta$3 = "_cta_c35cs_1322";
const offerBrabuscta = "_offerBrabuscta_c35cs_1330";
const campaignMediaWrapper = "_campaignMediaWrapper_c35cs_1338";
const mobileFirstPage = "_mobileFirstPage_c35cs_1364";
const secondLevelPreviewImage = "_secondLevelPreviewImage_c35cs_1602";
const mt76 = "_mt76_c35cs_1633";
const mt32 = "_mt32_c35cs_1636";
const itemsGroup = "_itemsGroup_c35cs_1706";
const currentItem = "_currentItem_c35cs_1770";
const menuItemHover = "_menuItemHover_c35cs_1777";
const isLogoutButton = "_isLogoutButton_c35cs_1784";
const isHighlightedCategory = "_isHighlightedCategory_c35cs_1787";
const isHighlightedLink = "_isHighlightedLink_c35cs_1806";
const buttonWrapper = "_buttonWrapper_c35cs_1819";
const isExternal = "_isExternal_c35cs_1866";
const externalIcon = "_externalIcon_c35cs_1869";
const firstLevelButtonItem = "_firstLevelButtonItem_c35cs_1873";
const overviewByline = "_overviewByline_c35cs_1939";
const overviewPrice = "_overviewPrice_c35cs_1940";
const secondLevelList = "_secondLevelList_c35cs_1975";
const mobileBackIcon = "_mobileBackIcon_c35cs_2044";
const open = "_open_c35cs_2059";
const isOpen = "_isOpen_c35cs_2458";
const secondLevelIsOpen = "_secondLevelIsOpen_c35cs_2492";
const flexColumn = "_flexColumn_c35cs_2630";
const flex = "_flex_c35cs_2630";
const layer = "_layer_c35cs_2636";
const menuIsHide = "_menuIsHide_c35cs_2663";
const hasBannerMargin = "_hasBannerMargin_c35cs_2685";
const visibleMenuCTAs = "_visibleMenuCTAs_c35cs_2740";
const styles$a = {
  header,
  "dark-theme": "_dark-theme_c35cs_50",
  visibledropdownshow,
  visibleLinkItem,
  visibleButton,
  burgerMenu,
  close,
  languageSelector__select,
  languageSelector__icon,
  greetingText,
  wishlistCarSelect,
  accountLink,
  shoppingLink,
  logoLink,
  inner,
  languageSelector,
  optionListShow,
  languageSelector__option,
  iconPR8,
  selected,
  optionsHide,
  pointerEvents,
  selectorHide,
  languageWrapper,
  mobileSelector,
  backIcon,
  menuButton,
  flyout,
  firstMenuButton,
  secondMenuButton,
  visibleList,
  isHovered,
  mr32,
  visibleButtonIcon,
  rotateIcon,
  visibleDropdownList,
  visibleDropdownShow,
  headlineText,
  launchText,
  tileAnimation0,
  tileAnimation1,
  tileAnimation2,
  tileAnimation3,
  tileAnimation4,
  tileAnimation5,
  visibleTile2,
  visibleTile3,
  visibleTile4,
  visibleTile5,
  visibleTile6,
  carTile,
  contentTileWrapper,
  arrowRight,
  contentTile,
  visibleSubItems,
  "visibleSubItems--threeTiles": "_visibleSubItems--threeTiles_c35cs_579",
  visibleButtonItem,
  cursorPointer,
  "visibleSubItems--twoTiles": "_visibleSubItems--twoTiles_c35cs_642",
  tileTop,
  "tileTop--twoTiles": "_tileTop--twoTiles_c35cs_651",
  modelName,
  priceTag,
  carTileImgPosition,
  "carTileImgPosition--threeTiles": "_carTileImgPosition--threeTiles_c35cs_718",
  contentTag,
  multiRow,
  wishlistAccountContainer,
  badge,
  wishlistBadge,
  shoppingBadge,
  iconContainer,
  smallIcon,
  mediumIcon,
  mobileSecondPage,
  list: list$1,
  link: link$3,
  navItemButton,
  navCategory,
  secondLevel,
  linkItem,
  item: item$2,
  isActive,
  compactIcon,
  logoutButton,
  previewImage,
  campaignSpot,
  campaignHeadline,
  campaignLinkLabel,
  campaignText,
  logos,
  offerText,
  awardText,
  campaignSubline,
  campaignTitle,
  awardSubline,
  awardTitle,
  offerTitle,
  offersubtitle,
  offerSubline,
  subtitle,
  awardHeadline,
  offertitle,
  offerBrabusSubtitle,
  offerBrabusTitle,
  offerBrabusSubline,
  offerBrabusParagraph,
  paragraph: paragraph$2,
  awardParagraph,
  offerparagraph,
  awardcta,
  offercta,
  cta: cta$3,
  offerBrabuscta,
  campaignMediaWrapper,
  mobileFirstPage,
  secondLevelPreviewImage,
  mt76,
  mt32,
  itemsGroup,
  currentItem,
  menuItemHover,
  isLogoutButton,
  isHighlightedCategory,
  isHighlightedLink,
  buttonWrapper,
  isExternal,
  externalIcon,
  firstLevelButtonItem,
  overviewByline,
  overviewPrice,
  secondLevelList,
  mobileBackIcon,
  open,
  isOpen,
  secondLevelIsOpen,
  flexColumn,
  flex,
  layer,
  menuIsHide,
  "header-mask": "_header-mask_c35cs_2671",
  hasBannerMargin,
  "profile-dropdown": "_profile-dropdown_c35cs_2694",
  "icon-wrapper": "_icon-wrapper_c35cs_2735",
  visibleMenuCTAs,
  "fade-in": "_fade-in_c35cs_1",
  "fade-out": "_fade-out_c35cs_1",
  "rotate-plus": "_rotate-plus_c35cs_1",
  "rotate-minus": "_rotate-minus_c35cs_1"
};
const useScrollTop = (ref, open2) => {
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    if (open2) {
      return;
    }
    const el = ref.current;
    const scrollTopWithTimer = setTimeout(() => el.scrollTop = 0, 150);
    return () => {
      clearTimeout(scrollTopWithTimer);
    };
  }, [open2, ref]);
};
const imageConfigSingleCard = [
  {
    aspectRatio: "3-4",
    sizes: "33.33vw",
    media: `(max-width: ${breakpoints$1.l / 16}em)`
  },
  {
    aspectRatio: "3-4",
    sizes: "100vw",
    media: `(min-width: ${breakpoints$1.l / 16}em)`
  }
];
const SecondLevel = ({
  overviewByline: overviewByline2,
  overviewPrice: overviewPrice2,
  items,
  isOpen: isOpen2,
  className,
  children,
  setHoveredCampaign,
  removeHoveredCampaign
}) => {
  let enterTimer;
  const listRef = useRef(null);
  const wrapperRef = useRef(null);
  const [isHovered2, setIsHovered] = useState(false);
  useScrollTop(listRef, isOpen2);
  useScrollTop(wrapperRef, isOpen2);
  return /* @__PURE__ */ jsxs("div", { ref: wrapperRef, "aria-hidden": !isOpen2, className: classNames(styles$a.secondLevel, className), children: [
    children,
    /* @__PURE__ */ jsx("div", { className: styles$a.overviewByline, children: overviewByline2 }),
    /* @__PURE__ */ jsx("div", { className: styles$a.overviewPrice, children: overviewPrice2 }),
    /* @__PURE__ */ jsx("ul", { className: styles$a.secondLevelList, ref: listRef, children: items.subItems.map((item2, index) => /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames(styles$a.navCategory, { [styles$a.isHovered]: isHovered2, [styles$a.mt32]: index === 0 }),
          children: /* @__PURE__ */ jsx("span", { children: item2.categoryLabel })
        }
      ),
      item2.menuItems.map((menuItem, menuIndex) => /* @__PURE__ */ jsx(
        "li",
        {
          className: classNames(styles$a.item, { [styles$a.isHovered]: isHovered2 }),
          onMouseEnter: () => {
            setIsHovered(true);
            setHoveredCampaign(menuItem.campaign);
          },
          onMouseLeave: () => {
            clearTimeout(enterTimer);
            removeHoveredCampaign();
            setIsHovered(false);
          },
          children: /* @__PURE__ */ jsx(
            TextLink,
            {
              variant: "hyperlink-100",
              ...menuItem,
              className: classNames(styles$a.link, {
                [styles$a.isExternal]: menuItem.isExternal
              }),
              linkText: menuItem.label
            }
          )
        },
        (menuItem.label || "") + "" + index + menuIndex
      ))
    ] }, (item2.categoryLabel || "") + "" + index)) })
  ] });
};
[
  {
    aspectRatio: "1-1",
    sizes: "100%",
    media: `(max-width: ${breakpoints$1.l / 16}em)`
  },
  {
    aspectRatio: "1-1",
    sizes: "100%",
    media: `(min-width: ${breakpoints$1.l / 16}em)`
  }
];
const CarTile = ({ className, item: item2, index, tileAmount }) => {
  var _a, _b, _c;
  return /* @__PURE__ */ jsxs(
    "a",
    {
      "aria-label": (_a = item2.link) == null ? void 0 : _a.label,
      href: (_b = item2.link) == null ? void 0 : _b.href,
      onClick: (e) => {
        var _a2, _b2;
        e.stopPropagation();
        e.preventDefault();
        if (((_a2 = item2.link) == null ? void 0 : _a2.href) && item2.link.onClick) {
          (_b2 = item2.link) == null ? void 0 : _b2.onClick(e);
        }
      },
      className: classNames(
        styles$a.visibleSubItems,
        index / 2 === 0 ? styles$a.white : styles$a.gray,
        {
          [styles$a.flexColumn]: tileAmount > 3,
          [styles$a.cursorPointer]: (_c = item2.link) == null ? void 0 : _c.href,
          [styles$a[`visibleSubItems--twoTiles`]]: tileAmount <= 2,
          [styles$a[`visibleSubItems--threeTiles`]]: tileAmount === 3
        },
        className
      ),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(styles$a.tileTop, {
              [styles$a[`tileTop--twoTiles`]]: tileAmount <= 2
            }),
            children: [
              /* @__PURE__ */ jsx("span", { className: styles$a.modelName, children: item2.label }),
              /* @__PURE__ */ jsx("p", { className: styles$a.priceTag, children: item2.price }),
              /* @__PURE__ */ jsxs("div", { className: styles$a.visibleMenuCTAs, children: [
                item2.primaryLink && /* @__PURE__ */ jsx(
                  TextLink,
                  {
                    variant: "hyperlink-200",
                    ...item2.primaryLink,
                    linkText: item2.primaryLink.label,
                    onClick: (e) => {
                      var _a2;
                      e.stopPropagation();
                      e.preventDefault();
                      if ((_a2 = item2.primaryLink) == null ? void 0 : _a2.onClick) {
                        item2.primaryLink.onClick(e);
                      }
                    }
                  }
                ),
                item2.secondaryLink && /* @__PURE__ */ jsx(
                  TextLink,
                  {
                    variant: "hyperlink-200",
                    ...item2.secondaryLink,
                    linkText: item2.secondaryLink.label,
                    onClick: (e) => {
                      var _a2;
                      e.stopPropagation();
                      e.preventDefault();
                      if ((_a2 = item2.secondaryLink) == null ? void 0 : _a2.onClick) {
                        item2.secondaryLink.onClick(e);
                      }
                    }
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(styles$a.carTileImgPosition, {
              [styles$a[`carTileImgPosition--threeTiles`]]: tileAmount === 3
            }),
            children: /* @__PURE__ */ jsx(
              DynamicMediaPicture,
              {
                imageAltText: "test",
                hasImageTransparency: true,
                imageUrl: item2.imageUrl || "",
                imageConfigs: [
                  {
                    aspectRatio: tileAmount === 3 ? "16-9" : "1-1",
                    sizes: "100%",
                    media: `(max-width: ${breakpoints$1.l / 16}em)`
                  },
                  {
                    aspectRatio: tileAmount === 3 ? "16-9" : "1-1",
                    sizes: "100%",
                    media: `(min-width: ${breakpoints$1.l / 16}em)`
                  }
                ],
                hasDarkeningLayer: true,
                isObjectFit: true
              }
            )
          }
        ),
        item2.contentTag && /* @__PURE__ */ jsx(Tag, { className: styles$a.contentTag, variant: item2.contentTag.variant, children: item2.contentTag.label })
      ]
    },
    item2.label || "" + index
  );
};
const ContentTile = ({ className, item: item2, index, tileAmount }) => {
  var _a, _b, _c, _d, _e;
  const tileItem = {
    label: (_a = item2.link) == null ? void 0 : _a.label,
    href: (_b = item2.link) == null ? void 0 : _b.href,
    onClick: (_c = item2.link) == null ? void 0 : _c.onClick
  };
  return /* @__PURE__ */ jsxs("a", { ...tileItem, className: classNames(styles$a.contentTile, { [styles$a.cursorPointer]: (_d = item2.link) == null ? void 0 : _d.href }, className), children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("p", { className: styles$a.headlineText, children: item2.headlineText }),
      /* @__PURE__ */ jsx("p", { className: styles$a.launchText, children: item2.launchText })
    ] }),
    ((_e = item2.link) == null ? void 0 : _e.href) && /* @__PURE__ */ jsx("div", { className: styles$a.tileArrow, children: /* @__PURE__ */ jsx(Icon, { className: styles$a.arrowRight, name: "arrow-right--small" }) })
  ] });
};
const text$2 = "_text_udjue_178";
const active = "_active_udjue_195";
const link$2 = "_link_udjue_203";
const styles$9 = {
  "sub-menu": "_sub-menu_udjue_1",
  "hide-on-mobile": "_hide-on-mobile_udjue_41",
  "move-up": "_move-up_udjue_1",
  "show-on-mobile": "_show-on-mobile_udjue_45",
  "move-down": "_move-down_udjue_1",
  "secondary-line": "_secondary-line_udjue_69",
  "icon-button": "_icon-button_udjue_112",
  "sub-menu-content": "_sub-menu-content_udjue_116",
  "sub-menu-navigation-text": "_sub-menu-navigation-text_udjue_120",
  "sub-menu-buttons-wrapper": "_sub-menu-buttons-wrapper_udjue_142",
  "sub-menu-items": "_sub-menu-items_udjue_145",
  "sub-menu-item": "_sub-menu-item_udjue_145",
  text: text$2,
  active,
  link: link$2,
  "fade-in": "_fade-in_udjue_1",
  "fade-out": "_fade-out_udjue_1",
  "rotate-plus": "_rotate-plus_udjue_1",
  "rotate-minus": "_rotate-minus_udjue_1"
};
const MenuButton = ({ link: link2, type, icon: icon2 }) => {
  const isMobile = useIsMobile();
  if (!isMobile) {
    return /* @__PURE__ */ jsx(
      TextLink,
      {
        ...link2,
        className: styles$9.link,
        icon: icon2 && { name: icon2 },
        variant: type === "primary" ? "button-primary" : "button-secondary",
        linkText: (link2 == null ? void 0 : link2.label) || "",
        title: (link2 == null ? void 0 : link2.label) || ""
      }
    );
  } else {
    if (icon2) {
      return /* @__PURE__ */ jsx(
        IconLink,
        {
          ...link2,
          size: "200",
          className: styles$9["icon-button"],
          icon: { name: icon2 },
          variant: type === "primary" ? "button-primary" : "button-secondary",
          "aria-label": link2 == null ? void 0 : link2.label,
          href: link2.href
        }
      );
    }
    if (link2.label) {
      return /* @__PURE__ */ jsx(
        TextLink,
        {
          ...link2,
          icon: void 0,
          size: "200",
          className: styles$9.link,
          variant: type === "primary" ? "button-primary" : "button-secondary",
          linkText: (link2 == null ? void 0 : link2.label) || "",
          title: (link2 == null ? void 0 : link2.label) || ""
        }
      );
    }
    return null;
  }
};
const MenuButton$1 = MenuButton;
const dropdown = "_dropdown_iwx09_1";
const hidden = "_hidden_iwx09_75";
const styles$8 = {
  dropdown,
  "dropdown-button": "_dropdown-button_iwx09_4",
  "dropdown-panel": "_dropdown-panel_iwx09_8",
  "dropdown-items": "_dropdown-items_iwx09_23",
  "dropdown-item": "_dropdown-item_iwx09_23",
  "dropdown-item-link": "_dropdown-item-link_iwx09_51",
  hidden
};
const DropDown = memo(({ type, label: label2, items }) => {
  const [showDropDownPanel, setShowDropDownPanel] = useState(false);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$8.dropdown,
      onBlur: (e) => {
        e.preventDefault();
        setShowDropDownPanel(false);
      },
      children: [
        /* @__PURE__ */ jsx(
          TextButton,
          {
            size: "200",
            className: styles$8["dropdown-button"],
            onClick: () => setShowDropDownPanel(!showDropDownPanel),
            variant: type,
            iconPosition: "right",
            iconName: "chevron-compact-down--small",
            "aria-label": label2,
            children: label2
          }
        ),
        /* @__PURE__ */ jsx("div", { className: classNames(styles$8["dropdown-panel"], { [styles$8["hidden"]]: !showDropDownPanel }), children: /* @__PURE__ */ jsx("ul", { className: styles$8["dropdown-items"], children: items.map((item2) => /* @__PURE__ */ jsx("li", { className: styles$8["dropdown-item"], children: /* @__PURE__ */ jsx(
          TextLink,
          {
            variant: "button-ghost",
            iconPosition: "right",
            icon: { name: "arrow-right--small" },
            ...item2,
            linkText: item2.label ?? "",
            className: styles$8["dropdown-item-link"]
          }
        ) })) }) })
      ]
    }
  );
});
const DropDown$1 = DropDown;
const baseClass$3 = "sub-menu";
const convertToPath = (url) => {
  if (!url)
    return "";
  const path = url.indexOf("?") ? url.split("?")[0] : url;
  return path[path.length - 1] === "/" ? path : `${path}/`;
};
const renderButton = ({
  type,
  items,
  link: link2,
  icon: icon2
}) => {
  if (items && typeof link2 === "string") {
    return /* @__PURE__ */ jsx(DropDown$1, { type, items, label: link2 });
  }
  if (typeof link2 !== "string") {
    return /* @__PURE__ */ jsx(MenuButton$1, { link: link2, icon: icon2, type });
  }
  return null;
};
const SubMenu = React__default.memo(
  ({
    navigation: navigation2,
    items,
    primaryLink: primaryLink2,
    primaryDropDownMenuOptions,
    activeKey,
    primaryLinkIcon,
    secondaryLink: secondaryLink2,
    secondaryDropDownMenuOptions,
    secondaryLinkIcon,
    hideOnMobile
  }) => {
    const isMobile = useIsMobile();
    const activePath = React__default.useMemo(() => convertToPath(activeKey), [activeKey]);
    const secondaryRef = useRef(null);
    useEffect(() => {
      if (secondaryRef.current) {
        const classToAdd = hideOnMobile ? styles$9["hide-on-mobile"] : styles$9["show-on-mobile"];
        const classToRemove = hideOnMobile ? styles$9["show-on-mobile"] : styles$9["hide-on-mobile"];
        secondaryRef.current.classList.remove(classToRemove);
        secondaryRef.current.classList.add(classToAdd);
      }
    }, [hideOnMobile]);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { "data-focus-lock-disabled": "false", className: styles$9[baseClass$3], children: [
        /* @__PURE__ */ jsxs("div", { className: styles$9[`${baseClass$3}-content`], children: [
          navigation2 && (typeof navigation2 !== "string" ? /* @__PURE__ */ jsx(
            TextLink,
            {
              ...navigation2,
              size: "200",
              icon: void 0,
              variant: "HYP-200",
              className: styles$9[`${baseClass$3}-navigation-text`],
              linkText: navigation2.label
            }
          ) : /* @__PURE__ */ jsx(Text, { variant: "P-100", tag: "span", className: styles$9[`${baseClass$3}-navigation-text`], children: navigation2 })),
          (items == null ? void 0 : items.length) && !isMobile && /* @__PURE__ */ jsx("div", { className: styles$9[`${baseClass$3}-items`], children: items.map((item2, index) => /* @__PURE__ */ jsx(
            "div",
            {
              role: "button",
              tabIndex: index,
              className: classNames(styles$9[`${baseClass$3}-item`], {
                [styles$9.active]: !!activePath && typeof item2 !== "string" && convertToPath((item2 == null ? void 0 : item2.href) || "") === activePath
              }),
              children: typeof item2 === "string" ? /* @__PURE__ */ jsx(Text, { variant: "P-100", tag: "span", className: styles$9.text, children: item2 }) : /* @__PURE__ */ jsx(
                TextLink,
                {
                  ...item2,
                  size: "200",
                  icon: void 0,
                  isExternal: false,
                  variant: "hyperlink-200",
                  className: styles$9.text,
                  linkText: item2.label
                }
              )
            },
            `sub-menu-item-${index}`
          )) })
        ] }),
        (primaryLink2 || secondaryLink2) && /* @__PURE__ */ jsxs("div", { className: styles$9[`${baseClass$3}-buttons-wrapper`], children: [
          secondaryLink2 && renderButton({
            type: "secondary",
            link: secondaryLink2,
            items: secondaryDropDownMenuOptions,
            icon: secondaryLinkIcon
          }),
          primaryLink2 && renderButton({
            type: "primary",
            link: primaryLink2,
            items: primaryDropDownMenuOptions,
            icon: primaryLinkIcon
          })
        ] })
      ] }),
      items && items.length && isMobile && /* @__PURE__ */ jsx("div", { ref: secondaryRef, className: classNames(styles$9["secondary-line"]), children: items.map((item2, index) => /* @__PURE__ */ jsx(
        "div",
        {
          role: "button",
          tabIndex: index,
          className: classNames(styles$9[`${baseClass$3}-item`], {
            [styles$9.active]: typeof item2 !== "string" && activeKey === item2.href
          }),
          children: typeof item2 === "string" ? /* @__PURE__ */ jsx(Text, { variant: "P-100", tag: "span", className: styles$9.text, children: item2 }) : /* @__PURE__ */ jsx(
            TextLink,
            {
              ...item2,
              icon: void 0,
              isExternal: false,
              variant: "hyperlink-200",
              className: styles$9.text,
              linkText: item2.label
            }
          )
        },
        `sub-menu-item-${index}`
      )) })
    ] });
  }
);
const isLinkNavigationItem = (props) => typeof (props == null ? void 0 : props.label) === "string" && typeof (props == null ? void 0 : props.href) === "string";
const colorMapping = {
  "premium #1": "#BCC9C4",
  "premium #3": "#AAC1CD",
  brabus: "#3A3C3F",
  pulse: "#799DC9",
  "pro+": "#DED774",
  "pro,pure+,pure": "#E4E8EB"
};
const Header = React__default.forwardRef(
  ({
    className,
    campaign: defaultCampaign,
    visibleMenuItems,
    heroTemplate,
    backgroundColor,
    navigationItems,
    navigationAriaLabel,
    logoLink: logoLink2,
    openMenuAriaLabel,
    closeMenuAriaLabel,
    languageSwitch,
    greetingText: greetingText2,
    myAccountLink,
    myShoppingLink,
    myGarageLink,
    myGarageBadge,
    bannerProps,
    myShoppingBadge,
    isLoggedIn,
    logoutLink,
    subMenuProps,
    showShoppingCartForAnonymous
  }, ref) => {
    const previewRef = useRef(null);
    const [flyoutIsOpen, setFlyoutIsOpen] = useState(false);
    const [tileIsOpen, setTileIsOpen] = useState(false);
    const [secondLevelIsOpen2, setSecondLevelIsOpen] = useState(false);
    const [previewImage2, setPreviewImage] = useState("");
    const [overviewByline2, setOverviewByline] = useState("");
    const [overviewPrice2, setOverviewPrice] = useState("");
    const [selectedLanguage, setSelectedLanguage] = useState((languageSwitch == null ? void 0 : languageSwitch.value) || "");
    const [languageSelectorActive, setLanguageSelectorActive] = useState(false);
    const [mobileLanguageSelectorActive, setMobileLanguageSelectorActive] = useState(false);
    const [openedSecondLevelIndex, setOpenedSecondLevelIndex] = useState(false);
    const [showMyAccountDropdown, setShowMyAccountDropdown] = useState(false);
    const removeHoverTimerRef = useRef(null);
    const [activeMenuItem, setActiveMenuItem] = useState({
      subItems: [
        {
          categoryLabel: "",
          menuItems: [
            {
              label: "",
              href: "#",
              isExternal: false,
              onClick: () => {
                alert("click");
              }
            }
          ]
        }
      ],
      previewImage: ""
    });
    const [isHovered2, setIsHovered] = useState(false);
    const [iconIsHovered, setIconIsHovered] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState((languageSwitch == null ? void 0 : languageSwitch.value) || "");
    const firstLevelListRef = useRef(null);
    const [firstLevelCampaign, setFirstLevelCampaign] = useState(void 0);
    const [hoveredCampagin, setHoveredCampaign] = useState(void 0);
    const isInCampaign = useRef(false);
    const shouldShowCart = isLoggedIn || showShoppingCartForAnonymous;
    const headerRef = useRef(null);
    const getTextBackgroundColor = (option, model) => {
      if (model === "offer" && option) {
        return colorMapping[option];
      } else if (model === "award") {
        return "#f2f2f2";
      }
      return;
    };
    const getBackgroundColor = useMemo(() => {
      if (heroTemplate) {
        if (heroTemplate === "award" || heroTemplate === "offer") {
          return { style: { backgroundColor } };
        }
        return { style: { background: "transparent" } };
      }
      return { style: { background: "var(--bg-level-1)" } };
    }, [heroTemplate, backgroundColor]);
    const classes2 = classNames(styles$a.header, className, {
      [styles$a.withoutNavigation]: !navigationItems || navigationItems.length === 0,
      [styles$a.open]: flyoutIsOpen,
      [styles$a.secondLevelIsOpen]: secondLevelIsOpen2,
      "dark-theme": heroTemplate === "offer" && backgroundColor === "#3A3C3F" || heroTemplate === "campaign"
    });
    const generateMenuButton = () => {
      if (flyoutIsOpen) {
        return {
          ariaLabel: closeMenuAriaLabel,
          iconClass: "close",
          onClick: () => {
            closeMenu();
          }
        };
      }
      return {
        ariaLabel: openMenuAriaLabel,
        iconClass: "burgerMenu",
        onClick: () => {
          setTileIsOpen(false);
          setFlyoutIsOpen(true);
          setIsHovered(false);
        }
      };
    };
    const closeMenu = React__default.useCallback(() => {
      setSecondLevelIsOpen(false);
      setFlyoutIsOpen(false);
      setTileIsOpen(false);
      setHoveredCampaign(void 0);
      setFirstLevelCampaign(void 0);
      setTimeout(() => {
        setPreviewImage("");
      }, 500);
    }, []);
    const onAccountClick = (e) => {
      if (isLoggedIn) {
        setShowMyAccountDropdown(true);
        e.preventDefault();
        e.stopPropagation();
      } else {
        if (myAccountLink == null ? void 0 : myAccountLink.onClick) {
          myAccountLink.onClick(e);
          e.preventDefault();
          e.stopPropagation();
        }
      }
    };
    const setHoveredCampaignDelay = (campaign2) => {
      if (previewRef.current && campaign2) {
        if (removeHoverTimerRef.current) {
          clearTimeout(removeHoverTimerRef.current);
        }
        if (!isInCampaign.current) {
          setHoveredCampaign(campaign2);
        }
      }
    };
    const removeHoverdCampaignDelay = () => {
      if (previewRef.current && getCurrentImageType() === "hoveredCampagin") {
        if (removeHoverTimerRef.current) {
          clearTimeout(removeHoverTimerRef.current);
        }
        removeHoverTimerRef.current = setTimeout(() => {
          if (!isInCampaign.current) {
            setHoveredCampaign(void 0);
          }
        }, 500);
      }
    };
    const generateCampagin = (currentCampaign) => {
      var _a, _b, _c, _d, _e;
      if (!currentCampaign) {
        return null;
      }
      return /* @__PURE__ */ jsxs(
        "a",
        {
          className: classNames("campaign", styles$a.campaignSpot, {
            [styles$a.cursorPointer]: (_a = currentCampaign.link) == null ? void 0 : _a.href
          }),
          href: (_b = currentCampaign.link) == null ? void 0 : _b.href,
          onClick: (_c = currentCampaign.link) == null ? void 0 : _c.onClick,
          onMouseEnter: () => {
            isInCampaign.current = true;
          },
          onMouseLeave: () => {
            isInCampaign.current = false;
            removeHoverdCampaignDelay();
          },
          style: { background: getTextBackgroundColor(currentCampaign.backgroundColorOption, currentCampaign.variant) },
          children: [
            /* @__PURE__ */ jsx("div", { className: styles$a.campaignMediaWrapper, children: /* @__PURE__ */ jsx(
              DynamicMediaPicture,
              {
                imageAltText: "alt text",
                hasImageTransparency: true,
                imageUrl: currentCampaign.media,
                imageConfigs: imageConfigSingleCard,
                isObjectFit: true
              }
            ) }),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(styles$a.campaignText, {
                  [styles$a.awardText]: currentCampaign.variant === "award",
                  [styles$a.offerText]: currentCampaign.variant === "offer"
                }),
                style: {
                  background: getTextBackgroundColor(currentCampaign.backgroundColorOption, currentCampaign.variant)
                },
                children: [
                  /* @__PURE__ */ jsxs("div", { children: [
                    currentCampaign.variant === "award" && /* @__PURE__ */ jsx(Fragment, { children: currentCampaign.logo && /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(
                      LogoContainer,
                      {
                        className: styles$a.logos,
                        url: currentCampaign.logo.url,
                        size: currentCampaign.logo.size,
                        link: currentCampaign.logo.link
                      }
                    ) }) }),
                    currentCampaign.fromLabel && /* @__PURE__ */ jsx(
                      "p",
                      {
                        className: classNames(styles$a.campaignSubline, {
                          [styles$a.offerSubline]: currentCampaign.variant === "offer",
                          [styles$a.awardSubline]: currentCampaign.variant === "award",
                          [styles$a.offerBrabusSubline]: currentCampaign.backgroundColorOption === "brabus"
                        }),
                        children: currentCampaign.fromLabel
                      }
                    ),
                    currentCampaign.price && /* @__PURE__ */ jsx(
                      "p",
                      {
                        className: classNames(styles$a.campaignTitle, {
                          [styles$a.offerTitle]: currentCampaign.variant === "offer",
                          [styles$a.awardTitle]: currentCampaign.variant === "award",
                          [styles$a.offerBrabusTitle]: currentCampaign.backgroundColorOption === "brabus"
                        }),
                        children: currentCampaign.price
                      }
                    ),
                    currentCampaign.headline && /* @__PURE__ */ jsx(
                      "p",
                      {
                        className: classNames(styles$a.campaignHeadline, {
                          [styles$a.campaignHeadline]: currentCampaign.variant === "campaign",
                          [styles$a.awardHeadline]: currentCampaign.variant === "award",
                          [styles$a.offersubtitle]: currentCampaign.variant === "offer",
                          [styles$a.subtitle]: currentCampaign.variant !== "offer" && currentCampaign.variant === "campaign",
                          [styles$a.offerBrabusSubtitle]: currentCampaign.backgroundColorOption === "brabus" && currentCampaign.variant !== "award"
                        }),
                        children: currentCampaign.headline
                      }
                    ),
                    currentCampaign.description && /* @__PURE__ */ jsx(
                      "p",
                      {
                        className: classNames(styles$a.paragraph, {
                          [styles$a.paragraph]: currentCampaign.variant === "campaign",
                          [styles$a.awardParagraph]: currentCampaign.variant === "award",
                          [styles$a.offerBrabusParagraph]: currentCampaign.backgroundColorOption === "brabus" && currentCampaign.variant === "offer",
                          [styles$a.offerparagraph]: currentCampaign.variant === "offer"
                        }),
                        children: currentCampaign.description
                      }
                    )
                  ] }),
                  ((_d = currentCampaign == null ? void 0 : currentCampaign.link) == null ? void 0 : _d.label) && /* @__PURE__ */ jsx(
                    Button,
                    {
                      className: classNames(styles$a.cta, {
                        [styles$a.awardcta]: currentCampaign.variant === "award",
                        [styles$a.offercta]: currentCampaign.variant === "offer",
                        [styles$a.cta]: currentCampaign.variant === "campaign",
                        [styles$a.offerBrabuscta]: currentCampaign.backgroundColorOption === "brabus" && currentCampaign.variant === "offer"
                      }),
                      variant: "primary",
                      size: "200",
                      onClick: () => {
                        var _a2;
                        return (_a2 = currentCampaign.link) == null ? void 0 : _a2.onClick;
                      },
                      children: (_e = currentCampaign == null ? void 0 : currentCampaign.link) == null ? void 0 : _e.label
                    }
                  )
                ]
              }
            )
          ]
        }
      );
    };
    const generateModalImageOrCampagin = () => /* @__PURE__ */ jsxs(Fragment, { children: [
      hoveredCampagin && generateCampagin(hoveredCampagin),
      !hoveredCampagin && previewImage2 && /* @__PURE__ */ jsx(
        DynamicMediaPicture,
        {
          className: styles$a.secondLevelPreviewImage,
          imageAltText: "alt text",
          hasImageTransparency: true,
          imageUrl: previewImage2,
          imageConfigs: imageConfigSingleCard,
          isObjectFit: true
        }
      ),
      !hoveredCampagin && !previewImage2 && (firstLevelCampaign || defaultCampaign) && generateCampagin(firstLevelCampaign || defaultCampaign)
    ] });
    const getCurrentImageType = () => {
      if (hoveredCampagin) {
        return "hoveredCampagin";
      }
      if (previewImage2) {
        return "previewImage";
      }
      if (firstLevelCampaign || defaultCampaign) {
        return "campagin";
      }
      return null;
    };
    const menuButton2 = generateMenuButton();
    useImperativeHandle(
      ref,
      () => ({
        closeMenu,
        move: (isUp) => {
          if (headerRef.current) {
            const classList = headerRef.current.classList;
            const action = isUp ? "add" : "remove";
            const classStyleName = styles$a.menuIsHide;
            classList[action](classStyleName);
          }
        }
      }),
      [closeMenu]
    );
    useScrollTop(firstLevelListRef, flyoutIsOpen);
    return /* @__PURE__ */ jsxs(
      "header",
      {
        className: classes2,
        ...getBackgroundColor,
        ref: headerRef,
        "aria-label": navigationAriaLabel,
        "data-nosnippet": "true",
        "data-testid": "header-component",
        children: [
          /* @__PURE__ */ jsx(Banner, { ...bannerProps, showBanner: !!(bannerProps == null ? void 0 : bannerProps.showBanner) }),
          heroTemplate === "campaign" && /* @__PURE__ */ jsx("div", { className: classNames(styles$a["header-mask"], { [styles$a.hasBannerMargin]: !!(bannerProps == null ? void 0 : bannerProps.showBanner) }) }),
          /* @__PURE__ */ jsx(FocusOn, { enabled: flyoutIsOpen, onEscapeKey: closeMenu, onClickOutside: closeMenu, children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames(styles$a.inner, {
                [styles$a.visibledropdownshow]: !flyoutIsOpen && tileIsOpen
              }),
              children: [
                navigationItems && navigationItems.length !== 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      "aria-label": menuButton2.ariaLabel,
                      onClick: menuButton2.onClick,
                      "aria-expanded": flyoutIsOpen,
                      "aria-controls": "smart-header-id",
                      className: classNames(styles$a.menuButton),
                      children: /* @__PURE__ */ jsx(Icon, { className: styles$a.burgerMenu, name: "burger-menu--small" })
                    }
                  ),
                  /* @__PURE__ */ jsxs("nav", { className: classNames(styles$a.flyout), id: "smart-header-id", "aria-hidden": !flyoutIsOpen, children: [
                    /* @__PURE__ */ jsxs("div", { className: classNames(styles$a.mobileFirstPage), children: [
                      /* @__PURE__ */ jsxs("ul", { "aria-label": "side-navigation", className: classNames(styles$a.list), ref: firstLevelListRef, children: [
                        /* @__PURE__ */ jsx("div", { className: styles$a.buttonWrapper, children: /* @__PURE__ */ jsx(
                          "button",
                          {
                            "aria-label": menuButton2.ariaLabel,
                            onClick: menuButton2.onClick,
                            "aria-expanded": flyoutIsOpen,
                            "aria-controls": "smart-header-id",
                            className: classNames(styles$a.menuButton, styles$a.firstMenuButton),
                            children: /* @__PURE__ */ jsx(Icon, { className: styles$a.close, name: "close-without-circle--small" })
                          }
                        ) }),
                        navigationItems.map((item2, index) => /* @__PURE__ */ jsxs("div", { children: [
                          /* @__PURE__ */ jsx(
                            "div",
                            {
                              className: classNames(styles$a.navCategory, {
                                [styles$a.isLogoutButton]: !isLoggedIn && item2.isLogoutButton,
                                [styles$a.isHighlightedCategory]: item2.isHighlightedLinks,
                                [styles$a.isHovered]: isHovered2,
                                [styles$a.mt76]: index === 0
                              }),
                              children: /* @__PURE__ */ jsx("span", { children: item2 == null ? void 0 : item2.categoryLabel })
                            }
                          ),
                          /* @__PURE__ */ jsx("div", { className: styles$a.itemWrapper, children: item2.menuItems.map((menuItem, menuIndex) => {
                            if (isLinkNavigationItem(menuItem)) {
                              return (
                                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                                /* @__PURE__ */ jsxs(
                                  "div",
                                  {
                                    role: "button",
                                    tabIndex: index + menuIndex,
                                    className: classNames(
                                      {
                                        [styles$a.isHovered]: isHovered2
                                      },
                                      styles$a.item,
                                      styles$a.linkItem,
                                      styles$a.menuItemHover
                                    ),
                                    onClick: () => {
                                      setSecondLevelIsOpen(false);
                                      setFirstLevelCampaign(void 0);
                                    },
                                    onMouseEnter: () => {
                                      setIsHovered(true);
                                      setHoveredCampaignDelay(menuItem.campaign);
                                    },
                                    onMouseLeave: () => {
                                      !secondLevelIsOpen2 && setIsHovered(false);
                                      removeHoverdCampaignDelay();
                                    },
                                    children: [
                                      /* @__PURE__ */ jsx(
                                        TextLink,
                                        {
                                          ...menuItem,
                                          variant: "hyperlink-100",
                                          className: classNames(styles$a.link, {
                                            [styles$a.isExternal]: menuItem.isExternal,
                                            [styles$a.isHighlightedLink]: item2.isHighlightedLinks
                                          }),
                                          linkText: menuItem.label
                                        }
                                      ),
                                      menuItem.contentTag && /* @__PURE__ */ jsx(Tag, { className: styles$a.contentTag, variant: menuItem.contentTag.variant, children: menuItem.contentTag.label })
                                    ]
                                  },
                                  menuItem.label + index + menuIndex
                                )
                              );
                            }
                            return (
                              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                              /* @__PURE__ */ jsx(
                                "div",
                                {
                                  role: "button",
                                  tabIndex: index + menuIndex,
                                  className: classNames(styles$a.item, styles$a.menuItemHover, {
                                    [styles$a.isHovered]: isHovered2,
                                    [styles$a.currentItem]: secondLevelIsOpen2 && openedSecondLevelIndex === parseInt(index + "" + menuIndex)
                                  }),
                                  onClick: () => {
                                    setSecondLevelIsOpen(true);
                                    setOpenedSecondLevelIndex(parseInt(index + "" + menuIndex));
                                    setActiveMenuItem({
                                      subItems: menuItem.subItems,
                                      previewImage: menuItem.imageUrl || "",
                                      firstLevelCampaign: menuItem.campaign
                                    });
                                    setOverviewByline(menuItem.byline);
                                    setOverviewPrice(menuItem.price || "");
                                    setFirstLevelCampaign(menuItem.campaign);
                                    setPreviewImage(menuItem.imageUrl || "");
                                  },
                                  onMouseEnter: () => {
                                    setIsHovered(true);
                                    setHoveredCampaignDelay(menuItem.campaign);
                                  },
                                  onMouseLeave: () => {
                                    !secondLevelIsOpen2 && setIsHovered(false);
                                    removeHoverdCampaignDelay();
                                  },
                                  children: /* @__PURE__ */ jsxs(
                                    "button",
                                    {
                                      className: classNames(styles$a.navItemButton, {
                                        [styles$a.isActive]: secondLevelIsOpen2
                                      }),
                                      children: [
                                        /* @__PURE__ */ jsx("span", { children: menuItem.label }),
                                        menuItem.contentTag && /* @__PURE__ */ jsx(Tag, { className: styles$a.contentTag, variant: menuItem.contentTag.variant, children: menuItem.contentTag.label }),
                                        /* @__PURE__ */ jsx(Icon, { className: styles$a.compactIcon, name: "chevron-compact-right--small" })
                                      ]
                                    }
                                  )
                                },
                                menuItem.label + index + menuIndex
                              )
                            );
                          }) })
                        ] }, index))
                      ] }),
                      navigationItems.flatMap(
                        (item2) => {
                          var _a;
                          return (_a = item2.menuItems) == null ? void 0 : _a.flatMap((menuItem) => {
                            if (menuItem.subItems) {
                              return {
                                subItems: menuItem.subItems,
                                previewImage: menuItem.imageUrl || "",
                                firstLevelCampaign: menuItem.campaign
                              };
                            }
                            return [];
                          });
                        }
                      ).map((item2, index) => /* @__PURE__ */ jsx(
                        "div",
                        {
                          style: {
                            display: JSON.stringify(item2) === JSON.stringify(activeMenuItem) ? "block" : "none"
                          },
                          children: !isNaN(Number(openedSecondLevelIndex)) ? /* @__PURE__ */ jsx(
                            SecondLevel,
                            {
                              isOpen: secondLevelIsOpen2,
                              overviewByline: overviewByline2,
                              overviewPrice: overviewPrice2,
                              items: item2,
                              setHoveredCampaign: setHoveredCampaignDelay,
                              removeHoveredCampaign: removeHoverdCampaignDelay,
                              setPrevImage: (e) => {
                                setPreviewImage(e);
                              }
                            },
                            "mobileFirstPage" + index || null
                          ) : null
                        },
                        index
                      )),
                      languageSwitch && languageSwitch.options.length > 1 && /* @__PURE__ */ jsx("div", { className: styles$a.languageWrapper, children: /* @__PURE__ */ jsx("div", { className: classNames(styles$a.languageSelector, styles$a.mobileSelector), children: /* @__PURE__ */ jsxs(
                        FocusOn,
                        {
                          scrollLock: false,
                          enabled: mobileLanguageSelectorActive,
                          onEscapeKey: () => {
                            setMobileLanguageSelectorActive(false);
                          },
                          onClickOutside: () => {
                            setMobileLanguageSelectorActive(false);
                          },
                          children: [
                            /* @__PURE__ */ jsxs(
                              "button",
                              {
                                className: styles$a["languageSelector__select"],
                                "aria-label": languageSwitch.label,
                                onClick: () => {
                                  setMobileLanguageSelectorActive(true);
                                },
                                children: [
                                  selectedLanguage,
                                  /* @__PURE__ */ jsx(
                                    Icon,
                                    {
                                      name: "chevron-down--small",
                                      "aria-hidden": true,
                                      className: styles$a["languageSelector__icon"]
                                    }
                                  )
                                ]
                              }
                            ),
                            /* @__PURE__ */ jsxs(
                              "ul",
                              {
                                className: classNames(styles$a.languageSelector__option, {
                                  [styles$a.optionsHide]: !mobileLanguageSelectorActive
                                }),
                                children: [
                                  /* @__PURE__ */ jsxs("div", { children: [
                                    /* @__PURE__ */ jsx(
                                      Icon,
                                      {
                                        name: "successful-checkmark--small",
                                        className: classNames(styles$a.iconPR8, { [styles$a.selected]: false })
                                      }
                                    ),
                                    /* @__PURE__ */ jsx("span", { children: "Select a language" })
                                  ] }),
                                  languageSwitch.options.map((option, i) => /* @__PURE__ */ jsxs(
                                    "div",
                                    {
                                      role: "button",
                                      tabIndex: i,
                                      onClick: () => {
                                        setMobileLanguageSelectorActive(false);
                                        setSelectedLanguage(option.value);
                                        setSelectedIndex(option.value);
                                        languageSwitch.onChange(option.value);
                                      },
                                      onKeyDown: () => {
                                        setSelectedLanguage(option.value);
                                        setMobileLanguageSelectorActive(!mobileLanguageSelectorActive);
                                        languageSwitch.onChange(option.value);
                                      },
                                      children: [
                                        /* @__PURE__ */ jsx(
                                          Icon,
                                          {
                                            name: "successful-checkmark--small",
                                            className: classNames(styles$a.iconPR8, {
                                              [styles$a.selected]: selectedIndex === option.value
                                            })
                                          }
                                        ),
                                        /* @__PURE__ */ jsx("span", { children: option.value.toLocaleUpperCase() + " - " + option.label })
                                      ]
                                    },
                                    option.value + i
                                  ))
                                ]
                              }
                            )
                          ]
                        }
                      ) }) }),
                      /* @__PURE__ */ jsx("div", { ref: previewRef, className: styles$a.previewImage, children: generateModalImageOrCampagin() })
                    ] }),
                    /* @__PURE__ */ jsxs("div", { className: classNames(styles$a.mobileSecondPage), children: [
                      navigationItems.flatMap(
                        (item2) => {
                          var _a;
                          return (_a = item2.menuItems) == null ? void 0 : _a.flatMap((menuItem) => {
                            if (menuItem.subItems) {
                              return {
                                subItems: menuItem.subItems,
                                previewImage: menuItem.imageUrl || "",
                                firstLevelCampaign: menuItem.campaign
                              };
                            }
                            return [];
                          });
                        }
                      ).map((item2, index) => /* @__PURE__ */ jsx(
                        "div",
                        {
                          style: {
                            display: JSON.stringify(item2) === JSON.stringify(activeMenuItem) ? "block" : "none"
                          },
                          children: !isNaN(Number(openedSecondLevelIndex)) ? /* @__PURE__ */ jsx(
                            SecondLevel,
                            {
                              isOpen: secondLevelIsOpen2,
                              overviewByline: overviewByline2,
                              overviewPrice: overviewPrice2,
                              items: item2,
                              setHoveredCampaign: setHoveredCampaignDelay,
                              removeHoveredCampaign: removeHoverdCampaignDelay,
                              setPrevImage: (e) => {
                                setPreviewImage(e);
                              },
                              children: /* @__PURE__ */ jsxs("div", { className: styles$a.buttonWrapper, children: [
                                /* @__PURE__ */ jsx(
                                  "button",
                                  {
                                    className: classNames(styles$a.backIcon, {
                                      [styles$a.mobileBackIcon]: secondLevelIsOpen2
                                    }),
                                    onClick: () => {
                                      setSecondLevelIsOpen(false);
                                      setTimeout(() => {
                                        setPreviewImage("");
                                      }, 500);
                                    },
                                    children: /* @__PURE__ */ jsx(Icon, { name: "arrow-left--small" })
                                  }
                                ),
                                /* @__PURE__ */ jsx(
                                  "button",
                                  {
                                    "aria-label": menuButton2.ariaLabel,
                                    onClick: menuButton2.onClick,
                                    "aria-expanded": flyoutIsOpen,
                                    "aria-controls": "smart-header-id",
                                    className: classNames(styles$a.menuButton, styles$a.close, styles$a.secondMenuButton)
                                  }
                                )
                              ] })
                            },
                            "mobileSecondPage" + openedSecondLevelIndex || null
                          ) : null
                        },
                        index
                      )),
                      /* @__PURE__ */ jsx("div", { className: styles$a.previewImage, children: generateModalImageOrCampagin() })
                    ] })
                  ] })
                ] }),
                visibleMenuItems && visibleMenuItems.length !== 0 && /* @__PURE__ */ jsx("ul", { "aria-label": "top-navigation", className: classNames(styles$a.visibleList, {}), children: visibleMenuItems.map((item2, index) => {
                  if (isLinkNavigationItem(item2)) {
                    return /* @__PURE__ */ jsx(
                      "li",
                      {
                        className: classNames(styles$a.mr32),
                        onMouseEnter: () => {
                          setIsHovered(true);
                          setTileIsOpen(false);
                        },
                        onMouseLeave: () => {
                          setIsHovered(false);
                        },
                        children: /* @__PURE__ */ jsx(
                          TextLink,
                          {
                            ...item2,
                            variant: "hyperlink-100",
                            className: classNames(styles$a.visibleLinkItem, {
                              [styles$a.isExternal]: item2.isExternal,
                              [styles$a.isHovered]: isHovered2
                            }),
                            linkText: item2.label
                          }
                        )
                      },
                      item2.label + index
                    );
                  }
                  return /* @__PURE__ */ jsxs(
                    "li",
                    {
                      className: styles$a.mr32,
                      onMouseEnter: () => {
                        setIsHovered(true);
                      },
                      onMouseLeave: () => {
                        setIsHovered(false);
                      },
                      children: [
                        /* @__PURE__ */ jsxs(
                          "button",
                          {
                            onMouseEnter: () => {
                              setTileIsOpen(true);
                            },
                            "aria-expanded": tileIsOpen,
                            "aria-controls": "smart-visible-id",
                            className: classNames(styles$a.visibleButton, { [styles$a.isHovered]: isHovered2 }),
                            children: [
                              item2.label,
                              /* @__PURE__ */ jsx(
                                Icon,
                                {
                                  className: classNames(styles$a.visibleButtonIcon, { [styles$a.rotateIcon]: tileIsOpen }),
                                  name: "chevron-down--small"
                                }
                              )
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          "ul",
                          {
                            className: classNames(styles$a.visibleDropdownList, {
                              [styles$a.visibleDropdownShow]: !flyoutIsOpen && tileIsOpen,
                              [styles$a.flex]: item2.tiles[0].tileType === "carTile",
                              [styles$a.multiRow]: item2.tiles.length > 3
                            }),
                            "aria-hidden": !tileIsOpen,
                            "aria-label": "top-navigation-models",
                            id: "smart-visible-id",
                            onMouseLeave: () => {
                              setTileIsOpen(false);
                            },
                            children: item2.tiles[0].tileType === "contentTile" && item2.tiles.length > 3 ? item2.tiles.map((subItem, subIndex) => /* @__PURE__ */ jsx(
                              "li",
                              {
                                className: classNames(
                                  styles$a[`visibleTile${item2.tiles.length}`],
                                  styles$a[`tileAnimation${subIndex}`],
                                  { [styles$a.contentTileWrapper]: subItem.tileType === "contentTile" }
                                ),
                                children: subItem.tileType === "contentTile" ? /* @__PURE__ */ jsx(ContentTile, { item: subItem, index: subIndex, tileAmount: item2.tiles.length }) : /* @__PURE__ */ jsx(CarTile, { item: subItem, index: subIndex, tileAmount: item2.tiles.length })
                              },
                              subItem.tileType + subIndex
                            )) : item2.tiles.map(
                              (subItem, subIndex) => subItem.tileType === "carTile" ? /* @__PURE__ */ jsxs(
                                "li",
                                {
                                  className: classNames(styles$a.carTile, styles$a[`tileAnimation${subIndex}`]),
                                  children: [
                                    /* @__PURE__ */ jsx(CarTile, { item: subItem, index: subIndex, tileAmount: item2.tiles.length }),
                                    /* @__PURE__ */ jsx("div", { className: styles$a.mask })
                                  ]
                                },
                                subItem.tileType + subIndex
                              ) : null
                            )
                          }
                        )
                      ]
                    },
                    item2.label + index
                  );
                }) }),
                /* @__PURE__ */ jsx(
                  "a",
                  {
                    "aria-label": logoLink2.label,
                    className: classNames(styles$a.logoLink, {
                      [styles$a["dark-theme"]]: heroTemplate === "offer" && backgroundColor === "#3A3C3F" || heroTemplate === "campaign"
                    }),
                    href: logoLink2.href,
                    rel: logoLink2.rel,
                    target: logoLink2.target,
                    onClick: logoLink2.onClick
                  }
                ),
                (myAccountLink || myGarageLink || myShoppingLink) && /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: classNames(styles$a.wishlistAccountContainer, {
                      [styles$a.isHovered]: !flyoutIsOpen && tileIsOpen
                    }),
                    children: [
                      languageSwitch && languageSwitch.options.length > 1 && /* @__PURE__ */ jsxs(
                        "div",
                        {
                          className: classNames(styles$a.languageSelector, {
                            [styles$a.optionListShow]: languageSelectorActive
                          }),
                          children: [
                            /* @__PURE__ */ jsxs(
                              "button",
                              {
                                className: styles$a["languageSelector__select"],
                                "aria-label": languageSwitch.label,
                                onClick: () => {
                                  setLanguageSelectorActive(!languageSelectorActive);
                                },
                                children: [
                                  selectedLanguage,
                                  /* @__PURE__ */ jsx(Icon, { name: "chevron-down--small", "aria-hidden": true, className: styles$a["languageSelector__icon"] })
                                ]
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              FocusOn,
                              {
                                scrollLock: false,
                                enabled: languageSelectorActive,
                                onEscapeKey: () => {
                                  setLanguageSelectorActive(false);
                                },
                                onClickOutside: () => {
                                  setLanguageSelectorActive(false);
                                },
                                children: /* @__PURE__ */ jsxs(
                                  "ul",
                                  {
                                    "aria-label": "top-navigation-language",
                                    className: classNames(styles$a.languageSelector__option, {
                                      [styles$a.pointerEvents]: languageSelectorActive
                                    }),
                                    children: [
                                      /* @__PURE__ */ jsxs("div", { children: [
                                        /* @__PURE__ */ jsx(
                                          Icon,
                                          {
                                            name: "successful-checkmark--small",
                                            className: classNames(styles$a.iconPR8, { [styles$a.selected]: false })
                                          }
                                        ),
                                        /* @__PURE__ */ jsx("span", { children: "Select a language" })
                                      ] }),
                                      languageSwitch.options.map((option, i) => /* @__PURE__ */ jsxs(
                                        "div",
                                        {
                                          role: "button",
                                          tabIndex: i,
                                          onClick: () => {
                                            setSelectedLanguage(option.value);
                                            setLanguageSelectorActive(!languageSelectorActive);
                                            setSelectedIndex(option.value);
                                            languageSwitch.onChange(option.value);
                                          },
                                          onKeyDown: () => {
                                            setSelectedLanguage(option.value);
                                            languageSwitch.onChange(option.value);
                                            setLanguageSelectorActive(!languageSelectorActive);
                                          },
                                          className: classNames({
                                            [styles$a.pointerEvents]: languageSelectorActive
                                          }),
                                          children: [
                                            /* @__PURE__ */ jsx(
                                              Icon,
                                              {
                                                name: "successful-checkmark--small",
                                                className: classNames(styles$a.iconPR8, {
                                                  [styles$a.selected]: selectedIndex === option.value
                                                })
                                              }
                                            ),
                                            /* @__PURE__ */ jsx("span", { children: option.value.toLocaleUpperCase() + " - " + option.label })
                                          ]
                                        },
                                        option.value + i
                                      ))
                                    ]
                                  }
                                )
                              }
                            ),
                            /* @__PURE__ */ jsx(Icon, { name: "chevron-down--small", "aria-hidden": true, className: styles$a["languageSelector__icon"] })
                          ]
                        }
                      ),
                      myAccountLink && /* @__PURE__ */ jsxs(
                        "div",
                        {
                          className: classNames(styles$a.iconContainer, { [styles$a.isHovered]: iconIsHovered }),
                          onMouseEnter: () => {
                            setIconIsHovered(true);
                          },
                          onMouseLeave: () => {
                            setIconIsHovered(false);
                          },
                          children: [
                            isLoggedIn && /* @__PURE__ */ jsx("div", { className: styles$a.greetingText, children: greetingText2 }),
                            /* @__PURE__ */ jsx(
                              "a",
                              {
                                className: styles$a.accountLink,
                                href: myAccountLink.href,
                                "aria-label": myAccountLink.label,
                                onClick: onAccountClick,
                                target: myAccountLink.target,
                                rel: myAccountLink.rel,
                                children: isLoggedIn ? /* @__PURE__ */ jsxs("div", { className: styles$a["icon-wrapper"], children: [
                                  /* @__PURE__ */ jsx(Icon, { name: "account-logged-in--medium", className: styles$a.mediumIcon }),
                                  /* @__PURE__ */ jsx(Icon, { name: "account-logged-in--small", className: styles$a.smallIcon }),
                                  showMyAccountDropdown && /* @__PURE__ */ jsx(
                                    FocusOn,
                                    {
                                      onClickOutside: () => {
                                        setShowMyAccountDropdown(false);
                                      },
                                      children: /* @__PURE__ */ jsxs(
                                        "ul",
                                        {
                                          "aria-label": "top-navigation-my-account",
                                          className: classNames(styles$a["profile-dropdown"]),
                                          children: [
                                            /* @__PURE__ */ jsx(
                                              "a",
                                              {
                                                ...myAccountLink,
                                                role: "button",
                                                tabIndex: 0,
                                                onClick: (e) => {
                                                  if (myAccountLink == null ? void 0 : myAccountLink.onClick) {
                                                    setTimeout(() => {
                                                      setShowMyAccountDropdown(false);
                                                    }, 0);
                                                    myAccountLink.onClick(e);
                                                  }
                                                },
                                                children: myAccountLink == null ? void 0 : myAccountLink.label
                                              }
                                            ),
                                            /* @__PURE__ */ jsx(
                                              "a",
                                              {
                                                ...logoutLink,
                                                role: "button",
                                                tabIndex: 0,
                                                onClick: (e) => {
                                                  if (logoutLink == null ? void 0 : logoutLink.onClick) {
                                                    logoutLink.onClick(e);
                                                  }
                                                },
                                                onKeyDown: (e) => {
                                                  if (logoutLink == null ? void 0 : logoutLink.onClick) {
                                                    logoutLink.onClick(e);
                                                  }
                                                },
                                                children: logoutLink == null ? void 0 : logoutLink.label
                                              }
                                            )
                                          ]
                                        }
                                      )
                                    }
                                  )
                                ] }) : /* @__PURE__ */ jsxs("div", { className: styles$a["icon-wrapper"], children: [
                                  /* @__PURE__ */ jsx(Icon, { name: "account--medium", className: styles$a.mediumIcon }),
                                  /* @__PURE__ */ jsx(Icon, { name: "account--small", className: styles$a.smallIcon })
                                ] })
                              }
                            )
                          ]
                        }
                      ),
                      myGarageLink && isLoggedIn && /* @__PURE__ */ jsxs(
                        "div",
                        {
                          className: classNames(styles$a.iconContainer, { [styles$a.isHovered]: iconIsHovered }),
                          onMouseEnter: () => {
                            setIconIsHovered(true);
                          },
                          onMouseLeave: () => {
                            setIconIsHovered(false);
                          },
                          children: [
                            /* @__PURE__ */ jsxs(
                              "a",
                              {
                                className: styles$a.wishlistCarSelect,
                                href: myGarageLink.href,
                                "aria-label": myGarageLink.label,
                                onClick: myGarageLink.onClick,
                                target: myGarageLink.target,
                                rel: myGarageLink.rel,
                                children: [
                                  /* @__PURE__ */ jsx(Icon, { name: "save-favourite--medium", className: styles$a.mediumIcon }),
                                  /* @__PURE__ */ jsx(Icon, { name: "save-favourite--small", className: styles$a.smallIcon })
                                ]
                              }
                            ),
                            !!myGarageBadge && /* @__PURE__ */ jsx(
                              NotificationBadge,
                              {
                                variant: "200",
                                className: classNames(styles$a.badge, styles$a.wishlistBadge),
                                value: myGarageBadge
                              }
                            )
                          ]
                        }
                      ),
                      myShoppingLink && shouldShowCart && /* @__PURE__ */ jsxs(
                        "div",
                        {
                          className: classNames(styles$a.iconContainer, { [styles$a.isHovered]: iconIsHovered }),
                          onMouseEnter: () => {
                            setIconIsHovered(true);
                          },
                          onMouseLeave: () => {
                            setIconIsHovered(false);
                          },
                          children: [
                            /* @__PURE__ */ jsxs(
                              "a",
                              {
                                className: styles$a.shoppingLink,
                                href: myShoppingLink.href,
                                "aria-label": myShoppingLink.label,
                                onClick: myShoppingLink.onClick,
                                target: myShoppingLink.target,
                                rel: myShoppingLink.rel,
                                children: [
                                  /* @__PURE__ */ jsx(Icon, { name: "account-shop--medium", className: styles$a.mediumIcon }),
                                  /* @__PURE__ */ jsx(Icon, { name: "account-shop--small", className: styles$a.smallIcon })
                                ]
                              }
                            ),
                            !!myShoppingBadge && /* @__PURE__ */ jsx(
                              NotificationBadge,
                              {
                                variant: "200",
                                className: classNames(styles$a.badge, styles$a.shoppingBadge),
                                value: myShoppingBadge
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                )
              ]
            }
          ) }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(styles$a.layer, {
                [styles$a.open]: flyoutIsOpen || tileIsOpen
              }),
              onMouseEnter: () => {
                setIsHovered(false);
              }
            }
          ),
          subMenuProps && !flyoutIsOpen && /* @__PURE__ */ jsx(
            SubMenu,
            {
              navigation: subMenuProps == null ? void 0 : subMenuProps.navigation,
              items: subMenuProps == null ? void 0 : subMenuProps.items,
              primaryLink: subMenuProps == null ? void 0 : subMenuProps.primaryLink,
              primaryLinkIcon: subMenuProps.primaryLinkIcon,
              primaryDropDownMenuOptions: subMenuProps == null ? void 0 : subMenuProps.primaryDropDownMenuOptions,
              secondaryLink: subMenuProps == null ? void 0 : subMenuProps.secondaryLink,
              secondaryLinkIcon: subMenuProps.secondaryLinkIcon,
              secondaryDropDownMenuOptions: subMenuProps == null ? void 0 : subMenuProps.secondaryDropDownMenuOptions,
              activeKey: subMenuProps == null ? void 0 : subMenuProps.activeKey,
              hideOnMobile: subMenuProps == null ? void 0 : subMenuProps.hideOnMobile
            }
          )
        ]
      }
    );
  }
);
const linkWrapper = "_linkWrapper_1t15v_191";
const link$1 = "_link_1t15v_191";
const styles$7 = {
  "car-slide--wrapper": "_car-slide--wrapper_1t15v_1",
  "car-slide": "_car-slide_1t15v_1",
  "car-slide--noTopSpacing": "_car-slide--noTopSpacing_1t15v_23",
  "car-slide__images": "_car-slide__images_1t15v_26",
  "car-slide__shade": "_car-slide__shade_1t15v_36",
  "car-slide__slideMask": "_car-slide__slideMask_1t15v_49",
  "car-slide__slideMask--left": "_car-slide__slideMask--left_1t15v_63",
  "car-slide__slideMask--brabus-left": "_car-slide__slideMask--brabus-left_1t15v_67",
  "car-slide__slideMask--right": "_car-slide__slideMask--right_1t15v_71",
  "car-slide__slideMask--brabus-right": "_car-slide__slideMask--brabus-right_1t15v_75",
  "car-slide__contentWrapper": "_car-slide__contentWrapper_1t15v_80",
  "car-slide__content": "_car-slide__content_1t15v_80",
  "car-slide__title": "_car-slide__title_1t15v_111",
  "car-slide__subTitle": "_car-slide__subTitle_1t15v_125",
  "car-slide__price": "_car-slide__price_1t15v_139",
  "car-slide__vat": "_car-slide__vat_1t15v_153",
  "car-slide__splitter": "_car-slide__splitter_1t15v_164",
  "car-slide__cta": "_car-slide__cta_1t15v_172",
  linkWrapper,
  link: link$1,
  "car-slide__indicatorWrapper": "_car-slide__indicatorWrapper_1t15v_200",
  "car-slide__indicator": "_car-slide__indicator_1t15v_200",
  "car-slide__indicator--active": "_car-slide__indicator--active_1t15v_219",
  "car-slide__brabusIndicator--active": "_car-slide__brabusIndicator--active_1t15v_227",
  "car-slide__slideNumWrapper": "_car-slide__slideNumWrapper_1t15v_230",
  "car-slide__slideArrow": "_car-slide__slideArrow_1t15v_239",
  "car-slide__arrowButton": "_car-slide__arrowButton_1t15v_248",
  "car-slide__arrowButton--active": "_car-slide__arrowButton--active_1t15v_257",
  "car-slide__slideNum": "_car-slide__slideNum_1t15v_230",
  "car-slide__slideTotal": "_car-slide__slideTotal_1t15v_290",
  "legal-disclaimer": "_legal-disclaimer_1t15v_294"
};
const baseClass$2 = "car-slide";
const CarSlideComponent = forwardRef(
  ({ removeTopSpacing: removeTopSpacing2, pngSequenceBaseUrl, models, legalDisclaimers, className, mode }, ref) => {
    const currentIndexRef = useRef(0);
    const [currentIndex2, setCurrentIndex] = useState(models.length > 2 ? 1 : 0);
    const imageRefs = useRef([]);
    const contentRefs = useRef([]);
    const linkRefs = useRef([]);
    const indicatorRef = useRef(null);
    const isPortrait = useIsPortrait();
    const isSliding = useRef(false);
    const isLeftHovered = useRef(false);
    const isRightHovered = useRef(false);
    const frameCount = models.length > 2 ? 120 : 90;
    const viewportElementRef = useRef(null);
    const base64Pixel = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const [isInView, setIsInView] = useState(false);
    const animatePngSequence = (startFrameNumber, endFrameNumber) => {
      const hideAllAndDisplayCurrent = (frame) => {
        imageRefs.current.forEach((img2, i) => {
          if (img2) {
            img2.style.display = frame === i ? "block" : "none";
          }
        });
      };
      const direction = endFrameNumber > startFrameNumber ? "right" : "left";
      if (direction === "right") {
        let num = startFrameNumber;
        const step = () => {
          if (num <= endFrameNumber) {
            hideAllAndDisplayCurrent(num);
            num++;
            setTimeout(() => {
              requestAnimationFrame(step);
            }, 14);
          }
        };
        requestAnimationFrame(step);
      } else {
        let num = startFrameNumber;
        const step = () => {
          if (num >= endFrameNumber) {
            hideAllAndDisplayCurrent(num);
            num--;
            setTimeout(() => {
              requestAnimationFrame(step);
            }, 14);
          }
        };
        requestAnimationFrame(step);
      }
    };
    const animateElement = (current2, next, direction, delay) => {
      if (current2) {
        current2.style.opacity = "0";
        current2.style.transform = `translateY(${direction === "right" ? "-" : "+"}20px)`;
        current2.ontransitionend = () => {
          current2.style.display = "none";
          current2.ontransitionend = null;
        };
      }
      setTimeout(() => {
        if (next) {
          next.style.transform = `translateY(${direction === "right" ? "+" : "-"}20px)`;
          next.style.display = "flex";
          setTimeout(() => {
            next.style.opacity = "1";
            next.style.transform = `translateY(0)`;
          }, 100);
        }
      }, delay);
    };
    const slide2 = (direction) => {
      if (isSliding.current)
        return;
      isSliding.current = true;
      if (currentIndexRef.current === 0 && direction === "left" || currentIndexRef.current === models.length - 1 && direction === "right") {
        isSliding.current = false;
        return;
      }
      const nextIndex2 = direction === "right" ? currentIndexRef.current + 1 : currentIndexRef.current - 1;
      const currentContent = contentRefs.current[currentIndexRef.current];
      const nextContent = contentRefs.current[nextIndex2];
      animateElement(currentContent, nextContent, direction, 300);
      const currentLink = linkRefs.current[currentIndexRef.current];
      const nextLink = linkRefs.current[nextIndex2];
      animateElement(currentLink, nextLink, direction, 400);
      if (indicatorRef.current) {
        indicatorRef.current.style.left = `${100 / models.length * nextIndex2}%`;
      }
      if (models.length > 2) {
        if (direction === "right") {
          if (nextIndex2 === 1) {
            animatePngSequence(1, 60);
          }
          if (nextIndex2 === 2) {
            animatePngSequence(60, 120);
          }
        } else {
          if (nextIndex2 === 1) {
            animatePngSequence(120, 60);
          }
          if (nextIndex2 === 0) {
            animatePngSequence(60, 1);
          }
        }
      } else {
        if (direction === "right") {
          animatePngSequence(isRightHovered.current ? 16 : 1, frameCount);
        } else {
          animatePngSequence(isLeftHovered.current ? 35 : frameCount, 1);
        }
      }
      setTimeout(() => {
        setCurrentIndex(nextIndex2);
        currentIndexRef.current = nextIndex2;
        isSliding.current = false;
      }, 800);
    };
    const getImageSource = (d) => `${pngSequenceBaseUrl}/${mode === "brabus" || models.length > 2 ? "brabus_" : ""}${isPortrait ? "mobile_" : "desktop_"}${models.length > 2 ? "v2_" : ""}${d.toString().padStart(models.length > 2 ? 5 : 2, "0")}.jpg`;
    const checkIsInView = useCallback(() => {
      var _a;
      if (!viewportElementRef.current)
        return;
      const rect = (_a = viewportElementRef.current) == null ? void 0 : _a.getBoundingClientRect();
      if (rect.top <= window.innerHeight + 300) {
        setIsInView(true);
      }
    }, []);
    useEffect(() => {
      checkIsInView();
      window.addEventListener("scroll", checkIsInView);
      return () => window.removeEventListener("scroll", checkIsInView);
    }, [checkIsInView]);
    useEffect(() => {
      const updateStyles = (refs, index, display = "flex", transform = "translateY(0)", opacity = "1") => {
        if (refs.current[index]) {
          refs.current[index].style.display = display;
          refs.current[index].style.transform = transform;
          refs.current[index].style.opacity = opacity;
        }
      };
      if (models.length > 2) {
        if (imageRefs.current[60]) {
          imageRefs.current[60].style.display = "block";
        }
        if (indicatorRef.current) {
          indicatorRef.current.style.left = `${100 / models.length}%`;
        }
        currentIndexRef.current = 1;
        updateStyles(contentRefs, 1);
        updateStyles(linkRefs, 1);
      } else {
        if (imageRefs.current[1]) {
          imageRefs.current[1].style.display = "block";
        }
        updateStyles(contentRefs, 0);
        updateStyles(linkRefs, 0);
      }
      let touchstartX = 0;
      let touchendX = 0;
      const checkDirection = () => {
        if (touchendX < touchstartX) {
          slide2("right");
        }
        if (touchendX > touchstartX) {
          slide2("left");
        }
      };
      const touchStart = (e) => {
        touchstartX = e.changedTouches[0].screenX;
      };
      const touchEnd = (e) => {
        touchendX = e.changedTouches[0].screenX;
        checkDirection();
      };
      document.addEventListener("touchstart", touchStart);
      document.addEventListener("touchend", touchEnd);
      return () => {
        document.removeEventListener("touchstart", touchStart);
        document.removeEventListener("touchend", touchEnd);
      };
    }, []);
    return /* @__PURE__ */ jsxs(
      "section",
      {
        className: classNames(styles$7[`${baseClass$2}--wrapper`], {
          [styles$7[`${baseClass$2}--noTopSpacing`]]: removeTopSpacing2,
          [`dark-theme`]: mode === "dark" || mode === "brabus"
        }),
        ref: viewportElementRef,
        children: [
          /* @__PURE__ */ jsxs("section", { className: classNames(styles$7[baseClass$2], className), ref, children: [
            /* @__PURE__ */ jsx("div", { children: [...Array(frameCount).keys()].map((d) => /* @__PURE__ */ jsx(
              "img",
              {
                className: styles$7[`${baseClass$2}__images`],
                ref: (el) => imageRefs.current[d + 1] = el,
                alt: "car slide",
                src: isInView ? getImageSource(d) : base64Pixel
              },
              `car-slide-images-${d}`
            )) }),
            /* @__PURE__ */ jsx("div", { className: styles$7[`${baseClass$2}__shade`] }),
            currentIndex2 > 0 && /* @__PURE__ */ jsx(
              "div",
              {
                role: "button",
                className: classNames(styles$7[`${baseClass$2}__slideMask`], styles$7[`${baseClass$2}__slideMask--left`], {
                  [styles$7[`${baseClass$2}__slideMask--brabus-left`]]: mode === "brabus"
                }),
                onClick: () => slide2("left"),
                onKeyDown: () => slide2("left"),
                tabIndex: 0,
                onMouseOver: () => {
                },
                onFocus: () => {
                },
                onMouseLeave: () => {
                }
              }
            ),
            currentIndex2 < models.length - 1 && /* @__PURE__ */ jsx(
              "div",
              {
                role: "button",
                className: classNames(styles$7[`${baseClass$2}__slideMask`], styles$7[`${baseClass$2}__slideMask--right`], {
                  [styles$7[`${baseClass$2}__slideMask--brabus-right`]]: mode === "brabus"
                }),
                onClick: () => slide2("right"),
                onKeyDown: () => slide2("right"),
                tabIndex: 0,
                onMouseOver: () => {
                },
                onFocus: () => {
                },
                onMouseLeave: () => {
                }
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: styles$7[`${baseClass$2}__contentWrapper`], children: [
              models.slice(0, models.length > 2 ? 3 : 2).map((model, i) => /* @__PURE__ */ jsxs(
                "div",
                {
                  className: styles$7[`${baseClass$2}__content`],
                  ref: (el) => contentRefs.current[i] = el,
                  children: [
                    model.title && /* @__PURE__ */ jsx("div", { className: styles$7[`${baseClass$2}__title`], children: model.title }),
                    model.subTitle && /* @__PURE__ */ jsx("div", { className: styles$7[`${baseClass$2}__subTitle`], children: model.subTitle }),
                    model.priceTag && /* @__PURE__ */ jsxs("div", { className: styles$7[`${baseClass$2}__price`], children: [
                      /* @__PURE__ */ jsxs("span", { children: [
                        model.priceTag,
                        " "
                      ] }),
                      model.leasingPriceTag && /* @__PURE__ */ jsx("span", { children: model.leasingPriceTag }),
                      model.priceTagAnnotation && /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx("span", { className: styles$7[`${baseClass$2}__splitter`] }),
                        /* @__PURE__ */ jsx("span", { className: styles$7[`${baseClass$2}__vat`], children: model.priceTagAnnotation })
                      ] })
                    ] })
                  ]
                },
                `${model.title}--content--${i}`
              )),
              models.slice(0, models.length > 2 ? 3 : 2).map((model, i) => {
                var _a;
                return /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: styles$7[`${baseClass$2}__cta`],
                    ref: (el) => linkRefs.current[i] = el,
                    children: model.link && /* @__PURE__ */ jsx("div", { className: styles$7.linkWrapper, children: /* @__PURE__ */ jsx(
                      TextLink,
                      {
                        ...model.link,
                        className: styles$7.link,
                        variant: mode === "brabus" ? "button-primary-brabus" : "button-primary-lime",
                        linkText: ((_a = model.link) == null ? void 0 : _a.label) || ""
                      }
                    ) })
                  },
                  `${model.title}--link--${i}`
                );
              })
            ] }),
            /* @__PURE__ */ jsxs("div", { className: styles$7[`${baseClass$2}__indicatorWrapper`], children: [
              /* @__PURE__ */ jsx("div", { className: styles$7[`${baseClass$2}__indicator`], children: /* @__PURE__ */ jsx(
                "div",
                {
                  ref: indicatorRef,
                  className: classNames(styles$7[`${baseClass$2}__indicator--active`], {
                    [styles$7[`${baseClass$2}__brabusIndicator--active`]]: mode === "brabus"
                  }),
                  style: { width: `${100 / models.length}%` }
                }
              ) }),
              /* @__PURE__ */ jsxs("div", { className: styles$7[`${baseClass$2}__slideArrow`], children: [
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    className: classNames(styles$7[`${baseClass$2}__arrowButton`], {
                      [styles$7[`${baseClass$2}__arrowButton--active`]]: currentIndex2 > 0
                    }),
                    onClick: () => slide2("left"),
                    children: /* @__PURE__ */ jsx(Icon, { name: "arrow-left--medium" })
                  }
                ),
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    className: classNames(styles$7[`${baseClass$2}__arrowButton`], {
                      [styles$7[`${baseClass$2}__arrowButton--active`]]: currentIndex2 < models.length - 1
                    }),
                    onClick: () => slide2("right"),
                    children: /* @__PURE__ */ jsx(Icon, { name: "arrow-right--medium" })
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs("div", { className: styles$7[`${baseClass$2}__slideNum`], children: [
                /* @__PURE__ */ jsx("span", { children: (currentIndex2 + 1).toString().padStart(2, "0") }),
                /* @__PURE__ */ jsx("span", { className: styles$7[`${baseClass$2}__splitter`] }),
                /* @__PURE__ */ jsx("span", { className: styles$7[`${baseClass$2}__slideTotal`], children: models.length.toString().padStart(2, "0") })
              ] })
            ] })
          ] }),
          legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx("div", { className: styles$7["legal-disclaimer"], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers }) })
        ]
      }
    );
  }
);
CarSlideComponent.displayName = "CarSlideComponent";
const CarSlide = withSetting(CarSlideComponent, "inverted");
const lengthTargetRef = "_lengthTargetRef_bfa9e_1";
const mediaStage = "_mediaStage_bfa9e_5";
const mediaStage__video = "_mediaStage__video_bfa9e_17";
const mediaStage__image = "_mediaStage__image_bfa9e_22";
const defaultAspectRatio = "_defaultAspectRatio_bfa9e_26";
const highAspectRatio = "_highAspectRatio_bfa9e_29";
const noTopSpacing$4 = "_noTopSpacing_bfa9e_50";
const styles$6 = {
  lengthTargetRef,
  "mediaStage-wrapper": "_mediaStage-wrapper_bfa9e_5",
  mediaStage,
  "mediaStage--enableSideSpacing": "_mediaStage--enableSideSpacing_bfa9e_14",
  mediaStage__video,
  mediaStage__image,
  defaultAspectRatio,
  highAspectRatio,
  "legal-disclaimer": "_legal-disclaimer_bfa9e_38",
  noTopSpacing: noTopSpacing$4
};
const baseClass$1 = "mediaStage";
const MediaStage = ({
  mode,
  contentType,
  aspectRatio,
  video: video2,
  customVideoStylesBaseUrl,
  image: image2,
  legalDisclaimers,
  enableSideSpacing,
  removeTopSpacing: removeTopSpacing2
}) => {
  const mediaRef = useRef(null);
  const lengthTargetRef2 = useRef(null);
  const isPortrait = useIsPortrait();
  const url = isPortrait ? (video2 == null ? void 0 : video2.portraitUrl) || (video2 == null ? void 0 : video2.landscapeUrl) : video2 == null ? void 0 : video2.landscapeUrl;
  const [windowWidth, setWindowWidth] = useState(1920);
  const initialScale = 1;
  const [scrollRatio, setScrollRatio] = useState(initialScale);
  useEffect(() => {
    const setWidth2 = () => {
      setWindowWidth(window.innerWidth);
    };
    setWidth2();
    document.addEventListener("resize", setWidth2);
    const scaleEvent = () => {
      if (!mediaRef.current) {
        return;
      }
      const rect = mediaRef.current.getBoundingClientRect();
      if (!lengthTargetRef2.current) {
        return;
      }
      const bottomDistance = window.innerHeight - rect.bottom;
      if (bottomDistance >= 0 && !enableSideSpacing) {
        const endRatio = lengthTargetRef2.current.clientWidth / window.innerWidth;
        setScrollRatio(1 + bottomDistance * (endRatio - 1) / window.innerHeight);
      } else {
        setScrollRatio(1);
      }
    };
    const handleIntersections = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        document.addEventListener("scroll", scaleEvent);
      }
    };
    const observer = new IntersectionObserver(handleIntersections);
    const el = mediaRef.current;
    if (el) {
      observer.observe(el);
    }
    return () => {
      if (el) {
        observer.unobserve(el);
      }
    };
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { ref: lengthTargetRef2, className: styles$6.lengthTargetRef }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(styles$6[`${baseClass$1}-wrapper`], {
          [styles$6.noTopSpacing]: removeTopSpacing2,
          "dark-theme": mode === "brabus" || mode === "dark"
        }),
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                scale: `${scrollRatio}`
              },
              className: classNames(styles$6[baseClass$1], {
                [styles$6[`${baseClass$1}--enableSideSpacing`]]: enableSideSpacing
              }),
              ref: mediaRef,
              children: /* @__PURE__ */ jsx("div", { style: { aspectRatio: windowWidth >= breakpoints$1.l ? "16/9" : aspectRatio }, children: contentType === "image" ? /* @__PURE__ */ jsx(
                DynamicMediaPicture,
                {
                  className: styles$6[`${baseClass$1}__image`],
                  imageAltText: (image2 == null ? void 0 : image2.imageAltText) || "",
                  imageUrl: (image2 == null ? void 0 : image2.imageUrl) || "",
                  imageConfigs: [
                    {
                      // eslint-disable-next-line no-nested-ternary
                      aspectRatio: windowWidth >= breakpoints$1.l ? "16-9" : aspectRatio === "4/3" ? "4-3" : "16-9",
                      sizes: "100vw"
                    }
                  ]
                }
              ) : /* @__PURE__ */ jsx(
                DynamicMediaVideo,
                {
                  className: styles$6[`${baseClass$1}__video`],
                  video: {
                    url: url || "",
                    mute: true,
                    loop: true,
                    autoPlay: true,
                    preload: true,
                    posterImageUrl: video2 == null ? void 0 : video2.posterUrl,
                    customVideoStylesBaseUrl: customVideoStylesBaseUrl || ""
                  },
                  videoControls: true,
                  isInView: true,
                  altText: (video2 == null ? void 0 : video2.altText) || "",
                  isBrabusTheme: mode === "brabus"
                }
              ) })
            }
          ),
          legalDisclaimers && !!legalDisclaimers.length && /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(styles$6[`legal-disclaimer`], { "dark-theme": mode === "dark" || mode === "brabus" }),
              children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
            }
          )
        ]
      }
    )
  ] });
};
const headlinesV2 = "_headlinesV2_ncymd_37";
const log = "_log_ncymd_56";
const headlineParts = "_headlineParts_ncymd_64";
const twoOverThree = "_twoOverThree_ncymd_99";
const headlines = "_headlines_ncymd_37";
const subHeadlines = "_subHeadlines_ncymd_121";
const cta$2 = "_cta_ncymd_125";
const logo$1 = "_logo_ncymd_148";
const logoswrapper = "_logoswrapper_ncymd_176";
const logstitle = "_logstitle_ncymd_183";
const icons = "_icons_ncymd_210";
const pluscon_tainer$1 = "_pluscon_tainer_ncymd_216";
const plus_sign$1 = "_plus_sign_ncymd_221";
const minus_sign$1 = "_minus_sign_ncymd_229";
const plus_signs$1 = "_plus_signs_ncymd_238";
const reduction$1 = "_reduction_ncymd_241";
const contents$1 = "_contents_ncymd_244";
const unfold$1 = "_unfold_ncymd_250";
const closed$1 = "_closed_ncymd_258";
const twoOver = "_twoOver_ncymd_99";
const noTopSpacing$3 = "_noTopSpacing_ncymd_273";
const styles$5 = {
  headlinesV2,
  log,
  headlineParts,
  "headlineParts--hl-200": "_headlineParts--hl-200_ncymd_67",
  "headlineParts--hl-300": "_headlineParts--hl-300_ncymd_81",
  twoOverThree,
  headlines,
  subHeadlines,
  cta: cta$2,
  "logos-wrapper": "_logos-wrapper_ncymd_148",
  "logo-wrapper": "_logo-wrapper_ncymd_159",
  logo: logo$1,
  logoswrapper,
  logstitle,
  "logo-wrappers": "_logo-wrappers_ncymd_191",
  icons,
  pluscon_tainer: pluscon_tainer$1,
  plus_sign: plus_sign$1,
  minus_sign: minus_sign$1,
  plus_signs: plus_signs$1,
  "rotate-plus": "_rotate-plus_ncymd_1",
  reduction: reduction$1,
  "rotate-minus": "_rotate-minus_ncymd_1",
  contents: contents$1,
  unfold: unfold$1,
  "fade-in": "_fade-in_ncymd_1",
  closed: closed$1,
  "fade-out": "_fade-out_ncymd_1",
  twoOver,
  noTopSpacing: noTopSpacing$3
};
const HeadlineV2 = ({
  layout,
  headline: headline2,
  subHeadline: subHeadline2,
  link: link2,
  logos: logos2,
  mode,
  content: content2,
  removeTopSpacing: removeTopSpacing2,
  asAccordion,
  size
}) => {
  const [expanded, setExpanded] = useState(false);
  const acquire = useRef(null);
  const contentAcquire = useRef(null);
  const getSizeClass = (s) => {
    const sizeClass = {
      "Headline/200": "hl-200",
      "Headline/300": "hl-300"
    };
    if (s && sizeClass[s]) {
      return sizeClass[s];
    }
    return "hl-300";
  };
  const animationsStyle = (pre) => {
    if (acquire.current) {
      if (pre) {
        acquire.current.classList.remove(styles$5.plus_signs);
        acquire.current.classList.add(styles$5.reduction);
      } else {
        acquire.current.classList.remove(styles$5.reduction);
        acquire.current.classList.add(styles$5.plus_signs);
      }
    }
    if (contentAcquire.current) {
      if (pre) {
        contentAcquire.current.classList.remove(styles$5.unfold);
        contentAcquire.current.classList.add(styles$5.closed);
      } else {
        contentAcquire.current.classList.remove(styles$5.closed);
        contentAcquire.current.classList.add(styles$5.unfold);
      }
    }
  };
  const onClick2 = () => {
    setExpanded((pre) => {
      animationsStyle(pre);
      return !pre;
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "section",
      {
        className: classNames(styles$5.headlinesV2, {
          [styles$5.noTopSpacing]: removeTopSpacing2,
          "dark-theme": mode === "dark" || mode === "brabus",
          [styles$5.log]: !asAccordion
        }),
        children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames(styles$5.headlineParts, styles$5[`headlineParts--${getSizeClass(size)}`], {
                [styles$5.twoOverThree]: layout === "2/3"
              }),
              children: [
                headline2 && /* @__PURE__ */ jsxs("p", { className: styles$5.headlines, children: [
                  " ",
                  headline2
                ] }),
                /* @__PURE__ */ jsx("p", { className: styles$5.subHeadlines, children: subHeadline2 })
              ]
            }
          ),
          asAccordion ? /* @__PURE__ */ jsx(
            "div",
            {
              role: "button",
              className: classNames(styles$5.logoswrapper, {
                [styles$5.logstitle]: headline2 === ``
              }),
              onClick: onClick2,
              onKeyDown: onClick2,
              tabIndex: 0,
              onMouseOver: () => {
              },
              onFocus: () => {
              },
              onMouseLeave: () => {
              },
              children: /* @__PURE__ */ jsx("div", { className: styles$5["logo-wrappers"], children: /* @__PURE__ */ jsxs("div", { className: styles$5.pluscon_tainer, children: [
                /* @__PURE__ */ jsx("div", { className: styles$5.plus_sign }),
                /* @__PURE__ */ jsx("div", { ref: acquire, className: classNames(styles$5.minus_sign) })
              ] }) })
            }
          ) : /* @__PURE__ */ jsxs(Fragment, { children: [
            layout === "left aligned" && link2 && /* @__PURE__ */ jsx(TextLink, { ...link2, className: styles$5.cta, variant: "button-secondary", linkText: (link2 == null ? void 0 : link2.label) || "" }),
            layout === "left aligned" && !link2 && logos2 && logos2.length > 0 && /* @__PURE__ */ jsx("div", { className: styles$5["logos-wrapper"], children: /* @__PURE__ */ jsx("div", { className: styles$5["logo-wrapper"], children: /* @__PURE__ */ jsx("img", { className: styles$5.logo, src: `${logos2[0]}?wid=640`, alt: "award" }) }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "section",
      {
        className: classNames(styles$5.headlinesV2, {
          "dark-theme": mode === "dark" || mode === "brabus"
        }),
        children: asAccordion && /* @__PURE__ */ jsx(
          "div",
          {
            id: `item__content__${0}`,
            ref: contentAcquire,
            className: classNames(styles$5.contents, layout === "2/3" && [styles$5.twoOver]),
            role: "region",
            "aria-labelledby": `item__button__${0}`,
            "aria-hidden": !expanded,
            children: content2
          }
        )
      }
    )
  ] });
};
const statement = "_statement_kjb0g_1";
const subline$2 = "_subline_kjb0g_17";
const headline$3 = "_headline_kjb0g_39";
const btns = "_btns_kjb0g_59";
const mask$1 = "_mask_kjb0g_71";
const styles$4 = {
  statement,
  "statement--remove-top-spacing": "_statement--remove-top-spacing_kjb0g_8",
  subline: subline$2,
  "headline-wrapper": "_headline-wrapper_kjb0g_39",
  headline: headline$3,
  btns,
  mask: mask$1
};
const baseClass = "statement";
const Statement = ({
  removeTopSpacing: removeTopSpacing2,
  mode,
  subline: subline2,
  headline: headline2,
  primaryLink: primaryLink2,
  secondaryLink: secondaryLink2
}) => {
  const contentRef = useRef(null);
  const maskRefs = useRef({});
  const [linesCount, setLinesCount] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  useEffect(() => {
    const getLineHeight = () => {
      if (contentRef.current) {
        return parseFloat(window.getComputedStyle(contentRef.current, null).getPropertyValue("line-height"));
      }
      return 25;
    };
    const updateMasksWidth = () => {
      Object.keys(maskRefs.current).forEach((k) => {
        const currentMask = maskRefs.current[parseInt(k)];
        const clientRect = currentMask.getBoundingClientRect();
        let width = 100;
        const lineHeight = getLineHeight();
        const startPoint = window.innerHeight / 2;
        if (clientRect.top > startPoint) {
          width = 100;
        } else if (clientRect.top < startPoint - lineHeight) {
          width = 0;
        } else {
          width = 100 - (startPoint - clientRect.top) / lineHeight * 100;
        }
        currentMask.style.width = `${width}%`;
      });
    };
    const initialMasks = () => {
      setTimeout(() => {
        const height = contentRef.current.offsetHeight;
        const lineHeight = getLineHeight();
        setContentHeight(height);
        setLinesCount(Math.round(height / lineHeight));
        setTimeout(() => {
          updateMasksWidth();
        }, 0);
      }, 200);
    };
    initialMasks();
    window.addEventListener("scroll", () => {
      updateMasksWidth();
    });
    window.addEventListener("resize", () => {
      initialMasks();
    });
  }, []);
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className: classNames(styles$4[baseClass], {
        [styles$4[`${baseClass}--remove-top-spacing`]]: removeTopSpacing2,
        [`dark-theme`]: mode === "dark" || mode === "brabus"
      }),
      children: [
        /* @__PURE__ */ jsx("div", { className: styles$4["subline"], children: subline2 || `` }),
        /* @__PURE__ */ jsxs("div", { className: styles$4["headline-wrapper"], children: [
          /* @__PURE__ */ jsxs("div", { ref: contentRef, className: styles$4["headline"], children: [
            headline2,
            Array(linesCount).fill(void 0).map((l, i) => /* @__PURE__ */ jsx(
              "div",
              {
                ref: (el) => {
                  if (el) {
                    maskRefs.current[i] = el;
                  }
                },
                className: styles$4["mask"],
                style: { top: i * (contentHeight / linesCount), height: contentHeight / linesCount }
              },
              i
            ))
          ] }),
          (primaryLink2 || secondaryLink2) && /* @__PURE__ */ jsxs("div", { className: styles$4["btns"], children: [
            primaryLink2 && /* @__PURE__ */ jsx(TextLink, { ...primaryLink2, variant: "button-primary", linkText: primaryLink2.label }),
            secondaryLink2 && /* @__PURE__ */ jsx(TextLink, { ...secondaryLink2, variant: "button-secondary", linkText: secondaryLink2.label })
          ] })
        ] })
      ]
    }
  );
};
const wrapper = "_wrapper_12bq8_1";
const tableWrapper = "_tableWrapper_12bq8_13";
const stickyScrollBar = "_stickyScrollBar_12bq8_20";
const customizeScrollbar = "_customizeScrollbar_12bq8_26";
const customizeScrollThumb = "_customizeScrollThumb_12bq8_36";
const cta$1 = "_cta_12bq8_46";
const hideBorder = "_hideBorder_12bq8_143";
const mobileHeader = "_mobileHeader_12bq8_150";
const headerHide = "_headerHide_12bq8_177";
const mobileHeaderHide = "_mobileHeaderHide_12bq8_194";
const headerColumn = "_headerColumn_12bq8_206";
const leftPart = "_leftPart_12bq8_214";
const subline$1 = "_subline_12bq8_217";
const headline$2 = "_headline_12bq8_234";
const tablePart = "_tablePart_12bq8_252";
const twoOfAll$1 = "_twoOfAll_12bq8_257";
const threeOfAll$1 = "_threeOfAll_12bq8_263";
const noTopSpacing$2 = "_noTopSpacing_12bq8_268";
const half$1 = "_half_12bq8_273";
const styles$3 = {
  wrapper,
  tableWrapper,
  stickyScrollBar,
  customizeScrollbar,
  customizeScrollThumb,
  "legal-disclaimer": "_legal-disclaimer_12bq8_43",
  cta: cta$1,
  hideBorder,
  mobileHeader,
  headerHide,
  mobileHeaderHide,
  headerColumn,
  leftPart,
  subline: subline$1,
  headline: headline$2,
  tablePart,
  twoOfAll: twoOfAll$1,
  threeOfAll: threeOfAll$1,
  noTopSpacing: noTopSpacing$2,
  half: half$1
};
const Table = ({
  headline: headline2,
  subline: subline2,
  headerRow,
  headerColumn: headerColumn2,
  dataSource,
  removeTopSpacing: removeTopSpacing2,
  hasHeaderColumn,
  hasHeaderRow,
  disclaimers,
  mode,
  layoutAlign,
  link: link2
}) => {
  const wrapperRef = useRef(null);
  const fixedHeaderRef = useRef(null);
  const tableRef = useRef(null);
  const scrollThumbRef = useRef(null);
  const scrollBarRef = useRef(null);
  const [thumbWidthPercentage, setThumbWidthPercentage] = useState(1);
  const scrollPosition = useRef(0);
  const [mobileScroll, setMobileScroll] = useState(false);
  const [hasScroll, setHasScroll] = useState(false);
  const [tableWidth, setTableWidth] = useState(0);
  const scrollBarMove = (e) => {
    var _a, _b, _c, _d;
    if (!wrapperRef.current || !tableRef.current || !scrollThumbRef.current || !scrollBarRef.current || !fixedHeaderRef.current) {
      return;
    }
    const scrollBarWidth = scrollBarRef.current.getBoundingClientRect().width;
    const thumbWidth = parseFloat(window.getComputedStyle(scrollThumbRef.current).width);
    const scrollThumbPosition = e.clientX - ((_a = wrapperRef.current) == null ? void 0 : _a.getBoundingClientRect().left) - thumbWidth / 2;
    if (e.clientX - wrapperRef.current.getBoundingClientRect().left < thumbWidth / 2) {
      scrollPosition.current = 0;
      wrapperRef.current.scrollTo(-1, 0);
      fixedHeaderRef.current.scrollTo(-1, 0);
      (_b = scrollThumbRef.current) == null ? void 0 : _b.setAttribute("style", `transform:translateX(${0}px);width:${thumbWidthPercentage}%`);
    } else if (e.clientX - wrapperRef.current.getBoundingClientRect().left > scrollBarWidth - thumbWidth / 2) {
      scrollPosition.current = 1;
      wrapperRef.current.scrollTo(tableWidth, 0);
      fixedHeaderRef.current.scrollTo(tableWidth, 0);
      (_c = scrollThumbRef.current) == null ? void 0 : _c.setAttribute(
        "style",
        `transform:translateX(${scrollBarWidth - thumbWidth}px);width:${thumbWidthPercentage}%`
      );
    } else if (e.clientX - wrapperRef.current.getBoundingClientRect().left > thumbWidth / 2 && e.clientX - wrapperRef.current.getBoundingClientRect().left < scrollBarWidth - thumbWidth / 2) {
      scrollPosition.current = scrollThumbPosition / (scrollBarWidth - thumbWidth);
      wrapperRef.current.scrollTo(tableWidth * scrollThumbPosition / scrollBarWidth, 0);
      fixedHeaderRef.current.scrollTo(tableWidth * scrollThumbPosition / scrollBarWidth, 0);
      (_d = scrollThumbRef.current) == null ? void 0 : _d.setAttribute(
        "style",
        `transform:translateX(${scrollThumbPosition}px);width:${thumbWidthPercentage}%`
      );
    }
  };
  const handleClickScroll = (e) => {
    scrollBarMove(e);
  };
  const handleDragScroll = (e) => {
    document.addEventListener("mousemove", scrollBarMove);
    document.addEventListener("mouseup", () => {
      document.removeEventListener("mousemove", scrollBarMove);
    });
  };
  useEffect(() => {
    if (!wrapperRef.current || !tableRef.current) {
      return;
    }
    setHasScroll(tableRef.current.getBoundingClientRect().width > wrapperRef.current.getBoundingClientRect().width);
    setTableWidth(tableRef.current.getBoundingClientRect().width);
    const contentWidth2 = tableRef.current.getBoundingClientRect().width;
    const wrapperWidth = wrapperRef.current.getBoundingClientRect().width;
    if (wrapperWidth && contentWidth2) {
      setThumbWidthPercentage(wrapperWidth / contentWidth2 * 100);
    }
    window.addEventListener("resize", () => {
      var _a;
      if (!tableRef.current || !wrapperRef.current || !fixedHeaderRef.current || !scrollBarRef.current || !scrollThumbRef.current) {
        return;
      }
      setThumbWidthPercentage(wrapperWidth / contentWidth2 * 100);
      setTableWidth(tableRef.current.getBoundingClientRect().width);
      const scrollBarWidth = scrollBarRef.current.getBoundingClientRect().width;
      const thumbWidth = parseFloat(window.getComputedStyle(scrollThumbRef.current).width);
      wrapperRef.current.scrollTo(tableRef.current.getBoundingClientRect().width * scrollPosition.current, 0);
      fixedHeaderRef.current.scrollTo(tableRef.current.getBoundingClientRect().width * scrollPosition.current, 0);
      (_a = scrollThumbRef.current) == null ? void 0 : _a.setAttribute(
        "style",
        `transform:translateX(${(scrollBarWidth - thumbWidth) * scrollPosition.current}px);width:${wrapperWidth / contentWidth2 * 100}%`
      );
      setTableWidth(tableRef.current.getBoundingClientRect().width);
    });
    wrapperRef.current.addEventListener("scroll", () => {
      var _a, _b;
      if (!wrapperRef.current || !scrollBarRef.current || !fixedHeaderRef.current) {
        return;
      }
      fixedHeaderRef.current.scrollTo(wrapperRef.current.scrollLeft, 0);
      (_b = scrollThumbRef.current) == null ? void 0 : _b.setAttribute(
        "style",
        `transform:translateX(${wrapperRef.current.scrollLeft / wrapperRef.current.scrollWidth * ((_a = scrollBarRef.current) == null ? void 0 : _a.clientWidth)}px);width:${wrapperWidth / contentWidth2 * 100}%`
      );
      if (wrapperRef.current.scrollLeft > 0) {
        setMobileScroll(true);
      } else {
        setMobileScroll(false);
      }
    });
  }, []);
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className: classNames(styles$3.wrapper, {
        [styles$3.noTopSpacing]: removeTopSpacing2,
        [`dark-theme`]: mode === "dark" || mode === "brabus"
      }),
      children: [
        (layoutAlign === "2-3" || layoutAlign === "50-50") && /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(styles$3.leftPart, {
              [styles$3.twoOfAll]: layoutAlign === "2-3",
              [styles$3.half]: layoutAlign === "50-50"
            }),
            children: [
              subline2 && /* @__PURE__ */ jsx("p", { className: styles$3.subline, children: subline2 }),
              headline2 && /* @__PURE__ */ jsx("p", { className: styles$3.headline, children: headline2 })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(styles$3.tablePart, {
              [styles$3.threeOfAll]: layoutAlign === "2-3",
              [styles$3.half]: layoutAlign === "50-50"
            }),
            children: [
              /* @__PURE__ */ jsxs("div", { children: [
                /* @__PURE__ */ jsx("div", { className: classNames(styles$3.headerColumn, styles$3.tableWrapper), ref: fixedHeaderRef, children: /* @__PURE__ */ jsx("table", { children: hasHeaderColumn && /* @__PURE__ */ jsx("thead", { style: { width: tableWidth }, children: /* @__PURE__ */ jsxs("tr", { children: [
                  /* @__PURE__ */ jsx("th", { className: classNames({ [styles$3.hideBorder]: !mobileScroll }) }),
                  headerColumn2.map((data2, index) => /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsx("span", { children: data2 }) }, `headerColumn-${index}`))
                ] }) }) }) }),
                /* @__PURE__ */ jsx("div", { className: styles$3.tableWrapper, ref: wrapperRef, children: /* @__PURE__ */ jsx("table", { ref: tableRef, children: /* @__PURE__ */ jsx("tbody", { children: dataSource.map((rowData, index) => /* @__PURE__ */ jsxs("tr", { children: [
                  hasHeaderRow && /* @__PURE__ */ jsxs("th", { className: classNames({ [styles$3.hideBorder]: !mobileScroll }), children: [
                    /* @__PURE__ */ jsx("span", { className: classNames(styles$3.mobileHeader, { [styles$3.mobileHeaderHide]: !mobileScroll }), children: headerRow[index] }),
                    /* @__PURE__ */ jsx("span", { className: classNames({ [styles$3.headerHide]: mobileScroll }), children: headerRow[index] })
                  ] }),
                  rowData.map((data2, dataIndex) => /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx("span", { children: data2 }) }, `data-${dataIndex}`))
                ] }, `headerRow-${index}`)) }) }) })
              ] }),
              hasScroll && /* @__PURE__ */ jsx("div", { className: styles$3.stickyScrollBar, children: /* @__PURE__ */ jsx(
                "div",
                {
                  className: styles$3.customizeScrollbar,
                  style: { width: `calc(${window.innerWidth - document.body.clientWidth} - var(--content-margin) * 2)` },
                  onMouseDown: (e) => handleClickScroll(e),
                  role: "button",
                  tabIndex: -1,
                  ref: scrollBarRef,
                  children: /* @__PURE__ */ jsx(
                    "button",
                    {
                      ref: scrollThumbRef,
                      className: styles$3.customizeScrollThumb,
                      style: { width: `${thumbWidthPercentage}%` },
                      onMouseDown: (e) => {
                        handleDragScroll();
                      }
                    }
                  )
                }
              ) }),
              disclaimers && disclaimers.length > 0 && /* @__PURE__ */ jsx("div", { className: styles$3["legal-disclaimer"], children: /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers: disclaimers }) }),
              link2 && /* @__PURE__ */ jsx(TextLink, { ...link2, className: styles$3.cta, variant: "button-secondary", linkText: (link2 == null ? void 0 : link2.label) || "" })
            ]
          }
        )
      ]
    }
  );
};
const accordion = "_accordion_tlvyr_37";
const subline = "_subline_tlvyr_72";
const headline$1 = "_headline_tlvyr_53";
const list = "_list_tlvyr_117";
const move = "_move_tlvyr_127";
const moves = "_moves_tlvyr_131";
const item$1 = "_item_tlvyr_136";
const button = "_button_tlvyr_140";
const box = "_box_tlvyr_216";
const breadth = "_breadth_tlvyr_220";
const text$1 = "_text_tlvyr_244";
const setWidth = "_setWidth_tlvyr_259";
const paragraph$1 = "_paragraph_tlvyr_263";
const image = "_image_tlvyr_298";
const img = "_img_tlvyr_316";
const pluscon_tainer = "_pluscon_tainer_tlvyr_321";
const plus_sign = "_plus_sign_tlvyr_326";
const minus_sign = "_minus_sign_tlvyr_334";
const plus_signs = "_plus_signs_tlvyr_343";
const reduction = "_reduction_tlvyr_346";
const contents = "_contents_tlvyr_349";
const unfold = "_unfold_tlvyr_355";
const closed = "_closed_tlvyr_363";
const link = "_link_tlvyr_372";
const richtext = "_richtext_tlvyr_376";
const styles$2 = {
  accordion,
  "accordion--remove-top-spacing": "_accordion--remove-top-spacing_tlvyr_44",
  "headline-wrapper": "_headline-wrapper_tlvyr_53",
  "headline-wrapper--full": "_headline-wrapper--full_tlvyr_61",
  "headline-wrapper--2-3": "_headline-wrapper--2-3_tlvyr_64",
  "headline-wrapper--50-50": "_headline-wrapper--50-50_tlvyr_67",
  subline,
  "subline--has-headline": "_subline--has-headline_tlvyr_92",
  headline: headline$1,
  list,
  "list--2-3": "_list--2-3_tlvyr_121",
  "list--50-50": "_list--50-50_tlvyr_124",
  move,
  moves,
  item: item$1,
  "item--open": "_item--open_tlvyr_140",
  button,
  "button--hl-100": "_button--hl-100_tlvyr_166",
  "button--hl-50": "_button--hl-50_tlvyr_180",
  "button--p-300": "_button--p-300_tlvyr_194",
  box,
  breadth,
  text: text$1,
  setWidth,
  paragraph: paragraph$1,
  image,
  img,
  pluscon_tainer,
  plus_sign,
  minus_sign,
  plus_signs,
  "rotate-plus": "_rotate-plus_tlvyr_1",
  reduction,
  "rotate-minus": "_rotate-minus_tlvyr_1",
  contents,
  unfold,
  "fade-in": "_fade-in_tlvyr_1",
  closed,
  "fade-out": "_fade-out_tlvyr_1",
  link,
  richtext
};
const Accordion = ({
  variant,
  removeTopSpacing: removeTopSpacing2,
  mode,
  size,
  subline: subline2,
  headline: headline2,
  items,
  link: link2
}) => {
  const [openStatuses, setOpenStatuses] = useState([]);
  const getSizeClass = (s) => {
    const sizeClass = {
      "Headline/100": "hl-100",
      "Headline/50": "hl-50",
      "Paragraph/300": "p-300"
    };
    if (s && sizeClass[s]) {
      return sizeClass[s];
    }
    return "hl-100";
  };
  useEffect(() => {
    setOpenStatuses(
      items.map((item2, index) => ({
        isExpanded: void 0,
        onClick: () => {
          setOpenStatuses((prevOpenStatuses) => {
            const newOpenStatuses = [...prevOpenStatuses];
            if (newOpenStatuses[index].isExpanded === void 0) {
              newOpenStatuses[index].isExpanded = true;
            } else {
              newOpenStatuses[index].isExpanded = !newOpenStatuses[index].isExpanded;
            }
            return newOpenStatuses;
          });
        }
      }))
    );
  }, [items]);
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className: classNames(styles$2["accordion"], {
        [styles$2["accordion--remove-top-spacing"]]: removeTopSpacing2,
        [`dark-theme`]: mode === "dark" || mode === "brabus"
      }),
      children: [
        (variant === "2/3" || variant === "50/50") && (subline2 || headline2) && /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(styles$2["headline-wrapper"], styles$2[`headline-wrapper--${variant.replace("/", "-")}`]),
            children: [
              /* @__PURE__ */ jsx("div", { className: classNames(styles$2.subline, styles$2["subline--has-headline"]), children: subline2 }),
              headline2 && /* @__PURE__ */ jsx("div", { className: styles$2.headline, children: headline2 })
            ]
          }
        ),
        openStatuses.length > 0 && /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(styles$2.list, {
              [styles$2[`list--${variant.replace("/", "-")}`]]: subline2 && headline2,
              [styles$2.move]: variant === "2/3" && !subline2 && !headline2,
              [styles$2.moves]: variant === "50/50" && !subline2 && !headline2
            }),
            children: [
              items.map(({ title, content: content2, image: image2, paragraph: paragraph2 }, idx) => {
                const isExpanded = openStatuses[idx].isExpanded;
                const onClick2 = openStatuses[idx].onClick;
                const hasContent = !!content2;
                return /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: classNames(styles$2.item, {
                      [styles$2["item--open"]]: isExpanded && hasContent
                    }),
                    children: [
                      /* @__PURE__ */ jsxs(
                        "button",
                        {
                          onClick: onClick2,
                          className: classNames(styles$2.button, styles$2[`button--${getSizeClass(size)}`]),
                          "aria-expanded": isExpanded,
                          children: [
                            /* @__PURE__ */ jsxs(
                              "div",
                              {
                                className: classNames(styles$2.box, {
                                  [styles$2.breadth]: variant === "full"
                                }),
                                children: [
                                  /* @__PURE__ */ jsx(
                                    "span",
                                    {
                                      className: classNames(styles$2.text, {
                                        [styles$2.setWidth]: headline2
                                      }),
                                      children: title
                                    }
                                  ),
                                  variant === "full" && paragraph2 && image2 && /* @__PURE__ */ jsx("div", { className: classNames(styles$2.paragraph), children: paragraph2 })
                                ]
                              }
                            ),
                            variant === "full" && paragraph2 && image2 && !subline2 && !headline2 && /* @__PURE__ */ jsx("div", { className: styles$2.image, children: image2 && /* @__PURE__ */ jsx("img", { className: styles$2.img, src: image2, alt: "" }) }),
                            hasContent && /* @__PURE__ */ jsxs("div", { className: styles$2.pluscon_tainer, children: [
                              /* @__PURE__ */ jsx("div", { className: styles$2.plus_sign }),
                              /* @__PURE__ */ jsx(
                                "div",
                                {
                                  className: classNames(styles$2.minus_sign, {
                                    [styles$2.plus_signs]: isExpanded === true,
                                    [styles$2.reduction]: isExpanded === false
                                  })
                                }
                              )
                            ] })
                          ]
                        }
                      ),
                      hasContent && /* @__PURE__ */ jsx(
                        "div",
                        {
                          id: `item__content__${idx}`,
                          className: classNames(styles$2.contents, {
                            [styles$2.unfold]: isExpanded === true,
                            [styles$2.closed]: isExpanded === false
                          }),
                          role: "region",
                          "aria-labelledby": `item__button__${idx}`,
                          "aria-hidden": !isExpanded,
                          children: content2
                        }
                      )
                    ]
                  },
                  `list-${isExpanded}-${idx}`
                );
              }),
              link2 && /* @__PURE__ */ jsx(TextLink, { ...link2, className: styles$2.link, variant: "button-secondary", linkText: link2.label })
            ]
          }
        )
      ]
    }
  );
};
const container = "_container_1nfjp_37";
const content = "_content_1nfjp_42";
const uspItems = "_uspItems_1nfjp_99";
const item = "_item_1nfjp_99";
const iconBg = "_iconBg_1nfjp_103";
const highlightText = "_highlightText_1nfjp_115";
const iconAccent = "_iconAccent_1nfjp_131";
const iconBrabus = "_iconBrabus_1nfjp_135";
const iconDark = "_iconDark_1nfjp_138";
const text = "_text_1nfjp_142";
const headLine = "_headLine_1nfjp_145";
const highlightheadline = "_highlightheadline_1nfjp_160";
const paragraph = "_paragraph_1nfjp_175";
const textLinkLayout = "_textLinkLayout_1nfjp_190";
const linkLayout = "_linkLayout_1nfjp_198";
const cta = "_cta_1nfjp_201";
const twoOfAllLayout = "_twoOfAllLayout_1nfjp_227";
const halfLayout = "_halfLayout_1nfjp_238";
const twoOfAll = "_twoOfAll_1nfjp_227";
const threeOfAll = "_threeOfAll_1nfjp_255";
const half = "_half_1nfjp_238";
const twohalf = "_twohalf_1nfjp_273";
const full = "_full_1nfjp_286";
const contentTwoText = "_contentTwoText_1nfjp_299";
const contentThreeText = "_contentThreeText_1nfjp_305";
const itemIconTwoListText = "_itemIconTwoListText_1nfjp_310";
const itemNumberTwoText = "_itemNumberTwoText_1nfjp_314";
const itemNumberThreeText = "_itemNumberThreeText_1nfjp_318";
const itemIconThreeListText = "_itemIconThreeListText_1nfjp_322";
const itemIconGridText = "_itemIconGridText_1nfjp_327";
const itemIconGridTwoText = "_itemIconGridTwoText_1nfjp_343";
const itemIconGridThreeText = "_itemIconGridThreeText_1nfjp_349";
const fullWidthText = "_fullWidthText_1nfjp_355";
const noTopSpacing$1 = "_noTopSpacing_1nfjp_360";
const fullWidth = "_fullWidth_1nfjp_355";
const iconFullList = "_iconFullList_1nfjp_371";
const iconFullGrid = "_iconFullGrid_1nfjp_382";
const iconTwolist = "_iconTwolist_1nfjp_393";
const iconTwogrid = "_iconTwogrid_1nfjp_404";
const iconThreelist = "_iconThreelist_1nfjp_420";
const iconThreegrid = "_iconThreegrid_1nfjp_432";
const highlightFull = "_highlightFull_1nfjp_448";
const numberFull = "_numberFull_1nfjp_454";
const number = "_number_1nfjp_454";
const styles$1 = {
  container,
  content,
  "content-subline": "_content-subline_1nfjp_45",
  "content-headline": "_content-headline_1nfjp_61",
  "content-richtext": "_content-richtext_1nfjp_76",
  uspItems,
  item,
  iconBg,
  highlightText,
  iconAccent,
  iconBrabus,
  iconDark,
  text,
  headLine,
  highlightheadline,
  paragraph,
  textLinkLayout,
  linkLayout,
  cta,
  twoOfAllLayout,
  halfLayout,
  twoOfAll,
  threeOfAll,
  half,
  twohalf,
  full,
  contentTwoText,
  contentThreeText,
  itemIconTwoListText,
  itemNumberTwoText,
  itemNumberThreeText,
  itemIconThreeListText,
  itemIconGridText,
  itemIconGridTwoText,
  itemIconGridThreeText,
  fullWidthText,
  noTopSpacing: noTopSpacing$1,
  fullWidth,
  iconFullList,
  iconFullGrid,
  iconTwolist,
  iconTwogrid,
  iconThreelist,
  iconThreegrid,
  highlightFull,
  numberFull,
  number,
  "fade-in": "_fade-in_1nfjp_1",
  "fade-out": "_fade-out_1nfjp_1",
  "rotate-plus": "_rotate-plus_1nfjp_1",
  "rotate-minus": "_rotate-minus_1nfjp_1"
};
const getIconBgClassName = (iconType, mode) => {
  const isAccent = iconType === "icon-accent" || iconType === "number-accent";
  const isDarkGrey = iconType === "icon-dark-grey" || iconType === "number-dark-grey";
  const classNameList = {
    [styles$1.iconAccent]: isAccent && (mode === "dark" || mode === "light"),
    [styles$1.iconBrabus]: isAccent && mode === "brabus",
    [styles$1.iconDark]: isDarkGrey
  };
  return classNameList;
};
const USP = ({
  link: link2,
  mode,
  iconType,
  subline: subline2,
  headline: headline2,
  paragraph: paragraph2,
  uspItmes,
  variant,
  layout,
  removeTopSpacing: removeTopSpacing2
}) => {
  const isDarkTheme = mode === "dark" || mode === "brabus";
  const isIconType = iconType === "icon" || iconType === "icon-accent" || iconType === "icon-dark-grey";
  const isNumberType = iconType === "number" || iconType === "number-accent" || iconType === "number-dark-grey";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles$1.container, {
        "dark-theme": isDarkTheme,
        [styles$1.noTopSpacing]: removeTopSpacing2,
        [styles$1.twoOfAllLayout]: variant === "2/3",
        [styles$1.halfLayout]: variant === "50/50"
      }),
      children: [
        (variant === "2/3" || variant === "50/50") && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(styles$1.content, {
              [styles$1.twoOfAll]: variant === "2/3",
              [styles$1.half]: variant === "50/50"
            }),
            children: /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(styles$1.contentText, {
                  [styles$1.contentTwoText]: variant === "50/50",
                  [styles$1.contentThreeText]: variant === "2/3"
                }),
                children: [
                  /* @__PURE__ */ jsx("div", { className: styles$1["content-subline"], children: subline2 }),
                  /* @__PURE__ */ jsx("div", { className: styles$1["content-headline"], children: headline2 }),
                  paragraph2 && /* @__PURE__ */ jsx(RichText, { mdString: paragraph2, className: styles$1["content-richtext"] })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(styles$1.uspItems, {
              [styles$1.threeOfAll]: variant === "2/3",
              [styles$1.twohalf]: variant === "50/50",
              [styles$1.full]: variant === "full-width"
            }),
            children: [
              uspItmes == null ? void 0 : uspItmes.map((item2, index) => /* @__PURE__ */ jsx(
                "div",
                {
                  className: classNames(styles$1.item, {
                    [styles$1.fullWidth]: variant === "full-width",
                    [styles$1.iconFullList]: isIconType && layout === "list" && variant === "full-width",
                    [styles$1.iconFullGrid]: isIconType && layout === "grid" && variant === "full-width",
                    [styles$1.iconTwolist]: isIconType && layout === "list" && variant === "50/50",
                    [styles$1.iconTwogrid]: isIconType && layout === "grid" && variant === "50/50",
                    [styles$1.iconThreelist]: isIconType && layout === "list" && variant === "2/3",
                    [styles$1.iconThreegrid]: isIconType && layout === "grid" && variant === "2/3",
                    [styles$1.numberFull]: isNumberType && variant === "full-width",
                    [styles$1.number]: isNumberType
                  }),
                  children: /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: classNames(styles$1.itemText, {
                        [styles$1.fullWidthText]: variant === "full-width",
                        [styles$1.itemIconTwoListText]: variant === "50/50" && isIconType && layout === "list",
                        [styles$1.itemNumberTwoText]: variant === "50/50" && isNumberType,
                        [styles$1.itemNumberThreeText]: variant === "2/3" && isNumberType,
                        [styles$1.itemIconThreeListText]: variant === "2/3" && isIconType && layout === "list",
                        [styles$1.itemIconGridText]: isIconType && layout === "grid",
                        [styles$1.itemIconGridTwoText]: variant === "50/50" && isIconType && layout === "grid",
                        [styles$1.itemIconGridThreeText]: variant === "2/3" && isIconType && layout === "grid"
                      }),
                      children: [
                        isIconType && item2.iconName && /* @__PURE__ */ jsx("div", { className: classNames(styles$1.iconBg, getIconBgClassName(iconType, mode)), children: /* @__PURE__ */ jsx(Icon$1, { icon: item2.iconName, mode: 300 }) }),
                        isNumberType && /* @__PURE__ */ jsx("div", { className: classNames(styles$1.iconBg, getIconBgClassName(iconType, mode)), children: /* @__PURE__ */ jsx("div", { children: index + 1 }) }),
                        /* @__PURE__ */ jsxs("div", { className: styles$1.text, children: [
                          iconType === "highlight" && item2.highlightSubline && /* @__PURE__ */ jsx("div", { className: styles$1.highlightText, children: item2.highlightSubline }),
                          /* @__PURE__ */ jsx("div", { className: item2.iconName || isNumberType ? styles$1.headLine : styles$1.highlightheadline, children: item2.title }),
                          item2.description && /* @__PURE__ */ jsx(RichText, { className: styles$1.paragraph, mdString: item2.description }),
                          item2.textLink && /* @__PURE__ */ jsx(
                            TextLink,
                            {
                              ...item2.textLink,
                              className: styles$1.textLinkLayout,
                              variant: "hyperlink-200",
                              linkText: (item2 == null ? void 0 : item2.textLink.label) || ""
                            }
                          )
                        ] })
                      ]
                    }
                  )
                },
                index
              )),
              /* @__PURE__ */ jsx("div", { className: styles$1.linkLayout, children: link2 && /* @__PURE__ */ jsx(TextLink, { ...link2, className: styles$1.cta, variant: "button-secondary", linkText: (link2 == null ? void 0 : link2.label) || "" }) })
            ]
          }
        )
      ]
    }
  );
};
const midbanner = "_midbanner_1remn_1";
const toggle = "_toggle_1remn_6";
const contentWidth = "_contentWidth_1remn_9";
const offer = "_offer_1remn_12";
const masks = "_masks_1remn_15";
const mask = "_mask_1remn_15";
const swiper = "_swiper_1remn_51";
const offerboxs = "_offerboxs_1remn_60";
const textleft = "_textleft_1remn_72";
const offerbox = "_offerbox_1remn_60";
const fromLabel = "_fromLabel_1remn_108";
const price = "_price_1remn_123";
const headline = "_headline_1remn_154";
const subHeadline = "_subHeadline_1remn_170";
const primaryLink = "_primaryLink_1remn_186";
const imgrigth = "_imgrigth_1remn_192";
const campaign = "_campaign_1remn_227";
const campaign_left = "_campaign_left_1remn_239";
const vanish = "_vanish_1remn_268";
const campaignbox = "_campaignbox_1remn_278";
const logo = "_logo_1remn_308";
const textlink = "_textlink_1remn_353";
const reversal = "_reversal_1remn_357";
const campaign_rigth = "_campaign_rigth_1remn_362";
const indicatorWrapper = "_indicatorWrapper_1remn_370";
const indicator = "_indicator_1remn_370";
const indicator_active = "_indicator_active_1remn_386";
const slideArrow = "_slideArrow_1remn_394";
const arrowButton = "_arrowButton_1remn_403";
const arrowButton_active = "_arrowButton_active_1remn_411";
const slideNum = "_slideNum_1remn_419";
const splidetitle = "_splidetitle_1remn_441";
const splitter = "_splitter_1remn_444";
const slideTotal = "_slideTotal_1remn_453";
const legal_disclaimer = "_legal_disclaimer_1remn_456";
const noTopSpacing = "_noTopSpacing_1remn_500";
const styles = {
  midbanner,
  toggle,
  contentWidth,
  offer,
  masks,
  mask,
  "mask--left": "_mask--left_1remn_35",
  "mask--brabus-left": "_mask--brabus-left_1remn_39",
  "mask--right": "_mask--right_1remn_43",
  "mask--brabus-right": "_mask--brabus-right_1remn_47",
  swiper,
  offerboxs,
  textleft,
  offerbox,
  fromLabel,
  price,
  headline,
  subHeadline,
  primaryLink,
  imgrigth,
  "mid-banner-picture": "_mid-banner-picture_1remn_213",
  campaign,
  campaign_left,
  vanish,
  campaignbox,
  logo,
  textlink,
  reversal,
  campaign_rigth,
  indicatorWrapper,
  indicator,
  indicator_active,
  slideArrow,
  arrowButton,
  arrowButton_active,
  slideNum,
  splidetitle,
  splitter,
  slideTotal,
  legal_disclaimer,
  noTopSpacing
};
const effectCreative_min = "";
const Offer = ({ Items, legalDisclaimers, mode, variant }) => {
  const [windowWidth, setWindowWidth] = useState(1920);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const [swiper2, setSwiper] = useState();
  const containerRefs = useRef([]);
  const masksRef = useRef(null);
  const indicatorRef = useRef(null);
  const getBackgroundColor = (option) => {
    const colorMapping2 = {
      "premium #1": "#BCC9C4",
      "premium #3": "#AAC1CD",
      brabus: "#3A3C3F",
      pulse: "#799DC9",
      "pro+": "#DED774",
      "pro,pure+,pure": "#E4E8EB"
    };
    return colorMapping2[option];
  };
  const getSlideBackground = (item2, index) => {
    var _a, _b, _c, _d;
    const imgUrl = windowWidth >= breakpoints$1.m ? (_a = item2.landscapeImage) == null ? void 0 : _a.imageUrl : ((_b = item2.portraitImage) == null ? void 0 : _b.imageUrl) || ((_c = item2.landscapeImage) == null ? void 0 : _c.imageUrl);
    return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      DynamicMediaPicture,
      {
        className: styles["mid-banner-picture"],
        imageAltText: ((_d = item2.landscapeImage) == null ? void 0 : _d.imageAltText) || "",
        imageUrl: imgUrl || "",
        imageConfigs: [{ aspectRatio, sizes: "100vw" }],
        initialIsInView: true,
        noLoadingLogo: true,
        isObjectFit: true,
        hasImageTransparency: true,
        fetchPriority: "high"
      }
    ) }, index);
  };
  useEffect(() => {
    const setWidth2 = () => {
      setWindowWidth(window.innerWidth);
      setTimeout(() => {
        var _a;
        const imageHeight = (_a = containerRefs.current[0]) == null ? void 0 : _a.clientHeight;
        const mask2 = masksRef.current;
        if (mask2) {
          mask2.style.height = `${imageHeight}px`;
        }
      }, 500);
    };
    setWidth2();
    window.addEventListener("resize", () => {
      setWidth2();
    });
  }, []);
  useEffect(() => {
    if (indicatorRef.current) {
      indicatorRef.current.style.left = `${100 / Items.length * swiperIndex}%`;
    }
  }, [swiperIndex]);
  const aspectRatio = windowWidth >= breakpoints$1.m ? "4-3" : "1-1";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("section", { className: styles.offer, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.masks, ref: masksRef, children: [
        swiperIndex > 0 && /* @__PURE__ */ jsx(
          "button",
          {
            onClick: () => swiper2 == null ? void 0 : swiper2.slidePrev(),
            className: classNames(styles.mask, styles["mask--left"], {
              [styles[`mask--brabus-left`]]: mode === "brabus"
            })
          }
        ),
        swiperIndex < Items.length - 1 && /* @__PURE__ */ jsx(
          "button",
          {
            onClick: () => swiper2 == null ? void 0 : swiper2.slideNext(),
            className: classNames(styles.mask, styles["mask--right"], {
              [styles[`mask--brabus-right`]]: mode === "brabus"
            })
          }
        )
      ] }),
      /* @__PURE__ */ jsx(
        Swiper2,
        {
          className: styles.swiper,
          speed: windowWidth <= breakpoints$1.m ? 300 : 500,
          spaceBetween: 4,
          slidesPerView: 1,
          onActiveIndexChange: (swiperCore) => {
            setSwiperIndex(swiperCore.activeIndex);
          },
          onSwiper: (s) => {
            setSwiper(s);
          },
          touchEventsTarget: "container",
          children: Items.map((item2, i) => {
            var _a;
            return /* @__PURE__ */ jsx(SwiperSlide, { children: /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.offerboxs,
                style: { background: getBackgroundColor(item2.backgroundColorOption) },
                ref: (el) => containerRefs.current[i] = el,
                children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames(styles.textleft, {
                        "dark-theme": item2.backgroundColorOption === "brabus"
                      }),
                      children: /* @__PURE__ */ jsxs("div", { className: styles.offerbox, children: [
                        item2.fromLabel && /* @__PURE__ */ jsx("div", { className: styles.fromLabel, children: item2.fromLabel }),
                        item2.price && /* @__PURE__ */ jsx("div", { className: styles.price, children: item2.price }),
                        item2.headline && /* @__PURE__ */ jsx("div", { className: styles.headline, children: item2.headline }),
                        item2.subHeadline && /* @__PURE__ */ jsx("div", { className: styles.subHeadline, children: item2.subHeadline }),
                        item2.primaryLink && /* @__PURE__ */ jsx("div", { className: styles.primaryLink, children: /* @__PURE__ */ jsx(
                          TextLink,
                          {
                            ...item2.primaryLink,
                            variant: "button-primary",
                            linkText: ((_a = item2.primaryLink) == null ? void 0 : _a.label) || ""
                          }
                        ) })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ jsx("div", { className: styles.imgrigth, children: getSlideBackground(item2, i) })
                ]
              }
            ) }, `${item2.headline}-${i}`);
          })
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: styles.indicatorWrapper, children: [
        /* @__PURE__ */ jsx("div", { className: styles.indicator, children: /* @__PURE__ */ jsx(
          "div",
          {
            ref: indicatorRef,
            className: styles.indicator_active,
            style: { width: `${100 / Items.length}%` }
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: styles.slideArrow, children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              className: classNames(styles.arrowButton, {
                [styles.arrowButton_active]: swiperIndex > 0
              }),
              onClick: () => swiper2 == null ? void 0 : swiper2.slidePrev(),
              children: /* @__PURE__ */ jsx(Icon, { name: "arrow-left--medium" })
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: classNames(styles.arrowButton, {
                [styles.arrowButton_active]: swiperIndex < Items.length - 1
              }),
              onClick: () => swiper2 == null ? void 0 : swiper2.slideNext(),
              children: /* @__PURE__ */ jsx(Icon, { name: "arrow-right--medium" })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles.slideNum, children: [
          /* @__PURE__ */ jsx("span", { className: styles.splidetitle, children: (swiperIndex + 1).toString().padStart(2, "0") }),
          /* @__PURE__ */ jsx("span", { className: styles.splitter }),
          /* @__PURE__ */ jsx("span", { className: styles.slideTotal, children: Items.length.toString().padStart(2, "0") })
        ] })
      ] })
    ] }),
    legalDisclaimers && /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(styles.legal_disclaimer, {
          [styles.toggle]: variant === "offer"
        }),
        children: [
          /* @__PURE__ */ jsx("hr", {}),
          /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
        ]
      }
    )
  ] });
};
const Campaign = ({ variant, Items, legalDisclaimers }) => {
  var _a, _b, _c, _d, _e;
  useEffect(() => {
    const setWidth2 = () => {
      setWindowWidth(window.innerWidth);
    };
    setWidth2();
    window.addEventListener("resize", () => {
      setWidth2();
    });
  }, []);
  const items = Items[0];
  const [windowWidth, setWindowWidth] = useState(0);
  const imgUrl = windowWidth >= breakpoints$1.m ? (_a = items.landscapeImage) == null ? void 0 : _a.imageUrl : ((_b = items.portraitImage) == null ? void 0 : _b.imageUrl) || ((_c = items.landscapeImage) == null ? void 0 : _c.imageUrl);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: styles.campaign,
        style: {
          background: variant === "award" ? " var(--bg-level-2)" : ""
        },
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(styles.campaign_left, {
                [styles.vanish]: items.landscapeImage === void 0 && items.portraitImage === void 0 && variant === "campaign"
              }),
              style: {
                background: variant === "award" ? "var(--bg-level-2)" : ""
              },
              children: /* @__PURE__ */ jsxs(
                "div",
                {
                  className: classNames(styles.campaignbox, {
                    [styles.vanish]: items.landscapeImage === void 0 && items.portraitImage === void 0 && variant === "campaign"
                  }),
                  children: [
                    /* @__PURE__ */ jsxs(
                      "div",
                      {
                        className: styles.apposition,
                        style: {
                          marginTop: items.landscapeImage ? "var(--spacing-400)" : ""
                        },
                        children: [
                          items.logo && variant === "award" && /* @__PURE__ */ jsx(LogoContainer, { className: styles.logo, ...items.logo }),
                          items.headline && /* @__PURE__ */ jsx("div", { className: styles.headline, style: { color: variant === "award" ? "var(--c-high_contrast)" : "" }, children: items.headline }),
                          items.subHeadline && /* @__PURE__ */ jsx(
                            "div",
                            {
                              className: styles.subHeadline,
                              style: { color: variant === "award" ? "var(--c-high_contrast)" : "" },
                              children: items.subHeadline
                            }
                          )
                        ]
                      }
                    ),
                    items.primaryLink && /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: classNames(styles.primaryLink, {
                          [styles.vanish]: items.landscapeImage === void 0 && items.portraitImage === void 0 && variant === "campaign"
                        }),
                        children: /* @__PURE__ */ jsx(
                          TextLink,
                          {
                            className: classNames(styles.textlink, {
                              [styles.reversal]: variant === "award"
                            }),
                            ...items.primaryLink,
                            variant: "button-primary",
                            linkText: ((_d = items.primaryLink) == null ? void 0 : _d.label) || ""
                          }
                        )
                      }
                    )
                  ]
                }
              )
            }
          ),
          items.landscapeImage && /* @__PURE__ */ jsx("div", { className: styles.campaign_rigth, children: /* @__PURE__ */ jsx(
            DynamicMediaPicture,
            {
              className: styles["mid-banner-picture"],
              imageAltText: ((_e = items.landscapeImage) == null ? void 0 : _e.imageAltText) || "",
              imageUrl: imgUrl || "",
              imageConfigs: [
                {
                  aspectRatio: "4-3",
                  sizes: "100vw"
                }
              ],
              initialIsInView: true,
              noLoadingLogo: true,
              isObjectFit: true,
              hasImageTransparency: true,
              fetchPriority: "high"
            }
          ) })
        ]
      }
    ),
    legalDisclaimers && /* @__PURE__ */ jsxs("div", { className: styles.legal_disclaimer, children: [
      /* @__PURE__ */ jsx("hr", {}),
      /* @__PURE__ */ jsx(LegalDisclaimer, { legalDisclaimers })
    ] })
  ] });
};
const MidBanner = (props) => /* @__PURE__ */ jsxs(
  "div",
  {
    className: classNames(styles.midbanner, {
      [styles.noTopSpacing]: props.removeTopSpacing,
      "dark-theme": props.mode === "dark" || props.mode === "brabus",
      [styles.toggle]: props.variant === "campaign" || props.variant === "award"
    }),
    children: [
      props.variant === "offer" && /* @__PURE__ */ jsx(Offer, { ...props }),
      (props.variant === "campaign" || props.variant === "award") && /* @__PURE__ */ jsx(Campaign, { ...props })
    ]
  }
);
const useHeaderIntersectionObserver = (stageRef) => {
  const [inverted, setInverted] = useState(true);
  const observerRef = useRef(null);
  useEffect(() => {
    let { current: observer } = observerRef;
    const reference2 = stageRef.current;
    const options = {
      threshold: 0
    };
    if (observer)
      observer.disconnect();
    observer = new IntersectionObserver(([entry]) => {
      setInverted(!entry.isIntersecting);
    }, options);
    reference2 && observer.observe(reference2);
    return () => {
      reference2 && (observer == null ? void 0 : observer.unobserve(reference2));
    };
  }, [stageRef]);
  return inverted;
};
export {
  Accordion,
  Banner,
  CarSlide,
  ExtendedFlexibleGallery,
  ExternalLinkPopUp,
  FactsAndFigures,
  FlexibleGallery,
  FlexibleTextImage,
  FullWidthTeaser,
  Header,
  HeadlineV2,
  HeadlineWithImage,
  HeadlineWithText,
  HeroStage,
  ImageStage,
  ImageStageSmall,
  InStageNavigation,
  LegalDisclaimerStandalone,
  LogoContainer,
  MediaStage,
  MidBanner,
  ProductTeaserCard,
  RichtextStandalone,
  Scrollytelling,
  Statement,
  Steps,
  Table,
  TeaserGroup,
  TeaserGroupItem,
  TeaserRow,
  TeaserRowV2,
  TeaserRowWithText,
  TextParagraph,
  TextWithMedia,
  USP,
  Video,
  VideoStage,
  useHeaderIntersectionObserver
};
